import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Profile": [
      "PersonalProfile",
      "PublicProfile"
    ]
  }
};
      export default result;
    
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: { input: any; output: any; }
  /** hashed ids */
  HashedId: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AbstractEmployeeWithRankAndTags = {
  __typename?: 'AbstractEmployeeWithRankAndTags';
  assessable: Scalars['Boolean']['output'];
  draftEvaluation?: Maybe<Scalars['Float']['output']>;
  employee: EmployeeDisplayShortInfo;
  evaluation?: Maybe<Scalars['Float']['output']>;
  evaluationMeetingId?: Maybe<Scalars['HashedId']['output']>;
  id: Scalars['HashedId']['output'];
  latestEvaluation?: Maybe<Scalars['Float']['output']>;
  previousCompanyRankData?: Maybe<EmployeeRankDto>;
  previousRank?: Maybe<Scalars['Int']['output']>;
  rank: Scalars['Int']['output'];
  tags: Array<EmployeeTagDto>;
};

export type AbstractRelation = {
  __typename?: 'AbstractRelation';
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ActiveHrBusinessPartnerDto = {
  __typename?: 'ActiveHRBusinessPartnerDTO';
  companyId: Scalars['HashedId']['output'];
  companyName: Scalars['String']['output'];
  employee: EmployeeDisplayShortInfo;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ActivityListDto = {
  __typename?: 'ActivityListDTO';
  data: Array<ActivityListDataDto>;
  length: Scalars['Int']['output'];
  type: ActivityListType;
};

export type ActivityListDataDto = {
  __typename?: 'ActivityListDataDTO';
  date: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** All activity list types */
export enum ActivityListType {
  Achievements = 'ACHIEVEMENTS',
  Communities = 'COMMUNITIES',
  KnowledgeSharing = 'KNOWLEDGE_SHARING',
  Learning = 'LEARNING'
}

export type AllowedMonetaryTargetsDto = {
  __typename?: 'AllowedMonetaryTargetsDTO';
  newTargetsAllowed: Scalars['Boolean']['output'];
  pastTargetsAllowed: Scalars['Boolean']['output'];
};

export type AppraisalConfirmationInfo = {
  __typename?: 'AppraisalConfirmationInfo';
  date: Scalars['DateTime']['output'];
  discussedWith?: Maybe<EmployeeDisplayTinyInfo>;
  forceConfirmedBy?: Maybe<EmployeeDisplayTinyInfo>;
  forceConfirmedReason?: Maybe<Scalars['String']['output']>;
};

export type AppraisalDisplayInfo = {
  __typename?: 'AppraisalDisplayInfo';
  appraisalSeason: AppraisalSeasonDto;
  companyNameOfMeeting?: Maybe<Scalars['String']['output']>;
  conclusionPdf?: Maybe<MeetingConclusionPdf>;
  confirmation?: Maybe<AppraisalConfirmationInfo>;
  date: Scalars['DateTime']['output'];
  hrDisputeComment?: Maybe<Scalars['String']['output']>;
  hrFeedBack?: Maybe<Scalars['String']['output']>;
  hrResult: MeetingHrFeedbackResult;
  id: Scalars['HashedId']['output'];
  meetingStatus: MeetingStatus;
  meetingType: MeetingType;
  reviewer?: Maybe<EmployeeDisplayTinyInfo>;
  status: MeetingInvitationStatus;
  type?: Maybe<AppraisalType>;
};

/** Appraisal-Meeting types/categories. */
export enum AppraisalMeetingType {
  ForcedTargets = 'ForcedTargets',
  Normal = 'Normal',
  SkippedSteps = 'SkippedSteps'
}

export type AppraisalSeasonDto = {
  __typename?: 'AppraisalSeasonDTO';
  companyId: Scalars['HashedId']['output'];
  country: Scalars['String']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  year: Scalars['Int']['output'];
};

export type AppraisalSeasonOpeningInfoDto = {
  __typename?: 'AppraisalSeasonOpeningInfoDTO';
  currentAppraisalSeasonOpeningMonth: Scalars['Int']['output'];
  currentAppraisalSeasonOpeningYear: Scalars['Int']['output'];
  currentAppraisalSeasonYear: Scalars['Int']['output'];
  defaultAppraisalSeasonOpeningMonth: Scalars['Int']['output'];
  defaultCountryTimezone: Scalars['String']['output'];
  nextAppraisalSeasonOpeningMonth: Scalars['Int']['output'];
  nextAppraisalSeasonOpeningYear?: Maybe<Scalars['Int']['output']>;
  nextAppraisalSeasonYear: Scalars['Int']['output'];
};

export type AppraisalType = {
  __typename?: 'AppraisalType';
  name: AppraisalMeetingType;
  reason?: Maybe<SkipMeetingStepReason>;
  skippedSteps: Array<MeetingStepViewId>;
};

export type AppraisalWithFeedbackDto = {
  __typename?: 'AppraisalWithFeedbackDTO';
  appraisalSeason: AppraisalSeasonDto;
  companyName: Scalars['String']['output'];
  conclusionPdf: MeetingConclusionPdf;
  date: Scalars['DateTime']['output'];
  discussedWith?: Maybe<EmployeeDisplayTinyInfo>;
  employeeConfirmationDate: Scalars['DateTime']['output'];
  hrDisputeComment?: Maybe<Scalars['String']['output']>;
  hrFeedback: Scalars['String']['output'];
  hrResult: MeetingHrFeedbackResult;
  id: Scalars['HashedId']['output'];
  managerConfirmationDate: Scalars['DateTime']['output'];
  meetingType: MeetingType;
  replyer: EmployeeDisplayTinyInfo;
  reviewer: EmployeeDisplayTinyInfo;
  status: MeetingStatus;
};

export type AppraisalWithFeedbackPagination = {
  __typename?: 'AppraisalWithFeedbackPagination';
  edges: Array<AppraisalWithFeedbackDto>;
  endCursorConfirmationDate?: Maybe<Scalars['DateTime']['output']>;
  endCursorMeetingId?: Maybe<Scalars['HashedId']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  token: Scalars['String']['output'];
  user: CurrentUser;
};

export type AuthorInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['HashedId']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type BOofCompanyDto = {
  __typename?: 'BOofCompanyDTO';
  branchOfficesWithEmployees: Array<BranchOfficeWithEmployeesDto>;
  companyId: Scalars['HashedId']['output'];
};

export type BubobuMcountersDto = {
  __typename?: 'BUBOBUMcountersDTO';
  branchOffice: Scalars['Int']['output'];
  buManagers: Scalars['Int']['output'];
  businessUnit: Scalars['Int']['output'];
  companyId: Scalars['HashedId']['output'];
};

export type BumOfBusinessUnitDto = {
  __typename?: 'BUMOfBusinessUnitDTO';
  buManagers: Array<EmployeeWithLevelDto>;
  businessUnit: BusinessUnitTiny;
};

export type BumOfCompanyDto = {
  __typename?: 'BUMOfCompanyDTO';
  buManagers: Array<BumOfBusinessUnitDto>;
  companyId: Scalars['HashedId']['output'];
};

export type BUofCompanyDto = {
  __typename?: 'BUofCompanyDTO';
  businessUnitsWithManagers: Array<BusinessUnitWithManagersDto>;
  companyId: Scalars['HashedId']['output'];
};

export type BonusBetweenAnnualBonusAndProrataDto = {
  __typename?: 'BonusBetweenAnnualBonusAndProrataDTO';
  appraisalSeasonId: Scalars['HashedId']['output'];
  bonusAmount: Scalars['Float']['output'];
  bonusStatus: FlexibleProrataBonusStatus;
  contractCurrency: Currency;
  contractId: Scalars['HashedId']['output'];
  id: Scalars['HashedId']['output'];
};

export type BranchOffice = {
  __typename?: 'BranchOffice';
  address: InternationalAddress;
  addressId: Scalars['HashedId']['output'];
  code: Scalars['String']['output'];
  employees?: Maybe<Array<Employee>>;
  hiringOffice?: Maybe<HiringOffice>;
  id: Scalars['HashedId']['output'];
  name: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BranchOfficeDto = {
  __typename?: 'BranchOfficeDTO';
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['HashedId']['output']>;
  name: Scalars['String']['output'];
};

export type BranchOfficeWithEmployeesDto = {
  __typename?: 'BranchOfficeWithEmployeesDTO';
  branchOffice: BranchOfficeDto;
  employees: Array<EmployeeWithLevelDto>;
};

export type Brand = {
  __typename?: 'Brand';
  companies?: Maybe<Array<Company>>;
  id: Scalars['HashedId']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Bu = {
  __typename?: 'Bu';
  buId: Scalars['HashedId']['output'];
  displayName: Scalars['String']['output'];
  isAllBu: Scalars['Boolean']['output'];
};

export type BusinessPartnerOfCompany = {
  __typename?: 'BusinessPartnerOfCompany';
  company: Company;
  companyId: Scalars['HashedId']['output'];
  employee: Employee;
  employeeId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessUnit = {
  __typename?: 'BusinessUnit';
  company: Company;
  description: Scalars['String']['output'];
  employees?: Maybe<Array<Employee>>;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  managers?: Maybe<Array<ManagerOfBusinessUnit>>;
  name: Scalars['String']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** A business unit. */
export type BusinessUnitTiny = {
  __typename?: 'BusinessUnitTiny';
  /** Company this business unit belongs to */
  company?: Maybe<CompanyTiny>;
  /** The displayed name of the business unit. */
  displayName: Scalars['String']['output'];
  /** ID of the business unit. */
  id: Scalars['HashedId']['output'];
  /** Is company expired */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /** internal name of the business unit. When displaying information on the BU use 'displayName' instead. */
  name: Scalars['String']['output'];
};

export type BusinessUnitWithManagersDto = {
  __typename?: 'BusinessUnitWithManagersDTO';
  buManagers: Array<EmployeeDisplayTinyInfo>;
  businessUnit: BusinessUnitTiny;
  numberOfEmployees: Scalars['Int']['output'];
};

/** All possible contract cancellation types */
export enum CancellationType {
  AbolitionTreatment = 'ABOLITION_TREATMENT',
  AbolitionTreatmentEmployee = 'ABOLITION_TREATMENT_EMPLOYEE',
  Death = 'DEATH',
  EmployeeTermination = 'EMPLOYEE_TERMINATION',
  EmployeeTerminationInProbation = 'EMPLOYEE_TERMINATION_IN_PROBATION',
  EmployerTermination = 'EMPLOYER_TERMINATION',
  EmployerTerminationInProbation = 'EMPLOYER_TERMINATION_IN_PROBATION',
  InternalChange = 'INTERNAL_CHANGE',
  Pension = 'PENSION',
  TemporaryContract = 'TEMPORARY_CONTRACT',
  Unknown = 'UNKNOWN'
}

export type CareerPathDto = {
  __typename?: 'CareerPathDto';
  careerPathType: Scalars['String']['output'];
  country: Scalars['String']['output'];
  level: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min: Scalars['Float']['output'];
};

export type CareerPathEvaluation = {
  __typename?: 'CareerPathEvaluation';
  bonusEvaluation: CareerPathEvaluationState;
  salary: Scalars['Float']['output'];
  salaryEvaluation: CareerPathEvaluationState;
  summary: CareerPathEvaluationState;
  targetBonus: Scalars['Float']['output'];
};

/** All Possible career path evaluation states */
export enum CareerPathEvaluationState {
  Inline = 'INLINE',
  OutOfLine = 'OUT_OF_LINE'
}

export type Change = {
  __typename?: 'Change';
  changes: Scalars['String']['output'];
  employee: Employee;
  id: Scalars['HashedId']['output'];
  status?: Maybe<ChangeStatus>;
  type?: Maybe<ChangeType>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
};

export type ChangeError = {
  __typename?: 'ChangeError';
  bonus?: Maybe<ChangeResponseErrorObject>;
  employeeLevel?: Maybe<ChangeResponseErrorObject>;
  governmentJobTitle?: Maybe<ChangeResponseErrorObject>;
  nationalReferenceLevel?: Maybe<ChangeResponseErrorObject>;
  salary?: Maybe<ChangeResponseErrorObject>;
  validFrom?: Maybe<ChangeResponseErrorObject>;
};

export type ChangeInput = {
  changes?: InputMaybe<ChangeJson>;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeJson = {
  bonus?: InputMaybe<Scalars['Float']['input']>;
  employeeLevel?: InputMaybe<Scalars['String']['input']>;
  governmentJobTitle?: InputMaybe<GovernmentJobTitleTinyInput>;
  nationalReferenceLevel?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
};

export type ChangeResponseErrorObject = {
  __typename?: 'ChangeResponseErrorObject';
  message: Scalars['String']['output'];
  props?: Maybe<Scalars['String']['output']>;
};

/** All possible change status */
export enum ChangeStatus {
  Closed = 'Closed',
  Open = 'Open',
  Send = 'Send'
}

/** All possible change types */
export enum ChangeType {
  AddressChange = 'AddressChange',
  ContractChange = 'ContractChange',
  EducationChange = 'EducationChange'
}

export type Children = {
  __typename?: 'Children';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Citizenship = {
  __typename?: 'Citizenship';
  country: Scalars['String']['output'];
  displayOrder: Scalars['Float']['output'];
  employeeId: Scalars['HashedId']['output'];
  fromDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CompaniesForRankingReportDto = {
  __typename?: 'CompaniesForRankingReportDTO';
  companyId: Scalars['HashedId']['output'];
  companyName: Scalars['String']['output'];
};

export type CompaniesForRankingReportInput = {
  companyId: Scalars['HashedId']['input'];
  companyName: Scalars['String']['input'];
};

export type Company = {
  __typename?: 'Company';
  brand?: Maybe<Brand>;
  businessPartners?: Maybe<Array<BusinessPartnerOfCompany>>;
  businessUnits: Array<BusinessUnit>;
  code: Scalars['String']['output'];
  companyRankings: Array<CompanyRanking>;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isSharedService: Scalars['Boolean']['output'];
  managers?: Maybe<Array<ManagerOfCompany>>;
  name: Scalars['String']['output'];
  network: Network;
  reviewers?: Maybe<Array<ReviewerOfEmployees>>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CompanyAndBu = {
  __typename?: 'CompanyAndBu';
  bu: Array<Bu>;
  companyId: Scalars['HashedId']['output'];
  companyName: Scalars['String']['output'];
};

export type CompanyCar = {
  __typename?: 'CompanyCar';
  contract: Contract;
  currency: Scalars['String']['output'];
  deduction?: Maybe<Scalars['Float']['output']>;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Appraisal meeting statuses shown in the Company Manager dashboard widget */
export enum CompanyManagerAppraisalMeetingStatus {
  Done = 'Done',
  HavingAnAppraisalUpdate = 'HavingAnAppraisalUpdate',
  NotInvited = 'NotInvited',
  NotPrepared = 'NotPrepared',
  Outdated = 'Outdated',
  Prepared = 'Prepared',
  WaitingForEmployeeConfirmation = 'WaitingForEmployeeConfirmation',
  WaitingForHrResult = 'WaitingForHRResult'
}

export type CompanyManagerAppraisalMeetingStatusDto = {
  __typename?: 'CompanyManagerAppraisalMeetingStatusDTO';
  companyId: Scalars['HashedId']['output'];
  ongoingAppraisalUpdateAfterLatestConfirmedMeetingCount: Scalars['Int']['output'];
  rows: Array<CompanyManagerAppraisalMeetingStatusTableRowDto>;
};

export type CompanyManagerAppraisalMeetingStatusTableRowDto = {
  __typename?: 'CompanyManagerAppraisalMeetingStatusTableRowDTO';
  buManagers: Array<EmployeeDisplayTinyInfo>;
  businessUnit: BusinessUnitTiny;
  confirmedOrLatestMeetingConclusionPdf?: Maybe<MeetingConclusionPdf>;
  confirmedOrLatestMeetingId?: Maybe<Scalars['HashedId']['output']>;
  confirmedOrLatestMeetingType?: Maybe<MeetingType>;
  country: Country;
  employee: EmployeeWithLevelDto;
  office?: Maybe<BranchOfficeDto>;
  replyEntryDate: Scalars['DateTime']['output'];
  status: CompanyManagerAppraisalMeetingStatus;
};

export type CompanyRanking = {
  __typename?: 'CompanyRanking';
  closed: Scalars['Boolean']['output'];
  company: Company;
  country: Country;
  employeeRankings: Array<EmployeeRanking>;
  id: Scalars['HashedId']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  year: Scalars['Int']['output'];
};

export type CompanyRankingSettingsDto = {
  __typename?: 'CompanyRankingSettingsDTO';
  lowPercentage: Scalars['Float']['output'];
  lowPercentageIsBlocker: Scalars['Boolean']['output'];
  rankingIsDisabled: Scalars['Boolean']['output'];
  tagAssignmentIsInProgress: Scalars['Boolean']['output'];
  topPercentage: Scalars['Float']['output'];
};

/** All possible types for Company Scope */
export enum CompanyScope {
  All = 'ALL',
  HrUser = 'HR_USER'
}

export type CompanySubordinate = {
  __typename?: 'CompanySubordinate';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  careerPath?: Maybe<Array<CareerPathDto>>;
  careerPathEvaluation?: Maybe<CareerPathEvaluation>;
  companyName?: Maybe<Scalars['String']['output']>;
  contractValidTo?: Maybe<Scalars['DateTime']['output']>;
  country: Country;
  currencyForPayments: Currency;
  currentLevel?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  replyEntryDate: Scalars['DateTime']['output'];
  resultScore?: Maybe<Scalars['Float']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  skillStatus?: Maybe<SkillEmployeeStatusDto>;
  targetBonus?: Maybe<Scalars['Float']['output']>;
  timezone: Scalars['String']['output'];
};

export type CompanyTiny = {
  __typename?: 'CompanyTiny';
  id: Scalars['HashedId']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyTinyWithName = {
  __typename?: 'CompanyTinyWithName';
  id: Scalars['HashedId']['output'];
  name: Scalars['String']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  annualSalary: Array<Salary>;
  cancellationFrom?: Maybe<Scalars['DateTime']['output']>;
  cancellationTo?: Maybe<Scalars['DateTime']['output']>;
  cancellationType?: Maybe<Scalars['String']['output']>;
  companyCars: Array<CompanyCar>;
  contractGovernmentJobTitles: Array<ContractGovernmentJobTitle>;
  contractType: Array<ContractType>;
  currencyForPayments: Scalars['String']['output'];
  currentAnnualSalary: Salary;
  currentContractEmployeeLevel: ContractEmployeeLevel;
  currentEmployeeLevel: ContractEmployeeLevel;
  currentLeaveEntitlement: LeaveEntitlement;
  currentTargetBonus: TargetBonus;
  employee?: Maybe<Employee>;
  employeeLevels: Array<ContractEmployeeLevel>;
  executedPayments: Array<ExecutedPayment>;
  flexibleBenefit?: Maybe<Scalars['Float']['output']>;
  id: Scalars['HashedId']['output'];
  leaveEntitlement: Array<LeaveEntitlement>;
  legalEntity: LegalEntity;
  nationalContractEmployeeLevels: Array<NationalContractLevel>;
  probationPeriodEndDate?: Maybe<Scalars['DateTime']['output']>;
  retentionPeriodEndDate?: Maybe<Scalars['DateTime']['output']>;
  tagHistory?: Maybe<Array<EmployeeTagInfo>>;
  targetBonus?: Maybe<Array<TargetBonus>>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  updatesRestrictedTo?: Maybe<Scalars['DateTime']['output']>;
  validFrom: Scalars['DateTime']['output'];
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractChangeValidationEntry = {
  __typename?: 'ContractChangeValidationEntry';
  bonus?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  employeeLevel?: Maybe<EmployeeLevelEnum>;
  governmentJobTitle?: Maybe<GovernmentJobTitleTinyDto>;
  nationalContractLevel?: Maybe<NationalContractLevelEnum>;
  salary?: Maybe<Scalars['Float']['output']>;
};

export type ContractChangeValidationList = {
  __typename?: 'ContractChangeValidationList';
  validationEntries: Array<ContractChangeValidationEntry>;
};

export type ContractEmployeeLevel = {
  __typename?: 'ContractEmployeeLevel';
  contract: Contract;
  contractId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isTentative: Scalars['Boolean']['output'];
  level: EmployeeLevelEnum;
  note?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractEmployeeLevelDto = {
  __typename?: 'ContractEmployeeLevelDTO';
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isTentative: Scalars['Boolean']['output'];
  level: EmployeeLevelEnum;
  note?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractEmployeeLevelHistoryDto = {
  __typename?: 'ContractEmployeeLevelHistoryDTO';
  contractEmployeeLevelHistory: Array<ContractEmployeeLevelDto>;
};

export type ContractGovernmentJobTitle = {
  __typename?: 'ContractGovernmentJobTitle';
  contractId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  governmentJobTitle: GovernmentJobTitle;
  id: Scalars['HashedId']['output'];
  note?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractType = {
  __typename?: 'ContractType';
  contract: Contract;
  contractId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  typeOfContract: ContractTypeEnum;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** All possible contract types */
export enum ContractTypeEnum {
  Administrator = 'ADMINISTRATOR',
  Apprenticeship = 'APPRENTICESHIP',
  AtWill = 'AT_WILL',
  FixedTermContract = 'FIXED_TERM_CONTRACT',
  Internship = 'INTERNSHIP',
  Other = 'OTHER',
  ProjectContract = 'PROJECT_CONTRACT',
  Regular = 'REGULAR',
  Unlimited = 'UNLIMITED',
  WorkExperience = 'WORK_EXPERIENCE',
  ZeroHourContract = 'ZERO_HOUR_CONTRACT'
}

/** All possible countries as ISO 3166-1 alpha-3 codes */
export enum Country {
  Abw = 'ABW',
  Afg = 'AFG',
  Ago = 'AGO',
  Aia = 'AIA',
  Ala = 'ALA',
  Alb = 'ALB',
  All = 'ALL',
  And = 'AND',
  Are = 'ARE',
  Arg = 'ARG',
  Arm = 'ARM',
  Asm = 'ASM',
  Ata = 'ATA',
  Atf = 'ATF',
  Atg = 'ATG',
  Aus = 'AUS',
  Aut = 'AUT',
  Aze = 'AZE',
  Bdi = 'BDI',
  Bel = 'BEL',
  Ben = 'BEN',
  Bes = 'BES',
  Bfa = 'BFA',
  Bgd = 'BGD',
  Bgr = 'BGR',
  Bhr = 'BHR',
  Bhs = 'BHS',
  Bih = 'BIH',
  Blm = 'BLM',
  Blr = 'BLR',
  Blz = 'BLZ',
  Bmu = 'BMU',
  Bol = 'BOL',
  Bra = 'BRA',
  Brb = 'BRB',
  Brn = 'BRN',
  Btn = 'BTN',
  Bvt = 'BVT',
  Bwa = 'BWA',
  Caf = 'CAF',
  Can = 'CAN',
  Cck = 'CCK',
  Che = 'CHE',
  Chl = 'CHL',
  Chn = 'CHN',
  Civ = 'CIV',
  Cmr = 'CMR',
  Cod = 'COD',
  Cog = 'COG',
  Cok = 'COK',
  Col = 'COL',
  Com = 'COM',
  Cpv = 'CPV',
  Cri = 'CRI',
  Cub = 'CUB',
  Cuw = 'CUW',
  Cxr = 'CXR',
  Cym = 'CYM',
  Cyp = 'CYP',
  Cze = 'CZE',
  Default = 'DEFAULT',
  Deu = 'DEU',
  Dji = 'DJI',
  Dma = 'DMA',
  Dnk = 'DNK',
  Dom = 'DOM',
  Dza = 'DZA',
  Ecu = 'ECU',
  Egy = 'EGY',
  Eri = 'ERI',
  Esh = 'ESH',
  Esp = 'ESP',
  Est = 'EST',
  Eth = 'ETH',
  Fin = 'FIN',
  Fji = 'FJI',
  Flk = 'FLK',
  Fra = 'FRA',
  Fro = 'FRO',
  Fsm = 'FSM',
  Gab = 'GAB',
  Gbr = 'GBR',
  Geo = 'GEO',
  Ggy = 'GGY',
  Gha = 'GHA',
  Gib = 'GIB',
  Gin = 'GIN',
  Glp = 'GLP',
  Gmb = 'GMB',
  Gnb = 'GNB',
  Gnq = 'GNQ',
  Grc = 'GRC',
  Grd = 'GRD',
  Grl = 'GRL',
  Gtm = 'GTM',
  Guf = 'GUF',
  Gum = 'GUM',
  Guy = 'GUY',
  Hkg = 'HKG',
  Hmd = 'HMD',
  Hnd = 'HND',
  Hrv = 'HRV',
  Hti = 'HTI',
  Hun = 'HUN',
  Idn = 'IDN',
  Imn = 'IMN',
  Ind = 'IND',
  Iot = 'IOT',
  Irl = 'IRL',
  Irn = 'IRN',
  Irq = 'IRQ',
  Isl = 'ISL',
  Isr = 'ISR',
  Ita = 'ITA',
  Jam = 'JAM',
  Jey = 'JEY',
  Jor = 'JOR',
  Jpn = 'JPN',
  Kaz = 'KAZ',
  Ken = 'KEN',
  Kgz = 'KGZ',
  Khm = 'KHM',
  Kir = 'KIR',
  Kna = 'KNA',
  Kor = 'KOR',
  Kwt = 'KWT',
  Lao = 'LAO',
  Lbn = 'LBN',
  Lbr = 'LBR',
  Lby = 'LBY',
  Lca = 'LCA',
  Lie = 'LIE',
  Lka = 'LKA',
  Lso = 'LSO',
  Ltu = 'LTU',
  Lux = 'LUX',
  Lva = 'LVA',
  Mac = 'MAC',
  Maf = 'MAF',
  Mar = 'MAR',
  Mco = 'MCO',
  Mda = 'MDA',
  Mdg = 'MDG',
  Mdv = 'MDV',
  Mex = 'MEX',
  Mhl = 'MHL',
  Mkd = 'MKD',
  Mli = 'MLI',
  Mlt = 'MLT',
  Mmr = 'MMR',
  Mne = 'MNE',
  Mng = 'MNG',
  Mnp = 'MNP',
  Moz = 'MOZ',
  Mrt = 'MRT',
  Msr = 'MSR',
  Mtq = 'MTQ',
  Mus = 'MUS',
  Mwi = 'MWI',
  Mys = 'MYS',
  Myt = 'MYT',
  Nam = 'NAM',
  Ncl = 'NCL',
  Ner = 'NER',
  Nfk = 'NFK',
  Nga = 'NGA',
  Nic = 'NIC',
  Niu = 'NIU',
  Nld = 'NLD',
  Nor = 'NOR',
  Npl = 'NPL',
  Nru = 'NRU',
  Nzl = 'NZL',
  Omn = 'OMN',
  Pak = 'PAK',
  Pan = 'PAN',
  Pcn = 'PCN',
  Per = 'PER',
  Phl = 'PHL',
  Plw = 'PLW',
  Png = 'PNG',
  Pol = 'POL',
  Pri = 'PRI',
  Prk = 'PRK',
  Prt = 'PRT',
  Pry = 'PRY',
  Pse = 'PSE',
  Pyf = 'PYF',
  Qat = 'QAT',
  Reu = 'REU',
  Rou = 'ROU',
  Rus = 'RUS',
  Rwa = 'RWA',
  Sau = 'SAU',
  Sdn = 'SDN',
  Sen = 'SEN',
  Sgp = 'SGP',
  Sgs = 'SGS',
  Shn = 'SHN',
  Sjm = 'SJM',
  Slb = 'SLB',
  Sle = 'SLE',
  Slv = 'SLV',
  Smr = 'SMR',
  Som = 'SOM',
  Spm = 'SPM',
  Srb = 'SRB',
  Ssd = 'SSD',
  Stp = 'STP',
  Sur = 'SUR',
  Svk = 'SVK',
  Svn = 'SVN',
  Swe = 'SWE',
  Swz = 'SWZ',
  Sxm = 'SXM',
  Syc = 'SYC',
  Syr = 'SYR',
  Tca = 'TCA',
  Tcd = 'TCD',
  Tgo = 'TGO',
  Tha = 'THA',
  Tjk = 'TJK',
  Tkl = 'TKL',
  Tkm = 'TKM',
  Tls = 'TLS',
  Ton = 'TON',
  Tto = 'TTO',
  Tun = 'TUN',
  Tur = 'TUR',
  Tuv = 'TUV',
  Twn = 'TWN',
  Tza = 'TZA',
  Uga = 'UGA',
  Ukr = 'UKR',
  Umi = 'UMI',
  Ury = 'URY',
  Usa = 'USA',
  Uzb = 'UZB',
  Vat = 'VAT',
  Vct = 'VCT',
  Ven = 'VEN',
  Vgb = 'VGB',
  Vir = 'VIR',
  Vnm = 'VNM',
  Vut = 'VUT',
  Wlf = 'WLF',
  Wsm = 'WSM',
  Yem = 'YEM',
  Zaf = 'ZAF',
  Zmb = 'ZMB',
  Zwe = 'ZWE'
}

export type CountryAndReportGenerationFlags = {
  __typename?: 'CountryAndReportGenerationFlags';
  country: Country;
  createBigReport: Scalars['Boolean']['output'];
  createPyramidReport: Scalars['Boolean']['output'];
  createSmallReport: Scalars['Boolean']['output'];
  createTargetReport: Scalars['Boolean']['output'];
};

export type CountrySettingsDto = {
  __typename?: 'CountrySettingsDto';
  country: Country;
  createTargetReport: Scalars['Boolean']['output'];
  cutOffDay: Scalars['Float']['output'];
  defaultKudosFeatureEnabled: Scalars['Boolean']['output'];
  defaultRankingLowPercentage: Scalars['Float']['output'];
  defaultRankingLowPercentageIsBlocker: Scalars['Boolean']['output'];
  defaultRankingRankingIsDisabled: Scalars['Boolean']['output'];
  defaultRankingTopPercentage: Scalars['Float']['output'];
  employeeLevelsSet: EmployeeLevelsSets;
  flexibleProrataManagementEnabled: Scalars['Boolean']['output'];
  hasGovernmentJobTitleReferenceLevel: Scalars['Boolean']['output'];
  hasNationalContractReferenceLevel: Scalars['Boolean']['output'];
  id: Scalars['HashedId']['output'];
  isAgePyramidVisible: Scalars['Boolean']['output'];
  isBranchOfficeVisible: Scalars['Boolean']['output'];
  isDateOfBirthVisible: Scalars['Boolean']['output'];
  isDeductionEnabled: Scalars['Boolean']['output'];
  isIdVWeightEnabled: Scalars['Boolean']['output'];
  isMonthlySalaryDisplayed: Scalars['Boolean']['output'];
  maintainTagHistory: Scalars['Boolean']['output'];
  monthlySalaryMonthsInYear: Scalars['Int']['output'];
  paymentsAndChangesDisclaimerVisible: Scalars['Boolean']['output'];
  selfReflectionAndEvaluationAlwaysVisible: Scalars['Boolean']['output'];
  skillStatusBlocker: Scalars['Boolean']['output'];
};

export type CountryWithAgePyramidVisibleFlag = {
  __typename?: 'CountryWithAgePyramidVisibleFlag';
  country: Country;
  isAgePyramidVisible: Scalars['Boolean']['output'];
};

export type CountryWithBranchOfficeVisibleFlag = {
  __typename?: 'CountryWithBranchOfficeVisibleFlag';
  country: Country;
  isBranchOfficeVisible: Scalars['Boolean']['output'];
};

export type CreateChangeResponse = {
  __typename?: 'CreateChangeResponse';
  change?: Maybe<Change>;
  error?: Maybe<ChangeError>;
  success: Scalars['Boolean']['output'];
};

/** All possible currencies as ISO 4217 String codes like EUR, USD */
export enum Currency {
  Bef = 'BEF',
  Brl = 'BRL',
  Byn = 'BYN',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Czk = 'CZK',
  Dem = 'DEM',
  Dkk = 'DKK',
  Eur = 'EUR',
  Frf = 'FRF',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Hrk = 'HRK',
  Iep = 'IEP',
  Inr = 'INR',
  Itl = 'ITL',
  Luf = 'LUF',
  Mad = 'MAD',
  Mxn = 'MXN',
  Nlg = 'NLG',
  Nzd = 'NZD',
  Pln = 'PLN',
  Plz = 'PLZ',
  Ron = 'RON',
  Rub = 'RUB',
  Sek = 'SEK',
  Usd = 'USD'
}

export type CurrencyConversionDto = {
  __typename?: 'CurrencyConversionDTO';
  /** Currency conversion rate */
  conversionRate: Scalars['Float']['output'];
  id: Scalars['HashedId']['output'];
  /** The currency we want to convert from */
  startingCurrency: Currency;
  /** The currency we want to convert to */
  targetCurrency: Currency;
};

export type CurrencyConversionWithContractCurrencyDto = {
  __typename?: 'CurrencyConversionWithContractCurrencyDTO';
  contractCurrency: Currency;
  currencyConversionData: Array<CurrencyConversionDto>;
  id: Scalars['HashedId']['output'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  employeeId: Scalars['HashedId']['output'];
  roles?: Maybe<Array<RoleName>>;
  userId: Scalars['HashedId']['output'];
};

export type CursorPaginationMeetingInput = {
  cursorConfirmationDate?: InputMaybe<Scalars['DateTime']['input']>;
  cursorMeetingId?: InputMaybe<Scalars['HashedId']['input']>;
};

export type CursorPaginationReportInput = {
  cursorReportDate?: InputMaybe<Scalars['DateTime']['input']>;
  cursorReportId?: InputMaybe<Scalars['HashedId']['input']>;
};

export type CursorPaginationSubordinateInput = {
  cursorId?: InputMaybe<Scalars['HashedId']['input']>;
  cursorLegalFirstName?: InputMaybe<Scalars['String']['input']>;
  cursorLegalLastName?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardListOfCompanies = {
  __typename?: 'DashboardListOfCompanies';
  companyId: Scalars['HashedId']['output'];
  companyName: Scalars['String']['output'];
  countries: Array<Country>;
  rolesOnCompany: Array<RoleName>;
};

export type DashboardWorkforceCountersDto = {
  __typename?: 'DashboardWorkforceCountersDTO';
  companyId: Scalars['HashedId']['output'];
  totalEmployees: Scalars['Int']['output'];
  workforceMovementCounters: Array<WorkforceMovementCounters>;
};

export type DeleteOk = {
  __typename?: 'DeleteOk';
  id: Scalars['HashedId']['output'];
};

export type DraftScoreGoalInput = {
  id?: InputMaybe<Scalars['HashedId']['input']>;
  resultEvaluation: Scalars['Float']['input'];
  viewId: ScoreGoalType;
};

export type DraftScoreGridInput = {
  id?: InputMaybe<Scalars['HashedId']['input']>;
  scoreGoals: Array<DraftScoreGoalInput>;
};

export type Education = {
  __typename?: 'Education';
  country?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  employeeId: Scalars['HashedId']['output'];
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['HashedId']['output'];
  isHighestEducation?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  officialDegreeName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  university?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type EmbeddedBusinessUnit = {
  __typename?: 'EmbeddedBusinessUnit';
  id: Scalars['HashedId']['output'];
  name: Scalars['String']['output'];
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  contactRelationship: Scalars['String']['output'];
  contactType: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['HashedId']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Employee = {
  __typename?: 'Employee';
  academicTitle?: Maybe<Scalars['String']['output']>;
  address: Array<EmployeeAddress>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<InternationalBankAccount>;
  branchOffice: BranchOffice;
  branchOfficeId: Scalars['HashedId']['output'];
  businessPartnerOfCompanies?: Maybe<Array<BusinessPartnerOfCompany>>;
  businessUnit: BusinessUnit;
  businessUnitId: Scalars['HashedId']['output'];
  careerPath?: Maybe<Array<CareerPathDto>>;
  careerPathEvaluation?: Maybe<CareerPathEvaluation>;
  changes: Array<Change>;
  chosenFirstName?: Maybe<Scalars['String']['output']>;
  chosenLastName?: Maybe<Scalars['String']['output']>;
  citizenships: Array<Citizenship>;
  contracts?: Maybe<Array<Contract>>;
  currentContract?: Maybe<Contract>;
  currentEmployeeLevel?: Maybe<Scalars['String']['output']>;
  dateOfBirth: Scalars['DateTime']['output'];
  editable?: Maybe<Scalars['Boolean']['output']>;
  education: Array<Education>;
  email: Scalars['String']['output'];
  emergencyContacts: Array<EmergencyContact>;
  employeeRankings: Array<EmployeeRanking>;
  employmentStatus: Scalars['String']['output'];
  forcedMeetings: Array<Meeting>;
  gender: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  legalFirstName: Scalars['String']['output'];
  legalLastName: Scalars['String']['output'];
  managerMeetings: Array<Meeting>;
  managerOfBusinessUnits?: Maybe<Array<ManagerOfBusinessUnit>>;
  managerOfClusters?: Maybe<Array<ManagerOfCluster>>;
  managerOfCompanies?: Maybe<Array<ManagerOfCompany>>;
  managerOfNetworks?: Maybe<Array<ManagerOfNetwork>>;
  meetings: Array<Meeting>;
  partnerMeetings: Array<Meeting>;
  privateEmailAddress?: Maybe<Scalars['String']['output']>;
  replyEntryDate: Scalars['DateTime']['output'];
  replyerGrids: Array<ScoreGrid>;
  reviewerOf?: Maybe<Array<ReviewerOfEmployees>>;
  reviewers?: Maybe<Array<ReviewerOfEmployees>>;
  selfReflection?: Maybe<Array<SelfreflectionQuestion>>;
  skillCenterUrl?: Maybe<Scalars['String']['output']>;
  subordinates?: Maybe<Array<Employee>>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  userId: Scalars['HashedId']['output'];
  username: Scalars['String']['output'];
};

export type EmployeeAddress = {
  __typename?: 'EmployeeAddress';
  address?: Maybe<InternationalAddress>;
  addressId?: Maybe<Scalars['HashedId']['output']>;
  employeeId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeAndAppraisalMeetings = {
  __typename?: 'EmployeeAndAppraisalMeetings';
  appraisal?: Maybe<AppraisalDisplayInfo>;
  branchOfficeCode?: Maybe<Scalars['String']['output']>;
  country: Country;
  employee: EmployeeDisplayShortWithBuManager;
  id: Scalars['HashedId']['output'];
  mandatory: Scalars['Boolean']['output'];
  meetingToDoInCurrentAppraisalSeason: Scalars['Boolean']['output'];
  skillStatus?: Maybe<SkillEmployeeStatusDto>;
  status: MeetingInvitationStatus;
};

export type EmployeeAndTag = {
  __typename?: 'EmployeeAndTag';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currentLevel?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  tags: Array<EmployeeTagDto>;
};

export type EmployeeCloseMeetingInput = {
  employeeId: Scalars['HashedId']['input'];
  feedbackForHR?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['HashedId']['input'];
  meetingStatus: MeetingStatus;
};

export type EmployeeConfirmPreparationInput = {
  evaluationShared?: InputMaybe<Scalars['Boolean']['input']>;
  selfReflectionShared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployeeDisplayShortInfo = {
  __typename?: 'EmployeeDisplayShortInfo';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currentLevel?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
};

export type EmployeeDisplayShortInfoMeetingInvite = {
  __typename?: 'EmployeeDisplayShortInfoMeetingInvite';
  employees: Array<EmployeeDisplayShortInfo>;
  queriedBy: Scalars['String']['output'];
};

/** Extends the EmployeeDisplayShortInfo by information on the employees last meeting */
export type EmployeeDisplayShortInfoWithLastMeeting = {
  __typename?: 'EmployeeDisplayShortInfoWithLastMeeting';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currentLevel?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  /** last meeting completed with the employee */
  lastCompletedMeeting?: Maybe<MeetingTiny>;
  lastName: Scalars['String']['output'];
};

export type EmployeeDisplayShortWithBuManager = {
  __typename?: 'EmployeeDisplayShortWithBuManager';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currentLevel?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  managers?: Maybe<Array<EmployeeDisplayTinyInfo>>;
};

export type EmployeeDisplayTinyInfo = {
  __typename?: 'EmployeeDisplayTinyInfo';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
};

export type EmployeeEmploymentStatusDto = {
  __typename?: 'EmployeeEmploymentStatusDTO';
  currentBonusAfterFirstJanuary: Scalars['Boolean']['output'];
  futureChangesForeseenByContract: Scalars['Boolean']['output'];
  openChanges: Scalars['Boolean']['output'];
};

/** All possible employee levels */
export enum EmployeeLevelEnum {
  Ap = 'AP',
  Bo = 'BO',
  C = 'C',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  Co = 'CO',
  D = 'D',
  Ep = 'EP',
  L = 'L',
  Lead = 'LEAD',
  Leaver = 'LEAVER',
  M = 'M',
  None = 'NONE',
  Nrl = 'NRL',
  P = 'P',
  Pcm = 'PCM',
  Pm = 'PM',
  Pr = 'PR',
  Pro = 'PRO',
  Sc = 'SC',
  Sc1 = 'SC1',
  Sc2 = 'SC2',
  Sm = 'SM',
  Sp = 'SP',
  Spr = 'SPR'
}

export type EmployeeLevelWithDisplayOrder = {
  __typename?: 'EmployeeLevelWithDisplayOrder';
  displayOrder: Scalars['Int']['output'];
  level: EmployeeLevelEnum;
};

/** All level sets */
export enum EmployeeLevelsSets {
  AllLevels = 'ALL_LEVELS',
  DeuLevels = 'DEU_LEVELS',
  ItaLevels = 'ITA_LEVELS',
  R3Levels = 'R3_LEVELS'
}

export type EmployeeNameSearchInfo = {
  __typename?: 'EmployeeNameSearchInfo';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  chosenFirstName?: Maybe<Scalars['String']['output']>;
  chosenLastName?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  legalFirstName: Scalars['String']['output'];
  legalLastName: Scalars['String']['output'];
};

/** an employee currently on probation */
export type EmployeeOnProbation = {
  __typename?: 'EmployeeOnProbation';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currentLevel?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  /** true if the employee is currently in the second half of his probation period */
  inSecondHalfOfProbationPeriod: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** the end date of the employees probation period */
  probationEndDate: Scalars['DateTime']['output'];
  timezone: Scalars['String']['output'];
};

export type EmployeeRankDto = {
  __typename?: 'EmployeeRankDTO';
  companyName: Scalars['String']['output'];
  employeeId: Scalars['HashedId']['output'];
  rank: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EmployeeRanking = {
  __typename?: 'EmployeeRanking';
  companyRanking: CompanyRanking;
  employee: Employee;
  exclusion: Scalars['Boolean']['output'];
  exclusionReason?: Maybe<Scalars['String']['output']>;
  flag: RankingLevel;
  id: Scalars['HashedId']['output'];
  rang?: Maybe<Scalars['Int']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** DTO used for employee search in navigation and in search-results page */
export type EmployeeSearch = {
  __typename?: 'EmployeeSearch';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  businessUnitName: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  contractLevel: EmployeeLevelEnum;
  contractValidTo?: Maybe<Scalars['DateTime']['output']>;
  employmentStatus: EmploymentStatus;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  replyEntryDate: Scalars['DateTime']['output'];
};

export type EmployeeSubordinateDto = {
  __typename?: 'EmployeeSubordinateDTO';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  branchOfficeCode?: Maybe<Scalars['String']['output']>;
  businessUnit: BusinessUnit;
  careerPath?: Maybe<Array<CareerPathDto>>;
  careerPathEvaluation?: Maybe<CareerPathEvaluation>;
  companyName: Scalars['String']['output'];
  contractLevel: EmployeeLevelEnum;
  contractValidTo?: Maybe<Scalars['DateTime']['output']>;
  country: Country;
  currencyForPayments: Currency;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  replyEntryDate: Scalars['DateTime']['output'];
  resultScore?: Maybe<Scalars['Float']['output']>;
  salary?: Maybe<Salary>;
  skillStatus?: Maybe<SkillEmployeeStatusDto>;
  targetBonus?: Maybe<TargetBonus>;
  timezone: Scalars['String']['output'];
};

export type EmployeeTagDto = {
  __typename?: 'EmployeeTagDto';
  /** timestamp with time zone */
  addedDate: Scalars['DateTime']['output'];
  globalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['HashedId']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** timestamp with time zone */
  removedDate?: Maybe<Scalars['DateTime']['output']>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

export type EmployeeTagInfo = {
  __typename?: 'EmployeeTagInfo';
  addedBy?: Maybe<EmployeeDisplayTinyInfo>;
  addedDate: Scalars['DateTime']['output'];
  employee: EmployeeDisplayTinyInfo;
  id: Scalars['HashedId']['output'];
  note?: Maybe<Scalars['String']['output']>;
  removedBy?: Maybe<EmployeeDisplayTinyInfo>;
  removedDate?: Maybe<Scalars['DateTime']['output']>;
  type: EmployeeTagType;
};

export type EmployeeTagInfoShort = {
  __typename?: 'EmployeeTagInfoShort';
  addedById?: Maybe<Scalars['HashedId']['output']>;
  addedDate: Scalars['DateTime']['output'];
  employeeId: Scalars['HashedId']['output'];
  id: Scalars['HashedId']['output'];
  note?: Maybe<Scalars['String']['output']>;
  removedById?: Maybe<Scalars['HashedId']['output']>;
  removedDate?: Maybe<Scalars['DateTime']['output']>;
  type: EmployeeTagType;
};

export type EmployeeTagInfoTiny = {
  __typename?: 'EmployeeTagInfoTiny';
  addedDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  note?: Maybe<Scalars['String']['output']>;
  removedDate?: Maybe<Scalars['DateTime']['output']>;
  type: EmployeeTagType;
};

/** All possible tags a employee can be described with */
export enum EmployeeTagType {
  Coach = 'COACH',
  EntryLevelLow = 'ENTRY_LEVEL_LOW',
  Expert = 'EXPERT',
  ImpactOfLossCritical = 'IMPACT_OF_LOSS_CRITICAL',
  ImpactOfLossMinor = 'IMPACT_OF_LOSS_MINOR',
  ImpactOfLossModerate = 'IMPACT_OF_LOSS_MODERATE',
  ImpactOfLossSignificant = 'IMPACT_OF_LOSS_SIGNIFICANT',
  Leaver = 'LEAVER',
  Limited = 'LIMITED',
  Low = 'LOW',
  RiskOfLossHigh = 'RISK_OF_LOSS_HIGH',
  RiskOfLossLow = 'RISK_OF_LOSS_LOW',
  RiskOfLossMedium = 'RISK_OF_LOSS_MEDIUM',
  RiskOfLossVeryHigh = 'RISK_OF_LOSS_VERY_HIGH',
  Sales = 'SALES',
  Speaker = 'SPEAKER',
  Top = 'TOP'
}

/** an employee with a target bonus */
export type EmployeeWithBonus = {
  __typename?: 'EmployeeWithBonus';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  /** the currency for the targetBonus and the objectiveAmount */
  currency: Currency;
  currentLevel?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  /** the sum of money distributed across the employees objectives */
  objectiveAmount: Scalars['Float']['output'];
  /** the target bonus for the employee based on his current contract */
  targetBonus: Scalars['Float']['output'];
};

export type EmployeeWithBusinessUnit = {
  __typename?: 'EmployeeWithBusinessUnit';
  businessUnit: EmbeddedBusinessUnit;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
};

/** Employee with an ending contract */
export type EmployeeWithEndingContract = {
  __typename?: 'EmployeeWithEndingContract';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currentLevel?: Maybe<Scalars['String']['output']>;
  /** end date of contract */
  endOfContract?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type EmployeeWithLatestAndDraftEvaluation = {
  __typename?: 'EmployeeWithLatestAndDraftEvaluation';
  businessUnit: BusinessUnitTiny;
  draftEvaluation?: Maybe<Scalars['Float']['output']>;
  employee: EmployeeDisplayShortInfo;
  existingDraftEvaluation: Scalars['Boolean']['output'];
  existingLatestEvaluation: Scalars['Boolean']['output'];
  globalId: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  latestEvaluation?: Maybe<Scalars['Float']['output']>;
  scoreGoals?: Maybe<Array<ScoreGoalDto>>;
  scoreGridStatus?: Maybe<ScoreGridStatus>;
};

export type EmployeeWithLevelDto = {
  __typename?: 'EmployeeWithLevelDTO';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  currentLevel: EmployeeLevelEnum;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
};

export type EmployeeWithRankAndTags = {
  __typename?: 'EmployeeWithRankAndTags';
  assessable: Scalars['Boolean']['output'];
  draftEvaluation?: Maybe<Scalars['Float']['output']>;
  employee: EmployeeDisplayShortInfo;
  evaluation?: Maybe<Scalars['Float']['output']>;
  evaluationMeetingId?: Maybe<Scalars['HashedId']['output']>;
  id: Scalars['HashedId']['output'];
  latestEvaluation?: Maybe<Scalars['Float']['output']>;
  previousCompanyRankData?: Maybe<EmployeeRankDto>;
  previousRank?: Maybe<Scalars['Int']['output']>;
  rank: Scalars['Int']['output'];
  tags: Array<EmployeeTagDto>;
};

export type EmployeeWithRankAndTagsForExcel = {
  __typename?: 'EmployeeWithRankAndTagsForExcel';
  assessable: Scalars['Boolean']['output'];
  draftEvaluation?: Maybe<Scalars['Float']['output']>;
  employee: EmployeeDisplayShortInfo;
  evaluation?: Maybe<Scalars['Float']['output']>;
  evaluationMeetingId?: Maybe<Scalars['HashedId']['output']>;
  id: Scalars['HashedId']['output'];
  latestEvaluation?: Maybe<Scalars['Float']['output']>;
  previousCompanyRankData?: Maybe<EmployeeRankDto>;
  previousRank?: Maybe<Scalars['Int']['output']>;
  rank: Scalars['Int']['output'];
  tags: Array<EmployeeTagDto>;
};

export type EmployeeWithRole = {
  __typename?: 'EmployeeWithRole';
  assignedTo: Array<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  buName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currentLevel?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hasDownloaderRole: Scalars['Boolean']['output'];
  hrRoleOfUser: Array<RoleOfUser>;
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
};

export type EmployeesWithWrongStatusOrMissingContractDto = {
  __typename?: 'EmployeesWithWrongStatusOrMissingContractDTO';
  businessUnitId: Scalars['HashedId']['output'];
  fullName: Scalars['String']['output'];
};

/** All possible employment statuses */
export enum EmploymentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pension = 'PENSION'
}

export type ExcelDataInput = {
  assessable: Scalars['Boolean']['input'];
  employeeId: Scalars['HashedId']['input'];
  rankingPosition?: InputMaybe<Scalars['Float']['input']>;
};

export type ExecutedPayment = {
  __typename?: 'ExecutedPayment';
  amount: Scalars['Float']['output'];
  contract: Contract;
  contractId: Scalars['HashedId']['output'];
  currency: Currency;
  id: Scalars['HashedId']['output'];
  paymentDate: Scalars['DateTime']['output'];
  referenceYear: Scalars['Float']['output'];
  type: ExecutedPaymentType;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ExecutedPaymentDto = {
  __typename?: 'ExecutedPaymentDTO';
  amount: Scalars['Float']['output'];
  currency: Currency;
  id: Scalars['HashedId']['output'];
  paymentDate: Scalars['DateTime']['output'];
  referenceYear: Scalars['Float']['output'];
  type: ExecutedPaymentType;
};

export type ExecutedPaymentHistoryDto = {
  __typename?: 'ExecutedPaymentHistoryDTO';
  executedPayments: Array<ExecutedPaymentDto>;
};

/** Which type of payment was executed */
export enum ExecutedPaymentType {
  CarAllowance = 'CAR_ALLOWANCE',
  OneOff = 'ONE_OFF',
  Raf = 'RAF',
  Retention = 'RETENTION',
  TargetBonus = 'TARGET_BONUS',
  TargetBonusPrepayment = 'TARGET_BONUS_PREPAYMENT',
  ValuableHours = 'VALUABLE_HOURS',
  VariableSalaryComponent = 'VARIABLE_SALARY_COMPONENT',
  Warrants = 'WARRANTS'
}

export type FeatureMaintenanceData = {
  __typename?: 'FeatureMaintenanceData';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FlatCompanyWithLegalEntitiesAndCountries = {
  __typename?: 'FlatCompanyWithLegalEntitiesAndCountries';
  companyId?: Maybe<Scalars['HashedId']['output']>;
  companyName: Scalars['String']['output'];
  country: Scalars['String']['output'];
  legalEntityId?: Maybe<Scalars['HashedId']['output']>;
  legalEntityName: Scalars['String']['output'];
  networkCode: Scalars['String']['output'];
  networkId?: Maybe<Scalars['HashedId']['output']>;
  networkName: Scalars['String']['output'];
};

/** All possible statuses of Bonus between annual bonus and prorata */
export enum FlexibleProrataBonusStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  DismissedPending = 'DismissedPending',
  Pending = 'Pending'
}

export type FullMeetingPreviewDto = {
  __typename?: 'FullMeetingPreviewDTO';
  contractChanges: Array<Change>;
  latestContract: LatestContractDto;
  meeting: Meeting;
  objectivePayment?: Maybe<ObjectivePayment>;
  objectives: Array<ObjectiveDto>;
  oneOffPayment?: Maybe<OneOffPayment>;
  salaryOfYear: Array<Salary>;
  scoreGrid?: Maybe<ScoreGridDto>;
  selfReflectionQuestions: Array<SelfreflectionQuestion>;
  targetBonusOfYear: Array<TargetBonus>;
  targetCorrectionPayment?: Maybe<TargetCorrectionPaymentDto>;
};

export type GecoProjectsInfo = {
  __typename?: 'GecoProjectsInfo';
  bookedTimeInPercent: Scalars['Float']['output'];
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
};

export type GovernmentJobTitle = {
  __typename?: 'GovernmentJobTitle';
  currency: Currency;
  department: Scalars['String']['output'];
  fromDate: Scalars['DateTime']['output'];
  hiringOffice: HiringOffice;
  id: Scalars['HashedId']['output'];
  level: EmployeeLevelEnum;
  monthlySalaryMaximum: Scalars['Float']['output'];
  monthlySalaryMinimum: Scalars['Float']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type GovernmentJobTitleTinyDto = {
  __typename?: 'GovernmentJobTitleTinyDTO';
  department: Scalars['String']['output'];
  hiringOfficeCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GovernmentJobTitleTinyInput = {
  department: Scalars['String']['input'];
  hiringOfficeCode: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type GroupedCompanyWithLegalEntitiesAndCountries = {
  __typename?: 'GroupedCompanyWithLegalEntitiesAndCountries';
  companyCountries: Array<GroupedLegalEntityWithCountry>;
  companyId?: Maybe<Scalars['HashedId']['output']>;
  companyName: Scalars['String']['output'];
};

export type GroupedLegalEntityWithCountry = {
  __typename?: 'GroupedLegalEntityWithCountry';
  country: Scalars['String']['output'];
  legalEntityId?: Maybe<Scalars['HashedId']['output']>;
  legalEntityName: Scalars['String']['output'];
  years?: Maybe<Array<Scalars['Int']['output']>>;
};

export type GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries = {
  __typename?: 'GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries';
  companies: Array<GroupedCompanyWithLegalEntitiesAndCountries>;
  networkId?: Maybe<Scalars['HashedId']['output']>;
  networkName: Scalars['String']['output'];
};

/** number of employees by happiness category */
export type HappinessLevel = {
  __typename?: 'HappinessLevel';
  /** number of employees that are happy */
  happy: Scalars['Int']['output'];
  /** number of employees that are nether happy nor unhappy */
  neutral: Scalars['Int']['output'];
  /** number of employees that are unhappy */
  unhappy: Scalars['Int']['output'];
  /** number of employees that are very happy */
  veryHappy: Scalars['Int']['output'];
  /** number of employees that are very unhappy */
  veryUnhappy: Scalars['Int']['output'];
};

export type HiringOffice = {
  __typename?: 'HiringOffice';
  code: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type HrManageMeetingInput = {
  hrDisputeComment?: InputMaybe<Scalars['String']['input']>;
  hrResult: MeetingHrFeedbackResult;
  meetingId: Scalars['HashedId']['input'];
};

export type HrSupportFeedbackTabFilter = {
  companyFromDate?: InputMaybe<Scalars['String']['input']>;
  companyToDate?: InputMaybe<Scalars['String']['input']>;
  employeeFromDate?: InputMaybe<Scalars['String']['input']>;
  employeeToDate?: InputMaybe<Scalars['String']['input']>;
  feedbackResolutions: Array<MeetingHrFeedbackResult>;
  meetingStatuses: Array<MeetingStatus>;
};

export type IdvWeightDto = {
  __typename?: 'IdvWeightDto';
  country: Country;
  level: EmployeeLevelEnum;
  value: ScoreGoalType;
  weight: Scalars['Int']['output'];
};

export type ImportNationalContractReferenceInput = {
  updates: Array<UpdateNationalContractReferenceInput>;
};

export type InternationalAddress = {
  __typename?: 'InternationalAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  branchOffice?: Maybe<BranchOffice>;
  country?: Maybe<Country>;
  employeeAddress?: Maybe<EmployeeAddress>;
  id: Scalars['HashedId']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  stateRegion?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  zipPostalCode?: Maybe<Scalars['String']['output']>;
};

export type InternationalBankAccount = {
  __typename?: 'InternationalBankAccount';
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber: Scalars['String']['output'];
  agency?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankSortCode?: Maybe<Scalars['String']['output']>;
  bicSwift?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['HashedId']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type KeyResultDto = {
  __typename?: 'KeyResultDTO';
  completed: Scalars['Boolean']['output'];
  globalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['HashedId']['output']>;
  text: Scalars['String']['output'];
};

export type KeyResultInput = {
  completed: Scalars['Boolean']['input'];
  globalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  text: Scalars['String']['input'];
};

export type KudosAppraisalInput = {
  appraisalSeasonYear: Scalars['Float']['input'];
  meetingType: MeetingType;
  pagination: KudosPaginationInput;
};

export type KudosByReplyerFilterInput = {
  employeeCompanyId?: InputMaybe<Scalars['HashedId']['input']>;
  employeeId?: InputMaybe<Scalars['HashedId']['input']>;
  pagination: KudosShowMoreInput;
};

export type KudosCompanyCountryVisibilityDto = {
  __typename?: 'KudosCompanyCountryVisibilityDTO';
  companyId: Scalars['HashedId']['output'];
  companyName: Scalars['String']['output'];
  country: Country;
  id: Scalars['HashedId']['output'];
  kudosEnabled: Scalars['Boolean']['output'];
};

export type KudosCompanyCountryVisibilityFilterInput = {
  companyId?: InputMaybe<Scalars['HashedId']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  pagination: KudosVisibilityShowMoreInput;
  status: KudosVisibilityStatusFilter;
};

export type KudosCompanyCountryVisibilityInput = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  kudosEnabled: Scalars['Boolean']['input'];
};

export type KudosCompanyCountryVisibilityShowMoreDto = {
  __typename?: 'KudosCompanyCountryVisibilityShowMoreDTO';
  hasMore: Scalars['Boolean']['output'];
  kudosCompanyCountryVisibilityList: Array<KudosCompanyCountryVisibilityDto>;
  nextOffset?: Maybe<Scalars['Int']['output']>;
};

export type KudosDto = {
  __typename?: 'KudosDTO';
  author?: Maybe<EmployeeDisplayShortInfo>;
  authorId: Scalars['HashedId']['output'];
  createdDate: Scalars['DateTime']['output'];
  deletable: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  employee?: Maybe<EmployeeDisplayShortInfo>;
  employeeId: Scalars['HashedId']['output'];
  id: Scalars['HashedId']['output'];
  type: KudosType;
};

export type KudosFilterInput = {
  authorId?: InputMaybe<Scalars['HashedId']['input']>;
  country?: InputMaybe<Country>;
  employeeCompanyId?: InputMaybe<Scalars['HashedId']['input']>;
  employeeId?: InputMaybe<Scalars['HashedId']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByMe?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: KudosShowMoreInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type KudosLegalEntityVisibilityDto = {
  __typename?: 'KudosLegalEntityVisibilityDTO';
  country: Country;
  id: Scalars['HashedId']['output'];
  kudosEnabled: Scalars['Boolean']['output'];
  legalEntityId: Scalars['HashedId']['output'];
  legalEntityName: Scalars['String']['output'];
};

export type KudosLegalEntityVisibilityFilterInput = {
  country?: InputMaybe<Country>;
  legalEntityId?: InputMaybe<Scalars['HashedId']['input']>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  pagination: KudosVisibilityShowMoreInput;
  status: KudosVisibilityStatusFilter;
};

export type KudosLegalEntityVisibilityInput = {
  kudosEnabled: Scalars['Boolean']['input'];
  legalEntityId: Scalars['HashedId']['input'];
};

export type KudosLegalEntityVisibilityShowMoreDto = {
  __typename?: 'KudosLegalEntityVisibilityShowMoreDTO';
  hasMore: Scalars['Boolean']['output'];
  kudosLegalEntityVisibilityList: Array<KudosLegalEntityVisibilityDto>;
  nextOffset?: Maybe<Scalars['Int']['output']>;
};

export type KudosPaginationDto = {
  __typename?: 'KudosPaginationDTO';
  currentPage: Scalars['Int']['output'];
  kudos: Array<KudosDto>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type KudosPaginationInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type KudosShowMoreDto = {
  __typename?: 'KudosShowMoreDTO';
  hasMore: Scalars['Boolean']['output'];
  kudos: Array<KudosDto>;
  nextOffset?: Maybe<Scalars['Int']['output']>;
};

export type KudosShowMoreInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/** Type of kudos */
export enum KudosType {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type KudosVisibilityShowMoreInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type KudosVisibilityStatusFilter = {
  kudosDisabled: Scalars['Boolean']['input'];
  kudosEnabled: Scalars['Boolean']['input'];
};

export type KudosWithVisibilityFlagDto = {
  __typename?: 'KudosWithVisibilityFlagDTO';
  employeeOptedOut: Scalars['Boolean']['output'];
  isKudosEnabled: Scalars['Boolean']['output'];
  kudosPagination: KudosPaginationDto;
};

export type LatestContractDto = {
  __typename?: 'LatestContractDTO';
  annualSalary?: Maybe<Salary>;
  cancellationFrom?: Maybe<Scalars['DateTime']['output']>;
  cancellationTo?: Maybe<Scalars['DateTime']['output']>;
  cancellationType?: Maybe<CancellationType>;
  companyCar?: Maybe<CompanyCar>;
  contractGovernmentJobTitle?: Maybe<ContractGovernmentJobTitle>;
  contractType: ContractType;
  currencyForPayments: Currency;
  employeeLevel?: Maybe<ContractEmployeeLevel>;
  executedPayments?: Maybe<Array<ExecutedPayment>>;
  flexibleBenefit?: Maybe<Scalars['Float']['output']>;
  hasNationalContract: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['HashedId']['output']>;
  isDeductionEnabled: Scalars['Boolean']['output'];
  isMonthlySalaryDisplayed: Scalars['Boolean']['output'];
  leaveEntitlement?: Maybe<LeaveEntitlement>;
  legalEntity: LegalEntity;
  monthlySalaryMonthsInYear: Scalars['Int']['output'];
  nationalContractLevel?: Maybe<NationalContractLevel>;
  nationalContractReferenceLevel?: Maybe<NationalContractReferenceDto>;
  probationPeriodEndDate?: Maybe<Scalars['DateTime']['output']>;
  targetBonus?: Maybe<TargetBonus>;
  updatesRestrictedTo?: Maybe<Scalars['DateTime']['output']>;
  validFrom: Scalars['DateTime']['output'];
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type LeaveEntitlement = {
  __typename?: 'LeaveEntitlement';
  amount: Scalars['Float']['output'];
  contract: Contract;
  contractId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Leavers = {
  __typename?: 'Leavers';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  businessUnit: BusinessUnitTiny;
  contractCancellationTo: Scalars['DateTime']['output'];
  contractCancellationType: CancellationType;
  contractType: ContractTypeEnum;
  contractValidFrom: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  leaverLevel: EmployeeLevelEnum;
};

export type LeaversByPeriod = {
  __typename?: 'LeaversByPeriod';
  currentMonth: Array<Leavers>;
  nextMonth: Array<Leavers>;
};

export type LegalEntity = {
  __typename?: 'LegalEntity';
  contracts?: Maybe<Array<Contract>>;
  country: Country;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type LegalEntityTiny = {
  __typename?: 'LegalEntityTiny';
  id: Scalars['HashedId']['output'];
  name: Scalars['String']['output'];
};

export type LocaleDto = {
  __typename?: 'LocaleDTO';
  country: Scalars['String']['output'];
  locale: Scalars['String']['output'];
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LogoutOk = {
  __typename?: 'LogoutOk';
  ok: Scalars['Boolean']['output'];
};

export type ManagedCompany = {
  __typename?: 'ManagedCompany';
  companyId: Scalars['HashedId']['output'];
  companyName: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
};

export type ManagerCloseMeetingInput = {
  additionalParticipants?: InputMaybe<Scalars['String']['input']>;
  displayDate: Scalars['DateTime']['input'];
  id: Scalars['HashedId']['input'];
  partnerId?: InputMaybe<Scalars['HashedId']['input']>;
};

export type ManagerOfBusinessUnit = {
  __typename?: 'ManagerOfBusinessUnit';
  businessUnit: Array<BusinessUnit>;
  businessUnitId: Scalars['HashedId']['output'];
  employee: Employee;
  employeeId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ManagerOfCluster = {
  __typename?: 'ManagerOfCluster';
  employee: Employee;
  employeeId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  network: Network;
  networkId: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ManagerOfCompany = {
  __typename?: 'ManagerOfCompany';
  company: Company;
  companyId: Scalars['HashedId']['output'];
  employee: Employee;
  employeeId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ManagerOfNetwork = {
  __typename?: 'ManagerOfNetwork';
  employee: Employee;
  employeeId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  network: Network;
  networkId: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ManagingUnits = {
  __typename?: 'ManagingUnits';
  companies?: Maybe<Array<Company>>;
  networks?: Maybe<Array<Network>>;
};

export type Meeting = {
  __typename?: 'Meeting';
  activeMeetingStep?: Maybe<MeetingStep>;
  activityListEnabled: Scalars['Boolean']['output'];
  additionalParticipants?: Maybe<Scalars['String']['output']>;
  allowedMonetaryTargets: AllowedMonetaryTargetsDto;
  appraisal?: Maybe<MeetingEmbedAppraisal>;
  appraisalSeason: AppraisalSeasonDto;
  conclusionPdfDownloadToken: Scalars['String']['output'];
  conclusionPdfFileName: Scalars['String']['output'];
  conclusionPdfStatus: MeetingPdfStatus;
  confirmationDate?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['DateTime']['output'];
  displayDate: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  employee: Employee;
  employeePreparationActiveStep?: Maybe<MeetingStep>;
  employeePreparationDate?: Maybe<Scalars['DateTime']['output']>;
  employeePrepared: Scalars['Boolean']['output'];
  forceConfirmationEmployee?: Maybe<EmployeeDisplayShortInfo>;
  forceConfirmationEmployeeId?: Maybe<Scalars['HashedId']['output']>;
  forceConfirmationReason?: Maybe<Scalars['String']['output']>;
  hasEvaluationScore: Scalars['Boolean']['output'];
  id: Scalars['HashedId']['output'];
  isLoggedUserCompanyManagerOfAppraisalSeasonCompany: Scalars['Boolean']['output'];
  isMigrated: Scalars['Boolean']['output'];
  isReplyerActive: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  managerConfirmationDate?: Maybe<Scalars['DateTime']['output']>;
  managerPreparationActiveStep?: Maybe<MeetingStep>;
  managerPrepared: Scalars['Boolean']['output'];
  meetingSteps?: Maybe<Array<MeetingStep>>;
  nextPaymentCycle: Scalars['DateTime']['output'];
  nonParticipants: Array<EmployeeWithBusinessUnit>;
  objectivePayment?: Maybe<ObjectivePayment>;
  oneOffPayment?: Maybe<OneOffPayment>;
  other?: Maybe<MeetingEmbedOther>;
  partner?: Maybe<Employee>;
  partnerId?: Maybe<Scalars['HashedId']['output']>;
  preparationPdfDownloadToken: Scalars['String']['output'];
  preparationPdfFileName: Scalars['String']['output'];
  preparationPdfStatus: Scalars['String']['output'];
  reasonForMeetingCancel?: Maybe<Scalars['String']['output']>;
  requiresSpecialHandlingOfLowTag: Scalars['Boolean']['output'];
  rescheduleNumber: Scalars['Int']['output'];
  reviewer?: Maybe<EmployeeDisplayShortInfo>;
  selfReflection?: Maybe<Array<SelfreflectionQuestion>>;
  selfReflectionAndEvaluationVisible: Scalars['Boolean']['output'];
  status: MeetingStatus;
  targetsCalculationHelper: TargetsCalculationHelperDto;
  type: MeetingType;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MeetingConclusionPdf = {
  __typename?: 'MeetingConclusionPdf';
  downloadToken: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  status: MeetingPdfStatus;
};

export type MeetingEmbedAppraisal = {
  __typename?: 'MeetingEmbedAppraisal';
  emailText?: Maybe<Scalars['String']['output']>;
  employeeGeneralFeedback?: Maybe<Scalars['String']['output']>;
  employeeSelfReflectionDev?: Maybe<Scalars['String']['output']>;
  employeeSelfReflectionDevScore?: Maybe<Scalars['Float']['output']>;
  employeeSelfReflectionPerf?: Maybe<Scalars['String']['output']>;
  employeeSelfReflectionPerfScore?: Maybe<Scalars['Float']['output']>;
  evaluationShared: Scalars['Boolean']['output'];
  feedbackForHR?: Maybe<Scalars['String']['output']>;
  hrDisputeComment?: Maybe<Scalars['String']['output']>;
  hrResult: Scalars['String']['output'];
  meetingGeneralFeedback?: Maybe<Scalars['String']['output']>;
  reasonForReducedSteps?: Maybe<Scalars['String']['output']>;
  reviewerGeneralFeedback?: Maybe<Scalars['String']['output']>;
  selfReflectionShared: Scalars['Boolean']['output'];
  shareWithHR: Scalars['Boolean']['output'];
  targetCommentsShared: Scalars['Boolean']['output'];
};

export type MeetingEmbedOther = {
  __typename?: 'MeetingEmbedOther';
  agenda?: Maybe<Scalars['String']['output']>;
  emailText?: Maybe<Scalars['String']['output']>;
  notesEmployee?: Maybe<Scalars['String']['output']>;
  notesManager?: Maybe<Scalars['String']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
};

/** All Meeting results hr can resolve after employee confirmation or dispute */
export enum MeetingHrFeedbackResult {
  AppraisalUpdate = 'AppraisalUpdate',
  KeepingChanges = 'KeepingChanges',
  NoResult = 'NoResult',
  Resolved = 'Resolved'
}

export type MeetingInput = {
  activeMeetingStep?: InputMaybe<MeetingStepInput>;
  appraisal?: InputMaybe<MeetingInputAppraisal>;
  date: Scalars['DateTime']['input'];
  displayDate: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  employeePrepared?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  managerPrepared?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<MeetingInputOther>;
  status?: InputMaybe<MeetingStatus>;
  type?: InputMaybe<MeetingType>;
};

export type MeetingInputAppraisal = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  employeeGeneralFeedback?: InputMaybe<Scalars['String']['input']>;
  employeeSelfReflectionPerf?: InputMaybe<Scalars['String']['input']>;
  employeeSelfReflectionPerfScore?: InputMaybe<Scalars['Float']['input']>;
  evaluationShared?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackForHR?: InputMaybe<Scalars['String']['input']>;
  hrDisputeComment?: InputMaybe<Scalars['String']['input']>;
  hrResult?: InputMaybe<MeetingHrFeedbackResult>;
  meetingGeneralFeedback?: InputMaybe<Scalars['String']['input']>;
  meetingStepView?: InputMaybe<Array<MeetingStepViewId>>;
  reviewerGeneralFeedback?: InputMaybe<Scalars['String']['input']>;
  selfReflectionShared?: InputMaybe<Scalars['Boolean']['input']>;
  shareWithHR?: InputMaybe<Scalars['Boolean']['input']>;
  targetCommentsShared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetingInputOther = {
  agenda?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  notesEmployee?: InputMaybe<Scalars['String']['input']>;
  notesManager?: InputMaybe<Scalars['String']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
};

export type MeetingInvitationStatus = {
  __typename?: 'MeetingInvitationStatus';
  name: Scalars['String']['output'];
  sortOrder: Scalars['String']['output'];
};

export type MeetingInviteInput = {
  additionalParticipantsIds: Array<Scalars['HashedId']['input']>;
  appraisalSeasonId: Scalars['HashedId']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['HashedId']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meetingAgenda?: InputMaybe<Scalars['String']['input']>;
  meetingDate: Scalars['String']['input'];
  meetingId?: InputMaybe<Scalars['HashedId']['input']>;
  meetingType?: InputMaybe<MeetingType>;
  reasonForReducedSteps?: InputMaybe<SkipMeetingStepReason>;
  reviewerId?: InputMaybe<Scalars['HashedId']['input']>;
  viewIds?: InputMaybe<Array<MeetingStepViewId>>;
};

export type MeetingInviteOptions = {
  __typename?: 'MeetingInviteOptions';
  possible: Array<MeetingType>;
};

export type MeetingInviteOptionsExtended = {
  __typename?: 'MeetingInviteOptionsExtended';
  isAppraisalEnabled: Scalars['Boolean']['output'];
  possible: Array<MeetingType>;
  tagAssignmentIsInProgress: Scalars['Boolean']['output'];
};

/** All possible meeting pdf statuses */
export enum MeetingPdfStatus {
  FinishedError = 'FinishedError',
  FinishedSuccess = 'FinishedSuccess',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

/** MeetingRequestDTO */
export type MeetingRequestDto = {
  __typename?: 'MeetingRequestDTO';
  appraisalSeason: AppraisalSeasonDto;
  /** ID */
  id: Scalars['HashedId']['output'];
  isRequestValid: Scalars['Boolean']['output'];
  meeting?: Maybe<MeetingTiny>;
  reasonForRequest: Scalars['String']['output'];
  reasonOfRejection?: Maybe<Scalars['String']['output']>;
  /** date time of the meetingRequest */
  requestedDate: Scalars['DateTime']['output'];
  requester: EmployeeDisplayTinyInfo;
  reviewer: EmployeeDisplayTinyInfo;
  status: MeetingRequestStatus;
  type: MeetingType;
};

/** MeetingRequestStatus types. */
export enum MeetingRequestStatus {
  Accepted = 'Accepted',
  Declined = 'Declined',
  Requested = 'Requested',
  Withdrawn = 'Withdrawn'
}

/** All Meeting statuses */
export enum MeetingStatus {
  Canceled = 'Canceled',
  Confirmed = 'Confirmed',
  DisputedConfirmed = 'DisputedConfirmed',
  Draft = 'Draft',
  PendingConfirmation = 'PendingConfirmation',
  Prepared = 'Prepared'
}

export type MeetingStep = {
  __typename?: 'MeetingStep';
  id: Scalars['HashedId']['output'];
  meeting?: Maybe<Meeting>;
  position: Scalars['Int']['output'];
  status: MeetingStepStatus;
  type: MeetingStepType;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  viewId: MeetingStepViewId;
};

export type MeetingStepInput = {
  id?: InputMaybe<Scalars['HashedId']['input']>;
  status?: InputMaybe<MeetingStepStatus>;
};

/** All possible meeting steps status */
export enum MeetingStepStatus {
  Current = 'Current',
  Done = 'Done',
  Incomplete = 'Incomplete',
  Todo = 'Todo',
  Visited = 'Visited'
}

/** Meeting step types. Possible values are Meeting, EmployeePrep or ManagerPrep */
export enum MeetingStepType {
  EmployeePrep = 'EmployeePrep',
  ManagerPrep = 'ManagerPrep',
  Meeting = 'Meeting'
}

/** All possible meeting steps */
export enum MeetingStepViewId {
  Conclusion = 'Conclusion',
  ContractChanges = 'ContractChanges',
  DevelopmentAndTargets = 'DevelopmentAndTargets',
  Evaluation = 'Evaluation',
  Feedback = 'Feedback',
  Intro = 'Intro',
  MeetingNotes = 'MeetingNotes',
  NewTargets = 'NewTargets',
  Notes = 'Notes',
  OtherFeedback = 'OtherFeedback',
  PastTargets = 'PastTargets',
  Payments = 'Payments',
  SelfReflection = 'SelfReflection'
}

/** most reduced version of a meeting */
export type MeetingTiny = {
  __typename?: 'MeetingTiny';
  /** date time of the meeting */
  date: Scalars['DateTime']['output'];
  /** ID of the meeting */
  id: Scalars['HashedId']['output'];
};

/** Meeting types. */
export enum MeetingType {
  Appraisal = 'Appraisal',
  AppraisalUpdate = 'AppraisalUpdate',
  OtherGeneric = 'OtherGeneric',
  OtherProbationTalk = 'OtherProbationTalk',
  OtherProjectFeedback = 'OtherProjectFeedback'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptRequestedMeeting: MeetingRequestDto;
  addDownloaderRoleToEmployee: Array<Scalars['Int']['output']>;
  addEmployeeTag: EmployeeTagInfoShort;
  addEntryLevelLowTag: EmployeeTagInfoShort;
  addHrRoleToEmployee: Array<Scalars['Int']['output']>;
  cancelMeeting: Scalars['HashedId']['output'];
  changeLocale: Scalars['Boolean']['output'];
  changeNameDisplayPreference: Scalars['Boolean']['output'];
  changeTimezone: Scalars['Boolean']['output'];
  closeOutdatedTargets: Scalars['Boolean']['output'];
  confirmRankingSeason: Scalars['Boolean']['output'];
  confirmTagAssignmentForCompanyCountry: Scalars['Boolean']['output'];
  createAttentionPoint: Scalars['Boolean']['output'];
  createCompanyRanking: Scalars['Boolean']['output'];
  createHRBPRelation: Scalars['Boolean']['output'];
  createKudos: Scalars['Boolean']['output'];
  createOrUpdateChange: CreateChangeResponse;
  createOrUpdateDraftScoreGrid: Scalars['Boolean']['output'];
  createOrUpdateObjectivePayment: ObjectivePayment;
  createOrUpdateOneOffPayment?: Maybe<OneOffPayment>;
  createOrUpdateTargetCorrectionPayment?: Maybe<TargetCorrectionPaymentDto>;
  createReviewerOfEmployee: ReviewerOfEmployees;
  createZipWithSelectedRankingReports: Scalars['Boolean']['output'];
  declineRequestedMeeting: MeetingRequestDto;
  deleteAttentionPoint: Scalars['Boolean']['output'];
  deleteChange: DeleteOk;
  deleteHRBPRelation: Scalars['Boolean']['output'];
  deleteKudos: Scalars['Boolean']['output'];
  deleteKudosCompanyCountryVisibility: Scalars['Boolean']['output'];
  deleteObjectiveInMeeting: Scalars['Boolean']['output'];
  deleteOneOffPayment: Scalars['Int']['output'];
  deleteReferencedPyramids: DeleteOk;
  deleteReviewerOfEmployee: Scalars['Boolean']['output'];
  deleteTargetCorrectionPayment: DeleteOk;
  deleteTargetTemplate: Scalars['Boolean']['output'];
  disableRankingSeasonForCompanyCountry: Scalars['Boolean']['output'];
  dismissObjectiveInMeeting: Scalars['HashedId']['output'];
  duplicateAndDismissObjectiveInMeeting: Scalars['Boolean']['output'];
  duplicateObjectiveInMeeting: Scalars['Boolean']['output'];
  duplicateTargetTemplate: Scalars['Boolean']['output'];
  editFlexibleBonusByEmployeeId: Scalars['Boolean']['output'];
  employeeCloseMeeting: Meeting;
  employeeConfirmPreparation: Meeting;
  enableRankingSeasonForCompanyCountry: Scalars['Boolean']['output'];
  generateRankingReport: Scalars['Boolean']['output'];
  generateTargetReportRequest: TargetReportGenerationRequestDto;
  hrManageMeeting: Meeting;
  importScoreGrids: Scalars['Boolean']['output'];
  importSelectableNationalContractReferenceLevels: Array<NationalContractReferenceWithTypeDto>;
  inviteToAppraisalMeeting: Meeting;
  login?: Maybe<AuthPayload>;
  logout?: Maybe<LogoutOk>;
  managerCloseMeeting: Meeting;
  managerConfirmPreparation: Meeting;
  managerForceMeetingConfirmation: Scalars['Boolean']['output'];
  otherMeetingConfirmAsManager: Meeting;
  otherMeetingFinishPreparation: Meeting;
  otherMeetingInvite: Meeting;
  reactiveObjectiveInMeeting: Scalars['HashedId']['output'];
  refreshEmployeeSkillStatus: Scalars['Boolean']['output'];
  refreshEmployeesOfBUSkillStatuses: Scalars['Boolean']['output'];
  refreshEmployeesOfCompanySkillStatuses: Scalars['Boolean']['output'];
  refreshMySkillStatus: Scalars['Boolean']['output'];
  refreshSubordinatesOfCompanySkillStatuses: Scalars['Boolean']['output'];
  refreshSubordinatesSkillStatuses: Scalars['Boolean']['output'];
  removeDownloaderRoleFromEmployee: Scalars['Int']['output'];
  removeEmployeeTag: EmployeeTagInfoShort;
  removeHrRoleFromEmployee: Scalars['Int']['output'];
  requestMeetingAsEmployee: MeetingRequestDto;
  rescheduleMeeting: Scalars['Boolean']['output'];
  saveObjective: ObjectiveDto;
  saveObjectiveInMeeting: ObjectiveDto;
  savePyramidForecast: Array<PyramidForecastDto>;
  saveRanking: Scalars['Boolean']['output'];
  saveScoreGrid: ScoreGridDto;
  saveTargetBonusAmountDistribution: Scalars['Boolean']['output'];
  saveTargetTemplate: Scalars['Boolean']['output'];
  sendSkillStatusUpdateReminderEmail: Scalars['Boolean']['output'];
  setCutoffDayForCountry: Scalars['Boolean']['output'];
  setDisableRankingForCompanyCountry: Scalars['Boolean']['output'];
  setIsTagAssignmentInProgressForCompanyCountry: Scalars['Boolean']['output'];
  setKudosCompanyCountryVisibility: Scalars['Boolean']['output'];
  setKudosLegalEntityVisibility: Scalars['Boolean']['output'];
  setLowPercentageForCompanyCountry: Scalars['Boolean']['output'];
  setLowPercentageIsBlockerForCompanyCountry: Scalars['Boolean']['output'];
  setNextAppraisalSeasonOpeningDate: Scalars['Boolean']['output'];
  setNextMeetingStep: Meeting;
  setTopPercentageForCompanyCountry: Scalars['Boolean']['output'];
  takeOver: Meeting;
  updateEmployeeOptOutValue: Scalars['Boolean']['output'];
  updateMeetingFeedback: Meeting;
  updateMeetingNotes: Scalars['Boolean']['output'];
  updateMeetingStep: MeetingStep;
  updateMyOptOutValue: Scalars['Boolean']['output'];
  updateOnboardingDate: Scalars['Boolean']['output'];
  updateRankingSeason: Scalars['Boolean']['output'];
  updateReferencedPyramids: ReferencePyramid;
  updateSelectableNationalContractReferenceLevels: NationalContractReferenceWithTypeDto;
  updateSelfreflectionQuestion: SelfreflectionQuestion;
  updateSelfreflectionQuestionBoolean: SelfreflectionQuestionBoolean;
  uploadObjectiveAttachment: Scalars['String']['output'];
  withdrawRequestedMeeting: DeleteOk;
};


export type MutationAcceptRequestedMeetingArgs = {
  meetingInput: MeetingInviteInput;
  requestedMeetingId: Scalars['HashedId']['input'];
};


export type MutationAddDownloaderRoleToEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type MutationAddEmployeeTagArgs = {
  employeeId: Scalars['HashedId']['input'];
  type: EmployeeTagType;
};


export type MutationAddEntryLevelLowTagArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type MutationAddHrRoleToEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
  hrVisibilityExcluded: Scalars['Boolean']['input'];
  roleName: Scalars['String']['input'];
};


export type MutationCancelMeetingArgs = {
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
  reasonForMeetingCancel: Scalars['String']['input'];
};


export type MutationChangeLocaleArgs = {
  employeeId: Scalars['HashedId']['input'];
  locale: Scalars['String']['input'];
};


export type MutationChangeNameDisplayPreferenceArgs = {
  employeeId: Scalars['HashedId']['input'];
  nameDisplayPreference: Scalars['String']['input'];
};


export type MutationChangeTimezoneArgs = {
  employeeId: Scalars['HashedId']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationCloseOutdatedTargetsArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type MutationConfirmRankingSeasonArgs = {
  talentsSeasonId: Scalars['HashedId']['input'];
};


export type MutationConfirmTagAssignmentForCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
};


export type MutationCreateAttentionPointArgs = {
  description: Scalars['String']['input'];
  employeeId: Scalars['HashedId']['input'];
};


export type MutationCreateCompanyRankingArgs = {
  companyId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
};


export type MutationCreateHrbpRelationArgs = {
  companyIds: Array<Scalars['HashedId']['input']>;
  employeeId: Scalars['HashedId']['input'];
};


export type MutationCreateKudosArgs = {
  description: Scalars['String']['input'];
  employeeId: Scalars['HashedId']['input'];
};


export type MutationCreateOrUpdateChangeArgs = {
  change: ChangeInput;
  employeeId: Scalars['HashedId']['input'];
};


export type MutationCreateOrUpdateDraftScoreGridArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  draftScoreGridInput: DraftScoreGridInput;
  employeeId: Scalars['HashedId']['input'];
};


export type MutationCreateOrUpdateObjectivePaymentArgs = {
  objectivePayment: ObjectivePaymentInput;
};


export type MutationCreateOrUpdateOneOffPaymentArgs = {
  oneOffPayment: OneOffPaymentInput;
};


export type MutationCreateOrUpdateTargetCorrectionPaymentArgs = {
  targetCorrectionPayment: TargetCorrectionPaymentInput;
};


export type MutationCreateReviewerOfEmployeeArgs = {
  revEmpInput: ReviewerOfEmployeesInput;
};


export type MutationCreateZipWithSelectedRankingReportsArgs = {
  reportIds: Array<Scalars['HashedId']['input']>;
};


export type MutationDeclineRequestedMeetingArgs = {
  reasonOfRejection: Scalars['String']['input'];
  requestedMeetingId: Scalars['HashedId']['input'];
};


export type MutationDeleteAttentionPointArgs = {
  attentionPointId: Scalars['HashedId']['input'];
};


export type MutationDeleteChangeArgs = {
  changeId: Scalars['HashedId']['input'];
  employeeId: Scalars['HashedId']['input'];
};


export type MutationDeleteHrbpRelationArgs = {
  id: Scalars['HashedId']['input'];
};


export type MutationDeleteKudosArgs = {
  kudosId: Scalars['HashedId']['input'];
};


export type MutationDeleteKudosCompanyCountryVisibilityArgs = {
  kudosCompanyCountryVisibilityId: Scalars['HashedId']['input'];
};


export type MutationDeleteObjectiveInMeetingArgs = {
  globalId: Scalars['String']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type MutationDeleteOneOffPaymentArgs = {
  oneOffPaymentId: Scalars['HashedId']['input'];
};


export type MutationDeleteReferencedPyramidsArgs = {
  companyId: Scalars['HashedId']['input'];
  referencePyramidId: Scalars['HashedId']['input'];
};


export type MutationDeleteReviewerOfEmployeeArgs = {
  relationId: Scalars['HashedId']['input'];
};


export type MutationDeleteTargetCorrectionPaymentArgs = {
  targetCorrectionPaymentId: Scalars['HashedId']['input'];
};


export type MutationDeleteTargetTemplateArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  objectiveId: Scalars['HashedId']['input'];
};


export type MutationDisableRankingSeasonForCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type MutationDismissObjectiveInMeetingArgs = {
  id: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type MutationDuplicateAndDismissObjectiveInMeetingArgs = {
  meetingId: Scalars['HashedId']['input'];
  objective: ObjectiveInput;
};


export type MutationDuplicateObjectiveInMeetingArgs = {
  globalId: Scalars['String']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type MutationDuplicateTargetTemplateArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  objectiveId: Scalars['HashedId']['input'];
};


export type MutationEditFlexibleBonusByEmployeeIdArgs = {
  bonusAmount: Scalars['Float']['input'];
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type MutationEmployeeCloseMeetingArgs = {
  closeMeetingInput: EmployeeCloseMeetingInput;
};


export type MutationEmployeeConfirmPreparationArgs = {
  input: EmployeeConfirmPreparationInput;
  meetingId: Scalars['HashedId']['input'];
};


export type MutationEnableRankingSeasonForCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type MutationGenerateRankingReportArgs = {
  reportId: Scalars['HashedId']['input'];
};


export type MutationGenerateTargetReportRequestArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type MutationHrManageMeetingArgs = {
  hrManageMeetingInput: HrManageMeetingInput;
};


export type MutationImportScoreGridsArgs = {
  buIds: Array<Scalars['HashedId']['input']>;
  companyId: Scalars['HashedId']['input'];
  country: Country;
  excelData: Array<ScoreGridExcelDataInput>;
};


export type MutationImportSelectableNationalContractReferenceLevelsArgs = {
  input: ImportNationalContractReferenceInput;
};


export type MutationInviteToAppraisalMeetingArgs = {
  meetingInput: MeetingInviteInput;
};


export type MutationLoginArgs = {
  user: LoginInput;
};


export type MutationLogoutArgs = {
  doLogout: Scalars['Boolean']['input'];
};


export type MutationManagerCloseMeetingArgs = {
  closeMeetingInput: ManagerCloseMeetingInput;
};


export type MutationManagerConfirmPreparationArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type MutationManagerForceMeetingConfirmationArgs = {
  meetingId: Scalars['HashedId']['input'];
  reason: Scalars['String']['input'];
};


export type MutationOtherMeetingConfirmAsManagerArgs = {
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
  protocol: Scalars['String']['input'];
  reviewerEmployeeId: Scalars['HashedId']['input'];
};


export type MutationOtherMeetingFinishPreparationArgs = {
  asManager: Scalars['Boolean']['input'];
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
  notes: Scalars['String']['input'];
  reviewerEmployeeId: Scalars['HashedId']['input'];
};


export type MutationOtherMeetingInviteArgs = {
  meetingInput: MeetingInviteInput;
};


export type MutationReactiveObjectiveInMeetingArgs = {
  id: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type MutationRefreshEmployeeSkillStatusArgs = {
  id: Scalars['HashedId']['input'];
};


export type MutationRefreshEmployeesOfBuSkillStatusesArgs = {
  businessUnitId: Scalars['HashedId']['input'];
};


export type MutationRefreshEmployeesOfCompanySkillStatusesArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type MutationRefreshMySkillStatusArgs = {
  id: Scalars['HashedId']['input'];
};


export type MutationRefreshSubordinatesOfCompanySkillStatusesArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type MutationRefreshSubordinatesSkillStatusesArgs = {
  buId?: InputMaybe<Scalars['HashedId']['input']>;
  companyId: Scalars['HashedId']['input'];
  reviewer: Scalars['Boolean']['input'];
};


export type MutationRemoveDownloaderRoleFromEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type MutationRemoveEmployeeTagArgs = {
  removeEmployeeTagInput: RemoveEmployeeTagInput;
};


export type MutationRemoveHrRoleFromEmployeeArgs = {
  countryRoleName: Scalars['String']['input'];
  employeeId: Scalars['HashedId']['input'];
  roleIds: Array<Scalars['HashedId']['input']>;
};


export type MutationRequestMeetingAsEmployeeArgs = {
  meetingReason: Scalars['String']['input'];
  meetingType: MeetingType;
  requesterId: Scalars['HashedId']['input'];
  reviewerId: Scalars['HashedId']['input'];
};


export type MutationRescheduleMeetingArgs = {
  rescheduleInput: RescheduleMeetingInput;
};


export type MutationSaveObjectiveArgs = {
  employeeId: Scalars['HashedId']['input'];
  objective: ObjectiveInput;
};


export type MutationSaveObjectiveInMeetingArgs = {
  meetingId: Scalars['HashedId']['input'];
  objective: ObjectiveInput;
};


export type MutationSavePyramidForecastArgs = {
  companyId: Scalars['HashedId']['input'];
  pyramidForecasts: Array<PyramidForecastInput>;
};


export type MutationSaveRankingArgs = {
  companyId: Scalars['HashedId']['input'];
  ranks: Array<RankInput>;
  talentsSeasonId: Scalars['HashedId']['input'];
};


export type MutationSaveScoreGridArgs = {
  grid: ScoreGridInput;
  meetingId: Scalars['HashedId']['input'];
};


export type MutationSaveTargetBonusAmountDistributionArgs = {
  meetingId: Scalars['HashedId']['input'];
  objectivesDistributedAmountInput: Array<ObjectiveDistributedAmountInput>;
};


export type MutationSaveTargetTemplateArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  objective: ObjectiveTemplateInput;
};


export type MutationSendSkillStatusUpdateReminderEmailArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type MutationSetCutoffDayForCountryArgs = {
  country: Country;
  cutoffDay: Scalars['Int']['input'];
};


export type MutationSetDisableRankingForCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  isDisabled: Scalars['Boolean']['input'];
};


export type MutationSetIsTagAssignmentInProgressForCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationSetKudosCompanyCountryVisibilityArgs = {
  kudosCompanyCountryVisibilityInput: KudosCompanyCountryVisibilityInput;
};


export type MutationSetKudosLegalEntityVisibilityArgs = {
  kudosLegalEntityVisibilityInput: KudosLegalEntityVisibilityInput;
};


export type MutationSetLowPercentageForCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  lowPercentage: Scalars['Float']['input'];
};


export type MutationSetLowPercentageIsBlockerForCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  lowPercentageIsBlocker: Scalars['Boolean']['input'];
};


export type MutationSetNextAppraisalSeasonOpeningDateArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  openingMonth: Scalars['Int']['input'];
  openingYear: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationSetNextMeetingStepArgs = {
  currentStepStatus?: InputMaybe<MeetingStepStatus>;
  id: Scalars['HashedId']['input'];
  nextStepId: Scalars['HashedId']['input'];
  stepType?: InputMaybe<MeetingStepType>;
};


export type MutationSetTopPercentageForCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  topPercentage: Scalars['Float']['input'];
};


export type MutationTakeOverArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type MutationUpdateEmployeeOptOutValueArgs = {
  employeeId: Scalars['HashedId']['input'];
  newOptOutValue: Scalars['Boolean']['input'];
};


export type MutationUpdateMeetingFeedbackArgs = {
  feedback: Scalars['String']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type MutationUpdateMeetingNotesArgs = {
  meetingId: Scalars['HashedId']['input'];
  notes: Scalars['String']['input'];
};


export type MutationUpdateMeetingStepArgs = {
  id: Scalars['HashedId']['input'];
  newStepStatus: MeetingStepStatus;
};


export type MutationUpdateMyOptOutValueArgs = {
  newOptOutValue: Scalars['Boolean']['input'];
};


export type MutationUpdateRankingSeasonArgs = {
  talentsSeasonInput: TalentsSeasonInput;
};


export type MutationUpdateReferencedPyramidsArgs = {
  referencePyramid: ReferencePyramidInput;
};


export type MutationUpdateSelectableNationalContractReferenceLevelsArgs = {
  input: UpdateNationalContractReferenceInput;
};


export type MutationUpdateSelfreflectionQuestionArgs = {
  selfreflectionQuestion: SelfreflectionInput;
};


export type MutationUpdateSelfreflectionQuestionBooleanArgs = {
  selfreflectionQuestionBoolean: SelfreflectionQuestionBooleanInput;
};


export type MutationUploadObjectiveAttachmentArgs = {
  employeeIdOfMeetingNotLoggedInEmployeeId: Scalars['HashedId']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationWithdrawRequestedMeetingArgs = {
  employeeId: Scalars['HashedId']['input'];
  requestId: Scalars['HashedId']['input'];
};

export type NationalContractEmployeeLevelDto = {
  __typename?: 'NationalContractEmployeeLevelDTO';
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isTentative: Scalars['Boolean']['output'];
  level: NationalContractLevelEnum;
  note?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  type: NationalContractType;
};

export type NationalContractEmployeeLevelHistoryDto = {
  __typename?: 'NationalContractEmployeeLevelHistoryDTO';
  nationalContractEmployeeLevelHistory: Array<NationalContractEmployeeLevelDto>;
};

export type NationalContractLevel = {
  __typename?: 'NationalContractLevel';
  contract: Contract;
  contractId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isTentative: Scalars['Boolean']['output'];
  level: NationalContractLevelEnum;
  note?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  type: NationalContractType;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** All possible national contract employee levels */
export enum NationalContractLevelEnum {
  A = 'A',
  A1 = 'A1',
  A2 = 'A2',
  Ac = 'AC',
  As = 'AS',
  Asc = 'ASC',
  B1 = 'B1',
  B1S = 'B1S',
  B2 = 'B2',
  B3 = 'B3',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  D1 = 'D1',
  D2 = 'D2',
  Dir = 'DIR',
  E = 'E',
  EightQ = 'EIGHT_Q',
  Five = 'FIVE',
  FiveS = 'FIVE_S',
  Four = 'FOUR',
  I = 'I',
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  Ope1 = 'OPE1',
  Q = 'Q',
  Seven = 'SEVEN',
  SevenQ = 'SEVEN_Q',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO',
  V = 'V',
  Vi = 'VI',
  Vii = 'VII'
}

export type NationalContractReferenceDto = {
  __typename?: 'NationalContractReferenceDTO';
  description: Scalars['String']['output'];
  levels: Array<NationalContractReferenceLevelDto>;
};

export type NationalContractReferenceLevelDto = {
  __typename?: 'NationalContractReferenceLevelDTO';
  displayOrder: Scalars['Float']['output'];
  level: Scalars['String']['output'];
  minSalary: Scalars['Float']['output'];
  selectable: Scalars['Boolean']['output'];
};

export type NationalContractReferenceWithTypeDto = {
  __typename?: 'NationalContractReferenceWithTypeDTO';
  description: Scalars['String']['output'];
  levels: Array<NationalContractReferenceLevelDto>;
  type: NationalContractType;
};

/** All possible national contract types */
export enum NationalContractType {
  Commercio = 'COMMERCIO',
  CommercioBitmama = 'COMMERCIO_BITMAMA',
  CommercioLem = 'COMMERCIO_LEM',
  CommercioStandardMi = 'COMMERCIO_STANDARD_MI',
  CommercioStandardRm = 'COMMERCIO_STANDARD_RM',
  CommercioStandardTo = 'COMMERCIO_STANDARD_TO',
  DirIndustria = 'DIR_INDUSTRIA',
  Grafico = 'GRAFICO',
  GraficoEos = 'GRAFICO_EOS',
  Industria = 'INDUSTRIA',
  Tlc = 'TLC'
}

export type Network = {
  __typename?: 'Network';
  clusterManagers?: Maybe<Array<ManagerOfCluster>>;
  code: Scalars['String']['output'];
  companies?: Maybe<Array<Company>>;
  id: Scalars['HashedId']['output'];
  name: Scalars['String']['output'];
  networkManagers?: Maybe<Array<ManagerOfNetwork>>;
  status: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type NewEntries = {
  __typename?: 'NewEntries';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  businessUnit: BusinessUnitTiny;
  contractValidFrom: Scalars['DateTime']['output'];
  currentLevel: EmployeeLevelEnum;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  replyEntryDate: Scalars['DateTime']['output'];
};

export type NewEntriesByPeriod = {
  __typename?: 'NewEntriesByPeriod';
  currentMonth: Array<NewEntries>;
  previousMonth: Array<NewEntries>;
};

/** information on employees that are missing objectives to realize their bonus */
export type NextBestActionMissingTargets = {
  __typename?: 'NextBestActionMissingTargets';
  /** number of employees */
  count: Scalars['Int']['output'];
  /** employees missing a target bonus */
  employees: Array<EmployeeWithBonus>;
};

/** provides information on good actions to take for a given selection */
export type NextBestActivity = {
  __typename?: 'NextBestActivity';
  /** information on employees that have limited contracts about to expire */
  expiringLimitedContracts: NextBestActivityLimitedContractEnding;
  /** employees that will leave the company */
  leavingSoon: NextBestActivityLeavingEmployees;
  /** employees that have a bonus in their contract but are missing objectives for this bonus */
  missingTargets: NextBestActionMissingTargets;
  /** information on employees where the last meeting happened an unusual long time ago. */
  noMeeting: NextBestActivityNoMeeting;
  /** information on employees that are currently on probation. */
  onProbation: NextBestActivityProbationTalk;
  /** total number of employees in the selection */
  totalCount: Scalars['Int']['output'];
};


/** provides information on good actions to take for a given selection */
export type NextBestActivityExpiringLimitedContractsArgs = {
  period: Period;
};


/** provides information on good actions to take for a given selection */
export type NextBestActivityLeavingSoonArgs = {
  period: Period;
};


/** provides information on good actions to take for a given selection */
export type NextBestActivityNoMeetingArgs = {
  since: Scalars['DateTime']['input'];
};


/** provides information on good actions to take for a given selection */
export type NextBestActivityOnProbationArgs = {
  onlyEmployeesInSecondHalfOfProbationPeriod?: InputMaybe<Scalars['Boolean']['input']>;
};

/** employees leaving the company soon */
export type NextBestActivityLeavingEmployees = {
  __typename?: 'NextBestActivityLeavingEmployees';
  /** number of employees */
  count: Scalars['Int']['output'];
  /** employees in this category */
  employees: Array<EmployeeWithEndingContract>;
};

/** employees with limited contracts that are about to expire */
export type NextBestActivityLimitedContractEnding = {
  __typename?: 'NextBestActivityLimitedContractEnding';
  /** number of employees */
  count: Scalars['Int']['output'];
  /** employees in this category */
  employees: Array<EmployeeWithEndingContract>;
};

/** A group of employees where action should be taken as the last meeting was an unusual long time ago. */
export type NextBestActivityNoMeeting = {
  __typename?: 'NextBestActivityNoMeeting';
  /** number of employees */
  count: Scalars['Int']['output'];
  /** array of all employees in question. */
  employees: Array<EmployeeDisplayShortInfoWithLastMeeting>;
};

/** information on employees with witch a probation talk should happen */
export type NextBestActivityProbationTalk = {
  __typename?: 'NextBestActivityProbationTalk';
  /** number of employees */
  count: Scalars['Int']['output'];
  /** employees currently on probation */
  employees: Array<EmployeeOnProbation>;
};

export type NoteInfo = {
  __typename?: 'NoteInfo';
  author: EmployeeDisplayTinyInfo;
  date: Scalars['DateTime']['output'];
  globalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['HashedId']['output']>;
  text: Scalars['String']['output'];
};

export type NoteInfoInput = {
  author: AuthorInput;
  date: Scalars['DateTime']['input'];
  globalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  text: Scalars['String']['input'];
};

export type ObjectiveAttachmentInfoDto = {
  __typename?: 'ObjectiveAttachmentInfoDTO';
  attachment?: Maybe<Scalars['String']['output']>;
  attachmentDownloadToken?: Maybe<Scalars['String']['output']>;
  globalId?: Maybe<Scalars['String']['output']>;
};

export type ObjectiveDto = {
  __typename?: 'ObjectiveDTO';
  achievedAmount?: Maybe<Scalars['Float']['output']>;
  appraisalSeason: AppraisalSeasonDto;
  attachment?: Maybe<Scalars['String']['output']>;
  attachmentDownloadToken?: Maybe<Scalars['String']['output']>;
  closedDate?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Currency>;
  due: Scalars['DateTime']['output'];
  globalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['HashedId']['output']>;
  keyResults: Array<KeyResultDto>;
  noteList: Array<NoteInfo>;
  start: Scalars['DateTime']['output'];
  status: ObjectiveStatus;
  targetAmount?: Maybe<Scalars['Float']['output']>;
  taskNotes?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ObjectiveDistributedAmountInput = {
  globalId: Scalars['String']['input'];
  targetAmount: Scalars['Float']['input'];
};

export type ObjectiveInput = {
  achievedAmount?: InputMaybe<Scalars['Float']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  attachmentDownloadToken?: InputMaybe<Scalars['String']['input']>;
  closedDate?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Currency>;
  due: Scalars['DateTime']['input'];
  globalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  keyResults: Array<KeyResultInput>;
  noteList: Array<NoteInfoInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status: ObjectiveStatus;
  targetAmount?: InputMaybe<Scalars['Float']['input']>;
  taskNotes?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ObjectiveKeyResultDto = {
  __typename?: 'ObjectiveKeyResultDTO';
  displayOrder: Scalars['Float']['output'];
  globalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['HashedId']['output'];
  text: Scalars['String']['output'];
};

export type ObjectiveKeyResultInput = {
  displayOrder: Scalars['Float']['input'];
  globalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  text: Scalars['String']['input'];
};

export type ObjectivePayment = {
  __typename?: 'ObjectivePayment';
  amount?: Maybe<Scalars['Float']['output']>;
  deduction?: Maybe<Scalars['Float']['output']>;
  deductionReason?: Maybe<ObjectivePaymentManualDeductionReason>;
  id: Scalars['HashedId']['output'];
  meetingId: Scalars['HashedId']['output'];
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentDateValid: Scalars['Boolean']['output'];
  status?: Maybe<ObjectivePaymentStatus>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ObjectivePaymentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  deduction?: InputMaybe<Scalars['Float']['input']>;
  deductionReason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  meetingId: Scalars['HashedId']['input'];
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** All possible Objective Payment Manual Deduction Reason types */
export enum ObjectivePaymentManualDeductionReason {
  LongTermSickness = 'LongTermSickness',
  Other = 'Other',
  ParentalLeave = 'ParentalLeave',
  Sabatical = 'Sabatical'
}

/** All possible Objective Payment Status types */
export enum ObjectivePaymentStatus {
  Closed = 'Closed',
  Draft = 'Draft',
  Send = 'Send',
  ToBeSend = 'ToBeSend'
}

/** All possible objective statuses */
export enum ObjectiveStatus {
  Approved = 'Approved',
  Closed = 'Closed',
  Dismissed = 'Dismissed',
  DismissedPending = 'DismissedPending',
  MarkedAsDone = 'MarkedAsDone',
  PastApproved = 'PastApproved',
  Proposal = 'Proposal',
  ProposalFromManager = 'ProposalFromManager',
  ReadyForPayOff = 'ReadyForPayOff'
}

export type ObjectiveTemplateDto = {
  __typename?: 'ObjectiveTemplateDTO';
  creator: EmployeeDisplayTinyInfo;
  id: Scalars['HashedId']['output'];
  lastEditedDate: Scalars['DateTime']['output'];
  lastModifier: EmployeeDisplayTinyInfo;
  objectiveKeyResults: Array<ObjectiveKeyResultDto>;
  objectiveNotes: Array<NoteInfo>;
  objectiveTitle: Scalars['String']['output'];
};

export type ObjectiveTemplateInput = {
  creator: AuthorInput;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  lastModifier: AuthorInput;
  objectiveKeyResults: Array<ObjectiveKeyResultInput>;
  objectiveNotes: Array<NoteInfoInput>;
  objectiveTitle: Scalars['String']['input'];
};

export type OnboardingDataDto = {
  __typename?: 'OnboardingDataDTO';
  authUrl: Scalars['String']['output'];
  damUrl: Scalars['String']['output'];
  queryParamsString: Scalars['String']['output'];
  redirectUrlQueryParamName: Scalars['String']['output'];
  setCookieUrl: Scalars['String']['output'];
};

export type OneOffPayment = {
  __typename?: 'OneOffPayment';
  comment: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  meetingId: Scalars['HashedId']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentDateValid?: Maybe<Scalars['Boolean']['output']>;
  resultAmount?: Maybe<Scalars['Float']['output']>;
  status: OneOffPaymentStatus;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type OneOffPaymentInput = {
  comment: Scalars['String']['input'];
  id?: InputMaybe<Scalars['HashedId']['input']>;
  meetingId: Scalars['HashedId']['input'];
  paymentDate: Scalars['DateTime']['input'];
  resultAmount: Scalars['Float']['input'];
};

/** All possible OneOffPayment statuses */
export enum OneOffPaymentStatus {
  Active = 'Active',
  Sent = 'Sent'
}

export type Option = {
  __typename?: 'Option';
  children?: Maybe<Array<Children>>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PerBaseEntity = {
  __typename?: 'PerBaseEntity';
  id: Scalars['HashedId']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** a time period */
export type Period = {
  /** the end of the period */
  end: Scalars['DateTime']['input'];
  /** the begin of the period */
  start: Scalars['DateTime']['input'];
};

export type PermissionCheck = {
  __typename?: 'PermissionCheck';
  permit: Scalars['Boolean']['output'];
};

export type PersonalProfile = Profile & {
  __typename?: 'PersonalProfile';
  academicTitle?: Maybe<Scalars['String']['output']>;
  activityListEnabled?: Maybe<Scalars['Boolean']['output']>;
  address: Array<EmployeeAddress>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<InternationalBankAccount>;
  branchOfficeCode?: Maybe<Scalars['String']['output']>;
  businessUnit?: Maybe<BusinessUnit>;
  chosenFirstName?: Maybe<Scalars['String']['output']>;
  chosenLastName?: Maybe<Scalars['String']['output']>;
  citizenships: Array<Citizenship>;
  currentContractLevel?: Maybe<ContractEmployeeLevel>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  education: Array<Education>;
  email: Scalars['String']['output'];
  emergencyContacts: Array<EmergencyContact>;
  employeeId: Scalars['HashedId']['output'];
  employeeTimezone: Scalars['String']['output'];
  employmentStatus: EmploymentStatus;
  legalFirstName: Scalars['String']['output'];
  legalLastName: Scalars['String']['output'];
  privateEmailAddress?: Maybe<Scalars['String']['output']>;
  replyEntryDate: Scalars['DateTime']['output'];
  skillCenterUrl?: Maybe<Scalars['String']['output']>;
  skillStatus?: Maybe<SkillEmployeeStatusDto>;
  username: Scalars['String']['output'];
};

export type ProbationPeriodEnding = {
  __typename?: 'ProbationPeriodEnding';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  businessUnit: BusinessUnitTiny;
  currentLevel: EmployeeLevelEnum;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  probationPeriodEndDate: Scalars['DateTime']['output'];
};

export type ProbationPeriodEndingByPeriod = {
  __typename?: 'ProbationPeriodEndingByPeriod';
  currentMonth: Array<ProbationPeriodEnding>;
  nextMonth: Array<ProbationPeriodEnding>;
};

export type Profile = {
  academicTitle?: Maybe<Scalars['String']['output']>;
  activityListEnabled?: Maybe<Scalars['Boolean']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  branchOfficeCode?: Maybe<Scalars['String']['output']>;
  chosenFirstName?: Maybe<Scalars['String']['output']>;
  chosenLastName?: Maybe<Scalars['String']['output']>;
  currentContractLevel?: Maybe<ContractEmployeeLevel>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  education: Array<Education>;
  email: Scalars['String']['output'];
  employeeId: Scalars['HashedId']['output'];
  employeeTimezone: Scalars['String']['output'];
  employmentStatus: EmploymentStatus;
  legalFirstName: Scalars['String']['output'];
  legalLastName: Scalars['String']['output'];
  replyEntryDate: Scalars['DateTime']['output'];
  skillCenterUrl?: Maybe<Scalars['String']['output']>;
  skillStatus?: Maybe<SkillEmployeeStatusDto>;
  username: Scalars['String']['output'];
};

export type PublicProfile = Profile & {
  __typename?: 'PublicProfile';
  academicTitle?: Maybe<Scalars['String']['output']>;
  activityListEnabled?: Maybe<Scalars['Boolean']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  branchOfficeCode?: Maybe<Scalars['String']['output']>;
  businessUnit?: Maybe<BusinessUnit>;
  chosenFirstName?: Maybe<Scalars['String']['output']>;
  chosenLastName?: Maybe<Scalars['String']['output']>;
  country: Country;
  currentContractLevel?: Maybe<ContractEmployeeLevel>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  editable: Scalars['Boolean']['output'];
  education: Array<Education>;
  email: Scalars['String']['output'];
  employeeId: Scalars['HashedId']['output'];
  employeeTimezone: Scalars['String']['output'];
  employmentStatus: EmploymentStatus;
  legalFirstName: Scalars['String']['output'];
  legalLastName: Scalars['String']['output'];
  meetings: Array<Meeting>;
  replyEntryDate: Scalars['DateTime']['output'];
  skillCenterUrl?: Maybe<Scalars['String']['output']>;
  skillStatus?: Maybe<SkillEmployeeStatusDto>;
  username: Scalars['String']['output'];
};

export type PyramidForecastDto = {
  __typename?: 'PyramidForecastDTO';
  age?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  businessUnitId?: Maybe<Scalars['HashedId']['output']>;
  businessUnitName?: Maybe<Scalars['String']['output']>;
  careerPath?: Maybe<CareerPathEvaluation>;
  companyId: Scalars['HashedId']['output'];
  country: Country;
  currencyForPayments?: Maybe<Currency>;
  currentEmployeeLevel?: Maybe<EmployeeLevelEnum>;
  dateOfLevelChange?: Maybe<Scalars['DateTime']['output']>;
  employeeFullName?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['HashedId']['output']>;
  employeeTimezone?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  forecastDate?: Maybe<Scalars['DateTime']['output']>;
  forecastEndDate?: Maybe<Scalars['DateTime']['output']>;
  forecastId?: Maybe<Scalars['HashedId']['output']>;
  id: Scalars['String']['output'];
  levelChange?: Maybe<EmployeeLevelEnum>;
  newHiringFullName?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  tags?: Maybe<Array<EmployeeTagType>>;
};

export type PyramidForecastFiltersDto = {
  __typename?: 'PyramidForecastFiltersDTO';
  businessUnits: Array<BusinessUnitTiny>;
  employees: Array<EmployeeDisplayTinyInfo>;
};

export type PyramidForecastInput = {
  age?: InputMaybe<Scalars['Float']['input']>;
  bonus?: InputMaybe<Scalars['Float']['input']>;
  businessUnitId?: InputMaybe<Scalars['HashedId']['input']>;
  companyId: Scalars['HashedId']['input'];
  country: Country;
  dateOfLevelChange?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['HashedId']['input']>;
  forecastDate?: InputMaybe<Scalars['DateTime']['input']>;
  forecastEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  forecastId?: InputMaybe<Scalars['HashedId']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  levelChange?: InputMaybe<EmployeeLevelEnum>;
  newHiringFullName?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
};

export type PyramidForecastValueDto = {
  __typename?: 'PyramidForecastValueDto';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type PyramidForecastValues = {
  __typename?: 'PyramidForecastValues';
  ageValues: Array<PyramidForecastValueDto>;
  decrease: Array<PyramidValueLevelDecrease>;
  values: Array<PyramidForecastValueDto>;
};

export type PyramidForecastWithFiltersDto = {
  __typename?: 'PyramidForecastWithFiltersDTO';
  activeEmployees: Array<PyramidForecastDto>;
  careerPath?: Maybe<Array<CareerPathDto>>;
  filters: PyramidForecastFiltersDto;
  newHirings: Array<PyramidForecastDto>;
};

export type PyramidSelectorYearAndMonth = {
  __typename?: 'PyramidSelectorYearAndMonth';
  options?: Maybe<Array<Option>>;
};

/** All Possible Pyramid Types */
export enum PyramidType {
  Age = 'Age',
  Level = 'Level'
}

export type PyramidValueDto = {
  __typename?: 'PyramidValueDto';
  count: Scalars['Int']['output'];
  displayOrder: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type PyramidValueLevelDecrease = {
  __typename?: 'PyramidValueLevelDecrease';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeEmployeesOfCompany?: Maybe<Array<EmployeeWithBusinessUnit>>;
  activeEmployeesOfCompanyWithoutPartners?: Maybe<Array<EmployeeWithBusinessUnit>>;
  activeEmployeesSearch: Array<EmployeeSearch>;
  activeSubordinatesOfBuManager: Array<EmployeeWithBusinessUnit>;
  addressChangesByEmployee?: Maybe<Array<Change>>;
  allReviewersByEmployeeId: Array<EmployeeDisplayTinyInfo>;
  anyone: Scalars['String']['output'];
  appraisalSeasonOptionByEmployeeId: AppraisalSeasonDto;
  appraisalsOfEmployeeByYear: Array<AppraisalDisplayInfo>;
  areKudosVisibleForMe: Scalars['Boolean']['output'];
  branchOfficeByEmployee: BranchOffice;
  careerPath?: Maybe<Array<CareerPathDto>>;
  careerPathEvaluation?: Maybe<CareerPathEvaluation>;
  careerPathEvaluationByMeetingId?: Maybe<CareerPathEvaluation>;
  checkChatbotPermission: Scalars['Boolean']['output'];
  checkCompanyManagerOfCompany: PermissionCheck;
  checkOnboardingPermission: Scalars['Boolean']['output'];
  checkVisibilityOnboarding: Scalars['Boolean']['output'];
  companiesAndBusinessUnitsByEmployee: Array<CompanyAndBu>;
  companiesOfUser: Array<ManagedCompany>;
  companyManagerDashboardASYear?: Maybe<Scalars['Int']['output']>;
  companyManagerDashboardAppraisalMeetingStatus: CompanyManagerAppraisalMeetingStatusDto;
  companyManagerDashboardBoOfCompany: BOofCompanyDto;
  companyManagerDashboardBuOfCompany: BUofCompanyDto;
  companyManagerDashboardBubobumCounters: BubobuMcountersDto;
  companyManagerDashboardBumOfCompany: BumOfCompanyDto;
  companyManagerDashboardListOfCompanies: Array<DashboardListOfCompanies>;
  companyManagerDashboardPartialVisibility: Scalars['Boolean']['output'];
  companyManagerDashboardWorkforceCounters: DashboardWorkforceCountersDto;
  companyManagerDashboardWorkforceLeavers: LeaversByPeriod;
  companyManagerDashboardWorkforceNewEntries: NewEntriesByPeriod;
  companyManagerDashboardWorkforceProbationPeriodEnding: ProbationPeriodEndingByPeriod;
  companyPartners: Array<Employee>;
  companyRankingSettingsForCountry: CompanyRankingSettingsDto;
  companyRankings: Array<EmployeeRanking>;
  companySearch: Array<CompanyTiny>;
  contractChangeValidationList: ContractChangeValidationList;
  contractChangesByEmployee: Array<Change>;
  contractEmployeeLevelsByContractId: ContractEmployeeLevelHistoryDto;
  contractEmployeeLevelsByEmployeeId: ContractEmployeeLevelHistoryDto;
  contractGovernmentJobTitleHistoryByEmployeeId: Array<ContractGovernmentJobTitle>;
  contractsInYear: Array<Contract>;
  countriesOfLegalEntities?: Maybe<Array<Country>>;
  currentAppraisalSeason: AppraisalSeasonDto;
  currentContract: LatestContractDto;
  currentContractsHistory: Contract;
  educationChangesByEmployee?: Maybe<Array<Change>>;
  employee?: Maybe<Employee>;
  employeeDisplayShortInfoByEmployeeId?: Maybe<EmployeeDisplayShortInfo>;
  employeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager?: Maybe<EmployeeDisplayShortInfoMeetingInvite>;
  employeeDisplayTinyInfoByEmployeeId?: Maybe<EmployeeDisplayTinyInfo>;
  employeeHasOngoingAppraisal: Scalars['Boolean']['output'];
  employees?: Maybe<Array<Employee>>;
  employeesAndTags: Array<EmployeeAndTag>;
  employeesAndTagsWithRankingDisabled: Array<EmployeeAndTag>;
  employeesWithHrOrDownloaderRole: Array<EmployeeWithRole>;
  employmentStatusOfEmployee: EmployeeEmploymentStatusDto;
  evaluationFromLastTwoAppraisals?: Maybe<ScoreGridsOverviewDto>;
  excecutedPaymentsByContractId: ExecutedPaymentHistoryDto;
  excecutedPaymentsByEmployeeId: ExecutedPaymentHistoryDto;
  existingDevObjectivesToBeClosedInMeeting: Scalars['Boolean']['output'];
  featureDisclaimerData?: Maybe<FeatureMaintenanceData>;
  featureToggles: Array<FeatureToggle>;
  findActiveLegalEntities: Array<LegalEntity>;
  findBonusByEmployeeIdInAppraisalSeasonOfMeeting?: Maybe<BonusBetweenAnnualBonusAndProrataDto>;
  findCompaniesAndCountriesByCompanyManager: Array<GroupedCompanyWithLegalEntitiesAndCountries>;
  findCompaniesAndCountriesByCompanyManagerOrResponsible: Array<GroupedCompanyWithLegalEntitiesAndCountries>;
  findCompaniesAndCountriesByManagerOrResponsible: Array<GroupedCompanyWithLegalEntitiesAndCountries>;
  findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP: Array<GroupedCompanyWithLegalEntitiesAndCountries>;
  findCompaniesAndCountriesByResponsible: Array<GroupedCompanyWithLegalEntitiesAndCountries>;
  findCompaniesByManagerOrResponsible: Array<CompanyTiny>;
  findCountriesHrIsResponsibleOf: Array<Country>;
  findCurrentBusinessUnitsByCompanyId: Array<BusinessUnitTiny>;
  findPastYearFlexibleBonusByEmployeeIdAndMeetingId?: Maybe<BonusBetweenAnnualBonusAndProrataDto>;
  findPossibleYearsAndCompaniesForRankingReport: YearsAndCompaniesForRankingReportDto;
  findReportsInDownloadsViewByCountryAndType: ReportPaginationDto;
  findTalentsSeasonsYears: Array<TalentsSeasonYearDto>;
  findTargetReportsByCountryAndCompany: Array<ReportDto>;
  findUserManagerRolesByCompany: Array<RoleName>;
  findUserManagerRolesByEmployee: Array<RoleName>;
  fullMeetingPreview: FullMeetingPreviewDto;
  getAllAttentionPoints: KudosShowMoreDto;
  getAllKudos: KudosShowMoreDto;
  getAppraisalSeasonOpeningInfo: AppraisalSeasonOpeningInfoDto;
  getAppraisalsWithFeedbackByCountryAndFilters: AppraisalWithFeedbackPagination;
  getAppraisalsWithFeedbackToResolveCounterByCountry: Scalars['Int']['output'];
  getAttentionPointsForEmployee: KudosPaginationDto;
  getCountriesAndReportGenerationFlags: Array<CountryAndReportGenerationFlags>;
  getCountriesList: Array<Country>;
  getCountriesWhereReportGenerationIsActive: Array<Country>;
  getCountriesWithAgePyramidVisibleFlag: Array<CountryWithAgePyramidVisibleFlag>;
  getCountriesWithBranchOfficeVisibleFlag: Array<CountryWithBranchOfficeVisibleFlag>;
  getCountryEmployeeLevels: Array<EmployeeLevelEnum>;
  getCountryEmployeeLevelsWithOrder: Array<EmployeeLevelWithDisplayOrder>;
  getCountrySettings: CountrySettingsDto;
  getCurrencyConversionsByEmployee: CurrencyConversionWithContractCurrencyDto;
  getDraftOrLatestScoreGridByEmployee?: Maybe<ScoreGridDto>;
  getEmployeeSkillStatusInMeeting?: Maybe<SkillEmployeeStatusDto>;
  getEmployeesWithLatestAndDraftScoreGrid: Array<EmployeeWithLatestAndDraftEvaluation>;
  getHrBusinessPartnersByCountry: Array<ActiveHrBusinessPartnerDto>;
  getIdVWeightsByCountry: Array<IdvWeightDto>;
  getKudosCompanyCountryVisibilityData: KudosCompanyCountryVisibilityShowMoreDto;
  getKudosForEmployee: KudosWithVisibilityFlagDto;
  getKudosForEmployeeInAppraisal: KudosWithVisibilityFlagDto;
  getKudosGivenByReplyer: KudosShowMoreDto;
  getKudosLegalEntityVisibilityData: KudosLegalEntityVisibilityShowMoreDto;
  getKudosReceivedByMe: KudosWithVisibilityFlagDto;
  getLatestScoreGridByEmployee?: Maybe<ScoreGridDto>;
  getMeetingRequest: MeetingRequestDto;
  getMeetingRequestsByCompanyCountry: Array<MeetingRequestDto>;
  getMeetingRequestsByRequester: Array<MeetingRequestDto>;
  getMeetingRequestsByReviewer: Array<MeetingRequestDto>;
  getOnboardingData: OnboardingDataDto;
  getPersonalSkillStatusInEmployeePreparation?: Maybe<SkillEmployeeStatusDto>;
  getPossibleCompaniesForCreateNewHrBusinessPartner: Array<CompanyTinyWithName>;
  getRankingReportsByCountryAndFilters: ReportPaginationDto;
  getSelectableNationalContractReferences: Array<NationalContractReferenceWithTypeDto>;
  getTargetsTemplates: Array<ObjectiveTemplateDto>;
  governmentJobTitlesByEmployeeId: Array<GovernmentJobTitle>;
  governmentJobTitlesByHiringOfficeId: Array<GovernmentJobTitle>;
  hasCountryNationalContractReferenceLevel: Scalars['Boolean']['output'];
  importExcel: Array<EmployeeWithRankAndTagsForExcel>;
  isActivityListEnabled: Scalars['Boolean']['output'];
  isAgePyramidVisible: Scalars['Boolean']['output'];
  isBonusValidationEnabled: Scalars['Boolean']['output'];
  isCareerPathEnabled: Scalars['Boolean']['output'];
  isCultivatingTalentsEnabledForCompanyAndCountry: Scalars['Boolean']['output'];
  isEmployeeLevelValidationEnabled: Scalars['Boolean']['output'];
  isFlexibleProrataManagementEnabled: Scalars['Boolean']['output'];
  isIdVWeightEnabled: Scalars['Boolean']['output'];
  isOneOffPaymentNotAllowed: Scalars['Boolean']['output'];
  isRankingEnabledForCompanyAndCountry: Scalars['Boolean']['output'];
  isSkillStatusBlocker: Scalars['Boolean']['output'];
  justAuthorized: Scalars['String']['output'];
  legalEntitySearch: Array<LegalEntityTiny>;
  liveBoardOrHistory: Array<EmployeeWithRankAndTags>;
  locales: Array<LocaleDto>;
  managerOf: ManagingUnits;
  managerOnly: Scalars['String']['output'];
  me?: Maybe<UserInfo>;
  meeting: Meeting;
  meetingEmployeePreparation: Meeting;
  meetingInviteOptionsForEmployee: MeetingInviteOptionsExtended;
  meetingManagerPreparation: Meeting;
  meetingPdfStatus: Meeting;
  meetingRequestOptionsForEmployee: MeetingInviteOptionsExtended;
  meetingStep?: Maybe<MeetingStep>;
  meetingsByManager: Array<Meeting>;
  meetingsByReplyer: Array<Meeting>;
  meetingsHistoryByReplyer: Array<Meeting>;
  mostBookedGecoProjectsOfEmployee: Array<GecoProjectsInfo>;
  myprofile?: Maybe<Employee>;
  nameSearch: Array<EmployeeNameSearchInfo>;
  nameSearchForHRBPSelect: Array<EmployeeNameSearchInfo>;
  nationalContractEmployeeLevelsByContractId: NationalContractEmployeeLevelHistoryDto;
  nationalContractEmployeeLevelsByEmployeeId: NationalContractEmployeeLevelHistoryDto;
  networksCompaniesCountriesYears: Array<GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries>;
  /** provides information on what good actions to take might be for a set of business units */
  nextBestActivity: NextBestActivity;
  nonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeeting: Array<EmployeeAndAppraisalMeetings>;
  nonManagerEmployeesOfCompanyWithCurrentAppraisalMeeting: Array<EmployeeAndAppraisalMeetings>;
  nonParticipantsOptionsForEmployee: Array<EmployeeWithBusinessUnit>;
  objectivePaymentByMeeting?: Maybe<ObjectivePayment>;
  objectivesDtoList: Array<ObjectiveDto>;
  objectivesInMeeting: Array<ObjectiveDto>;
  objectivesWithAttachmentsFromMeeting: Array<ObjectiveAttachmentInfoDto>;
  oneOffPayment?: Maybe<OneOffPayment>;
  oneOffPaymentByMeetingId?: Maybe<OneOffPayment>;
  personalProfile: PersonalProfile;
  possibleRevieweesByReviewerId: Array<EmployeeWithBusinessUnit>;
  publicProfile: PublicProfile;
  pyramidForecastValueSelector: PyramidSelectorYearAndMonth;
  pyramidForecastValues: PyramidForecastValues;
  pyramidForecastWithFilters: PyramidForecastWithFiltersDto;
  pyramidPastValueSelector: PyramidSelectorYearAndMonth;
  pyramidPastValues: Array<PyramidValueDto>;
  pyramidValues: Array<PyramidValueDto>;
  referencedPyramidsByCompanyIdAndCountry?: Maybe<ReferencePyramid>;
  referencedPyramidsTemplateByCountryAndType?: Maybe<Array<ReferencePyramidTemplateDto>>;
  replyerOnly: Scalars['String']['output'];
  resignedContract?: Maybe<LatestContractDto>;
  resignedEmployeeCareerPathEvaluation?: Maybe<CareerPathEvaluation>;
  resignedEmployeePublicProfile: PublicProfile;
  resignedEmployeesOfCompany: ResignedViewEmployeesDto;
  resignedEmployeesOfCompanyCountry: ResignedViewEmployeesDto;
  retrieveActivityListData?: Maybe<Array<ActivityListDataDto>>;
  retrieveActivityListInitialData: Array<ActivityListDto>;
  retrieveChatbotToken: Scalars['String']['output'];
  retrieveChatbotUrl: Scalars['String']['output'];
  retrieveSkillStatusDataInMeetingInvitation: SkillEmployeeStatusMeetingInvitationDto;
  reviewersByCompanyId: Array<ReviewerAndEmployee>;
  reviewersRelationOfBusinessUnitId: Array<ReviewerAndEmployee>;
  salaryByContractId: SalaryHistoryDto;
  salaryByEmployeeId: SalaryHistoryDto;
  salaryOfYear: Array<Salary>;
  scheduledMeetingsByManager: Array<Meeting>;
  scoreGridWithHistory: ScoreGridDto;
  /** Returns the summary of the employee self-reflection for given business units */
  selfReflectionSummary: SelfReflectionSummary;
  selfreflectionQuestions: Array<SelfreflectionQuestion>;
  skillStatusBlocksMeeting: Scalars['Boolean']['output'];
  subOrdinatesByEmployee: Array<Employee>;
  subordinateMeetings: Array<Meeting>;
  subordinateOfCompany: Array<CompanySubordinate>;
  subordinateSearch: SubordinateSearchPagination;
  subordinates: Array<EmployeeSubordinateDto>;
  tagHistoryOfEmployee: Array<EmployeeTagInfo>;
  tagHistoryOfEmployeeUntilReplyEntryDate: Array<EmployeeTagInfo>;
  tagHistoryOfResignedEmployeeUntilReplyEntryDate: Array<EmployeeTagInfo>;
  talentsSeasonSettings: TalentsSeasonSettingsDto;
  targetBonusByContractId: TargetBonusHistoryDto;
  targetBonusByEmployeeId: TargetBonusHistoryDto;
  targetBonusOfYear: Array<TargetBonus>;
  targetCorrectionPayment?: Maybe<TargetCorrectionPaymentDto>;
  targetCorrectionPaymentAllowedYears: TargetCorrectionPaymentAllowedYearsDto;
  targetCorrectionPaymentByMeetingId?: Maybe<TargetCorrectionPaymentDto>;
  targetTemplatesOfCompany: Array<ObjectiveTemplateDto>;
};


export type QueryActiveEmployeesOfCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type QueryActiveEmployeesOfCompanyWithoutPartnersArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type QueryActiveEmployeesSearchArgs = {
  companyId?: InputMaybe<Scalars['HashedId']['input']>;
  kudosView: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QueryActiveSubordinatesOfBuManagerArgs = {
  buId: Scalars['HashedId']['input'];
};


export type QueryAddressChangesByEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryAllReviewersByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryAppraisalSeasonOptionByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  utcMeetingDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAppraisalsOfEmployeeByYearArgs = {
  appraisalSeasonYear: Scalars['Int']['input'];
  employeeId: Scalars['HashedId']['input'];
  latestMeetingId: Scalars['HashedId']['input'];
};


export type QueryBranchOfficeByEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryCareerPathArgs = {
  country: Country;
};


export type QueryCareerPathEvaluationArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryCareerPathEvaluationByMeetingIdArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QueryCheckCompanyManagerOfCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type QueryCompaniesAndBusinessUnitsByEmployeeArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryCompanyManagerDashboardAsYearArgs = {
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardAppraisalMeetingStatusArgs = {
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardBoOfCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardBuOfCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardBubobumCountersArgs = {
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardBumOfCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardPartialVisibilityArgs = {
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardWorkforceCountersArgs = {
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardWorkforceLeaversArgs = {
  companyId: Scalars['HashedId']['input'];
  period?: InputMaybe<WorkforceMovementPeriodEnum>;
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardWorkforceNewEntriesArgs = {
  companyId: Scalars['HashedId']['input'];
  period?: InputMaybe<WorkforceMovementPeriodEnum>;
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyManagerDashboardWorkforceProbationPeriodEndingArgs = {
  companyId: Scalars['HashedId']['input'];
  period?: InputMaybe<WorkforceMovementPeriodEnum>;
  userDashboardRoles: Array<RoleName>;
};


export type QueryCompanyPartnersArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryCompanyRankingSettingsForCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryCompanyRankingsArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type QueryCompanySearchArgs = {
  companyScope: CompanyScope;
  limit: Scalars['Int']['input'];
  search: Scalars['String']['input'];
};


export type QueryContractChangeValidationListArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryContractChangesByEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryContractEmployeeLevelsByContractIdArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryContractEmployeeLevelsByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContractGovernmentJobTitleHistoryByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContractsInYearArgs = {
  employeeId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
};


export type QueryCurrentAppraisalSeasonArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryCurrentContractArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryCurrentContractsHistoryArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryEducationChangesByEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryEmployeeArgs = {
  checkPermissions: Scalars['Boolean']['input'];
  id: Scalars['HashedId']['input'];
};


export type QueryEmployeeDisplayShortInfoByEmployeeIdArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryEmployeeDisplayTinyInfoByEmployeeIdArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryEmployeeHasOngoingAppraisalArgs = {
  replyerId: Scalars['HashedId']['input'];
};


export type QueryEmployeesAndTagsArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryEmployeesAndTagsWithRankingDisabledArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryEmploymentStatusOfEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryEvaluationFromLastTwoAppraisalsArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryExcecutedPaymentsByContractIdArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryExcecutedPaymentsByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExistingDevObjectivesToBeClosedInMeetingArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QueryFindActiveLegalEntitiesArgs = {
  countries?: InputMaybe<Array<Country>>;
};


export type QueryFindBonusByEmployeeIdInAppraisalSeasonOfMeetingArgs = {
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type QueryFindCompaniesAndCountriesByCompanyManagerArgs = {
  excludeBusinessPartnerCompanies?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindCompaniesAndCountriesByManagerOrResponsibleArgs = {
  businessPartnerVisibility: Scalars['Boolean']['input'];
};


export type QueryFindCompaniesByManagerOrResponsibleArgs = {
  businessPartnerVisibility: Scalars['Boolean']['input'];
};


export type QueryFindCurrentBusinessUnitsByCompanyIdArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryFindPastYearFlexibleBonusByEmployeeIdAndMeetingIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type QueryFindPossibleYearsAndCompaniesForRankingReportArgs = {
  country?: InputMaybe<Country>;
};


export type QueryFindReportsInDownloadsViewByCountryAndTypeArgs = {
  countries: Array<Country>;
  pagination: CursorPaginationReportInput;
  reportType: ReportType;
};


export type QueryFindTalentsSeasonsYearsArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryFindTargetReportsByCountryAndCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryFindUserManagerRolesByCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type QueryFindUserManagerRolesByEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryFullMeetingPreviewArgs = {
  employeeId: Scalars['HashedId']['input'];
  isAppraisalUpdate: Scalars['Boolean']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type QueryGetAllAttentionPointsArgs = {
  filters: KudosFilterInput;
};


export type QueryGetAllKudosArgs = {
  filters: KudosFilterInput;
};


export type QueryGetAppraisalSeasonOpeningInfoArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryGetAppraisalsWithFeedbackByCountryAndFiltersArgs = {
  country: Country;
  filters: HrSupportFeedbackTabFilter;
  pagination: CursorPaginationMeetingInput;
};


export type QueryGetAppraisalsWithFeedbackToResolveCounterByCountryArgs = {
  country: Country;
};


export type QueryGetAttentionPointsForEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: KudosPaginationInput;
};


export type QueryGetCountriesWhereReportGenerationIsActiveArgs = {
  reportType: ReportType;
};


export type QueryGetCountryEmployeeLevelsArgs = {
  country: Country;
};


export type QueryGetCountryEmployeeLevelsWithOrderArgs = {
  country: Country;
};


export type QueryGetCountrySettingsArgs = {
  country: Country;
};


export type QueryGetCurrencyConversionsByEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryGetDraftOrLatestScoreGridByEmployeeArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  employeeId: Scalars['HashedId']['input'];
};


export type QueryGetEmployeeSkillStatusInMeetingArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryGetEmployeesWithLatestAndDraftScoreGridArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryGetHrBusinessPartnersByCountryArgs = {
  country: Country;
};


export type QueryGetIdVWeightsByCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryGetKudosCompanyCountryVisibilityDataArgs = {
  filters: KudosCompanyCountryVisibilityFilterInput;
};


export type QueryGetKudosForEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: KudosPaginationInput;
};


export type QueryGetKudosForEmployeeInAppraisalArgs = {
  appraisalInput: KudosAppraisalInput;
  employeeId: Scalars['HashedId']['input'];
};


export type QueryGetKudosGivenByReplyerArgs = {
  filters: KudosByReplyerFilterInput;
};


export type QueryGetKudosLegalEntityVisibilityDataArgs = {
  filters: KudosLegalEntityVisibilityFilterInput;
};


export type QueryGetKudosReceivedByMeArgs = {
  pagination: KudosPaginationInput;
};


export type QueryGetLatestScoreGridByEmployeeArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  employeeId: Scalars['HashedId']['input'];
};


export type QueryGetMeetingRequestArgs = {
  meetingRequestId: Scalars['HashedId']['input'];
};


export type QueryGetMeetingRequestsByCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
};


export type QueryGetMeetingRequestsByRequesterArgs = {
  requesterId: Scalars['HashedId']['input'];
};


export type QueryGetMeetingRequestsByReviewerArgs = {
  reviewerId: Scalars['HashedId']['input'];
};


export type QueryGetOnboardingDataArgs = {
  iframeId: Scalars['String']['input'];
};


export type QueryGetPersonalSkillStatusInEmployeePreparationArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryGetRankingReportsByCountryAndFiltersArgs = {
  countries: Array<Country>;
  filters: RankingReportFilterInput;
  pagination: CursorPaginationReportInput;
};


export type QueryGetTargetsTemplatesArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryGovernmentJobTitlesByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  excludePartnerLevels?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGovernmentJobTitlesByHiringOfficeIdArgs = {
  excludePartnerLevels?: InputMaybe<Scalars['Boolean']['input']>;
  hiringOfficeId: Scalars['HashedId']['input'];
};


export type QueryHasCountryNationalContractReferenceLevelArgs = {
  country: Country;
};


export type QueryImportExcelArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  excelData: Array<ExcelDataInput>;
  year: Scalars['Int']['input'];
};


export type QueryIsActivityListEnabledArgs = {
  country: Country;
};


export type QueryIsAgePyramidVisibleArgs = {
  country: Country;
};


export type QueryIsBonusValidationEnabledArgs = {
  country: Country;
};


export type QueryIsCareerPathEnabledArgs = {
  country: Country;
};


export type QueryIsCultivatingTalentsEnabledForCompanyAndCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryIsEmployeeLevelValidationEnabledArgs = {
  country: Country;
};


export type QueryIsFlexibleProrataManagementEnabledArgs = {
  country: Country;
};


export type QueryIsIdVWeightEnabledArgs = {
  country: Country;
};


export type QueryIsOneOffPaymentNotAllowedArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QueryIsRankingEnabledForCompanyAndCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryIsSkillStatusBlockerArgs = {
  country: Country;
};


export type QueryLegalEntitySearchArgs = {
  limit: Scalars['Int']['input'];
  search: Scalars['String']['input'];
};


export type QueryLiveBoardOrHistoryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  year: Scalars['Int']['input'];
};


export type QueryManagerOfArgs = {
  managerId: Scalars['HashedId']['input'];
};


export type QueryMeetingArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryMeetingEmployeePreparationArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryMeetingInviteOptionsForEmployeeArgs = {
  appraisalSeasonId?: InputMaybe<Scalars['HashedId']['input']>;
  employeeId: Scalars['HashedId']['input'];
};


export type QueryMeetingManagerPreparationArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryMeetingPdfStatusArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryMeetingRequestOptionsForEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryMeetingStepArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryMeetingsByManagerArgs = {
  disputedMeetingsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  managerId: Scalars['HashedId']['input'];
};


export type QueryMeetingsByReplyerArgs = {
  disputedMeetingsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  replyerId: Scalars['HashedId']['input'];
};


export type QueryMeetingsHistoryByReplyerArgs = {
  isResigned?: InputMaybe<Scalars['Boolean']['input']>;
  replyerId: Scalars['HashedId']['input'];
};


export type QueryMostBookedGecoProjectsOfEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
  endDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryNameSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  rawInput: Scalars['String']['input'];
};


export type QueryNameSearchForHrbpSelectArgs = {
  country: Country;
  limit: Scalars['Int']['input'];
  rawInput: Scalars['String']['input'];
};


export type QueryNationalContractEmployeeLevelsByContractIdArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryNationalContractEmployeeLevelsByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNextBestActivityArgs = {
  businessUnitIds: Array<Scalars['HashedId']['input']>;
  includeBusinessUnitManager: Scalars['Boolean']['input'];
};


export type QueryNonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingArgs = {
  businessUnitId: Scalars['HashedId']['input'];
};


export type QueryNonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryNonParticipantsOptionsForEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryObjectivePaymentByMeetingArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryObjectivesDtoListArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryObjectivesInMeetingArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QueryObjectivesWithAttachmentsFromMeetingArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QueryOneOffPaymentArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryOneOffPaymentByMeetingIdArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QueryPersonalProfileArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryPossibleRevieweesByReviewerIdArgs = {
  companyId: Scalars['HashedId']['input'];
  employeeId: Scalars['HashedId']['input'];
};


export type QueryPublicProfileArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryPyramidForecastValueSelectorArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryPyramidForecastValuesArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  month: Scalars['Float']['input'];
  year: Scalars['Float']['input'];
};


export type QueryPyramidForecastWithFiltersArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};


export type QueryPyramidPastValueSelectorArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  pyramidType: PyramidType;
};


export type QueryPyramidPastValuesArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  month: Scalars['Float']['input'];
  pyramidType: PyramidType;
  year: Scalars['Float']['input'];
};


export type QueryPyramidValuesArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  pyramidType: PyramidType;
};


export type QueryReferencedPyramidsByCompanyIdAndCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  pyramidType: PyramidType;
};


export type QueryReferencedPyramidsTemplateByCountryAndTypeArgs = {
  country: Country;
  referencePyramidType: PyramidType;
};


export type QueryResignedContractArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryResignedEmployeeCareerPathEvaluationArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryResignedEmployeePublicProfileArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryResignedEmployeesOfCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type QueryResignedEmployeesOfCompanyCountryArgs = {
  companyId: Scalars['HashedId']['input'];
  country?: InputMaybe<Country>;
};


export type QueryRetrieveActivityListDataArgs = {
  employeeId: Scalars['HashedId']['input'];
  lastYear?: InputMaybe<Scalars['Boolean']['input']>;
  length: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  type: ActivityListType;
};


export type QueryRetrieveActivityListInitialDataArgs = {
  employeeId: Scalars['HashedId']['input'];
  lastYear?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRetrieveSkillStatusDataInMeetingInvitationArgs = {
  employeeId: Scalars['HashedId']['input'];
};


export type QueryReviewersByCompanyIdArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type QueryReviewersRelationOfBusinessUnitIdArgs = {
  buId: Scalars['HashedId']['input'];
};


export type QuerySalaryByContractIdArgs = {
  id: Scalars['HashedId']['input'];
};


export type QuerySalaryByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySalaryOfYearArgs = {
  employeeId: Scalars['HashedId']['input'];
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryScheduledMeetingsByManagerArgs = {
  managerId: Scalars['HashedId']['input'];
  year: Scalars['Float']['input'];
};


export type QueryScoreGridWithHistoryArgs = {
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type QuerySelfReflectionSummaryArgs = {
  businessUnitIds: Array<Scalars['HashedId']['input']>;
};


export type QuerySelfreflectionQuestionsArgs = {
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
};


export type QuerySkillStatusBlocksMeetingArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QuerySubOrdinatesByEmployeeArgs = {
  id: Scalars['HashedId']['input'];
};


export type QuerySubordinateMeetingsArgs = {
  managerId: Scalars['HashedId']['input'];
};


export type QuerySubordinateOfCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
};


export type QuerySubordinateSearchArgs = {
  pagination: CursorPaginationSubordinateInput;
  search: Scalars['String']['input'];
};


export type QuerySubordinatesArgs = {
  buId?: InputMaybe<Scalars['HashedId']['input']>;
  companyId: Scalars['HashedId']['input'];
  reviewer: Scalars['Boolean']['input'];
};


export type QueryTagHistoryOfEmployeeArgs = {
  employeeId: Scalars['HashedId']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<EmployeeTagType>>;
};


export type QueryTagHistoryOfEmployeeUntilReplyEntryDateArgs = {
  employeeId: Scalars['HashedId']['input'];
  types?: InputMaybe<Array<EmployeeTagType>>;
};


export type QueryTagHistoryOfResignedEmployeeUntilReplyEntryDateArgs = {
  employeeId: Scalars['HashedId']['input'];
  types?: InputMaybe<Array<EmployeeTagType>>;
};


export type QueryTalentsSeasonSettingsArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  year: Scalars['Int']['input'];
};


export type QueryTargetBonusByContractIdArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryTargetBonusByEmployeeIdArgs = {
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTargetBonusOfYearArgs = {
  employeeId: Scalars['HashedId']['input'];
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryTargetCorrectionPaymentArgs = {
  id: Scalars['HashedId']['input'];
};


export type QueryTargetCorrectionPaymentAllowedYearsArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QueryTargetCorrectionPaymentByMeetingIdArgs = {
  meetingId: Scalars['HashedId']['input'];
};


export type QueryTargetTemplatesOfCompanyArgs = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
};

export type RankInput = {
  assessable: Scalars['Boolean']['input'];
  employeeId: Scalars['HashedId']['input'];
  rank: Scalars['Float']['input'];
};

/** All possible ranking levels */
export enum RankingLevel {
  High = 'HIGH',
  Low = 'LOW',
  Unrated = 'UNRATED'
}

export type RankingReportFilterInput = {
  company?: InputMaybe<CompaniesForRankingReportInput>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type ReferencePyramid = {
  __typename?: 'ReferencePyramid';
  companyId: Scalars['HashedId']['output'];
  country: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  referencePyramidDetails?: Maybe<Array<ReferencePyramidDetail>>;
  referencePyramidType: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferencePyramidDetail = {
  __typename?: 'ReferencePyramidDetail';
  displayOrder: Scalars['Float']['output'];
  id: Scalars['HashedId']['output'];
  limitType: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  range: Scalars['String']['output'];
  referencePyramid?: Maybe<ReferencePyramid>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferencePyramidDetailsInput = {
  displayOrder: Scalars['Float']['input'];
  limitType: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
  range: Scalars['String']['input'];
};

export type ReferencePyramidInput = {
  companyId: Scalars['HashedId']['input'];
  country: Country;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  referencePyramidDetailsInput?: InputMaybe<Array<ReferencePyramidDetailsInput>>;
  referencePyramidType: PyramidType;
};

export type ReferencePyramidTemplateDto = {
  __typename?: 'ReferencePyramidTemplateDTO';
  country: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  referencePyramidTemplateDetails?: Maybe<Array<ReferencePyramidTemplateDetailDto>>;
  referencePyramidType: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ReferencePyramidTemplateDetailDto = {
  __typename?: 'ReferencePyramidTemplateDetailDTO';
  displayOrder: Scalars['Float']['output'];
  id: Scalars['HashedId']['output'];
  limitType: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  range: Scalars['String']['output'];
  referencePyramidTemplate?: Maybe<ReferencePyramidTemplateDto>;
};

export type RemoveEmployeeTagInput = {
  employeeId: Scalars['HashedId']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  type: EmployeeTagType;
};

export type ReportDto = {
  __typename?: 'ReportDTO';
  companyId?: Maybe<Scalars['HashedId']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country: Country;
  createTargetReport?: Maybe<Scalars['Boolean']['output']>;
  creator?: Maybe<EmployeeDisplayTinyInfo>;
  date: Scalars['DateTime']['output'];
  downloadLink: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  format: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  size: Scalars['Float']['output'];
  status: ReportStatus;
  type: ReportType;
};

export type ReportPaginationDto = {
  __typename?: 'ReportPaginationDTO';
  edges: Array<ReportDto>;
  endCursorReportDate?: Maybe<Scalars['DateTime']['output']>;
  endCursorReportId?: Maybe<Scalars['HashedId']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

/** All possible report statuses */
export enum ReportStatus {
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

/** All possible types for Reports */
export enum ReportType {
  Detailed = 'DETAILED',
  Meeting = 'MEETING',
  MeetingDeprecated = 'MEETING_DEPRECATED',
  Pyramid = 'PYRAMID',
  Ranking = 'RANKING',
  Target = 'TARGET'
}

export type RescheduleMeetingInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meetingDate: Scalars['DateTime']['input'];
  meetingId?: InputMaybe<Scalars['HashedId']['input']>;
};

/** data structure for resigned employees */
export type ResignedEmployeeDto = {
  __typename?: 'ResignedEmployeeDto';
  /** last target bonus  */
  bonus?: Maybe<Scalars['Float']['output']>;
  /** bussines unit of employee */
  businessUnit: BusinessUnitTiny;
  /** currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** end date  of contract */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** employee first name */
  firstName: Scalars['String']['output'];
  /** ID of the resigned employee */
  id: Scalars['HashedId']['output'];
  /** employee last name */
  lastName: Scalars['String']['output'];
  /** levelof employee */
  level?: Maybe<EmployeeLevelEnum>;
  /** reason for resignation */
  reason?: Maybe<CancellationType>;
  /** last salary */
  salary?: Maybe<Scalars['Float']['output']>;
  /** start date of contract */
  startDate: Scalars['DateTime']['output'];
  timezone: Scalars['String']['output'];
  /** unpaid ammount */
  toBePaid?: Maybe<ToBePaid>;
};

/** data structure for resigned employees in company settings view */
export type ResignedViewEmployeesDto = {
  __typename?: 'ResignedViewEmployeesDTO';
  employeesWithWrongStatusOrMissingContractDTO: Array<EmployeesWithWrongStatusOrMissingContractDto>;
  resignedEmployees: Array<ResignedEmployeeDto>;
};

export type ReviewerAndEmployee = {
  __typename?: 'ReviewerAndEmployee';
  canDelete: Scalars['Boolean']['output'];
  employee: EmployeeDisplayShortInfo;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  reviewer: EmployeeDisplayShortInfo;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  type: ReviewerOfEmployeeType;
};

/** All possible types of reviewer relations */
export enum ReviewerOfEmployeeType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type ReviewerOfEmployees = {
  __typename?: 'ReviewerOfEmployees';
  company: Company;
  companyId: Scalars['HashedId']['output'];
  employee: Employee;
  employeeId: Scalars['HashedId']['output'];
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  reviewer: Array<Employee>;
  reviewerId: Scalars['HashedId']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  type: ReviewerOfEmployeeType;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ReviewerOfEmployeesInput = {
  companyId: Scalars['HashedId']['input'];
  employeeId: Scalars['HashedId']['input'];
  fromDate: Scalars['DateTime']['input'];
  reviewerId: Scalars['HashedId']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<ReviewerOfEmployeeType>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['HashedId']['output'];
  name: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** All possible role names */
export enum RoleName {
  BuManager = 'BuManager',
  BusinessPartner = 'BusinessPartner',
  ChatbotUser = 'ChatbotUser',
  ClusterManager = 'ClusterManager',
  CompanyManager = 'CompanyManager',
  Downloader = 'Downloader',
  GlobalAdmin = 'GlobalAdmin',
  Hr = 'HR',
  HrAdminAut = 'HR_ADMIN_AUT',
  HrAdminBel = 'HR_ADMIN_BEL',
  HrAdminBlr = 'HR_ADMIN_BLR',
  HrAdminBra = 'HR_ADMIN_BRA',
  HrAdminChe = 'HR_ADMIN_CHE',
  HrAdminChn = 'HR_ADMIN_CHN',
  HrAdminDeu = 'HR_ADMIN_DEU',
  HrAdminFra = 'HR_ADMIN_FRA',
  HrAdminGbr = 'HR_ADMIN_GBR',
  HrAdminHkg = 'HR_ADMIN_HKG',
  HrAdminHrv = 'HR_ADMIN_HRV',
  HrAdminInd = 'HR_ADMIN_IND',
  HrAdminIta = 'HR_ADMIN_ITA',
  HrAdminLux = 'HR_ADMIN_LUX',
  HrAdminMar = 'HR_ADMIN_MAR',
  HrAdminNld = 'HR_ADMIN_NLD',
  HrAdminNzl = 'HR_ADMIN_NZL',
  HrAdminPol = 'HR_ADMIN_POL',
  HrAdminRou = 'HR_ADMIN_ROU',
  HrAdminUsa = 'HR_ADMIN_USA',
  HrReadonlyAut = 'HR_READONLY_AUT',
  HrReadonlyBel = 'HR_READONLY_BEL',
  HrReadonlyBlr = 'HR_READONLY_BLR',
  HrReadonlyBra = 'HR_READONLY_BRA',
  HrReadonlyChe = 'HR_READONLY_CHE',
  HrReadonlyChn = 'HR_READONLY_CHN',
  HrReadonlyDeu = 'HR_READONLY_DEU',
  HrReadonlyFra = 'HR_READONLY_FRA',
  HrReadonlyGbr = 'HR_READONLY_GBR',
  HrReadonlyHkg = 'HR_READONLY_HKG',
  HrReadonlyHrv = 'HR_READONLY_HRV',
  HrReadonlyInd = 'HR_READONLY_IND',
  HrReadonlyIta = 'HR_READONLY_ITA',
  HrReadonlyLux = 'HR_READONLY_LUX',
  HrReadonlyMar = 'HR_READONLY_MAR',
  HrReadonlyNld = 'HR_READONLY_NLD',
  HrReadonlyNzl = 'HR_READONLY_NZL',
  HrReadonlyPol = 'HR_READONLY_POL',
  HrReadonlyRou = 'HR_READONLY_ROU',
  HrReadonlyUsa = 'HR_READONLY_USA',
  HrRestrictedAut = 'HR_RESTRICTED_AUT',
  HrRestrictedBel = 'HR_RESTRICTED_BEL',
  HrRestrictedBlr = 'HR_RESTRICTED_BLR',
  HrRestrictedBra = 'HR_RESTRICTED_BRA',
  HrRestrictedChe = 'HR_RESTRICTED_CHE',
  HrRestrictedChn = 'HR_RESTRICTED_CHN',
  HrRestrictedDeu = 'HR_RESTRICTED_DEU',
  HrRestrictedFra = 'HR_RESTRICTED_FRA',
  HrRestrictedGbr = 'HR_RESTRICTED_GBR',
  HrRestrictedHkg = 'HR_RESTRICTED_HKG',
  HrRestrictedHrv = 'HR_RESTRICTED_HRV',
  HrRestrictedInd = 'HR_RESTRICTED_IND',
  HrRestrictedIta = 'HR_RESTRICTED_ITA',
  HrRestrictedLux = 'HR_RESTRICTED_LUX',
  HrRestrictedMar = 'HR_RESTRICTED_MAR',
  HrRestrictedNld = 'HR_RESTRICTED_NLD',
  HrRestrictedNzl = 'HR_RESTRICTED_NZL',
  HrRestrictedPol = 'HR_RESTRICTED_POL',
  HrRestrictedRou = 'HR_RESTRICTED_ROU',
  HrRestrictedUsa = 'HR_RESTRICTED_USA',
  NetworkManager = 'NetworkManager',
  OnboardingUser = 'OnboardingUser',
  Replyer = 'Replyer',
  Reviewer = 'Reviewer'
}

export type RoleOfUser = {
  __typename?: 'RoleOfUser';
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  role: Role;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['HashedId']['output'];
};

export type Salary = {
  __typename?: 'Salary';
  amount: Scalars['Float']['output'];
  contract: Contract;
  contractId: Scalars['HashedId']['output'];
  currency: Currency;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isFulltime: Scalars['Boolean']['output'];
  isTentative: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  percentageOfWorktime: Scalars['Float']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type SalaryDto = {
  __typename?: 'SalaryDTO';
  amount: Scalars['Float']['output'];
  contractId: Scalars['HashedId']['output'];
  currency: Currency;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isFulltime: Scalars['Boolean']['output'];
  isTentative: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  percentageOfWorktime: Scalars['Float']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
};

export type SalaryHistoryDto = {
  __typename?: 'SalaryHistoryDTO';
  salaryHistory: Array<SalaryDto>;
};

export type ScoreGoal = {
  __typename?: 'ScoreGoal';
  employeeEvaluation?: Maybe<Scalars['Float']['output']>;
  id: Scalars['HashedId']['output'];
  lastResultEvaluation?: Maybe<Scalars['Float']['output']>;
  resultEvaluation?: Maybe<Scalars['Float']['output']>;
  reviewerEvaluation?: Maybe<Scalars['Float']['output']>;
  scoreGrid?: Maybe<ScoreGrid>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  viewId: ScoreGoalType;
};

/** the scoring of one employee in one category */
export type ScoreGoalDto = {
  __typename?: 'ScoreGoalDto';
  /** the self evaluation of the employee in this category */
  employeeEvaluation?: Maybe<Scalars['Float']['output']>;
  /** the ID of this evaluation */
  id: Scalars['HashedId']['output'];
  /** the resulting evaluation */
  lastResultEvaluation?: Maybe<Scalars['Float']['output']>;
  /** the resulting evaluation */
  resultEvaluation?: Maybe<Scalars['Float']['output']>;
  /** the evaluation of the employee by the reviewer */
  reviewerEvaluation?: Maybe<Scalars['Float']['output']>;
  /** the category the employee is scored in */
  viewId: ScoreGoalType;
};

export type ScoreGoalInput = {
  employeeEvaluation?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['HashedId']['input'];
  resultEvaluation?: InputMaybe<Scalars['Float']['input']>;
  reviewerEvaluation?: InputMaybe<Scalars['Float']['input']>;
  viewId: ScoreGoalType;
};

/** All possible score goal types */
export enum ScoreGoalType {
  Customer_1 = 'Customer_1',
  Customer_2 = 'Customer_2',
  Customer_3 = 'Customer_3',
  Customer_4 = 'Customer_4',
  Customer_5 = 'Customer_5',
  Excellence_1 = 'Excellence_1',
  Excellence_2 = 'Excellence_2',
  Excellence_3 = 'Excellence_3',
  HumanValues_1 = 'HumanValues_1',
  HumanValues_2 = 'HumanValues_2',
  Innovation_1 = 'Innovation_1',
  Innovation_2 = 'Innovation_2',
  Speed_1 = 'Speed_1',
  Speed_2 = 'Speed_2',
  Speed_3 = 'Speed_3',
  Teamwork_1 = 'Teamwork_1',
  Teamwork_2 = 'Teamwork_2',
  Teamwork_3 = 'Teamwork_3'
}

export type ScoreGrid = {
  __typename?: 'ScoreGrid';
  date: Scalars['DateTime']['output'];
  employeePreparationScore?: Maybe<Scalars['Float']['output']>;
  id: Scalars['HashedId']['output'];
  managerPreparationScore?: Maybe<Scalars['Float']['output']>;
  resultScore?: Maybe<Scalars['Float']['output']>;
  scoreGoals: Array<ScoreGoal>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** a score grid containing the score for one Employee */
export type ScoreGridDto = {
  __typename?: 'ScoreGridDto';
  date: Scalars['DateTime']['output'];
  /** The score resulting from the self evaluation done by the employee */
  employeePreparationScore?: Maybe<Scalars['Float']['output']>;
  /** the id of the Score Grid */
  id: Scalars['HashedId']['output'];
  /** The score resulting from the last evaluation */
  lastResultScore?: Maybe<Scalars['Float']['output']>;
  /** The score resulting from the prepared evaluation done by the reviewer */
  managerPreparationScore?: Maybe<Scalars['Float']['output']>;
  /** The resulting score set in the meeting between employee and reviewer */
  resultScore?: Maybe<Scalars['Float']['output']>;
  /** the evaluations of the employee */
  scoreGoals: Array<ScoreGoalDto>;
};

export type ScoreGridExcelDataInput = {
  employeeId: Scalars['HashedId']['input'];
  scoreGrid?: InputMaybe<DraftScoreGridInput>;
};

export type ScoreGridInput = {
  date: Scalars['DateTime']['input'];
  id: Scalars['HashedId']['input'];
  scoreGoals: Array<ScoreGoalInput>;
};

/** All ScoreGrid statuses */
export enum ScoreGridStatus {
  Closed = 'Closed',
  Discarded = 'Discarded',
  Draft = 'Draft',
  DraftAppliedPreparationConfirmed = 'DraftAppliedPreparationConfirmed',
  DraftAppliedPreparationNotConfirmed = 'DraftAppliedPreparationNotConfirmed',
  Open = 'Open'
}

/** Overview of the score grids from last two appraisals */
export type ScoreGridsOverviewDto = {
  __typename?: 'ScoreGridsOverviewDTO';
  /** the ID of the overview */
  id: Scalars['HashedId']['output'];
  /** the date of the last appraisal */
  lastAppraisalDate: Scalars['DateTime']['output'];
  /** the date of the employee preparation of the last appraisal */
  lastAppraisalEmplPrepDate?: Maybe<Scalars['DateTime']['output']>;
  /** the date of the appraisal prior to the last appraisal */
  priorAppraisalDate?: Maybe<Scalars['DateTime']['output']>;
  /** the appraisal evaluations of the employee */
  scoreGoals: Array<ScoreGoalDto>;
};

/** All possible selfreflection question types */
export enum SelfReflectionQuestionType {
  BooleanCheckbox = 'BooleanCheckbox',
  BooleanTick = 'BooleanTick',
  CategorialFaces = 'CategorialFaces',
  CategorialSlider = 'CategorialSlider'
}

/** summary of the self-reflection information for business units */
export type SelfReflectionSummary = {
  __typename?: 'SelfReflectionSummary';
  /** number of employees that answered the survey and decided to share their answers */
  numberOfAnswers: Scalars['Int']['output'];
  /** how happy employees are with their project situation */
  projectHappiness: HappinessLevel;
  /** total number of employees that where expected to answer the survey */
  totalParticipants: Scalars['Int']['output'];
};

export type SelfreflectionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['HashedId']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SelfreflectionQuestion = {
  __typename?: 'SelfreflectionQuestion';
  comment?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  id: Scalars['HashedId']['output'];
  meetingId: Scalars['HashedId']['output'];
  position: Scalars['Float']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subItems: Array<SelfreflectionQuestionBoolean>;
  textId: Scalars['String']['output'];
  type: SelfReflectionQuestionType;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SelfreflectionQuestionBoolean = {
  __typename?: 'SelfreflectionQuestionBoolean';
  id: Scalars['HashedId']['output'];
  position: Scalars['Float']['output'];
  selfreflectionQuestion?: Maybe<SelfreflectionQuestion>;
  textId?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type SelfreflectionQuestionBooleanInput = {
  id: Scalars['HashedId']['input'];
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkillEmployeeStatusDto = {
  __typename?: 'SkillEmployeeStatusDto';
  employeeExpireDate?: Maybe<Scalars['DateTime']['output']>;
  employeeId: Scalars['HashedId']['output'];
  expired: Scalars['Boolean']['output'];
  latestSyncDate: Scalars['DateTime']['output'];
  skillStatus: SkillEmployeeStatusEnum;
  statusId: Scalars['HashedId']['output'];
};

/** All possible states of the skill center. The status will be Unknown if information retrieval fails */
export enum SkillEmployeeStatusEnum {
  Completed = 'COMPLETED',
  CvIncomplete = 'CV_INCOMPLETE',
  Missing = 'MISSING',
  NearlyExpiring = 'NEARLY_EXPIRING',
  Outdated = 'OUTDATED',
  PendingAiReview = 'PENDING_AI_REVIEW',
  RequiresImprovement = 'REQUIRES_IMPROVEMENT',
  Unknown = 'UNKNOWN',
  UnknownYellow = 'UNKNOWN_YELLOW'
}

export type SkillEmployeeStatusMeetingInvitationDto = {
  __typename?: 'SkillEmployeeStatusMeetingInvitationDto';
  isSkillStatusBlocker: Scalars['Boolean']['output'];
  retrievalError: Scalars['Boolean']['output'];
  skillEmployeeStatusDto?: Maybe<SkillEmployeeStatusDto>;
};

/** All possible Reasons for skipping a step in a meeting */
export enum SkipMeetingStepReason {
  LongTermSickness = 'LongTermSickness',
  NewStarter = 'NewStarter',
  Other = 'Other',
  ParentalLeave = 'ParentalLeave',
  Resigned = 'Resigned',
  Sabatical = 'Sabatical'
}

export type SqsBuffer = {
  __typename?: 'SqsBuffer';
  id: Scalars['HashedId']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Subordinate = {
  __typename?: 'Subordinate';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  businessUnit: BusinessUnit;
  careerPath?: Maybe<Array<CareerPathDto>>;
  careerPathEvaluation?: Maybe<CareerPathEvaluation>;
  companyName: Scalars['String']['output'];
  contractLevel: EmployeeLevelEnum;
  contractValidTo?: Maybe<Scalars['DateTime']['output']>;
  country: Country;
  currencyForPayments: Currency;
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  replyEntryDate: Scalars['DateTime']['output'];
  resultScore?: Maybe<Scalars['Float']['output']>;
  salary?: Maybe<Salary>;
  skillStatus?: Maybe<SkillEmployeeStatusDto>;
  targetBonus?: Maybe<TargetBonus>;
  timezone: Scalars['String']['output'];
};

export type SubordinateSearchPagination = {
  __typename?: 'SubordinateSearchPagination';
  edges: Array<EmployeeSearch>;
  endCursorId?: Maybe<Scalars['HashedId']['output']>;
  endCursorLegalFirstName?: Maybe<Scalars['String']['output']>;
  endCursorLegalLastName?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type TalentsSeasonInput = {
  blockedChangesForLow?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['HashedId']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['HashedId']['input']>;
  lowPercentage?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  talentsSeasonStatus: TalentsSeasonStatus;
  topPercentage?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type TalentsSeasonSettingsDto = {
  __typename?: 'TalentsSeasonSettingsDTO';
  blockedChangesForLow: Scalars['Boolean']['output'];
  /** timestamp with time zone */
  closingDate?: Maybe<Scalars['DateTime']['output']>;
  closingEmployee?: Maybe<EmployeeDisplayTinyInfo>;
  companyId: Scalars['HashedId']['output'];
  /** timestamp with time zone */
  confirmationDate?: Maybe<Scalars['DateTime']['output']>;
  confirmationEmployee?: Maybe<EmployeeDisplayTinyInfo>;
  country: Country;
  lowPercentage: Scalars['Float']['output'];
  talentsSeasonId?: Maybe<Scalars['HashedId']['output']>;
  talentsSeasonStatus: TalentsSeasonStatus;
  topPercentage: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

/** All possible statuses of Talents Season */
export enum TalentsSeasonStatus {
  Closed = 'Closed',
  Confirmed = 'Confirmed',
  Opened = 'Opened',
  Ready = 'Ready'
}

export type TalentsSeasonYearDto = {
  __typename?: 'TalentsSeasonYearDTO';
  companyId: Scalars['HashedId']['output'];
  country: Country;
  talentsSeasonId?: Maybe<Scalars['HashedId']['output']>;
  talentsSeasonStatus: TalentsSeasonStatus;
  year: Scalars['Float']['output'];
};

export type TargetBonus = {
  __typename?: 'TargetBonus';
  amount: Scalars['Float']['output'];
  contract: Contract;
  contractId: Scalars['HashedId']['output'];
  currency: Currency;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isTentative: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TargetBonusDto = {
  __typename?: 'TargetBonusDTO';
  amount: Scalars['Float']['output'];
  contractId: Scalars['HashedId']['output'];
  currency: Currency;
  fromDate: Scalars['DateTime']['output'];
  id: Scalars['HashedId']['output'];
  isTentative: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  toDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TargetBonusHistoryDto = {
  __typename?: 'TargetBonusHistoryDTO';
  targetBonusHistory: Array<TargetBonusDto>;
};

export type TargetCorrectionPaymentAllowedYearsDto = {
  __typename?: 'TargetCorrectionPaymentAllowedYearsDto';
  currentYearAllowed: Scalars['Boolean']['output'];
  previousYearAllowed: Scalars['Boolean']['output'];
};

export type TargetCorrectionPaymentDto = {
  __typename?: 'TargetCorrectionPaymentDto';
  comment: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  meetingId: Scalars['HashedId']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentDateValid: Scalars['Boolean']['output'];
  referenceYear: Scalars['Float']['output'];
  resultAmount?: Maybe<Scalars['Float']['output']>;
  status: TargetCorrectionPaymentStatus;
};

export type TargetCorrectionPaymentInput = {
  comment: Scalars['String']['input'];
  id?: InputMaybe<Scalars['HashedId']['input']>;
  meetingId: Scalars['HashedId']['input'];
  paymentDate: Scalars['DateTime']['input'];
  referenceYear: Scalars['Float']['input'];
  resultAmount: Scalars['Float']['input'];
};

/** All possible TargetCorrectionPayment statuses */
export enum TargetCorrectionPaymentStatus {
  Active = 'Active',
  Sent = 'Sent'
}

export type TargetReportGenerationRequestDto = {
  __typename?: 'TargetReportGenerationRequestDTO';
  /** It defines if the target report generation is currently available */
  createTargetReport: Scalars['Boolean']['output'];
  /** It defines whether the target report generation request has been inserted in DB or not */
  generationResult: Scalars['Boolean']['output'];
};

export type TargetsCalculationHelperDto = {
  __typename?: 'TargetsCalculationHelperDTO';
  newTargetsReferenceYear: Scalars['Float']['output'];
  pastTargetsReferenceYear: Scalars['Float']['output'];
};

export type TemporalBoundaries = {
  __typename?: 'TemporalBoundaries';
  fromDate: Scalars['DateTime']['output'];
  toDate?: Maybe<Scalars['DateTime']['output']>;
};

/** amount and currency of aggregated objectives */
export type ToBePaid = {
  __typename?: 'ToBePaid';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export type UpdateNationalContractReferenceInput = {
  levels: Array<UpdateNationalContractReferenceLevelInput>;
  type: NationalContractType;
};

export type UpdateNationalContractReferenceLevelInput = {
  level: NationalContractLevelEnum;
  minSalary: Scalars['Float']['input'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  id: Scalars['HashedId']['output'];
  kudosOptOut: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  nameDisplayPreference: Scalars['String']['output'];
  onboardingDate?: Maybe<Scalars['DateTime']['output']>;
  roles?: Maybe<Array<RoleName>>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  currencyForPayments: Scalars['String']['output'];
  currentEmployeeLevel: Scalars['String']['output'];
  email: Scalars['String']['output'];
  employeeId: Scalars['HashedId']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['HashedId']['output'];
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  managedBusinessUnits: Array<BusinessUnitTiny>;
  managedCompanies: Array<CompanyTiny>;
  nameDisplayPreference: Scalars['String']['output'];
  roles?: Maybe<Array<RoleName>>;
  skillCenterUrl: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type WorkforceMovementCounters = {
  __typename?: 'WorkforceMovementCounters';
  currentMonth: Scalars['Int']['output'];
  nextMonth?: Maybe<Scalars['Int']['output']>;
  previousMonth?: Maybe<Scalars['Int']['output']>;
  workforceMovementType: WorkforceMovementsEnum;
};

/** Which calendar month bucket a workforce movement detail query refers to */
export enum WorkforceMovementPeriodEnum {
  CurrentMonth = 'CURRENT_MONTH',
  NextMonth = 'NEXT_MONTH',
  PreviousMonth = 'PREVIOUS_MONTH'
}

/** All possible movements of the workforce */
export enum WorkforceMovementsEnum {
  Leavers = 'Leavers',
  NewEntries = 'NewEntries',
  ProbationPeriodEnding = 'ProbationPeriodEnding'
}

export type YearsAndCompaniesForRankingReportDto = {
  __typename?: 'YearsAndCompaniesForRankingReportDTO';
  possibleCompanies: Array<CompaniesForRankingReportDto>;
  possibleYears: Array<Scalars['Float']['output']>;
};

export type CheckChatbotPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckChatbotPermissionQuery = { __typename?: 'Query', checkChatbotPermission: boolean };

export type GetOnboardingDataQueryVariables = Exact<{
  iframeId: Scalars['String']['input'];
}>;


export type GetOnboardingDataQuery = { __typename?: 'Query', getOnboardingData: { __typename?: 'OnboardingDataDTO', setCookieUrl: string, authUrl: string, damUrl: string, redirectUrlQueryParamName: string, queryParamsString: string } };

export type CheckOnboardingPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckOnboardingPermissionQuery = { __typename?: 'Query', checkOnboardingPermission: boolean };

export type CheckVisibilityOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckVisibilityOnboardingQuery = { __typename?: 'Query', checkVisibilityOnboarding: boolean };

export type UpdateOnboardingDateMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateOnboardingDateMutation = { __typename?: 'Mutation', updateOnboardingDate: boolean };

export type GetTargetsTemplatesQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type GetTargetsTemplatesQuery = { __typename?: 'Query', getTargetsTemplates: Array<{ __typename?: 'ObjectiveTemplateDTO', id: any, objectiveTitle: string, lastEditedDate: any, lastModifier: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, creator: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, objectiveKeyResults: Array<{ __typename?: 'ObjectiveKeyResultDTO', id: any, displayOrder: number, text: string }>, objectiveNotes: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } }> }> };

export type GetActivityListInitialDataQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  lastYear?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetActivityListInitialDataQuery = { __typename?: 'Query', retrieveActivityListInitialData: Array<{ __typename?: 'ActivityListDTO', type: ActivityListType, length: number, data: Array<{ __typename?: 'ActivityListDataDTO', type: string, name: string, date: any, url?: string | null }> }> };

export type GetActivityListDataQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  type: ActivityListType;
  page: Scalars['Int']['input'];
  length: Scalars['Int']['input'];
  lastYear?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetActivityListDataQuery = { __typename?: 'Query', retrieveActivityListData?: Array<{ __typename?: 'ActivityListDataDTO', type: string, name: string, date: any, url?: string | null }> | null };

export type GetManagerMeetingStepTargetsQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
  country: Country;
  withChanges: Scalars['Boolean']['input'];
  includeAllTargetBoni: Scalars['Boolean']['input'];
}>;


export type GetManagerMeetingStepTargetsQuery = { __typename?: 'Query', isBonusValidationEnabled: boolean, objectivesInMeeting: Array<{ __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, targetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }>, contractChangesByEmployee?: Array<{ __typename?: 'Change', id: any, changes: string, validFrom?: any | null, status?: ChangeStatus | null, updatedDate?: any | null }>, currentContract?: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency, validFrom: any, validTo?: any | null, updatesRestrictedTo?: any | null, cancellationType?: CancellationType | null, cancellationFrom?: any | null, cancellationTo?: any | null, flexibleBenefit?: number | null, hasNationalContract: boolean, isDeductionEnabled: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, legalEntity: { __typename?: 'LegalEntity', name?: string | null, country: Country }, annualSalary?: { __typename?: 'Salary', amount: number, isTentative: boolean, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', amount: number, currency: Currency } | null, contractType: { __typename?: 'ContractType', typeOfContract: ContractTypeEnum }, employeeLevel?: { __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, isTentative: boolean } | null, nationalContractLevel?: { __typename?: 'NationalContractLevel', type: NationalContractType, level: NationalContractLevelEnum } | null, nationalContractReferenceLevel?: { __typename?: 'NationalContractReferenceDTO', description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, selectable: boolean, displayOrder: number }> } | null, leaveEntitlement?: { __typename?: 'LeaveEntitlement', amount: number } | null, companyCar?: { __typename?: 'CompanyCar', deduction?: number | null, type?: string | null, currency: string } | null, executedPayments?: Array<{ __typename?: 'ExecutedPayment', amount: number, referenceYear: number, paymentDate: any, type: ExecutedPaymentType, currency: Currency }> | null, contractGovernmentJobTitle?: { __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } } | null }, salaryOfYear: Array<{ __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null }>, contractsInYear: Array<{ __typename?: 'Contract', id: any, validFrom: any, validTo?: any | null, cancellationTo?: any | null }>, branchOfficeByEmployee: { __typename?: 'BranchOffice', code: string, name: string, timezone: string, addressId: any } };

export type EmployeeConfirmPreparationMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
  input: EmployeeConfirmPreparationInput;
}>;


export type EmployeeConfirmPreparationMutation = { __typename?: 'Mutation', employeeConfirmPreparation: { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } } };

export type ManagerConfirmPreparationMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type ManagerConfirmPreparationMutation = { __typename?: 'Mutation', managerConfirmPreparation: { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } } };

export type SetNextAppraisalSeasonOpeningDateMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  year: Scalars['Int']['input'];
  openingMonth: Scalars['Int']['input'];
  openingYear: Scalars['Int']['input'];
}>;


export type SetNextAppraisalSeasonOpeningDateMutation = { __typename?: 'Mutation', setNextAppraisalSeasonOpeningDate: boolean };

export type GetAppraisalSeasonOpeningInfoQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type GetAppraisalSeasonOpeningInfoQuery = { __typename?: 'Query', getAppraisalSeasonOpeningInfo: { __typename?: 'AppraisalSeasonOpeningInfoDTO', defaultAppraisalSeasonOpeningMonth: number, defaultCountryTimezone: string, currentAppraisalSeasonOpeningMonth: number, currentAppraisalSeasonOpeningYear: number, nextAppraisalSeasonOpeningMonth: number, nextAppraisalSeasonOpeningYear?: number | null, currentAppraisalSeasonYear: number, nextAppraisalSeasonYear: number } };

export type GetCareerPathQueryVariables = Exact<{
  country: Country;
}>;


export type GetCareerPathQuery = { __typename?: 'Query', careerPath?: Array<{ __typename?: 'CareerPathDto', careerPathType: string, country: string, level: string, min: number, max?: number | null }> | null };

export type CareerPathEvaluationQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type CareerPathEvaluationQuery = { __typename?: 'Query', careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null };

export type ContractChangesByEmployeeQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type ContractChangesByEmployeeQuery = { __typename?: 'Query', contractChangesByEmployee: Array<{ __typename?: 'Change', id: any, validFrom?: any | null, changes: string, status?: ChangeStatus | null, type?: ChangeType | null }> };

export type CreateOrUpdateChangeMutationVariables = Exact<{
  change: ChangeInput;
  employeeId: Scalars['HashedId']['input'];
}>;


export type CreateOrUpdateChangeMutation = { __typename?: 'Mutation', createOrUpdateChange: { __typename?: 'CreateChangeResponse', success: boolean, change?: { __typename?: 'Change', id: any, validFrom?: any | null, changes: string, status?: ChangeStatus | null, type?: ChangeType | null } | null, error?: { __typename?: 'ChangeError', validFrom?: { __typename?: 'ChangeResponseErrorObject', message: string, props?: string | null } | null, bonus?: { __typename?: 'ChangeResponseErrorObject', message: string, props?: string | null } | null, salary?: { __typename?: 'ChangeResponseErrorObject', message: string, props?: string | null } | null, employeeLevel?: { __typename?: 'ChangeResponseErrorObject', message: string, props?: string | null } | null, nationalReferenceLevel?: { __typename?: 'ChangeResponseErrorObject', message: string, props?: string | null } | null } | null } };

export type DeleteChangeMutationVariables = Exact<{
  changeId: Scalars['HashedId']['input'];
  employeeId: Scalars['HashedId']['input'];
}>;


export type DeleteChangeMutation = { __typename?: 'Mutation', deleteChange: { __typename?: 'DeleteOk', id: any } };

export type CompanyManagerDashboardListOfCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyManagerDashboardListOfCompaniesQuery = { __typename?: 'Query', companyManagerDashboardListOfCompanies: Array<{ __typename?: 'DashboardListOfCompanies', companyId: any, companyName: string, countries: Array<Country>, rolesOnCompany: Array<RoleName> }> };

export type CompanyManagerDashboardPartialVisibilityQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardPartialVisibilityQuery = { __typename?: 'Query', companyManagerDashboardPartialVisibility: boolean };

export type CompanyManagerDashboardAsYearQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardAsYearQuery = { __typename?: 'Query', companyManagerDashboardASYear?: number | null, employeeLevels: Array<EmployeeLevelEnum> };

export type CompanyManagerDashboardAppraisalMeetingStatusQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardAppraisalMeetingStatusQuery = { __typename?: 'Query', companyManagerDashboardAppraisalMeetingStatus: { __typename?: 'CompanyManagerAppraisalMeetingStatusDTO', companyId: any, ongoingAppraisalUpdateAfterLatestConfirmedMeetingCount: number, rows: Array<{ __typename?: 'CompanyManagerAppraisalMeetingStatusTableRowDTO', status: CompanyManagerAppraisalMeetingStatus, country: Country, confirmedOrLatestMeetingType?: MeetingType | null, confirmedOrLatestMeetingId?: any | null, replyEntryDate: any, employee: { __typename?: 'EmployeeWithLevelDTO', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum }, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string }, office?: { __typename?: 'BranchOfficeDTO', id?: any | null, name: string, code: string } | null, buManagers: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }>, confirmedOrLatestMeetingConclusionPdf?: { __typename?: 'MeetingConclusionPdf', fileName: string, downloadToken: string, status: MeetingPdfStatus } | null }> } };

export type CompanyManagerDashboardBubobumCountersQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardBubobumCountersQuery = { __typename?: 'Query', companyManagerDashboardBubobumCounters: { __typename?: 'BUBOBUMcountersDTO', companyId: any, businessUnit: number, branchOffice: number, buManagers: number } };

export type CompanyManagerDashboardBumOfCompanyQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardBumOfCompanyQuery = { __typename?: 'Query', companyManagerDashboardBumOfCompany: { __typename?: 'BUMOfCompanyDTO', companyId: any, buManagers: Array<{ __typename?: 'BUMOfBusinessUnitDTO', businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string }, buManagers: Array<{ __typename?: 'EmployeeWithLevelDTO', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum }> }> } };

export type CompanyManagerDashboardBuOfCompanyQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardBuOfCompanyQuery = { __typename?: 'Query', companyManagerDashboardBuOfCompany: { __typename?: 'BUofCompanyDTO', companyId: any, businessUnitsWithManagers: Array<{ __typename?: 'BusinessUnitWithManagersDTO', numberOfEmployees: number, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string }, buManagers: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }> }> } };

export type CompanyManagerDashboardBoOfCompanyQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardBoOfCompanyQuery = { __typename?: 'Query', companyManagerDashboardBoOfCompany: { __typename?: 'BOofCompanyDTO', companyId: any, branchOfficesWithEmployees: Array<{ __typename?: 'BranchOfficeWithEmployeesDTO', branchOffice: { __typename?: 'BranchOfficeDTO', id?: any | null, code: string, name: string }, employees: Array<{ __typename?: 'EmployeeWithLevelDTO', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum }> }> } };

export type CompanyManagerAppraisalMeetingStatusTableRowFieldsFragment = { __typename?: 'CompanyManagerAppraisalMeetingStatusTableRowDTO', status: CompanyManagerAppraisalMeetingStatus, country: Country, confirmedOrLatestMeetingType?: MeetingType | null, confirmedOrLatestMeetingId?: any | null, replyEntryDate: any, employee: { __typename?: 'EmployeeWithLevelDTO', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum }, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string }, office?: { __typename?: 'BranchOfficeDTO', id?: any | null, name: string, code: string } | null, buManagers: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }>, confirmedOrLatestMeetingConclusionPdf?: { __typename?: 'MeetingConclusionPdf', fileName: string, downloadToken: string, status: MeetingPdfStatus } | null };

export type DashboardBusinessUnitTinyFieldsFragment = { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string };

export type DashboardEmployeeDisplayTinyInfoFieldsFragment = { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null };

export type DashboardEmployeeWithLevelFieldsFragment = { __typename?: 'EmployeeWithLevelDTO', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum };

export type DashboardBranchOfficeFieldsFragment = { __typename?: 'BranchOfficeDTO', id?: any | null, code: string, name: string };

export type CompanyManagerDashboardBuOfCompanyRowFieldsFragment = { __typename?: 'BusinessUnitWithManagersDTO', numberOfEmployees: number, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string }, buManagers: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }> };

export type CompanyManagerDashboardBumOfBusinessUnitRowFieldsFragment = { __typename?: 'BUMOfBusinessUnitDTO', businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string }, buManagers: Array<{ __typename?: 'EmployeeWithLevelDTO', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum }> };

export type CompanyManagerDashboardBoOfCompanyRowFieldsFragment = { __typename?: 'BranchOfficeWithEmployeesDTO', branchOffice: { __typename?: 'BranchOfficeDTO', id?: any | null, code: string, name: string }, employees: Array<{ __typename?: 'EmployeeWithLevelDTO', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum }> };

export type BusinessUnitTinyFieldsFragment = { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string };

export type WorkforceNewEntryRowFieldsFragment = { __typename?: 'NewEntries', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, replyEntryDate: any, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } };

export type WorkforceNewEntryByPeriodFieldsFragment = { __typename?: 'NewEntriesByPeriod', currentMonth: Array<{ __typename?: 'NewEntries', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, replyEntryDate: any, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }>, previousMonth: Array<{ __typename?: 'NewEntries', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, replyEntryDate: any, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }> };

export type WorkforceLeaverRowFieldsFragment = { __typename?: 'Leavers', id: any, firstName: string, lastName: string, avatarUrl?: string | null, leaverLevel: EmployeeLevelEnum, contractCancellationTo: any, contractCancellationType: CancellationType, contractType: ContractTypeEnum, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } };

export type WorkforceLeaverByPeriodFieldsFragment = { __typename?: 'LeaversByPeriod', currentMonth: Array<{ __typename?: 'Leavers', id: any, firstName: string, lastName: string, avatarUrl?: string | null, leaverLevel: EmployeeLevelEnum, contractCancellationTo: any, contractCancellationType: CancellationType, contractType: ContractTypeEnum, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }>, nextMonth: Array<{ __typename?: 'Leavers', id: any, firstName: string, lastName: string, avatarUrl?: string | null, leaverLevel: EmployeeLevelEnum, contractCancellationTo: any, contractCancellationType: CancellationType, contractType: ContractTypeEnum, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }> };

export type WorkforceProbationPeriodEndingRowFieldsFragment = { __typename?: 'ProbationPeriodEnding', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, probationPeriodEndDate: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } };

export type WorkforceProbationPeriodEndingByPeriodFieldsFragment = { __typename?: 'ProbationPeriodEndingByPeriod', currentMonth: Array<{ __typename?: 'ProbationPeriodEnding', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, probationPeriodEndDate: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }>, nextMonth: Array<{ __typename?: 'ProbationPeriodEnding', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, probationPeriodEndDate: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }> };

export type CompanyManagerDashboardWorkforceCountersQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardWorkforceCountersQuery = { __typename?: 'Query', companyManagerDashboardWorkforceCounters: { __typename?: 'DashboardWorkforceCountersDTO', companyId: any, totalEmployees: number, workforceMovementCounters: Array<{ __typename?: 'WorkforceMovementCounters', workforceMovementType: WorkforceMovementsEnum, currentMonth: number, nextMonth?: number | null, previousMonth?: number | null }> } };

export type CompanyManagerDashboardWorkforceNewEntriesQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  period?: InputMaybe<WorkforceMovementPeriodEnum>;
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardWorkforceNewEntriesQuery = { __typename?: 'Query', companyManagerDashboardWorkforceNewEntries: { __typename?: 'NewEntriesByPeriod', currentMonth: Array<{ __typename?: 'NewEntries', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, replyEntryDate: any, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }>, previousMonth: Array<{ __typename?: 'NewEntries', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, replyEntryDate: any, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }> } };

export type CompanyManagerDashboardWorkforceLeaversQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  period?: InputMaybe<WorkforceMovementPeriodEnum>;
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardWorkforceLeaversQuery = { __typename?: 'Query', companyManagerDashboardWorkforceLeavers: { __typename?: 'LeaversByPeriod', currentMonth: Array<{ __typename?: 'Leavers', id: any, firstName: string, lastName: string, avatarUrl?: string | null, leaverLevel: EmployeeLevelEnum, contractCancellationTo: any, contractCancellationType: CancellationType, contractType: ContractTypeEnum, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }>, nextMonth: Array<{ __typename?: 'Leavers', id: any, firstName: string, lastName: string, avatarUrl?: string | null, leaverLevel: EmployeeLevelEnum, contractCancellationTo: any, contractCancellationType: CancellationType, contractType: ContractTypeEnum, contractValidFrom: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }> } };

export type CompanyManagerDashboardWorkforceProbationPeriodEndingQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  period?: InputMaybe<WorkforceMovementPeriodEnum>;
  userDashboardRoles: Array<RoleName> | RoleName;
}>;


export type CompanyManagerDashboardWorkforceProbationPeriodEndingQuery = { __typename?: 'Query', companyManagerDashboardWorkforceProbationPeriodEnding: { __typename?: 'ProbationPeriodEndingByPeriod', currentMonth: Array<{ __typename?: 'ProbationPeriodEnding', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, probationPeriodEndDate: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }>, nextMonth: Array<{ __typename?: 'ProbationPeriodEnding', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel: EmployeeLevelEnum, probationPeriodEndDate: any, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string } }> } };

export type SetTopPercentageForCompanyCountryMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  topPercentage: Scalars['Float']['input'];
}>;


export type SetTopPercentageForCompanyCountryMutation = { __typename?: 'Mutation', setTopPercentageForCompanyCountry: boolean };

export type SetLowPercentageForCompanyCountryMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  lowPercentage: Scalars['Float']['input'];
}>;


export type SetLowPercentageForCompanyCountryMutation = { __typename?: 'Mutation', setLowPercentageForCompanyCountry: boolean };

export type SetLowPercentageIsBlockerForCompanyCountryMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  lowPercentageIsBlocker: Scalars['Boolean']['input'];
}>;


export type SetLowPercentageIsBlockerForCompanyCountryMutation = { __typename?: 'Mutation', setLowPercentageIsBlockerForCompanyCountry: boolean };

export type SetDisableRankingForCompanyCountryMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  isDisabled: Scalars['Boolean']['input'];
}>;


export type SetDisableRankingForCompanyCountryMutation = { __typename?: 'Mutation', setDisableRankingForCompanyCountry: boolean };

export type SetIsTagAssignmentInProgressForCompanyCountryMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
}>;


export type SetIsTagAssignmentInProgressForCompanyCountryMutation = { __typename?: 'Mutation', setIsTagAssignmentInProgressForCompanyCountry: boolean };

export type ConfirmTagAssignmentForCompanyCountryMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
}>;


export type ConfirmTagAssignmentForCompanyCountryMutation = { __typename?: 'Mutation', confirmTagAssignmentForCompanyCountry: boolean };

export type CompanyRankingSettingsForCountryQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type CompanyRankingSettingsForCountryQuery = { __typename?: 'Query', companyRankingSettingsForCountry: { __typename?: 'CompanyRankingSettingsDTO', topPercentage: number, lowPercentage: number, lowPercentageIsBlocker: boolean, rankingIsDisabled: boolean, tagAssignmentIsInProgress: boolean } };

export type CompaniesOfUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CompaniesOfUserQuery = { __typename?: 'Query', companiesOfUser: Array<{ __typename?: 'ManagedCompany', companyId: any, companyName: string, editable: boolean }> };

export type FindCompaniesAndCountriesByManagerOrResponsibleQueryVariables = Exact<{
  businessPartnerVisibility: Scalars['Boolean']['input'];
}>;


export type FindCompaniesAndCountriesByManagerOrResponsibleQuery = { __typename?: 'Query', findCompaniesAndCountriesByManagerOrResponsible: Array<{ __typename?: 'GroupedCompanyWithLegalEntitiesAndCountries', companyId?: any | null, companyName: string, companyCountries: Array<{ __typename?: 'GroupedLegalEntityWithCountry', legalEntityId?: any | null, legalEntityName: string, country: string }> }> };

export type FindCompaniesByManagerOrResponsibleQueryVariables = Exact<{
  businessPartnerVisibility: Scalars['Boolean']['input'];
}>;


export type FindCompaniesByManagerOrResponsibleQuery = { __typename?: 'Query', findCompaniesByManagerOrResponsible: Array<{ __typename?: 'CompanyTiny', id: any, name?: string | null }> };

export type FindCompaniesAndCountriesByCompanyManagerOrResponsibleQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCompaniesAndCountriesByCompanyManagerOrResponsibleQuery = { __typename?: 'Query', findCompaniesAndCountriesByCompanyManagerOrResponsible: Array<{ __typename?: 'GroupedCompanyWithLegalEntitiesAndCountries', companyId?: any | null, companyName: string, companyCountries: Array<{ __typename?: 'GroupedLegalEntityWithCountry', legalEntityId?: any | null, legalEntityName: string, country: string }> }> };

export type FindCompaniesAndCountriesByResponsibleQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCompaniesAndCountriesByResponsibleQuery = { __typename?: 'Query', findCompaniesAndCountriesByResponsible: Array<{ __typename?: 'GroupedCompanyWithLegalEntitiesAndCountries', companyId?: any | null, companyName: string, companyCountries: Array<{ __typename?: 'GroupedLegalEntityWithCountry', legalEntityId?: any | null, legalEntityName: string, country: string }> }> };

export type FindCompaniesAndCountriesByCompanyManagerQueryVariables = Exact<{
  excludeBusinessPartnerCompanies?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FindCompaniesAndCountriesByCompanyManagerQuery = { __typename?: 'Query', findCompaniesAndCountriesByCompanyManager: Array<{ __typename?: 'GroupedCompanyWithLegalEntitiesAndCountries', companyId?: any | null, companyName: string, companyCountries: Array<{ __typename?: 'GroupedLegalEntityWithCountry', legalEntityId?: any | null, legalEntityName: string, country: string }> }> };

export type FindCompaniesAndCountriesByNetworkOrCompanyManagerOrHrbpQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCompaniesAndCountriesByNetworkOrCompanyManagerOrHrbpQuery = { __typename?: 'Query', findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP: Array<{ __typename?: 'GroupedCompanyWithLegalEntitiesAndCountries', companyId?: any | null, companyName: string, companyCountries: Array<{ __typename?: 'GroupedLegalEntityWithCountry', legalEntityId?: any | null, legalEntityName: string, country: string }> }> };

export type FindUserManagerRolesByCompanyQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
}>;


export type FindUserManagerRolesByCompanyQuery = { __typename?: 'Query', findUserManagerRolesByCompany: Array<RoleName> };

export type FindUserManagerRolesByEmployeeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type FindUserManagerRolesByEmployeeQuery = { __typename?: 'Query', findUserManagerRolesByEmployee: Array<RoleName> };

export type CompanySearchQueryVariables = Exact<{
  companyScope: CompanyScope;
  search: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type CompanySearchQuery = { __typename?: 'Query', companySearch: Array<{ __typename?: 'CompanyTiny', id: any, name?: string | null }> };

export type SaveTargetTemplateMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  objective: ObjectiveTemplateInput;
}>;


export type SaveTargetTemplateMutation = { __typename?: 'Mutation', saveTargetTemplate: boolean };

export type DeleteTargetTemplateMutationVariables = Exact<{
  objectiveId: Scalars['HashedId']['input'];
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type DeleteTargetTemplateMutation = { __typename?: 'Mutation', deleteTargetTemplate: boolean };

export type DuplicateTargetTemplateMutationVariables = Exact<{
  objectiveId: Scalars['HashedId']['input'];
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type DuplicateTargetTemplateMutation = { __typename?: 'Mutation', duplicateTargetTemplate: boolean };

export type CompanySettingsReviewerQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
}>;


export type CompanySettingsReviewerQuery = { __typename?: 'Query', reviewersByCompanyId: Array<{ __typename?: 'ReviewerAndEmployee', id: any, fromDate: any, type: ReviewerOfEmployeeType, canDelete: boolean, reviewer: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, companyName?: string | null, buName: string, currentLevel?: string | null, avatarUrl?: string | null }, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, companyName?: string | null, buName: string, currentLevel?: string | null, avatarUrl?: string | null } }>, checkCompanyManagerOfCompany: { __typename?: 'PermissionCheck', permit: boolean }, activeEmployeesOfCompany?: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }> | null, activeEmployeesOfCompanyWithoutPartners?: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }> | null };

export type BuCompanySettingsReviewerQueryVariables = Exact<{
  buId: Scalars['HashedId']['input'];
}>;


export type BuCompanySettingsReviewerQuery = { __typename?: 'Query', reviewersRelationOfBusinessUnitId: Array<{ __typename?: 'ReviewerAndEmployee', id: any, fromDate: any, type: ReviewerOfEmployeeType, canDelete: boolean, reviewer: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, companyName?: string | null, buName: string, currentLevel?: string | null, avatarUrl?: string | null }, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, companyName?: string | null, buName: string, currentLevel?: string | null, avatarUrl?: string | null } }>, activeSubordinatesOfBuManager: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }> };

export type CompanySettingsTargetsQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type CompanySettingsTargetsQuery = { __typename?: 'Query', targetTemplatesOfCompany: Array<{ __typename?: 'ObjectiveTemplateDTO', id: any, objectiveTitle: string, lastEditedDate: any, lastModifier: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, creator: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, objectiveKeyResults: Array<{ __typename?: 'ObjectiveKeyResultDTO', id: any, text: string, displayOrder: number, globalId?: string | null }>, objectiveNotes: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } }> }> };

export type CompanySettingsEmployeesQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  employeeLevelCountry: Country;
}>;


export type CompanySettingsEmployeesQuery = { __typename?: 'Query', employeeLevels: Array<EmployeeLevelEnum>, subordinateOfCompany: Array<{ __typename?: 'CompanySubordinate', id: any, firstName: string, lastName: string, currentLevel?: string | null, avatarUrl?: string | null, buName: string, currencyForPayments: Currency, replyEntryDate: any, contractValidTo?: any | null, country: Country, salary?: number | null, targetBonus?: number | null, resultScore?: number | null, timezone: string, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, careerPath?: Array<{ __typename?: 'CareerPathDto', careerPathType: string, country: string, level: string, min: number, max?: number | null }> | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null }>, resignedEmployeesOfCompany: { __typename?: 'ResignedViewEmployeesDTO', employeesWithWrongStatusOrMissingContractDTO: Array<{ __typename?: 'EmployeesWithWrongStatusOrMissingContractDTO', fullName: string, businessUnitId: any }>, resignedEmployees: Array<{ __typename?: 'ResignedEmployeeDto', id: any, firstName: string, lastName: string, level?: EmployeeLevelEnum | null, salary?: number | null, currency?: string | null, bonus?: number | null, startDate: any, endDate?: any | null, reason?: CancellationType | null, timezone: string, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string, company?: { __typename?: 'CompanyTiny', id: any, name?: string | null } | null }, toBePaid?: { __typename?: 'ToBePaid', amount: number, currency: Currency } | null }> } };

export type SubordinateOfCompanyQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
}>;


export type SubordinateOfCompanyQuery = { __typename?: 'Query', subordinateOfCompany: Array<{ __typename?: 'CompanySubordinate', id: any, firstName: string, lastName: string, currentLevel?: string | null, avatarUrl?: string | null, buName: string, currencyForPayments: Currency, replyEntryDate: any, contractValidTo?: any | null, country: Country, salary?: number | null, targetBonus?: number | null, resultScore?: number | null, timezone: string, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, careerPath?: Array<{ __typename?: 'CareerPathDto', careerPathType: string, country: string, level: string, min: number, max?: number | null }> | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null }> };

export type CompanySettingsRankingQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type CompanySettingsRankingQuery = { __typename?: 'Query', employeesAndTags: Array<{ __typename?: 'EmployeeAndTag', id: any, firstName: string, lastName: string, currentLevel?: string | null, avatarUrl?: string | null, buName: string, companyName?: string | null, tags: Array<{ __typename?: 'EmployeeTagDto', id?: any | null, type: string, addedDate: any, removedDate?: any | null, note?: string | null, temporary?: boolean | null }> }>, companyRankingSettingsForCountry: { __typename?: 'CompanyRankingSettingsDTO', topPercentage: number, lowPercentage: number, lowPercentageIsBlocker: boolean, rankingIsDisabled: boolean, tagAssignmentIsInProgress: boolean } };

export type CompanySettingsPyramidsQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type CompanySettingsPyramidsQuery = { __typename?: 'Query', isAgePyramidVisible: boolean, ageReferencePyramid?: { __typename?: 'ReferencePyramid', id: any, companyId: any, referencePyramidType: string, referencePyramidDetails?: Array<{ __typename?: 'ReferencePyramidDetail', id: any, displayOrder: number, range: string, limitType: string, percentage: number }> | null } | null, levelReferencePyramid?: { __typename?: 'ReferencePyramid', id: any, companyId: any, referencePyramidType: string, referencePyramidDetails?: Array<{ __typename?: 'ReferencePyramidDetail', id: any, displayOrder: number, range: string, limitType: string, percentage: number }> | null } | null, ageReferencePyramidTemplate?: Array<{ __typename?: 'ReferencePyramidTemplateDTO', id: any, title?: string | null, country: string, referencePyramidType: string, referencePyramidTemplateDetails?: Array<{ __typename?: 'ReferencePyramidTemplateDetailDTO', id: any, range: string, limitType: string, percentage: number, displayOrder: number }> | null }> | null, levelReferencePyramidTemplate?: Array<{ __typename?: 'ReferencePyramidTemplateDTO', id: any, title?: string | null, country: string, referencePyramidType: string, referencePyramidTemplateDetails?: Array<{ __typename?: 'ReferencePyramidTemplateDetailDTO', id: any, range: string, limitType: string, percentage: number, displayOrder: number }> | null }> | null, employeeLevels: Array<{ __typename?: 'EmployeeLevelWithDisplayOrder', displayOrder: number, level: EmployeeLevelEnum }> };

export type CurrentContractQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type CurrentContractQuery = { __typename?: 'Query', currentContract: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency, validFrom: any, validTo?: any | null, updatesRestrictedTo?: any | null, cancellationType?: CancellationType | null, cancellationFrom?: any | null, cancellationTo?: any | null, flexibleBenefit?: number | null, hasNationalContract: boolean, isDeductionEnabled: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, legalEntity: { __typename?: 'LegalEntity', name?: string | null, country: Country }, annualSalary?: { __typename?: 'Salary', amount: number, isTentative: boolean, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', amount: number, currency: Currency } | null, contractType: { __typename?: 'ContractType', typeOfContract: ContractTypeEnum }, employeeLevel?: { __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, isTentative: boolean } | null, nationalContractLevel?: { __typename?: 'NationalContractLevel', type: NationalContractType, level: NationalContractLevelEnum } | null, nationalContractReferenceLevel?: { __typename?: 'NationalContractReferenceDTO', description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, selectable: boolean, displayOrder: number }> } | null, leaveEntitlement?: { __typename?: 'LeaveEntitlement', amount: number } | null, companyCar?: { __typename?: 'CompanyCar', deduction?: number | null, type?: string | null, currency: string } | null, executedPayments?: Array<{ __typename?: 'ExecutedPayment', amount: number, referenceYear: number, paymentDate: any, type: ExecutedPaymentType, currency: Currency }> | null, contractGovernmentJobTitle?: { __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } } | null }, branchOfficeByEmployee: { __typename?: 'BranchOffice', timezone: string } };

export type CurrentContractWithCareerPathEvaluationQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
  withChanges: Scalars['Boolean']['input'];
  includeAllTargetBoni: Scalars['Boolean']['input'];
  country: Country;
}>;


export type CurrentContractWithCareerPathEvaluationQuery = { __typename?: 'Query', isBonusValidationEnabled: boolean, targetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }>, contractChangesByEmployee?: Array<{ __typename?: 'Change', id: any, changes: string, validFrom?: any | null, status?: ChangeStatus | null, updatedDate?: any | null }>, currentContract?: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency, validFrom: any, validTo?: any | null, updatesRestrictedTo?: any | null, cancellationType?: CancellationType | null, cancellationFrom?: any | null, cancellationTo?: any | null, flexibleBenefit?: number | null, hasNationalContract: boolean, isDeductionEnabled: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, legalEntity: { __typename?: 'LegalEntity', name?: string | null, country: Country }, annualSalary?: { __typename?: 'Salary', amount: number, isTentative: boolean, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', amount: number, currency: Currency } | null, contractType: { __typename?: 'ContractType', typeOfContract: ContractTypeEnum }, employeeLevel?: { __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, isTentative: boolean } | null, nationalContractLevel?: { __typename?: 'NationalContractLevel', type: NationalContractType, level: NationalContractLevelEnum } | null, nationalContractReferenceLevel?: { __typename?: 'NationalContractReferenceDTO', description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, selectable: boolean, displayOrder: number }> } | null, leaveEntitlement?: { __typename?: 'LeaveEntitlement', amount: number } | null, companyCar?: { __typename?: 'CompanyCar', deduction?: number | null, type?: string | null, currency: string } | null, executedPayments?: Array<{ __typename?: 'ExecutedPayment', amount: number, referenceYear: number, paymentDate: any, type: ExecutedPaymentType, currency: Currency }> | null, contractGovernmentJobTitle?: { __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } } | null }, salaryOfYear: Array<{ __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null }>, contractsInYear: Array<{ __typename?: 'Contract', id: any, validFrom: any, validTo?: any | null, cancellationTo?: any | null }>, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, careerPath?: Array<{ __typename?: 'CareerPathDto', careerPathType: string, country: string, level: string, min: number, max?: number | null }> | null, branchOfficeByEmployee: { __typename?: 'BranchOffice', code: string, name: string, timezone: string, addressId: any } };

export type CurrentContractWithCareerPathEvaluationInProfileQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
  includeAllTargetBoni: Scalars['Boolean']['input'];
  country: Country;
}>;


export type CurrentContractWithCareerPathEvaluationInProfileQuery = { __typename?: 'Query', targetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }>, currentContract: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency, validFrom: any, validTo?: any | null, updatesRestrictedTo?: any | null, cancellationType?: CancellationType | null, cancellationFrom?: any | null, cancellationTo?: any | null, flexibleBenefit?: number | null, hasNationalContract: boolean, isDeductionEnabled: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, legalEntity: { __typename?: 'LegalEntity', name?: string | null, country: Country }, annualSalary?: { __typename?: 'Salary', amount: number, isTentative: boolean, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', amount: number, currency: Currency } | null, contractType: { __typename?: 'ContractType', typeOfContract: ContractTypeEnum }, employeeLevel?: { __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, isTentative: boolean } | null, nationalContractLevel?: { __typename?: 'NationalContractLevel', type: NationalContractType, level: NationalContractLevelEnum } | null, nationalContractReferenceLevel?: { __typename?: 'NationalContractReferenceDTO', description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, selectable: boolean, displayOrder: number }> } | null, leaveEntitlement?: { __typename?: 'LeaveEntitlement', amount: number } | null, companyCar?: { __typename?: 'CompanyCar', deduction?: number | null, type?: string | null, currency: string } | null, executedPayments?: Array<{ __typename?: 'ExecutedPayment', amount: number, referenceYear: number, paymentDate: any, type: ExecutedPaymentType, currency: Currency }> | null, contractGovernmentJobTitle?: { __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } } | null }, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, careerPath?: Array<{ __typename?: 'CareerPathDto', careerPathType: string, country: string, level: string, min: number, max?: number | null }> | null };

export type ResignedEmployeeOverviewTabDataQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  types?: InputMaybe<Array<EmployeeTagType> | EmployeeTagType>;
  country: Country;
}>;


export type ResignedEmployeeOverviewTabDataQuery = { __typename?: 'Query', resignedContract?: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency, validFrom: any, validTo?: any | null, updatesRestrictedTo?: any | null, cancellationType?: CancellationType | null, cancellationFrom?: any | null, cancellationTo?: any | null, flexibleBenefit?: number | null, hasNationalContract: boolean, isDeductionEnabled: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, legalEntity: { __typename?: 'LegalEntity', name?: string | null, country: Country }, annualSalary?: { __typename?: 'Salary', amount: number, isTentative: boolean, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', amount: number, currency: Currency } | null, contractType: { __typename?: 'ContractType', typeOfContract: ContractTypeEnum }, employeeLevel?: { __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, isTentative: boolean } | null, nationalContractLevel?: { __typename?: 'NationalContractLevel', type: NationalContractType, level: NationalContractLevelEnum } | null, nationalContractReferenceLevel?: { __typename?: 'NationalContractReferenceDTO', description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, selectable: boolean, displayOrder: number }> } | null, leaveEntitlement?: { __typename?: 'LeaveEntitlement', amount: number } | null, companyCar?: { __typename?: 'CompanyCar', deduction?: number | null, type?: string | null, currency: string } | null, executedPayments?: Array<{ __typename?: 'ExecutedPayment', amount: number, referenceYear: number, paymentDate: any, type: ExecutedPaymentType, currency: Currency }> | null, contractGovernmentJobTitle?: { __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } } | null } | null, resignedEmployeeCareerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, careerPath?: Array<{ __typename?: 'CareerPathDto', careerPathType: string, country: string, level: string, min: number, max?: number | null }> | null, tagHistoryOfResignedEmployeeUntilReplyEntryDate: Array<{ __typename?: 'EmployeeTagInfo', id: any, addedDate: any, removedDate?: any | null, type: EmployeeTagType, note?: string | null, employee: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, addedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, removedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null }> };

export type TargetBonusOfYearQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TargetBonusOfYearQuery = { __typename?: 'Query', targetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }> };

export type ContractChangesQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type ContractChangesQuery = { __typename?: 'Query', contractChangesByEmployee: Array<{ __typename?: 'Change', id: any, changes: string, validFrom?: any | null, status?: ChangeStatus | null, updatedDate?: any | null }> };

export type TargetBonusAndContractChangeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TargetBonusAndContractChangeQuery = { __typename?: 'Query', targetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }>, salaryOfYear: Array<{ __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null }>, contractChangesByEmployee: Array<{ __typename?: 'Change', id: any, changes: string, validFrom?: any | null, status?: ChangeStatus | null, updatedDate?: any | null }> };

export type ContractChangeValidationListQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type ContractChangeValidationListQuery = { __typename?: 'Query', isEmployeeLevelValidationEnabled: boolean, employeeLevels: Array<EmployeeLevelEnum>, contractChangeValidationList: { __typename?: 'ContractChangeValidationList', validationEntries: Array<{ __typename?: 'ContractChangeValidationEntry', date: any, salary?: number | null, bonus?: number | null, nationalContractLevel?: NationalContractLevelEnum | null, employeeLevel?: EmployeeLevelEnum | null, governmentJobTitle?: { __typename?: 'GovernmentJobTitleTinyDTO', hiringOfficeCode: string, department: string, title: string } | null }> } };

export type ContractChangeFragment = { __typename?: 'Change', id: any, changes: string, validFrom?: any | null, status?: ChangeStatus | null, updatedDate?: any | null };

export type ContractChangeValidationEntryFragment = { __typename?: 'ContractChangeValidationEntry', date: any, salary?: number | null, bonus?: number | null, nationalContractLevel?: NationalContractLevelEnum | null, employeeLevel?: EmployeeLevelEnum | null, governmentJobTitle?: { __typename?: 'GovernmentJobTitleTinyDTO', hiringOfficeCode: string, department: string, title: string } | null };

export type ContractChangeValidationListFragment = { __typename?: 'ContractChangeValidationList', validationEntries: Array<{ __typename?: 'ContractChangeValidationEntry', date: any, salary?: number | null, bonus?: number | null, nationalContractLevel?: NationalContractLevelEnum | null, employeeLevel?: EmployeeLevelEnum | null, governmentJobTitle?: { __typename?: 'GovernmentJobTitleTinyDTO', hiringOfficeCode: string, department: string, title: string } | null }> };

export type ContractHistoryFragment = { __typename?: 'Contract', id: any, currencyForPayments: string, validFrom: any, validTo?: any | null, cancellationType?: string | null, companyCars: Array<{ __typename?: 'CompanyCar', deduction?: number | null, currency: string, type?: string | null, fromDate: any, toDate?: any | null }>, employeeLevels: Array<{ __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, fromDate: any, toDate?: any | null }>, nationalContractEmployeeLevels: Array<{ __typename?: 'NationalContractLevel', level: NationalContractLevelEnum, type: NationalContractType, fromDate: any, toDate?: any | null }>, contractType: Array<{ __typename?: 'ContractType', typeOfContract: ContractTypeEnum }>, contractGovernmentJobTitles: Array<{ __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } }>, annualSalary: Array<{ __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null, isTentative: boolean, isFulltime: boolean, note?: string | null, percentageOfWorktime: number, currency: Currency }>, targetBonus?: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, isTentative: boolean, note?: string | null, currency: Currency }> | null, executedPayments: Array<{ __typename?: 'ExecutedPayment', id: any, amount: number, currency: Currency, referenceYear: number, type: ExecutedPaymentType }> };

export type ContractValidityInYearFragment = { __typename?: 'Contract', id: any, validFrom: any, validTo?: any | null, cancellationTo?: any | null };

export type LatestContractDtoFragment = { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency, validFrom: any, validTo?: any | null, updatesRestrictedTo?: any | null, cancellationType?: CancellationType | null, cancellationFrom?: any | null, cancellationTo?: any | null, flexibleBenefit?: number | null, hasNationalContract: boolean, isDeductionEnabled: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, legalEntity: { __typename?: 'LegalEntity', name?: string | null, country: Country }, annualSalary?: { __typename?: 'Salary', amount: number, isTentative: boolean, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', amount: number, currency: Currency } | null, contractType: { __typename?: 'ContractType', typeOfContract: ContractTypeEnum }, employeeLevel?: { __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, isTentative: boolean } | null, nationalContractLevel?: { __typename?: 'NationalContractLevel', type: NationalContractType, level: NationalContractLevelEnum } | null, nationalContractReferenceLevel?: { __typename?: 'NationalContractReferenceDTO', description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, selectable: boolean, displayOrder: number }> } | null, leaveEntitlement?: { __typename?: 'LeaveEntitlement', amount: number } | null, companyCar?: { __typename?: 'CompanyCar', deduction?: number | null, type?: string | null, currency: string } | null, executedPayments?: Array<{ __typename?: 'ExecutedPayment', amount: number, referenceYear: number, paymentDate: any, type: ExecutedPaymentType, currency: Currency }> | null, contractGovernmentJobTitle?: { __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } } | null };

export type SalaryOfYearFragment = { __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null };

export type TargetBonusOfYearFragment = { __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any };

export type ExcecutedPaymentsByContractIdQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type ExcecutedPaymentsByContractIdQuery = { __typename?: 'Query', excecutedPaymentsByContractId: { __typename?: 'ExecutedPaymentHistoryDTO', executedPayments: Array<{ __typename?: 'ExecutedPaymentDTO', id: any, amount: number, paymentDate: any, type: ExecutedPaymentType, referenceYear: number, currency: Currency }> } };

export type TargetBonusByContractIdQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type TargetBonusByContractIdQuery = { __typename?: 'Query', targetBonusByContractId: { __typename?: 'TargetBonusHistoryDTO', targetBonusHistory: Array<{ __typename?: 'TargetBonusDTO', id: any, amount: number, note?: string | null, isTentative: boolean, currency: Currency, fromDate: any, toDate?: any | null, contractId: any }> } };

export type SalaryByContractIdQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type SalaryByContractIdQuery = { __typename?: 'Query', salaryByContractId: { __typename?: 'SalaryHistoryDTO', salaryHistory: Array<{ __typename?: 'SalaryDTO', id: any, amount: number, note?: string | null, isTentative: boolean, currency: Currency, fromDate: any, toDate?: any | null, contractId: any, isFulltime: boolean, percentageOfWorktime: number }> } };

export type ContractEmployeeLevelsByContractIdQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type ContractEmployeeLevelsByContractIdQuery = { __typename?: 'Query', contractEmployeeLevelsByContractId: { __typename?: 'ContractEmployeeLevelHistoryDTO', contractEmployeeLevelHistory: Array<{ __typename?: 'ContractEmployeeLevelDTO', id: any, level: EmployeeLevelEnum, note?: string | null, isTentative: boolean, fromDate: any, toDate?: any | null }> } };

export type NationalContractEmployeeLevelsByContractIdQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type NationalContractEmployeeLevelsByContractIdQuery = { __typename?: 'Query', nationalContractEmployeeLevelsByContractId: { __typename?: 'NationalContractEmployeeLevelHistoryDTO', nationalContractEmployeeLevelHistory: Array<{ __typename?: 'NationalContractEmployeeLevelDTO', id: any, level: NationalContractLevelEnum, type: NationalContractType, note?: string | null, isTentative: boolean, fromDate: any, toDate?: any | null }> } };

export type ExcecutedPaymentsByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExcecutedPaymentsByEmployeeIdQuery = { __typename?: 'Query', excecutedPaymentsByEmployeeId: { __typename?: 'ExecutedPaymentHistoryDTO', executedPayments: Array<{ __typename?: 'ExecutedPaymentDTO', id: any, amount: number, paymentDate: any, type: ExecutedPaymentType, referenceYear: number, currency: Currency }> } };

export type TargetBonusByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TargetBonusByEmployeeIdQuery = { __typename?: 'Query', targetBonusByEmployeeId: { __typename?: 'TargetBonusHistoryDTO', targetBonusHistory: Array<{ __typename?: 'TargetBonusDTO', id: any, amount: number, note?: string | null, isTentative: boolean, currency: Currency, fromDate: any, toDate?: any | null, contractId: any }> } };

export type SalaryByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SalaryByEmployeeIdQuery = { __typename?: 'Query', salaryByEmployeeId: { __typename?: 'SalaryHistoryDTO', salaryHistory: Array<{ __typename?: 'SalaryDTO', id: any, amount: number, note?: string | null, isTentative: boolean, currency: Currency, fromDate: any, toDate?: any | null, contractId: any, isFulltime: boolean, percentageOfWorktime: number }> } };

export type ContractEmployeeLevelsByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContractEmployeeLevelsByEmployeeIdQuery = { __typename?: 'Query', contractEmployeeLevelsByEmployeeId: { __typename?: 'ContractEmployeeLevelHistoryDTO', contractEmployeeLevelHistory: Array<{ __typename?: 'ContractEmployeeLevelDTO', id: any, level: EmployeeLevelEnum, note?: string | null, isTentative: boolean, fromDate: any, toDate?: any | null }> } };

export type NationalContractEmployeeLevelsByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NationalContractEmployeeLevelsByEmployeeIdQuery = { __typename?: 'Query', nationalContractEmployeeLevelsByEmployeeId: { __typename?: 'NationalContractEmployeeLevelHistoryDTO', nationalContractEmployeeLevelHistory: Array<{ __typename?: 'NationalContractEmployeeLevelDTO', id: any, level: NationalContractLevelEnum, type: NationalContractType, note?: string | null, isTentative: boolean, fromDate: any, toDate?: any | null }> } };

export type ContractGovernmentJobTitleHistoryByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContractGovernmentJobTitleHistoryByEmployeeIdQuery = { __typename?: 'Query', contractGovernmentJobTitleHistoryByEmployeeId: Array<{ __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, note?: string | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } }> };

export type SetCutoffDayForCountryMutationVariables = Exact<{
  country: Country;
  cutoffDay: Scalars['Int']['input'];
}>;


export type SetCutoffDayForCountryMutation = { __typename?: 'Mutation', setCutoffDayForCountry: boolean };

export type HasCountryNationalContractReferenceLevelQueryVariables = Exact<{
  country: Country;
}>;


export type HasCountryNationalContractReferenceLevelQuery = { __typename?: 'Query', hasCountryNationalContractReferenceLevel: boolean };

export type GetCountrySettingsQueryVariables = Exact<{
  country: Country;
}>;


export type GetCountrySettingsQuery = { __typename?: 'Query', getCountrySettings: { __typename?: 'CountrySettingsDto', id: any, country: Country, defaultRankingTopPercentage: number, defaultRankingLowPercentage: number, defaultRankingLowPercentageIsBlocker: boolean, defaultRankingRankingIsDisabled: boolean, isIdVWeightEnabled: boolean, cutOffDay: number, employeeLevelsSet: EmployeeLevelsSets, isDeductionEnabled: boolean, hasNationalContractReferenceLevel: boolean, hasGovernmentJobTitleReferenceLevel: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, flexibleProrataManagementEnabled: boolean, selfReflectionAndEvaluationAlwaysVisible: boolean, createTargetReport: boolean, paymentsAndChangesDisclaimerVisible: boolean, isDateOfBirthVisible: boolean, isAgePyramidVisible: boolean, skillStatusBlocker: boolean, defaultKudosFeatureEnabled: boolean, isBranchOfficeVisible: boolean } };

export type GetCountriesWhereReportGenerationIsEnabledQueryVariables = Exact<{
  reportType: ReportType;
}>;


export type GetCountriesWhereReportGenerationIsEnabledQuery = { __typename?: 'Query', getCountriesWhereReportGenerationIsActive: Array<Country> };

export type GetCountriesAndReportGenerationFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesAndReportGenerationFlagsQuery = { __typename?: 'Query', getCountriesAndReportGenerationFlags: Array<{ __typename?: 'CountryAndReportGenerationFlags', country: Country, createBigReport: boolean, createSmallReport: boolean, createPyramidReport: boolean, createTargetReport: boolean }> };

export type AreAgeAndCareerPathVisibleQueryVariables = Exact<{
  country: Country;
}>;


export type AreAgeAndCareerPathVisibleQuery = { __typename?: 'Query', isAgePyramidVisible: boolean, isCareerPathEnabled: boolean };

export type GetCountriesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesListQuery = { __typename?: 'Query', getCountriesList: Array<Country> };

export type GetCountriesWithAgePyramidVisibleFlagQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesWithAgePyramidVisibleFlagQuery = { __typename?: 'Query', getCountriesWithAgePyramidVisibleFlag: Array<{ __typename?: 'CountryWithAgePyramidVisibleFlag', country: Country, isAgePyramidVisible: boolean }> };

export type GetCountriesWithBranchOfficeVisibleFlagQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesWithBranchOfficeVisibleFlagQuery = { __typename?: 'Query', getCountriesWithBranchOfficeVisibleFlag: Array<{ __typename?: 'CountryWithBranchOfficeVisibleFlag', country: Country, isBranchOfficeVisible: boolean }> };

export type CountrySettingsFragment = { __typename?: 'CountrySettingsDto', id: any, country: Country, defaultRankingTopPercentage: number, defaultRankingLowPercentage: number, defaultRankingLowPercentageIsBlocker: boolean, defaultRankingRankingIsDisabled: boolean, isIdVWeightEnabled: boolean, cutOffDay: number, employeeLevelsSet: EmployeeLevelsSets, isDeductionEnabled: boolean, hasNationalContractReferenceLevel: boolean, hasGovernmentJobTitleReferenceLevel: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, flexibleProrataManagementEnabled: boolean, selfReflectionAndEvaluationAlwaysVisible: boolean, createTargetReport: boolean, paymentsAndChangesDisclaimerVisible: boolean, isDateOfBirthVisible: boolean, isAgePyramidVisible: boolean, skillStatusBlocker: boolean, defaultKudosFeatureEnabled: boolean, isBranchOfficeVisible: boolean };

export type GetCurrencyConversionsByEmployeeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type GetCurrencyConversionsByEmployeeQuery = { __typename?: 'Query', getCurrencyConversionsByEmployee: { __typename?: 'CurrencyConversionWithContractCurrencyDTO', id: any, contractCurrency: Currency, currencyConversionData: Array<{ __typename?: 'CurrencyConversionDTO', id: any, startingCurrency: Currency, targetCurrency: Currency, conversionRate: number }> } };

export type CreateOrUpdateDraftScoreGridMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  employeeId: Scalars['HashedId']['input'];
  draftScoreGridInput: DraftScoreGridInput;
}>;


export type CreateOrUpdateDraftScoreGridMutation = { __typename?: 'Mutation', createOrUpdateDraftScoreGrid: boolean };

export type ImportScoreGridsMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  buIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
  country: Country;
  excelData: Array<ScoreGridExcelDataInput> | ScoreGridExcelDataInput;
}>;


export type ImportScoreGridsMutation = { __typename?: 'Mutation', importScoreGrids: boolean };

export type GetEmployeesWithLatestAndDraftScoreGridQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type GetEmployeesWithLatestAndDraftScoreGridQuery = { __typename?: 'Query', getCountryEmployeeLevels: Array<EmployeeLevelEnum>, getEmployeesWithLatestAndDraftScoreGrid: Array<{ __typename?: 'EmployeeWithLatestAndDraftEvaluation', id: any, globalId: string, latestEvaluation?: number | null, existingLatestEvaluation: boolean, draftEvaluation?: number | null, existingDraftEvaluation: boolean, scoreGridStatus?: ScoreGridStatus | null, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel?: string | null, companyName?: string | null, buName: string }, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string }, scoreGoals?: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, resultEvaluation?: number | null }> | null }>, getCountrySettings: { __typename?: 'CountrySettingsDto', id: any, country: Country, defaultRankingTopPercentage: number, defaultRankingLowPercentage: number, defaultRankingLowPercentageIsBlocker: boolean, defaultRankingRankingIsDisabled: boolean, isIdVWeightEnabled: boolean, cutOffDay: number, employeeLevelsSet: EmployeeLevelsSets, isDeductionEnabled: boolean, hasNationalContractReferenceLevel: boolean, hasGovernmentJobTitleReferenceLevel: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, flexibleProrataManagementEnabled: boolean, selfReflectionAndEvaluationAlwaysVisible: boolean, createTargetReport: boolean, paymentsAndChangesDisclaimerVisible: boolean, isDateOfBirthVisible: boolean, isAgePyramidVisible: boolean, skillStatusBlocker: boolean, defaultKudosFeatureEnabled: boolean, isBranchOfficeVisible: boolean }, getIdVWeightsByCountry: Array<{ __typename?: 'IdvWeightDto', country: Country, level: EmployeeLevelEnum, value: ScoreGoalType, weight: number }> };

export type GetDraftOrLatestScoreGridByEmployeeQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  employeeId: Scalars['HashedId']['input'];
}>;


export type GetDraftOrLatestScoreGridByEmployeeQuery = { __typename?: 'Query', getDraftOrLatestScoreGridByEmployee?: { __typename?: 'ScoreGridDto', id: any, resultScore?: number | null, lastResultScore?: number | null, employeePreparationScore?: number | null, managerPreparationScore?: number | null, date: any, scoreGoals: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, employeeEvaluation?: number | null, reviewerEvaluation?: number | null, resultEvaluation?: number | null, lastResultEvaluation?: number | null }> } | null };

export type GetLatestScoreGridByEmployeeQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  employeeId: Scalars['HashedId']['input'];
}>;


export type GetLatestScoreGridByEmployeeQuery = { __typename?: 'Query', getLatestScoreGridByEmployee?: { __typename?: 'ScoreGridDto', id: any, resultScore?: number | null, lastResultScore?: number | null, employeePreparationScore?: number | null, managerPreparationScore?: number | null, date: any, scoreGoals: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, employeeEvaluation?: number | null, reviewerEvaluation?: number | null, resultEvaluation?: number | null, lastResultEvaluation?: number | null }> } | null };

export type FindCurrentBusinessUnitsByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type FindCurrentBusinessUnitsByCompanyIdQuery = { __typename?: 'Query', findCurrentBusinessUnitsByCompanyId: Array<{ __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string }> };

export type EmployeeQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
  checkPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  withManagerOfCompanies?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EmployeeQuery = { __typename?: 'Query', employee?: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, managerOfCompanies?: Array<{ __typename?: 'ManagerOfCompany', company: { __typename?: 'Company', id: any, name: string, network: { __typename?: 'Network', id: any, name: string } } }> | null } | null };

export type SubordinatesByEmployeeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type SubordinatesByEmployeeQuery = { __typename?: 'Query', subOrdinatesByEmployee: Array<{ __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, businessUnit: { __typename?: 'BusinessUnit', id: any, name: string } }> };

export type CompanyPartnersOfEmployeeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type CompanyPartnersOfEmployeeQuery = { __typename?: 'Query', companyPartners: Array<{ __typename?: 'Employee', id: any, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }> };

export type EmployeeByNameQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeByNameQuery = { __typename?: 'Query', nameSearch: Array<{ __typename?: 'EmployeeNameSearchInfo', id: any, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, buName: string, companyName: string, avatarUrl?: string | null }> };

export type NonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type NonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingQuery = { __typename?: 'Query', employeeLevels: Array<EmployeeLevelEnum>, nonManagerEmployeesOfCompanyWithCurrentAppraisalMeeting: Array<{ __typename?: 'EmployeeAndAppraisalMeetings', id: any, mandatory: boolean, meetingToDoInCurrentAppraisalSeason: boolean, country: Country, branchOfficeCode?: string | null, status: { __typename?: 'MeetingInvitationStatus', name: string, sortOrder: string }, employee: { __typename?: 'EmployeeDisplayShortWithBuManager', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null, managers?: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }> | null }, appraisal?: { __typename?: 'AppraisalDisplayInfo', id: any, date: any, hrFeedBack?: string | null, hrDisputeComment?: string | null, hrResult: MeetingHrFeedbackResult, meetingStatus: MeetingStatus, meetingType: MeetingType, companyNameOfMeeting?: string | null, type?: { __typename?: 'AppraisalType', name: AppraisalMeetingType, reason?: SkipMeetingStepReason | null, skippedSteps: Array<MeetingStepViewId> } | null, reviewer?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, confirmation?: { __typename?: 'AppraisalConfirmationInfo', date: any, forceConfirmedReason?: string | null, discussedWith?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, forceConfirmedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null } | null, conclusionPdf?: { __typename?: 'MeetingConclusionPdf', fileName: string, downloadToken: string, status: MeetingPdfStatus } | null, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } } | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null }>, currentAppraisalSeason: { __typename?: 'AppraisalSeasonDTO', year: number } };

export type EmployeesWithHrOrDownloaderRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeesWithHrOrDownloaderRoleQuery = { __typename?: 'Query', employeesWithHrOrDownloaderRole: Array<{ __typename?: 'EmployeeWithRole', id: any, firstName: string, lastName: string, currentLevel?: string | null, avatarUrl?: string | null, companyName?: string | null, buName: string, assignedTo: Array<string>, hasDownloaderRole: boolean, hrRoleOfUser: Array<{ __typename?: 'RoleOfUser', id: any, userId: any, fromDate: any, role: { __typename?: 'Role', id: any, name: string } }> }> };

export type CompaniesAndBusinessUnitsByEmployeeQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
  country: Country;
}>;


export type CompaniesAndBusinessUnitsByEmployeeQuery = { __typename?: 'Query', employeeLevels: Array<EmployeeLevelEnum>, companiesAndBusinessUnitsByEmployee: Array<{ __typename?: 'CompanyAndBu', companyId: any, companyName: string, bu: Array<{ __typename?: 'Bu', buId: any, displayName: string, isAllBu: boolean }> }> };

export type NonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingQueryVariables = Exact<{
  businessUnitId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type NonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingQuery = { __typename?: 'Query', employeeLevels: Array<EmployeeLevelEnum>, nonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeeting: Array<{ __typename?: 'EmployeeAndAppraisalMeetings', id: any, mandatory: boolean, meetingToDoInCurrentAppraisalSeason: boolean, country: Country, branchOfficeCode?: string | null, status: { __typename?: 'MeetingInvitationStatus', name: string, sortOrder: string }, employee: { __typename?: 'EmployeeDisplayShortWithBuManager', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null, managers?: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }> | null }, appraisal?: { __typename?: 'AppraisalDisplayInfo', id: any, date: any, hrFeedBack?: string | null, hrDisputeComment?: string | null, hrResult: MeetingHrFeedbackResult, meetingStatus: MeetingStatus, meetingType: MeetingType, companyNameOfMeeting?: string | null, type?: { __typename?: 'AppraisalType', name: AppraisalMeetingType, reason?: SkipMeetingStepReason | null, skippedSteps: Array<MeetingStepViewId> } | null, reviewer?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, confirmation?: { __typename?: 'AppraisalConfirmationInfo', date: any, forceConfirmedReason?: string | null, discussedWith?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, forceConfirmedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null } | null, conclusionPdf?: { __typename?: 'MeetingConclusionPdf', fileName: string, downloadToken: string, status: MeetingPdfStatus } | null, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } } | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null }> };

export type EmployeeLevelsByCountryQueryVariables = Exact<{
  country: Country;
}>;


export type EmployeeLevelsByCountryQuery = { __typename?: 'Query', employeeLevels: Array<EmployeeLevelEnum> };

export type AppraisalsOfEmployeeByYearQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  latestMeetingId: Scalars['HashedId']['input'];
  appraisalSeasonYear: Scalars['Int']['input'];
}>;


export type AppraisalsOfEmployeeByYearQuery = { __typename?: 'Query', appraisalsOfEmployeeByYear: Array<{ __typename?: 'AppraisalDisplayInfo', id: any, date: any, hrFeedBack?: string | null, hrDisputeComment?: string | null, hrResult: MeetingHrFeedbackResult, meetingStatus: MeetingStatus, meetingType: MeetingType, companyNameOfMeeting?: string | null, type?: { __typename?: 'AppraisalType', name: AppraisalMeetingType, reason?: SkipMeetingStepReason | null, skippedSteps: Array<MeetingStepViewId> } | null, reviewer?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, confirmation?: { __typename?: 'AppraisalConfirmationInfo', date: any, forceConfirmedReason?: string | null, discussedWith?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, forceConfirmedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null } | null, conclusionPdf?: { __typename?: 'MeetingConclusionPdf', fileName: string, downloadToken: string, status: MeetingPdfStatus } | null, status: { __typename?: 'MeetingInvitationStatus', name: string, sortOrder: string }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> };

export type ActiveEmployeesSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  kudosView: Scalars['Boolean']['input'];
  companyId?: InputMaybe<Scalars['HashedId']['input']>;
}>;


export type ActiveEmployeesSearchQuery = { __typename?: 'Query', activeEmployeesSearch: Array<{ __typename?: 'EmployeeSearch', id: any, firstName: string, lastName: string, avatarUrl?: string | null, companyName: string, businessUnitName: string, contractLevel: EmployeeLevelEnum, replyEntryDate: any, contractValidTo?: any | null, employmentStatus: EmploymentStatus }> };

export type EmployeeBuFragment = { __typename?: 'Employee', id: any, businessUnit: { __typename?: 'BusinessUnit', id: any, name: string } };

export type EmployeeCoreFragment = { __typename?: 'Employee', id: any, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null };

export type EmployeeDisplayFragment = { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null };

export type EmployeeDisplayShortInfoFragment = { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null };

export type EmployeeDisplayTinyInfoFragment = { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null };

export type ManagerOfCompaniesFragment = { __typename?: 'Employee', id: any, managerOfCompanies?: Array<{ __typename?: 'ManagerOfCompany', company: { __typename?: 'Company', id: any, name: string, network: { __typename?: 'Network', id: any, name: string } } }> | null };

export type EmployeeWithBuFragment = { __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } };

export type EmployeesAndAppraisalsFragment = { __typename?: 'EmployeeAndAppraisalMeetings', id: any, mandatory: boolean, meetingToDoInCurrentAppraisalSeason: boolean, country: Country, branchOfficeCode?: string | null, status: { __typename?: 'MeetingInvitationStatus', name: string, sortOrder: string }, employee: { __typename?: 'EmployeeDisplayShortWithBuManager', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null, managers?: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }> | null }, appraisal?: { __typename?: 'AppraisalDisplayInfo', id: any, date: any, hrFeedBack?: string | null, hrDisputeComment?: string | null, hrResult: MeetingHrFeedbackResult, meetingStatus: MeetingStatus, meetingType: MeetingType, companyNameOfMeeting?: string | null, type?: { __typename?: 'AppraisalType', name: AppraisalMeetingType, reason?: SkipMeetingStepReason | null, skippedSteps: Array<MeetingStepViewId> } | null, reviewer?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, confirmation?: { __typename?: 'AppraisalConfirmationInfo', date: any, forceConfirmedReason?: string | null, discussedWith?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, forceConfirmedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null } | null, conclusionPdf?: { __typename?: 'MeetingConclusionPdf', fileName: string, downloadToken: string, status: MeetingPdfStatus } | null, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } } | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null };

export type EmployeesAndFeedbacksFragment = { __typename?: 'EmployeeAndAppraisalMeetings', id: any, mandatory: boolean, meetingToDoInCurrentAppraisalSeason: boolean, country: Country, status: { __typename?: 'MeetingInvitationStatus', name: string, sortOrder: string }, employee: { __typename?: 'EmployeeDisplayShortWithBuManager', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null, managers?: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }> | null }, appraisal?: { __typename?: 'AppraisalDisplayInfo', id: any, date: any, hrFeedBack?: string | null, hrDisputeComment?: string | null, hrResult: MeetingHrFeedbackResult, meetingStatus: MeetingStatus, meetingType: MeetingType, companyNameOfMeeting?: string | null, type?: { __typename?: 'AppraisalType', name: AppraisalMeetingType, reason?: SkipMeetingStepReason | null, skippedSteps: Array<MeetingStepViewId> } | null, reviewer?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, confirmation?: { __typename?: 'AppraisalConfirmationInfo', date: any, forceConfirmedReason?: string | null, discussedWith?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, forceConfirmedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null } | null, conclusionPdf?: { __typename?: 'MeetingConclusionPdf', fileName: string, downloadToken: string, status: MeetingPdfStatus } | null, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } } | null };

export type EmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManagerQuery = { __typename?: 'Query', employeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager?: { __typename?: 'EmployeeDisplayShortInfoMeetingInvite', queriedBy: string, employees: Array<{ __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null }> } | null };

export type EmployeeDisplayTinyInfoByEmployeeIdQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type EmployeeDisplayTinyInfoByEmployeeIdQuery = { __typename?: 'Query', employeeDisplayTinyInfoByEmployeeId?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null };

export type EmployeeGecoProjectsQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmployeeGecoProjectsQuery = { __typename?: 'Query', mostBookedGecoProjectsOfEmployee: Array<{ __typename?: 'GecoProjectsInfo', id: number, projectName: string, bookedTimeInPercent: number, hours?: number | null }> };

export type FeatureDisclaimerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureDisclaimerDataQuery = { __typename?: 'Query', featureDisclaimerData?: { __typename?: 'FeatureMaintenanceData', title: string, description: string } | null };

export type FeatureToggleQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureToggleQuery = { __typename?: 'Query', featureToggles: Array<{ __typename?: 'FeatureToggle', name: string, enabled: boolean }> };

export type GovernmentJobTitlesByHiringOfficeIdQueryVariables = Exact<{
  hiringOfficeId: Scalars['HashedId']['input'];
  excludePartnerLevels?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GovernmentJobTitlesByHiringOfficeIdQuery = { __typename?: 'Query', governmentJobTitlesByHiringOfficeId: Array<{ __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } }> };

export type DeleteHrbpRelationMutationVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type DeleteHrbpRelationMutation = { __typename?: 'Mutation', deleteHRBPRelation: boolean };

export type CreateHrbpRelationMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  companyIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
}>;


export type CreateHrbpRelationMutation = { __typename?: 'Mutation', createHRBPRelation: boolean };

export type GetHrBusinessPartnersByCountryQueryVariables = Exact<{
  country: Country;
}>;


export type GetHrBusinessPartnersByCountryQuery = { __typename?: 'Query', getHrBusinessPartnersByCountry: Array<{ __typename?: 'ActiveHRBusinessPartnerDTO', id: any, fromDate: any, toDate?: any | null, companyId: any, companyName: string, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null, companyName?: string | null, buName: string } }> };

export type GetPossibleCompaniesForCreateNewHrBusinessPartnerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPossibleCompaniesForCreateNewHrBusinessPartnerQuery = { __typename?: 'Query', getPossibleCompaniesForCreateNewHrBusinessPartner: Array<{ __typename?: 'CompanyTinyWithName', id: any, name: string }> };

export type NameSearchForHrbpSelectQueryVariables = Exact<{
  country: Country;
  searchString: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type NameSearchForHrbpSelectQuery = { __typename?: 'Query', nameSearchForHRBPSelect: Array<{ __typename?: 'EmployeeNameSearchInfo', id: any, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, buName: string, companyName: string, avatarUrl?: string | null }> };

export type ActiveHrBusinessPartnerFragment = { __typename?: 'ActiveHRBusinessPartnerDTO', id: any, fromDate: any, toDate?: any | null, companyId: any, companyName: string, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null, companyName?: string | null, buName: string } };

export type InviteOptionsQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  appraisalSeasonId?: InputMaybe<Scalars['HashedId']['input']>;
}>;


export type InviteOptionsQuery = { __typename?: 'Query', meetingInviteOptionsForEmployee: { __typename?: 'MeetingInviteOptionsExtended', possible: Array<MeetingType>, tagAssignmentIsInProgress: boolean, isAppraisalEnabled: boolean } };

export type NonParticipantsOptionsQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type NonParticipantsOptionsQuery = { __typename?: 'Query', nonParticipantsOptionsForEmployee: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }> };

export type AppraisalSeasonOptionByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  utcMeetingDate: Scalars['String']['input'];
}>;


export type AppraisalSeasonOptionByEmployeeIdQuery = { __typename?: 'Query', appraisalSeasonOptionByEmployeeId: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } };

export type EmployeeWithAppraisalInviteInfoQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type EmployeeWithAppraisalInviteInfoQuery = { __typename?: 'Query', employeeDisplayTinyInfoByEmployeeId?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, appraisalSeasonOptionByEmployeeId: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null }, nonParticipantsOptionsForEmployee: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }>, meetingInviteOptionsForEmployee: { __typename?: 'MeetingInviteOptionsExtended', possible: Array<MeetingType>, tagAssignmentIsInProgress: boolean, isAppraisalEnabled: boolean } };

export type CreateKudosMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateKudosMutation = { __typename?: 'Mutation', createKudos: boolean };

export type DeleteKudosMutationVariables = Exact<{
  kudosId: Scalars['HashedId']['input'];
}>;


export type DeleteKudosMutation = { __typename?: 'Mutation', deleteKudos: boolean };

export type CreateAttentionPointMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateAttentionPointMutation = { __typename?: 'Mutation', createAttentionPoint: boolean };

export type DeleteAttentionPointMutationVariables = Exact<{
  attentionPointId: Scalars['HashedId']['input'];
}>;


export type DeleteAttentionPointMutation = { __typename?: 'Mutation', deleteAttentionPoint: boolean };

export type UpdateMyOptOutValueMutationVariables = Exact<{
  newOptOutValue: Scalars['Boolean']['input'];
}>;


export type UpdateMyOptOutValueMutation = { __typename?: 'Mutation', updateMyOptOutValue: boolean };

export type UpdateEmployeeOptOutValueMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  newOptOutValue: Scalars['Boolean']['input'];
}>;


export type UpdateEmployeeOptOutValueMutation = { __typename?: 'Mutation', updateEmployeeOptOutValue: boolean };

export type SetKudosLegalEntityVisibilityMutationVariables = Exact<{
  kudosLegalEntityVisibilityInput: KudosLegalEntityVisibilityInput;
}>;


export type SetKudosLegalEntityVisibilityMutation = { __typename?: 'Mutation', setKudosLegalEntityVisibility: boolean };

export type SetKudosCompanyCountryVisibilityMutationVariables = Exact<{
  kudosCompanyCountryVisibilityInput: KudosCompanyCountryVisibilityInput;
}>;


export type SetKudosCompanyCountryVisibilityMutation = { __typename?: 'Mutation', setKudosCompanyCountryVisibility: boolean };

export type DeleteKudosCompanyCountryVisibilityMutationVariables = Exact<{
  kudosCompanyCountryVisibilityId: Scalars['HashedId']['input'];
}>;


export type DeleteKudosCompanyCountryVisibilityMutation = { __typename?: 'Mutation', deleteKudosCompanyCountryVisibility: boolean };

export type AreKudosVisibleForMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AreKudosVisibleForMeQuery = { __typename?: 'Query', areKudosVisibleForMe: boolean };

export type GetKudosReceivedByMeQueryVariables = Exact<{
  pagination: KudosPaginationInput;
}>;


export type GetKudosReceivedByMeQuery = { __typename?: 'Query', getKudosReceivedByMe: { __typename?: 'KudosWithVisibilityFlagDTO', isKudosEnabled: boolean, employeeOptedOut: boolean, kudosPagination: { __typename?: 'KudosPaginationDTO', totalPages: number, currentPage: number, totalCount: number, kudos: Array<{ __typename?: 'KudosDTO', id: any, employeeId: any, type: KudosType, authorId: any, description: string, createdDate: any, deletable: boolean, employee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, author?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null }> } } };

export type GetKudosForEmployeeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  pagination: KudosPaginationInput;
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetKudosForEmployeeQuery = { __typename?: 'Query', getKudosForEmployee: { __typename?: 'KudosWithVisibilityFlagDTO', isKudosEnabled: boolean, employeeOptedOut: boolean, kudosPagination: { __typename?: 'KudosPaginationDTO', totalPages: number, currentPage: number, totalCount: number, kudos: Array<{ __typename?: 'KudosDTO', id: any, employeeId: any, type: KudosType, authorId: any, description: string, createdDate: any, deletable: boolean, employee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, author?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null }> } } };

export type GetAttentionPointsForEmployeeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  pagination: KudosPaginationInput;
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAttentionPointsForEmployeeQuery = { __typename?: 'Query', getAttentionPointsForEmployee: { __typename?: 'KudosPaginationDTO', totalPages: number, currentPage: number, totalCount: number, kudos: Array<{ __typename?: 'KudosDTO', id: any, employeeId: any, type: KudosType, authorId: any, description: string, createdDate: any, deletable: boolean, employee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, author?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null }> } };

export type GetKudosForEmployeeInAppraisalQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  appraisalInput: KudosAppraisalInput;
}>;


export type GetKudosForEmployeeInAppraisalQuery = { __typename?: 'Query', getKudosForEmployeeInAppraisal: { __typename?: 'KudosWithVisibilityFlagDTO', isKudosEnabled: boolean, employeeOptedOut: boolean, kudosPagination: { __typename?: 'KudosPaginationDTO', totalPages: number, currentPage: number, totalCount: number, kudos: Array<{ __typename?: 'KudosDTO', id: any, employeeId: any, type: KudosType, authorId: any, description: string, createdDate: any, deletable: boolean, employee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, author?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null }> } } };

export type GetAllKudosQueryVariables = Exact<{
  filters: KudosFilterInput;
}>;


export type GetAllKudosQuery = { __typename?: 'Query', getAllKudos: { __typename?: 'KudosShowMoreDTO', hasMore: boolean, nextOffset?: number | null, kudos: Array<{ __typename?: 'KudosDTO', id: any, employeeId: any, type: KudosType, authorId: any, description: string, createdDate: any, deletable: boolean, employee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, author?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null }> } };

export type GetAllAttentionPointsQueryVariables = Exact<{
  filters: KudosFilterInput;
}>;


export type GetAllAttentionPointsQuery = { __typename?: 'Query', getAllAttentionPoints: { __typename?: 'KudosShowMoreDTO', hasMore: boolean, nextOffset?: number | null, kudos: Array<{ __typename?: 'KudosDTO', id: any, employeeId: any, type: KudosType, authorId: any, description: string, createdDate: any, deletable: boolean, employee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, author?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null }> } };

export type GetKudosGivenByReplyerQueryVariables = Exact<{
  filters: KudosByReplyerFilterInput;
}>;


export type GetKudosGivenByReplyerQuery = { __typename?: 'Query', getKudosGivenByReplyer: { __typename?: 'KudosShowMoreDTO', hasMore: boolean, nextOffset?: number | null, kudos: Array<{ __typename?: 'KudosDTO', id: any, employeeId: any, type: KudosType, authorId: any, description: string, createdDate: any, deletable: boolean, employee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, author?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null }> } };

export type GetKudosLegalEntityVisibilityDataQueryVariables = Exact<{
  filters: KudosLegalEntityVisibilityFilterInput;
}>;


export type GetKudosLegalEntityVisibilityDataQuery = { __typename?: 'Query', getKudosLegalEntityVisibilityData: { __typename?: 'KudosLegalEntityVisibilityShowMoreDTO', hasMore: boolean, nextOffset?: number | null, kudosLegalEntityVisibilityList: Array<{ __typename?: 'KudosLegalEntityVisibilityDTO', id: any, legalEntityId: any, legalEntityName: string, country: Country, kudosEnabled: boolean }> } };

export type GetKudosCompanyCountryVisibilityDataQueryVariables = Exact<{
  filters: KudosCompanyCountryVisibilityFilterInput;
}>;


export type GetKudosCompanyCountryVisibilityDataQuery = { __typename?: 'Query', getKudosCompanyCountryVisibilityData: { __typename?: 'KudosCompanyCountryVisibilityShowMoreDTO', hasMore: boolean, nextOffset?: number | null, kudosCompanyCountryVisibilityList: Array<{ __typename?: 'KudosCompanyCountryVisibilityDTO', id: any, companyId: any, companyName: string, country: Country, kudosEnabled: boolean }> } };

export type KudosFragment = { __typename?: 'KudosDTO', id: any, employeeId: any, type: KudosType, authorId: any, description: string, createdDate: any, deletable: boolean, employee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, author?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null };

export type CountriesOfLegalEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesOfLegalEntitiesQuery = { __typename?: 'Query', countriesOfLegalEntities?: Array<Country> | null };

export type LegalEntitySearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type LegalEntitySearchQuery = { __typename?: 'Query', legalEntitySearch: Array<{ __typename?: 'LegalEntityTiny', id: any, name: string }> };

export type LogoutMutationMutationVariables = Exact<{
  doLogout: Scalars['Boolean']['input'];
}>;


export type LogoutMutationMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutOk', ok: boolean } | null };

export type MeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQueryQuery = { __typename?: 'Query', me?: { __typename?: 'UserInfo', id: any, employeeId: any, email: string, firstName: string, lastName: string, nameDisplayPreference: string, locale: string, timezone: string, country: string, currentEmployeeLevel: string, roles?: Array<RoleName> | null, currencyForPayments: string, avatarUrl?: string | null, skillCenterUrl: string, managedBusinessUnits: Array<{ __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string, company?: { __typename?: 'CompanyTiny', id: any, name?: string | null } | null }>, managedCompanies: Array<{ __typename?: 'CompanyTiny', id: any }> } | null };

export type UpdateMeetingStepMutationVariables = Exact<{
  id: Scalars['HashedId']['input'];
  newStepStatus: MeetingStepStatus;
}>;


export type UpdateMeetingStepMutation = { __typename?: 'Mutation', updateMeetingStep: { __typename?: 'MeetingStep', id: any, status: MeetingStepStatus } };

export type SetNextMeetingStepMutationVariables = Exact<{
  id: Scalars['HashedId']['input'];
  nextStepId: Scalars['HashedId']['input'];
  currentStepStatus?: InputMaybe<MeetingStepStatus>;
  stepType: MeetingStepType;
}>;


export type SetNextMeetingStepMutation = { __typename?: 'Mutation', setNextMeetingStep: { __typename?: 'Meeting', id: any, date: any, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number }> | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId } | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId } | null } };

export type UpdateMeetingFeedbackMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
  feedback: Scalars['String']['input'];
}>;


export type UpdateMeetingFeedbackMutation = { __typename?: 'Mutation', updateMeetingFeedback: { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } } };

export type ManagerCloseMeetingMutationVariables = Exact<{
  meetingInput: ManagerCloseMeetingInput;
}>;


export type ManagerCloseMeetingMutation = { __typename?: 'Mutation', managerCloseMeeting: { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } } };

export type EmployeeCloseMeetingMutationVariables = Exact<{
  meetingInput: EmployeeCloseMeetingInput;
}>;


export type EmployeeCloseMeetingMutation = { __typename?: 'Mutation', employeeCloseMeeting: { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } } };

export type ManagerForceMeetingConfirmationMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
  reason: Scalars['String']['input'];
}>;


export type ManagerForceMeetingConfirmationMutation = { __typename?: 'Mutation', managerForceMeetingConfirmation: boolean };

export type CancelMeetingMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
  employeeId: Scalars['HashedId']['input'];
  reasonForMeetingCancel: Scalars['String']['input'];
}>;


export type CancelMeetingMutation = { __typename?: 'Mutation', cancelMeeting: any };

export type OtherMeetingConfirmAsManagerMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  reviewerEmployeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
  protocol: Scalars['String']['input'];
}>;


export type OtherMeetingConfirmAsManagerMutation = { __typename?: 'Mutation', otherMeetingConfirmAsManager: { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } } };

export type OtherMeetingFinishPreparationMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  reviewerEmployeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
  notes: Scalars['String']['input'];
  asManager: Scalars['Boolean']['input'];
}>;


export type OtherMeetingFinishPreparationMutation = { __typename?: 'Mutation', otherMeetingFinishPreparation: { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } } };

export type TakeOverMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type TakeOverMutation = { __typename?: 'Mutation', takeOver: { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null } };

export type HrManageMeetingMutationVariables = Exact<{
  hrManageMeetingInput: HrManageMeetingInput;
}>;


export type HrManageMeetingMutation = { __typename?: 'Mutation', hrManageMeeting: { __typename?: 'Meeting', id: any } };

export type RequestMeetingAsEmployeeMutationVariables = Exact<{
  meetingReason: Scalars['String']['input'];
  meetingType: MeetingType;
  reviewerId: Scalars['HashedId']['input'];
  requesterId: Scalars['HashedId']['input'];
}>;


export type RequestMeetingAsEmployeeMutation = { __typename?: 'Mutation', requestMeetingAsEmployee: { __typename?: 'MeetingRequestDTO', id: any, type: MeetingType, requestedDate: any, reasonForRequest: string, reasonOfRejection?: string | null, status: MeetingRequestStatus, requester: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, reviewer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } } };

export type AcceptRequestedMeetingMutationVariables = Exact<{
  requestedMeetingId: Scalars['HashedId']['input'];
  meetingInput: MeetingInviteInput;
}>;


export type AcceptRequestedMeetingMutation = { __typename?: 'Mutation', acceptRequestedMeeting: { __typename?: 'MeetingRequestDTO', id: any, type: MeetingType, requestedDate: any, reasonForRequest: string, reasonOfRejection?: string | null, status: MeetingRequestStatus, requester: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, reviewer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, meeting?: { __typename?: 'MeetingTiny', id: any, date: any } | null } };

export type DeclineRequestedMeetingMutationVariables = Exact<{
  requestedMeetingId: Scalars['HashedId']['input'];
  reasonOfRejection: Scalars['String']['input'];
}>;


export type DeclineRequestedMeetingMutation = { __typename?: 'Mutation', declineRequestedMeeting: { __typename?: 'MeetingRequestDTO', id: any, type: MeetingType, requestedDate: any, reasonForRequest: string, reasonOfRejection?: string | null, status: MeetingRequestStatus, requester: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, reviewer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } } };

export type WithdrawRequestedMeetingMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  requestId: Scalars['HashedId']['input'];
}>;


export type WithdrawRequestedMeetingMutation = { __typename?: 'Mutation', withdrawRequestedMeeting: { __typename?: 'DeleteOk', id: any } };

export type RescheduleMeetingMutationVariables = Exact<{
  rescheduleInput: RescheduleMeetingInput;
}>;


export type RescheduleMeetingMutation = { __typename?: 'Mutation', rescheduleMeeting: boolean };

export type UpdateMeetingNotesMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
  notes: Scalars['String']['input'];
}>;


export type UpdateMeetingNotesMutation = { __typename?: 'Mutation', updateMeetingNotes: boolean };

export type FullMeetingFragment = { __typename?: 'Meeting', selfReflectionAndEvaluationVisible: boolean, activityListEnabled: boolean, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, targetsCalculationHelper: { __typename?: 'TargetsCalculationHelperDTO', pastTargetsReferenceYear: number, newTargetsReferenceYear: number }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null }, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } };

export type FullMeetingWithEvaluationAndSelfReflectionFragment = { __typename?: 'Meeting', selfReflectionAndEvaluationVisible: boolean, activityListEnabled: boolean, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, targetsCalculationHelper: { __typename?: 'TargetsCalculationHelperDTO', pastTargetsReferenceYear: number, newTargetsReferenceYear: number }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null }, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } };

export type MeetingWithCareerPathEvaluationQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type MeetingWithCareerPathEvaluationQuery = { __typename?: 'Query', meeting: { __typename?: 'Meeting', selfReflectionAndEvaluationVisible: boolean, activityListEnabled: boolean, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, targetsCalculationHelper: { __typename?: 'TargetsCalculationHelperDTO', pastTargetsReferenceYear: number, newTargetsReferenceYear: number }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null }, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } }, careerPathEvaluationByMeetingId?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null };

export type MeetingEmployeePreparationQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type MeetingEmployeePreparationQuery = { __typename?: 'Query', meetingEmployeePreparation: { __typename?: 'Meeting', selfReflectionAndEvaluationVisible: boolean, activityListEnabled: boolean, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, targetsCalculationHelper: { __typename?: 'TargetsCalculationHelperDTO', pastTargetsReferenceYear: number, newTargetsReferenceYear: number }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null }, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } } };

export type MeetingManagerPreparationQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type MeetingManagerPreparationQuery = { __typename?: 'Query', meetingManagerPreparation: { __typename?: 'Meeting', selfReflectionAndEvaluationVisible: boolean, activityListEnabled: boolean, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, targetsCalculationHelper: { __typename?: 'TargetsCalculationHelperDTO', pastTargetsReferenceYear: number, newTargetsReferenceYear: number }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null }, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } }, careerPathEvaluationByMeetingId?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null };

export type MeetingPdfStatusQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type MeetingPdfStatusQuery = { __typename?: 'Query', meetingPdfStatus: { __typename?: 'Meeting', id: any, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string } };

export type AppraisalStatusModalQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
  employeeId: Scalars['HashedId']['input'];
  country: Country;
  isAppraisalUpdate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AppraisalStatusModalQuery = { __typename?: 'Query', isBonusValidationEnabled: boolean, fullMeetingPreview: { __typename?: 'FullMeetingPreviewDTO', meeting: { __typename?: 'Meeting', selfReflectionAndEvaluationVisible: boolean, activityListEnabled: boolean, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, targetsCalculationHelper: { __typename?: 'TargetsCalculationHelperDTO', pastTargetsReferenceYear: number, newTargetsReferenceYear: number }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null }, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } }, selfReflectionQuestions: Array<{ __typename?: 'SelfreflectionQuestion', id: any, textId: string, value?: number | null, comment?: string | null, position: number, type: SelfReflectionQuestionType, meetingId: any, subItems: Array<{ __typename?: 'SelfreflectionQuestionBoolean', id: any, textId?: string | null, value?: boolean | null, position: number }> }>, scoreGrid?: { __typename?: 'ScoreGridDto', id: any, resultScore?: number | null, lastResultScore?: number | null, employeePreparationScore?: number | null, managerPreparationScore?: number | null, date: any, scoreGoals: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, employeeEvaluation?: number | null, reviewerEvaluation?: number | null, resultEvaluation?: number | null, lastResultEvaluation?: number | null }> } | null, objectives: Array<{ __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, meetingId: any, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null, paymentDate?: any | null, status?: ObjectivePaymentStatus | null, paymentDateValid: boolean } | null, oneOffPayment?: { __typename?: 'OneOffPayment', id: any, comment: string, paymentDate: any, resultAmount?: number | null, status: OneOffPaymentStatus, meetingId: any, paymentDateValid?: boolean | null } | null, contractChanges: Array<{ __typename?: 'Change', id: any, changes: string, validFrom?: any | null, status?: ChangeStatus | null, updatedDate?: any | null }>, targetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }>, salaryOfYear: Array<{ __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null }>, latestContract: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency, validFrom: any, validTo?: any | null, updatesRestrictedTo?: any | null, cancellationType?: CancellationType | null, cancellationFrom?: any | null, cancellationTo?: any | null, flexibleBenefit?: number | null, hasNationalContract: boolean, isDeductionEnabled: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, legalEntity: { __typename?: 'LegalEntity', name?: string | null, country: Country }, annualSalary?: { __typename?: 'Salary', amount: number, isTentative: boolean, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', amount: number, currency: Currency } | null, contractType: { __typename?: 'ContractType', typeOfContract: ContractTypeEnum }, employeeLevel?: { __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, isTentative: boolean } | null, nationalContractLevel?: { __typename?: 'NationalContractLevel', type: NationalContractType, level: NationalContractLevelEnum } | null, nationalContractReferenceLevel?: { __typename?: 'NationalContractReferenceDTO', description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, selectable: boolean, displayOrder: number }> } | null, leaveEntitlement?: { __typename?: 'LeaveEntitlement', amount: number } | null, companyCar?: { __typename?: 'CompanyCar', deduction?: number | null, type?: string | null, currency: string } | null, executedPayments?: Array<{ __typename?: 'ExecutedPayment', amount: number, referenceYear: number, paymentDate: any, type: ExecutedPaymentType, currency: Currency }> | null, contractGovernmentJobTitle?: { __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } } | null }, targetCorrectionPayment?: { __typename?: 'TargetCorrectionPaymentDto', id: any, paymentDate: any, status: TargetCorrectionPaymentStatus, resultAmount?: number | null, comment: string, referenceYear: number, meetingId: any, paymentDateValid: boolean } | null }, branchOfficeByEmployee: { __typename?: 'BranchOffice', code: string, name: string, timezone: string, addressId: any } };

export type ScheduledMeetingsByManagerQueryVariables = Exact<{
  managerId: Scalars['HashedId']['input'];
  year: Scalars['Float']['input'];
}>;


export type ScheduledMeetingsByManagerQuery = { __typename?: 'Query', scheduledMeetingsByManager: Array<{ __typename?: 'Meeting', id: any, date: any, displayDate: any, duration?: number | null, type: MeetingType, status: MeetingStatus }> };

export type GetAppraisalsWithFeedbackByCountryAndFiltersQueryVariables = Exact<{
  country: Country;
  filters: HrSupportFeedbackTabFilter;
  pagination: CursorPaginationMeetingInput;
}>;


export type GetAppraisalsWithFeedbackByCountryAndFiltersQuery = { __typename?: 'Query', getAppraisalsWithFeedbackByCountryAndFilters: { __typename?: 'AppraisalWithFeedbackPagination', endCursorMeetingId?: any | null, endCursorConfirmationDate?: any | null, hasNextPage: boolean, edges: Array<{ __typename?: 'AppraisalWithFeedbackDTO', id: any, date: any, status: MeetingStatus, managerConfirmationDate: any, employeeConfirmationDate: any, hrFeedback: string, hrResult: MeetingHrFeedbackResult, hrDisputeComment?: string | null, meetingType: MeetingType, companyName: string, replyer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, reviewer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, discussedWith?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, conclusionPdf: { __typename?: 'MeetingConclusionPdf', fileName: string, downloadToken: string, status: MeetingPdfStatus }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> } };

export type GetAppraisalsWithFeedbackToResolveCounterByCountryQueryVariables = Exact<{
  country: Country;
}>;


export type GetAppraisalsWithFeedbackToResolveCounterByCountryQuery = { __typename?: 'Query', getAppraisalsWithFeedbackToResolveCounterByCountry: number };

export type MeetingsAndRequestsByReplyerQueryVariables = Exact<{
  replyerId: Scalars['HashedId']['input'];
  disputedMeetingsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MeetingsAndRequestsByReplyerQuery = { __typename?: 'Query', meetingsByReplyer: Array<{ __typename?: 'Meeting', managerPrepared: boolean, employeePrepared: boolean, conclusionPdfStatus: MeetingPdfStatus, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, preparationPdfFileName: string, preparationPdfDownloadToken: string, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, preparationPdfStatus: string, location?: string | null, duration?: number | null, employee: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType }> | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', shareWithHR: boolean, feedbackForHR?: string | null, hrResult: string } | null, other?: { __typename?: 'MeetingEmbedOther', agenda?: string | null } | null, nonParticipants: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, getMeetingRequestsByRequester: Array<{ __typename?: 'MeetingRequestDTO', id: any, type: MeetingType, requestedDate: any, reasonForRequest: string, reasonOfRejection?: string | null, status: MeetingRequestStatus, isRequestValid: boolean, requester: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, reviewer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, employeeDisplayShortInfoByEmployeeId?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null };

export type GetMeetingRequestsByReviewerQueryVariables = Exact<{
  reviewerId: Scalars['HashedId']['input'];
}>;


export type GetMeetingRequestsByReviewerQuery = { __typename?: 'Query', getMeetingRequestsByReviewer: Array<{ __typename?: 'MeetingRequestDTO', id: any, type: MeetingType, requestedDate: any, reasonForRequest: string, reasonOfRejection?: string | null, status: MeetingRequestStatus, isRequestValid: boolean, requester: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, reviewer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> };

export type GetMeetingRequestQueryVariables = Exact<{
  meetingRequestId: Scalars['HashedId']['input'];
}>;


export type GetMeetingRequestQuery = { __typename?: 'Query', getMeetingRequest: { __typename?: 'MeetingRequestDTO', id: any, type: MeetingType, requestedDate: any, reasonForRequest: string, reasonOfRejection?: string | null, status: MeetingRequestStatus, isRequestValid: boolean, requester: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, reviewer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } } };

export type GetMeetingRequestsByCompanyCountryQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Scalars['String']['input'];
}>;


export type GetMeetingRequestsByCompanyCountryQuery = { __typename?: 'Query', getMeetingRequestsByCompanyCountry: Array<{ __typename?: 'MeetingRequestDTO', id: any, type: MeetingType, requestedDate: any, reasonForRequest: string, reasonOfRejection?: string | null, status: MeetingRequestStatus, isRequestValid: boolean, requester: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, reviewer: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> };

export type AllowedMonetaryTargetsFragment = { __typename?: 'Meeting', allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } };

export type AppraisalSeasonFragment = { __typename?: 'Meeting', appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } };

export type MeetingCoreFragment = { __typename?: 'Meeting', id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null };

export type MeetingDashboardFragment = { __typename?: 'Meeting', managerPrepared: boolean, employeePrepared: boolean, conclusionPdfStatus: MeetingPdfStatus, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, preparationPdfFileName: string, preparationPdfDownloadToken: string, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, preparationPdfStatus: string, location?: string | null, duration?: number | null, employee: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType }> | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', shareWithHR: boolean, feedbackForHR?: string | null, hrResult: string } | null, other?: { __typename?: 'MeetingEmbedOther', agenda?: string | null } | null, nonParticipants: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } };

export type MeetingRestFragment = { __typename?: 'Meeting', employeePrepared: boolean, employeePreparationDate?: any | null, managerPrepared: boolean, hasEvaluationScore: boolean, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, nextPaymentCycle: any, requiresSpecialHandlingOfLowTag: boolean, other?: { __typename?: 'MeetingEmbedOther', notesEmployee?: string | null, notesManager?: string | null, agenda?: string | null, protocol?: string | null } | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', employeeSelfReflectionPerf?: string | null, employeeSelfReflectionPerfScore?: number | null, employeeGeneralFeedback?: string | null, reviewerGeneralFeedback?: string | null, meetingGeneralFeedback?: string | null, targetCommentsShared: boolean, evaluationShared: boolean, selfReflectionShared: boolean, shareWithHR: boolean, feedbackForHR?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, status: MeetingStepStatus, position: number, type: MeetingStepType }> | null, managerPreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employeePreparationActiveStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, activeMeetingStep?: { __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType } | null, employee: { __typename?: 'Employee', replyEntryDate: any, email: string, skillCenterUrl?: string | null, id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, currentContract?: { __typename?: 'Contract', currencyForPayments: string, legalEntity: { __typename?: 'LegalEntity', country: Country } } | null, branchOffice: { __typename?: 'BranchOffice', timezone: string } }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, paymentDate?: any | null, paymentDateValid: boolean, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null } | null, allowedMonetaryTargets: { __typename?: 'AllowedMonetaryTargetsDTO', newTargetsAllowed: boolean, pastTargetsAllowed: boolean } };

export type MeetingTargetsCalculationHelperFragment = { __typename?: 'Meeting', targetsCalculationHelper: { __typename?: 'TargetsCalculationHelperDTO', pastTargetsReferenceYear: number, newTargetsReferenceYear: number } };

export type MeetingsByManagerQueryVariables = Exact<{
  managerId: Scalars['HashedId']['input'];
  disputedMeetingsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MeetingsByManagerQuery = { __typename?: 'Query', meetingsByManager: Array<{ __typename?: 'Meeting', isLoggedUserCompanyManagerOfAppraisalSeasonCompany: boolean, isReplyerActive: boolean, managerPrepared: boolean, employeePrepared: boolean, conclusionPdfStatus: MeetingPdfStatus, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, preparationPdfFileName: string, preparationPdfDownloadToken: string, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, preparationPdfStatus: string, location?: string | null, duration?: number | null, employee: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType }> | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', shareWithHR: boolean, feedbackForHR?: string | null, hrResult: string } | null, other?: { __typename?: 'MeetingEmbedOther', agenda?: string | null } | null, nonParticipants: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> };

export type SubordinateMeetingsQueryVariables = Exact<{
  managerId: Scalars['HashedId']['input'];
}>;


export type SubordinateMeetingsQuery = { __typename?: 'Query', subordinateMeetings: Array<{ __typename?: 'Meeting', isLoggedUserCompanyManagerOfAppraisalSeasonCompany: boolean, managerPrepared: boolean, employeePrepared: boolean, conclusionPdfStatus: MeetingPdfStatus, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, preparationPdfFileName: string, preparationPdfDownloadToken: string, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, preparationPdfStatus: string, location?: string | null, duration?: number | null, employee: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType }> | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', shareWithHR: boolean, feedbackForHR?: string | null, hrResult: string } | null, other?: { __typename?: 'MeetingEmbedOther', agenda?: string | null } | null, nonParticipants: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> };

export type MeetingsByReplyerQueryVariables = Exact<{
  replyerId: Scalars['HashedId']['input'];
  disputedMeetingsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MeetingsByReplyerQuery = { __typename?: 'Query', meetingsByReplyer: Array<{ __typename?: 'Meeting', managerPrepared: boolean, employeePrepared: boolean, conclusionPdfStatus: MeetingPdfStatus, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, preparationPdfFileName: string, preparationPdfDownloadToken: string, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, preparationPdfStatus: string, location?: string | null, duration?: number | null, employee: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType }> | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', shareWithHR: boolean, feedbackForHR?: string | null, hrResult: string } | null, other?: { __typename?: 'MeetingEmbedOther', agenda?: string | null } | null, nonParticipants: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> };

export type MeetingsHistoryByReplyerQueryVariables = Exact<{
  replyerId: Scalars['HashedId']['input'];
  isResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MeetingsHistoryByReplyerQuery = { __typename?: 'Query', meetingsHistoryByReplyer: Array<{ __typename?: 'Meeting', confirmationDate?: any | null, forceConfirmationReason?: string | null, employeePrepared: boolean, preparationPdfFileName: string, preparationPdfDownloadToken: string, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, conclusionPdfStatus: MeetingPdfStatus, preparationPdfStatus: string, location?: string | null, duration?: number | null, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, employee: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }, forceConfirmationEmployee?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> };

export type InviteToAppraisalMeetingMutationVariables = Exact<{
  meetingInput: MeetingInviteInput;
}>;


export type InviteToAppraisalMeetingMutation = { __typename?: 'Mutation', inviteToAppraisalMeeting: { __typename?: 'Meeting', managerPrepared: boolean, employeePrepared: boolean, conclusionPdfStatus: MeetingPdfStatus, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, preparationPdfFileName: string, preparationPdfDownloadToken: string, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, preparationPdfStatus: string, location?: string | null, duration?: number | null, employee: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType }> | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', shareWithHR: boolean, feedbackForHR?: string | null, hrResult: string } | null, other?: { __typename?: 'MeetingEmbedOther', agenda?: string | null } | null, nonParticipants: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } } };

export type CreateOtherMeetingInviteMutationVariables = Exact<{
  meetingInput: MeetingInviteInput;
}>;


export type CreateOtherMeetingInviteMutation = { __typename?: 'Mutation', otherMeetingInvite: { __typename?: 'Meeting', managerPrepared: boolean, employeePrepared: boolean, conclusionPdfStatus: MeetingPdfStatus, conclusionPdfFileName: string, conclusionPdfDownloadToken: string, preparationPdfFileName: string, preparationPdfDownloadToken: string, id: any, date: any, displayDate: any, status: MeetingStatus, type: MeetingType, preparationPdfStatus: string, location?: string | null, duration?: number | null, employee: { __typename?: 'Employee', id: any, avatarUrl?: string | null, currentEmployeeLevel?: string | null, legalFirstName: string, legalLastName: string, chosenFirstName?: string | null, chosenLastName?: string | null }, reviewer?: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null } | null, meetingSteps?: Array<{ __typename?: 'MeetingStep', id: any, viewId: MeetingStepViewId, type: MeetingStepType }> | null, appraisal?: { __typename?: 'MeetingEmbedAppraisal', shareWithHR: boolean, feedbackForHR?: string | null, hrResult: string } | null, other?: { __typename?: 'MeetingEmbedOther', agenda?: string | null } | null, nonParticipants: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } } };

export type UpdateSelectableNationalContractReferenceLevelsMutationVariables = Exact<{
  input: UpdateNationalContractReferenceInput;
}>;


export type UpdateSelectableNationalContractReferenceLevelsMutation = { __typename?: 'Mutation', updateSelectableNationalContractReferenceLevels: { __typename?: 'NationalContractReferenceWithTypeDTO', type: NationalContractType, description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, displayOrder: number, selectable: boolean }> } };

export type ImportSelectableNationalContractReferenceLevelsMutationVariables = Exact<{
  input: ImportNationalContractReferenceInput;
}>;


export type ImportSelectableNationalContractReferenceLevelsMutation = { __typename?: 'Mutation', importSelectableNationalContractReferenceLevels: Array<{ __typename?: 'NationalContractReferenceWithTypeDTO', type: NationalContractType, description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, displayOrder: number, selectable: boolean }> }> };

export type GetSelectableNationalContractReferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectableNationalContractReferencesQuery = { __typename?: 'Query', getSelectableNationalContractReferences: Array<{ __typename?: 'NationalContractReferenceWithTypeDTO', type: NationalContractType, description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, displayOrder: number, selectable: boolean }> }> };

export type NationalContractReferenceWithTypeFragment = { __typename?: 'NationalContractReferenceWithTypeDTO', type: NationalContractType, description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, displayOrder: number, selectable: boolean }> };

export type NextBestActivityCountQueryVariables = Exact<{
  businessUnitIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
  includeBusinessUnitManager: Scalars['Boolean']['input'];
  noMeetingsSince: Scalars['DateTime']['input'];
  onlyEmployeesInSecondHalfOfProbationPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  periodLimitedContract: Period;
  periodLeaving: Period;
}>;


export type NextBestActivityCountQuery = { __typename?: 'Query', nextBestActivity: { __typename?: 'NextBestActivity', totalCount: number, noMeeting: { __typename?: 'NextBestActivityNoMeeting', count: number }, onProbation: { __typename?: 'NextBestActivityProbationTalk', count: number }, expiringLimitedContracts: { __typename?: 'NextBestActivityLimitedContractEnding', count: number }, missingTargets: { __typename?: 'NextBestActionMissingTargets', count: number }, leavingSoon: { __typename?: 'NextBestActivityLeavingEmployees', count: number } } };

export type NextBestActivityExpiringContractQueryVariables = Exact<{
  businessUnitIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
  includeBusinessUnitManager: Scalars['Boolean']['input'];
  period: Period;
}>;


export type NextBestActivityExpiringContractQuery = { __typename?: 'Query', nextBestActivity: { __typename?: 'NextBestActivity', expiringLimitedContracts: { __typename?: 'NextBestActivityLimitedContractEnding', employees: Array<{ __typename?: 'EmployeeWithEndingContract', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel?: string | null, companyName?: string | null, buName: string, endOfContract?: any | null, timezone: string }> } } };

export type NextBestActivityLeavingSoonQueryVariables = Exact<{
  businessUnitIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
  includeBusinessUnitManager: Scalars['Boolean']['input'];
  period: Period;
}>;


export type NextBestActivityLeavingSoonQuery = { __typename?: 'Query', nextBestActivity: { __typename?: 'NextBestActivity', leavingSoon: { __typename?: 'NextBestActivityLeavingEmployees', employees: Array<{ __typename?: 'EmployeeWithEndingContract', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel?: string | null, companyName?: string | null, buName: string, endOfContract?: any | null, timezone: string }> } } };

export type NextBestActivityMissingTargetsQueryVariables = Exact<{
  businessUnitIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
  includeBusinessUnitManager: Scalars['Boolean']['input'];
}>;


export type NextBestActivityMissingTargetsQuery = { __typename?: 'Query', nextBestActivity: { __typename?: 'NextBestActivity', missingTargets: { __typename?: 'NextBestActionMissingTargets', employees: Array<{ __typename?: 'EmployeeWithBonus', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel?: string | null, companyName?: string | null, buName: string, currency: Currency, targetBonus: number, objectiveAmount: number }> } } };

export type NextBestActivityEmployeesQueryVariables = Exact<{
  businessUnitIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
  includeBusinessUnitManager: Scalars['Boolean']['input'];
  since: Scalars['DateTime']['input'];
}>;


export type NextBestActivityEmployeesQuery = { __typename?: 'Query', nextBestActivity: { __typename?: 'NextBestActivity', noMeeting: { __typename?: 'NextBestActivityNoMeeting', employees: Array<{ __typename?: 'EmployeeDisplayShortInfoWithLastMeeting', id: any, firstName: string, lastName: string, currentLevel?: string | null, companyName?: string | null, buName: string, avatarUrl?: string | null, lastCompletedMeeting?: { __typename?: 'MeetingTiny', id: any, date: any } | null }> } } };

export type NextBestActivityOnProbationQueryVariables = Exact<{
  businessUnitIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
  includeBusinessUnitManager: Scalars['Boolean']['input'];
  onlyEmployeesInSecondHalfOfProbationPeriod?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NextBestActivityOnProbationQuery = { __typename?: 'Query', nextBestActivity: { __typename?: 'NextBestActivity', onProbation: { __typename?: 'NextBestActivityProbationTalk', employees: Array<{ __typename?: 'EmployeeOnProbation', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel?: string | null, companyName?: string | null, buName: string, probationEndDate: any, inSecondHalfOfProbationPeriod: boolean, timezone: string }> } } };

export type CreateOrUpdateObjectivePaymentMutationVariables = Exact<{
  objectivePayment: ObjectivePaymentInput;
}>;


export type CreateOrUpdateObjectivePaymentMutation = { __typename?: 'Mutation', createOrUpdateObjectivePayment: { __typename?: 'ObjectivePayment', id: any, meetingId: any, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null, paymentDate?: any | null, status?: ObjectivePaymentStatus | null, paymentDateValid: boolean } };

export type ObjectivePaymentByMeetingQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type ObjectivePaymentByMeetingQuery = { __typename?: 'Query', objectivePaymentByMeeting?: { __typename?: 'ObjectivePayment', id: any, meetingId: any, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null, paymentDate?: any | null, status?: ObjectivePaymentStatus | null, paymentDateValid: boolean } | null };

export type FullObjectivePaymentFragment = { __typename?: 'ObjectivePayment', id: any, meetingId: any, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null, paymentDate?: any | null, status?: ObjectivePaymentStatus | null, paymentDateValid: boolean };

export type ConclusionModalObjectiveFragmentFragment = { __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } };

export type FullObjectiveFragmentFragment = { __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } };

export type SaveObjectiveMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  objective: ObjectiveInput;
}>;


export type SaveObjectiveMutation = { __typename?: 'Mutation', saveObjective: { __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } } };

export type SaveObjectiveInMeetingMutationVariables = Exact<{
  objective: ObjectiveInput;
  meetingId: Scalars['HashedId']['input'];
}>;


export type SaveObjectiveInMeetingMutation = { __typename?: 'Mutation', saveObjectiveInMeeting: { __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } } };

export type DismissObjectiveInMeetingMutationVariables = Exact<{
  id: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
}>;


export type DismissObjectiveInMeetingMutation = { __typename?: 'Mutation', dismissObjectiveInMeeting: any };

export type DeleteObjectiveInMeetingMutationVariables = Exact<{
  globalId: Scalars['String']['input'];
  meetingId: Scalars['HashedId']['input'];
}>;


export type DeleteObjectiveInMeetingMutation = { __typename?: 'Mutation', deleteObjectiveInMeeting: boolean };

export type ReactiveObjectiveInMeetingMutationVariables = Exact<{
  id: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
}>;


export type ReactiveObjectiveInMeetingMutation = { __typename?: 'Mutation', reactiveObjectiveInMeeting: any };

export type DuplicateObjectiveInMeetingMutationVariables = Exact<{
  globalId: Scalars['String']['input'];
  meetingId: Scalars['HashedId']['input'];
}>;


export type DuplicateObjectiveInMeetingMutation = { __typename?: 'Mutation', duplicateObjectiveInMeeting: boolean };

export type DuplicateAndDimissObjectiveInMeetingMutationVariables = Exact<{
  objective: ObjectiveInput;
  meetingId: Scalars['HashedId']['input'];
}>;


export type DuplicateAndDimissObjectiveInMeetingMutation = { __typename?: 'Mutation', duplicateAndDismissObjectiveInMeeting: boolean };

export type CloseOutdatedTargetsMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type CloseOutdatedTargetsMutation = { __typename?: 'Mutation', closeOutdatedTargets: boolean };

export type ObjectivesDtoListQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ObjectivesDtoListQuery = { __typename?: 'Query', objectivesDtoList: Array<{ __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }> };

export type ObjectiveListAndEmployeeContractQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  employeeResigned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ObjectiveListAndEmployeeContractQuery = { __typename?: 'Query', objectivesDtoList: Array<{ __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, resignedContract?: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency } | null, currentContract?: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency } };

export type ObjectivesInMeetingQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type ObjectivesInMeetingQuery = { __typename?: 'Query', objectivesInMeeting: Array<{ __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, meetingId: any, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null, paymentDate?: any | null, status?: ObjectivePaymentStatus | null, paymentDateValid: boolean } | null };

export type ObjectivesWithAttachmentsFromMeetingQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type ObjectivesWithAttachmentsFromMeetingQuery = { __typename?: 'Query', objectivesWithAttachmentsFromMeeting: Array<{ __typename?: 'ObjectiveAttachmentInfoDTO', globalId?: string | null, attachment?: string | null, attachmentDownloadToken?: string | null }> };

export type ExistingDevObjectivesToBeClosedInMeetingQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type ExistingDevObjectivesToBeClosedInMeetingQuery = { __typename?: 'Query', existingDevObjectivesToBeClosedInMeeting: boolean };

export type UploadObjectiveAttachmentMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  employeeIdOfMeetingNotLoggedInEmployeeId: Scalars['HashedId']['input'];
}>;


export type UploadObjectiveAttachmentMutation = { __typename?: 'Mutation', uploadObjectiveAttachment: string };

export type CreateOrUpdateOneOffPaymentMutationVariables = Exact<{
  oneOffPayment: OneOffPaymentInput;
}>;


export type CreateOrUpdateOneOffPaymentMutation = { __typename?: 'Mutation', createOrUpdateOneOffPayment?: { __typename?: 'OneOffPayment', id: any, comment: string, paymentDate: any, resultAmount?: number | null, status: OneOffPaymentStatus, meetingId: any, paymentDateValid?: boolean | null } | null };

export type DeleteOneOffPaymentMutationVariables = Exact<{
  oneOffPaymentId: Scalars['HashedId']['input'];
}>;


export type DeleteOneOffPaymentMutation = { __typename?: 'Mutation', deleteOneOffPayment: number };

export type OneOffPaymentByMeetingIdQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type OneOffPaymentByMeetingIdQuery = { __typename?: 'Query', oneOffPaymentByMeetingId?: { __typename?: 'OneOffPayment', id: any, comment: string, paymentDate: any, resultAmount?: number | null, status: OneOffPaymentStatus, meetingId: any, paymentDateValid?: boolean | null } | null };

export type OneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectivesQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
  includeAllTargetBoni?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectivesQuery = { __typename?: 'Query', isOneOffPaymentNotAllowed: boolean, oneOffPaymentByMeetingId?: { __typename?: 'OneOffPayment', id: any, comment: string, paymentDate: any, resultAmount?: number | null, status: OneOffPaymentStatus, meetingId: any, paymentDateValid?: boolean | null } | null, objectivesInMeeting: Array<{ __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, meetingId: any, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null, paymentDate?: any | null, status?: ObjectivePaymentStatus | null, paymentDateValid: boolean } | null, targetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }>, targetCorrectionPaymentByMeetingId?: { __typename?: 'TargetCorrectionPaymentDto', id: any, paymentDate: any, status: TargetCorrectionPaymentStatus, resultAmount?: number | null, comment: string, referenceYear: number, meetingId: any, paymentDateValid: boolean } | null, targetCorrectionPaymentAllowedYears: { __typename?: 'TargetCorrectionPaymentAllowedYearsDto', currentYearAllowed: boolean, previousYearAllowed: boolean } };

export type OneOffPaymentAndObjectivePaymentsWithObjectivesQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type OneOffPaymentAndObjectivePaymentsWithObjectivesQuery = { __typename?: 'Query', isOneOffPaymentNotAllowed: boolean, oneOffPaymentByMeetingId?: { __typename?: 'OneOffPayment', id: any, comment: string, paymentDate: any, resultAmount?: number | null, status: OneOffPaymentStatus, meetingId: any, paymentDateValid?: boolean | null } | null, objectivesInMeeting: Array<{ __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, meetingId: any, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null, paymentDate?: any | null, status?: ObjectivePaymentStatus | null, paymentDateValid: boolean } | null };

export type OneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContractQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
  year: Scalars['Int']['input'];
  newTargetsYear: Scalars['Int']['input'];
  country: Country;
  includeAllTargetBoni?: InputMaybe<Scalars['Boolean']['input']>;
  includeGovernmentJobTitles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContractQuery = { __typename?: 'Query', isBonusValidationEnabled: boolean, isOneOffPaymentNotAllowed: boolean, existingDevObjectivesToBeClosedInMeeting: boolean, oneOffPaymentByMeetingId?: { __typename?: 'OneOffPayment', id: any, comment: string, paymentDate: any, resultAmount?: number | null, status: OneOffPaymentStatus, meetingId: any, paymentDateValid?: boolean | null } | null, objectivesInMeeting: Array<{ __typename?: 'ObjectiveDTO', id?: any | null, globalId?: string | null, title: string, due: any, start: any, status: ObjectiveStatus, targetAmount?: number | null, achievedAmount?: number | null, currency?: Currency | null, attachment?: string | null, closedDate?: any | null, taskNotes?: string | null, attachmentDownloadToken?: string | null, keyResults: Array<{ __typename?: 'KeyResultDTO', id?: any | null, text: string, completed: boolean, globalId?: string | null }>, noteList: Array<{ __typename?: 'NoteInfo', id?: any | null, text: string, date: any, globalId?: string | null, author: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } }>, appraisalSeason: { __typename?: 'AppraisalSeasonDTO', id: any, companyId: any, country: string, year: number, fromDate: any, toDate?: any | null } }>, objectivePayment?: { __typename?: 'ObjectivePayment', id: any, meetingId: any, deduction?: number | null, deductionReason?: ObjectivePaymentManualDeductionReason | null, paymentDate?: any | null, status?: ObjectivePaymentStatus | null, paymentDateValid: boolean } | null, targetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }>, salaryOfYear: Array<{ __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null }>, contractsInYear: Array<{ __typename?: 'Contract', id: any, validFrom: any, validTo?: any | null, cancellationTo?: any | null }>, newTargetsTargetBonusOfYear: Array<{ __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, currency: Currency, contractId: any }>, newTargetsSalaryOfYear: Array<{ __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null }>, newTargetsContractsInYear: Array<{ __typename?: 'Contract', id: any, validFrom: any, validTo?: any | null, cancellationTo?: any | null }>, contractChangesByEmployee: Array<{ __typename?: 'Change', id: any, changes: string, validFrom?: any | null, status?: ChangeStatus | null, updatedDate?: any | null }>, currentContract: { __typename?: 'LatestContractDTO', id?: any | null, currencyForPayments: Currency, validFrom: any, validTo?: any | null, updatesRestrictedTo?: any | null, cancellationType?: CancellationType | null, cancellationFrom?: any | null, cancellationTo?: any | null, flexibleBenefit?: number | null, hasNationalContract: boolean, isDeductionEnabled: boolean, isMonthlySalaryDisplayed: boolean, monthlySalaryMonthsInYear: number, legalEntity: { __typename?: 'LegalEntity', name?: string | null, country: Country }, annualSalary?: { __typename?: 'Salary', amount: number, isTentative: boolean, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', amount: number, currency: Currency } | null, contractType: { __typename?: 'ContractType', typeOfContract: ContractTypeEnum }, employeeLevel?: { __typename?: 'ContractEmployeeLevel', level: EmployeeLevelEnum, isTentative: boolean } | null, nationalContractLevel?: { __typename?: 'NationalContractLevel', type: NationalContractType, level: NationalContractLevelEnum } | null, nationalContractReferenceLevel?: { __typename?: 'NationalContractReferenceDTO', description: string, levels: Array<{ __typename?: 'NationalContractReferenceLevelDTO', level: string, minSalary: number, selectable: boolean, displayOrder: number }> } | null, leaveEntitlement?: { __typename?: 'LeaveEntitlement', amount: number } | null, companyCar?: { __typename?: 'CompanyCar', deduction?: number | null, type?: string | null, currency: string } | null, executedPayments?: Array<{ __typename?: 'ExecutedPayment', amount: number, referenceYear: number, paymentDate: any, type: ExecutedPaymentType, currency: Currency }> | null, contractGovernmentJobTitle?: { __typename?: 'ContractGovernmentJobTitle', id: any, fromDate: any, toDate?: any | null, governmentJobTitle: { __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, fromDate: any, toDate?: any | null, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } } } | null }, branchOfficeByEmployee: { __typename?: 'BranchOffice', code: string, name: string, timezone: string, addressId: any }, governmentJobTitlesByEmployeeId?: Array<{ __typename?: 'GovernmentJobTitle', id: any, department: string, title: string, level: EmployeeLevelEnum, monthlySalaryMinimum: number, monthlySalaryMaximum: number, currency: Currency, sortOrder?: number | null, hiringOffice: { __typename?: 'HiringOffice', id: any, code: string } }> };

export type FullOneOffPaymentFragment = { __typename?: 'OneOffPayment', id: any, comment: string, paymentDate: any, resultAmount?: number | null, status: OneOffPaymentStatus, meetingId: any, paymentDateValid?: boolean | null };

export type ChangeLocaleMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  locale: Scalars['String']['input'];
}>;


export type ChangeLocaleMutation = { __typename?: 'Mutation', changeLocale: boolean };

export type ChangeTimezoneMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  timezone: Scalars['String']['input'];
}>;


export type ChangeTimezoneMutation = { __typename?: 'Mutation', changeTimezone: boolean };

export type ChangeNameDisplayPreferenceMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  nameDisplayPreference: Scalars['String']['input'];
}>;


export type ChangeNameDisplayPreferenceMutation = { __typename?: 'Mutation', changeNameDisplayPreference: boolean };

export type MyPrivateProfileQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type MyPrivateProfileQuery = { __typename?: 'Query', personalProfile: { __typename?: 'PersonalProfile', employeeId: any, employmentStatus: EmploymentStatus, legalFirstName: string, legalLastName: string, email: string, username: string, chosenLastName?: string | null, chosenFirstName?: string | null, dateOfBirth?: any | null, avatarUrl?: string | null, academicTitle?: string | null, privateEmailAddress?: string | null, replyEntryDate: any, skillCenterUrl?: string | null, branchOfficeCode?: string | null, activityListEnabled?: boolean | null, citizenships: Array<{ __typename?: 'Citizenship', country: string, displayOrder: number }>, currentContractLevel?: { __typename?: 'ContractEmployeeLevel', id: any, level: EmployeeLevelEnum } | null, bankAccount?: { __typename?: 'InternationalBankAccount', country: string, bankName?: string | null, accountName?: string | null, iban?: string | null, bicSwift?: string | null, accountNumber: string, type?: string | null, agency?: string | null, bankSortCode?: string | null, bankCode?: string | null } | null, address: Array<{ __typename?: 'EmployeeAddress', addressId?: any | null, type: string, address?: { __typename?: 'InternationalAddress', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, stateRegion?: string | null, zipPostalCode?: string | null, country?: Country | null, phoneNumber?: string | null } | null }>, education: Array<{ __typename?: 'Education', id: any, level?: string | null, title?: string | null, university?: string | null, country?: string | null, isHighestEducation?: boolean | null, officialDegreeName?: string | null, date?: any | null, grade?: string | null }>, emergencyContacts: Array<{ __typename?: 'EmergencyContact', id: any, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress?: string | null, contactType: string }>, businessUnit?: { __typename?: 'BusinessUnit', name: string, company: { __typename?: 'Company', name: string } } | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null } };

export type PublicProfileQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type PublicProfileQuery = { __typename?: 'Query', publicProfile: { __typename?: 'PublicProfile', employeeId: any, employmentStatus: EmploymentStatus, legalFirstName: string, legalLastName: string, email: string, username: string, chosenLastName?: string | null, chosenFirstName?: string | null, dateOfBirth?: any | null, avatarUrl?: string | null, academicTitle?: string | null, replyEntryDate: any, editable: boolean, skillCenterUrl?: string | null, country: Country, employeeTimezone: string, branchOfficeCode?: string | null, activityListEnabled?: boolean | null, education: Array<{ __typename?: 'Education', id: any, level?: string | null, title?: string | null, university?: string | null, country?: string | null, isHighestEducation?: boolean | null, officialDegreeName?: string | null, date?: any | null, grade?: string | null }>, currentContractLevel?: { __typename?: 'ContractEmployeeLevel', id: any, level: EmployeeLevelEnum } | null, businessUnit?: { __typename?: 'BusinessUnit', name: string, company: { __typename?: 'Company', name: string } } | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null } };

export type ResignedEmployeePublicProfileQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type ResignedEmployeePublicProfileQuery = { __typename?: 'Query', resignedEmployeePublicProfile: { __typename?: 'PublicProfile', employeeId: any, employmentStatus: EmploymentStatus, legalFirstName: string, legalLastName: string, email: string, username: string, chosenLastName?: string | null, chosenFirstName?: string | null, dateOfBirth?: any | null, avatarUrl?: string | null, academicTitle?: string | null, replyEntryDate: any, editable: boolean, skillCenterUrl?: string | null, country: Country, employeeTimezone: string, branchOfficeCode?: string | null, activityListEnabled?: boolean | null, education: Array<{ __typename?: 'Education', id: any, level?: string | null, title?: string | null, university?: string | null, country?: string | null, isHighestEducation?: boolean | null, officialDegreeName?: string | null, date?: any | null, grade?: string | null }>, currentContractLevel?: { __typename?: 'ContractEmployeeLevel', id: any, level: EmployeeLevelEnum } | null, businessUnit?: { __typename?: 'BusinessUnit', name: string, company: { __typename?: 'Company', name: string } } | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null } };

export type LocalesQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalesQuery = { __typename?: 'Query', locales: Array<{ __typename?: 'LocaleDTO', country: string, locale: string }> };

export type BankAccountFragment = { __typename?: 'InternationalBankAccount', country: string, bankName?: string | null, accountName?: string | null, iban?: string | null, bicSwift?: string | null, accountNumber: string, type?: string | null, agency?: string | null, bankSortCode?: string | null, bankCode?: string | null };

export type BusinessUnitAndComapnyNameFragment = { __typename?: 'BusinessUnit', name: string, company: { __typename?: 'Company', name: string } };

export type CitizenshipFragment = { __typename?: 'Citizenship', country: string, displayOrder: number };

export type CompanyNameFragment = { __typename?: 'Company', name: string };

export type ContractEmployeeLevelFragment = { __typename?: 'ContractEmployeeLevel', id: any, level: EmployeeLevelEnum };

export type EducationFragment = { __typename?: 'Education', id: any, level?: string | null, title?: string | null, university?: string | null, country?: string | null, isHighestEducation?: boolean | null, officialDegreeName?: string | null, date?: any | null, grade?: string | null };

export type EmergencyContactFragment = { __typename?: 'EmergencyContact', id: any, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress?: string | null, contactType: string };

export type EmployeeAddressFragment = { __typename?: 'EmployeeAddress', addressId?: any | null, type: string, address?: { __typename?: 'InternationalAddress', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, stateRegion?: string | null, zipPostalCode?: string | null, country?: Country | null, phoneNumber?: string | null } | null };

export type InternationalAddressFragment = { __typename?: 'InternationalAddress', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, stateRegion?: string | null, zipPostalCode?: string | null, country?: Country | null, phoneNumber?: string | null };

export type PersonalProfileFragment = { __typename?: 'PersonalProfile', employeeId: any, employmentStatus: EmploymentStatus, legalFirstName: string, legalLastName: string, email: string, username: string, chosenLastName?: string | null, chosenFirstName?: string | null, dateOfBirth?: any | null, avatarUrl?: string | null, academicTitle?: string | null, privateEmailAddress?: string | null, replyEntryDate: any, skillCenterUrl?: string | null, branchOfficeCode?: string | null, activityListEnabled?: boolean | null, citizenships: Array<{ __typename?: 'Citizenship', country: string, displayOrder: number }>, currentContractLevel?: { __typename?: 'ContractEmployeeLevel', id: any, level: EmployeeLevelEnum } | null, bankAccount?: { __typename?: 'InternationalBankAccount', country: string, bankName?: string | null, accountName?: string | null, iban?: string | null, bicSwift?: string | null, accountNumber: string, type?: string | null, agency?: string | null, bankSortCode?: string | null, bankCode?: string | null } | null, address: Array<{ __typename?: 'EmployeeAddress', addressId?: any | null, type: string, address?: { __typename?: 'InternationalAddress', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, stateRegion?: string | null, zipPostalCode?: string | null, country?: Country | null, phoneNumber?: string | null } | null }>, education: Array<{ __typename?: 'Education', id: any, level?: string | null, title?: string | null, university?: string | null, country?: string | null, isHighestEducation?: boolean | null, officialDegreeName?: string | null, date?: any | null, grade?: string | null }>, emergencyContacts: Array<{ __typename?: 'EmergencyContact', id: any, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress?: string | null, contactType: string }>, businessUnit?: { __typename?: 'BusinessUnit', name: string, company: { __typename?: 'Company', name: string } } | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null };

export type PublicProfileFragment = { __typename?: 'PublicProfile', employeeId: any, employmentStatus: EmploymentStatus, legalFirstName: string, legalLastName: string, email: string, username: string, chosenLastName?: string | null, chosenFirstName?: string | null, dateOfBirth?: any | null, avatarUrl?: string | null, academicTitle?: string | null, replyEntryDate: any, editable: boolean, skillCenterUrl?: string | null, country: Country, employeeTimezone: string, branchOfficeCode?: string | null, activityListEnabled?: boolean | null, education: Array<{ __typename?: 'Education', id: any, level?: string | null, title?: string | null, university?: string | null, country?: string | null, isHighestEducation?: boolean | null, officialDegreeName?: string | null, date?: any | null, grade?: string | null }>, currentContractLevel?: { __typename?: 'ContractEmployeeLevel', id: any, level: EmployeeLevelEnum } | null, businessUnit?: { __typename?: 'BusinessUnit', name: string, company: { __typename?: 'Company', name: string } } | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null };

export type UpdateReferencedPyramidsMutationVariables = Exact<{
  referencePyramidInput: ReferencePyramidInput;
}>;


export type UpdateReferencedPyramidsMutation = { __typename?: 'Mutation', updateReferencedPyramids: { __typename?: 'ReferencePyramid', id: any } };

export type DeleteReferencedPyramidsMutationVariables = Exact<{
  referencePyramidId: Scalars['HashedId']['input'];
  companyId: Scalars['HashedId']['input'];
}>;


export type DeleteReferencedPyramidsMutation = { __typename?: 'Mutation', deleteReferencedPyramids: { __typename?: 'DeleteOk', id: any } };

export type SavePyramidForecastMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  pyramidForecasts: Array<PyramidForecastInput> | PyramidForecastInput;
}>;


export type SavePyramidForecastMutation = { __typename?: 'Mutation', savePyramidForecast: Array<{ __typename?: 'PyramidForecastDTO', id: string, forecastId?: any | null, newHiringFullName?: string | null, businessUnitId?: any | null, salary?: number | null, bonus?: number | null, age?: number | null, levelChange?: EmployeeLevelEnum | null, dateOfLevelChange?: any | null, forecastDate?: any | null, forecastEndDate?: any | null, companyId: any, employeeId?: any | null }> };

export type ReferencedPyramidsByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  pyramidType: PyramidType;
}>;


export type ReferencedPyramidsByCompanyIdQuery = { __typename?: 'Query', referencedPyramidsByCompanyIdAndCountry?: { __typename?: 'ReferencePyramid', id: any, companyId: any, referencePyramidType: string, referencePyramidDetails?: Array<{ __typename?: 'ReferencePyramidDetail', id: any, displayOrder: number, range: string, limitType: string, percentage: number }> | null } | null };

export type PyramidValuesAndReferencePyramidsQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  pyramidType: PyramidType;
}>;


export type PyramidValuesAndReferencePyramidsQuery = { __typename?: 'Query', referencePyramid?: { __typename?: 'ReferencePyramid', id: any, companyId: any, referencePyramidType: string, referencePyramidDetails?: Array<{ __typename?: 'ReferencePyramidDetail', id: any, displayOrder: number, range: string, limitType: string, percentage: number }> | null } | null, pyramidValues: Array<{ __typename?: 'PyramidValueDto', name: string, percentage: number, count: number, displayOrder: number }> };

export type AgeAndLevelReferencePyramidsQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type AgeAndLevelReferencePyramidsQuery = { __typename?: 'Query', ageReferencePyramid?: { __typename?: 'ReferencePyramid', id: any, companyId: any, referencePyramidType: string, referencePyramidDetails?: Array<{ __typename?: 'ReferencePyramidDetail', id: any, displayOrder: number, range: string, limitType: string, percentage: number }> | null } | null, levelReferencePyramid?: { __typename?: 'ReferencePyramid', id: any, companyId: any, referencePyramidType: string, referencePyramidDetails?: Array<{ __typename?: 'ReferencePyramidDetail', id: any, displayOrder: number, range: string, limitType: string, percentage: number }> | null } | null };

export type AgeAndLevelTemplatePyramidsQueryVariables = Exact<{
  country: Country;
}>;


export type AgeAndLevelTemplatePyramidsQuery = { __typename?: 'Query', ageReferencePyramidTemplate?: Array<{ __typename?: 'ReferencePyramidTemplateDTO', id: any, title?: string | null, country: string, referencePyramidType: string, referencePyramidTemplateDetails?: Array<{ __typename?: 'ReferencePyramidTemplateDetailDTO', id: any, range: string, limitType: string, percentage: number, displayOrder: number }> | null }> | null, levelReferencePyramidTemplate?: Array<{ __typename?: 'ReferencePyramidTemplateDTO', id: any, title?: string | null, country: string, referencePyramidType: string, referencePyramidTemplateDetails?: Array<{ __typename?: 'ReferencePyramidTemplateDetailDTO', id: any, range: string, limitType: string, percentage: number, displayOrder: number }> | null }> | null };

export type PyramidPastValuesQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  pyramidType: PyramidType;
  year: Scalars['Float']['input'];
  month: Scalars['Float']['input'];
}>;


export type PyramidPastValuesQuery = { __typename?: 'Query', pyramidPastValues: Array<{ __typename?: 'PyramidValueDto', name: string, count: number, percentage: number, displayOrder: number }> };

export type PyramidPastValueSelectorQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  pyramidType: PyramidType;
}>;


export type PyramidPastValueSelectorQuery = { __typename?: 'Query', pyramidPastValueSelector: { __typename?: 'PyramidSelectorYearAndMonth', options?: Array<{ __typename?: 'Option', value: string, label: string, children?: Array<{ __typename?: 'Children', value: string, label: string }> | null }> | null } };

export type PyramidForecastWithFiltersQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type PyramidForecastWithFiltersQuery = { __typename?: 'Query', isEmployeeLevelValidationEnabled: boolean, employeeLevels: Array<EmployeeLevelEnum>, pyramidForecastWithFilters: { __typename?: 'PyramidForecastWithFiltersDTO', activeEmployees: Array<{ __typename?: 'PyramidForecastDTO', id: string, forecastId?: any | null, employeeId?: any | null, employeeFullName?: string | null, newHiringFullName?: string | null, businessUnitId?: any | null, salary?: number | null, bonus?: number | null, age?: number | null, currentEmployeeLevel?: EmployeeLevelEnum | null, levelChange?: EmployeeLevelEnum | null, dateOfLevelChange?: any | null, forecastDate?: any | null, forecastEndDate?: any | null, startDate?: any | null, endDate?: any | null, tags?: Array<EmployeeTagType> | null, businessUnitName?: string | null, currencyForPayments?: Currency | null, employeeTimezone?: string | null, careerPath?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null }>, newHirings: Array<{ __typename?: 'PyramidForecastDTO', id: string, forecastId?: any | null, employeeId?: any | null, employeeFullName?: string | null, newHiringFullName?: string | null, businessUnitId?: any | null, salary?: number | null, bonus?: number | null, age?: number | null, currentEmployeeLevel?: EmployeeLevelEnum | null, levelChange?: EmployeeLevelEnum | null, dateOfLevelChange?: any | null, forecastDate?: any | null, forecastEndDate?: any | null, startDate?: any | null, endDate?: any | null, tags?: Array<EmployeeTagType> | null, businessUnitName?: string | null, currencyForPayments?: Currency | null, employeeTimezone?: string | null, careerPath?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null }>, filters: { __typename?: 'PyramidForecastFiltersDTO', businessUnits: Array<{ __typename?: 'BusinessUnitTiny', id: any, name: string, isExpired?: boolean | null }>, employees: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string }> }, careerPath?: Array<{ __typename?: 'CareerPathDto', careerPathType: string, country: string, level: string, min: number, max?: number | null }> | null } };

export type PyramidForecastValueSelectorQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type PyramidForecastValueSelectorQuery = { __typename?: 'Query', pyramidForecastValueSelector: { __typename?: 'PyramidSelectorYearAndMonth', options?: Array<{ __typename?: 'Option', value: string, label: string, children?: Array<{ __typename?: 'Children', value: string, label: string }> | null }> | null } };

export type PyramidForecastValuesQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  year: Scalars['Float']['input'];
  month: Scalars['Float']['input'];
}>;


export type PyramidForecastValuesQuery = { __typename?: 'Query', pyramidForecastValues: { __typename?: 'PyramidForecastValues', values: Array<{ __typename?: 'PyramidForecastValueDto', name: string, count: number, percentage: number }>, decrease: Array<{ __typename?: 'PyramidValueLevelDecrease', name: string, count: number }>, ageValues: Array<{ __typename?: 'PyramidForecastValueDto', name: string, count: number, percentage: number }> } };

export type PyramidForecastFragmentFragment = { __typename?: 'PyramidForecastDTO', id: string, forecastId?: any | null, employeeId?: any | null, employeeFullName?: string | null, newHiringFullName?: string | null, businessUnitId?: any | null, salary?: number | null, bonus?: number | null, age?: number | null, currentEmployeeLevel?: EmployeeLevelEnum | null, levelChange?: EmployeeLevelEnum | null, dateOfLevelChange?: any | null, forecastDate?: any | null, forecastEndDate?: any | null, startDate?: any | null, endDate?: any | null, tags?: Array<EmployeeTagType> | null, businessUnitName?: string | null, currencyForPayments?: Currency | null, employeeTimezone?: string | null, careerPath?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null };

export type RemoveEmployeeTagMutationVariables = Exact<{
  removeEmployeeTagInput: RemoveEmployeeTagInput;
}>;


export type RemoveEmployeeTagMutation = { __typename?: 'Mutation', removeEmployeeTag: { __typename?: 'EmployeeTagInfoShort', addedDate: any, removedDate?: any | null, type: EmployeeTagType, note?: string | null, employeeId: any, addedById?: any | null, removedById?: any | null } };

export type AddEmployeeTagMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  type: EmployeeTagType;
}>;


export type AddEmployeeTagMutation = { __typename?: 'Mutation', addEmployeeTag: { __typename?: 'EmployeeTagInfoShort', addedDate: any, removedDate?: any | null, type: EmployeeTagType, note?: string | null, employeeId: any, addedById?: any | null, removedById?: any | null } };

export type AddEntryLevelLowTagMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type AddEntryLevelLowTagMutation = { __typename?: 'Mutation', addEntryLevelLowTag: { __typename?: 'EmployeeTagInfoShort', addedDate: any, removedDate?: any | null, type: EmployeeTagType, note?: string | null, employeeId: any, addedById?: any | null, removedById?: any | null } };

export type EmployeesAndTagsQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type EmployeesAndTagsQuery = { __typename?: 'Query', employeesAndTags: Array<{ __typename?: 'EmployeeAndTag', id: any, firstName: string, lastName: string, currentLevel?: string | null, avatarUrl?: string | null, buName: string, companyName?: string | null, tags: Array<{ __typename?: 'EmployeeTagDto', id?: any | null, type: string, addedDate: any, removedDate?: any | null, note?: string | null, temporary?: boolean | null }> }> };

export type TagHistoryOfEmployeeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<EmployeeTagType> | EmployeeTagType>;
}>;


export type TagHistoryOfEmployeeQuery = { __typename?: 'Query', tagHistoryOfEmployee: Array<{ __typename?: 'EmployeeTagInfo', id: any, addedDate: any, removedDate?: any | null, type: EmployeeTagType, note?: string | null, employee: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, addedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, removedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null }> };

export type TagHistoryOfEmployeeUntilReplyEntryDateQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  types?: InputMaybe<Array<EmployeeTagType> | EmployeeTagType>;
}>;


export type TagHistoryOfEmployeeUntilReplyEntryDateQuery = { __typename?: 'Query', tagHistoryOfEmployeeUntilReplyEntryDate: Array<{ __typename?: 'EmployeeTagInfo', id: any, addedDate: any, removedDate?: any | null, type: EmployeeTagType, note?: string | null, employee: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, addedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, removedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null }> };

export type EmployeeHasOngoingAppraisalQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type EmployeeHasOngoingAppraisalQuery = { __typename?: 'Query', employeeHasOngoingAppraisal: boolean };

export type EmploymentStatusOfEmployeeQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type EmploymentStatusOfEmployeeQuery = { __typename?: 'Query', employmentStatusOfEmployee: { __typename?: 'EmployeeEmploymentStatusDTO', openChanges: boolean, futureChangesForeseenByContract: boolean, currentBonusAfterFirstJanuary: boolean } };

export type EmployeeTagInfoFragment = { __typename?: 'EmployeeTagInfo', id: any, addedDate: any, removedDate?: any | null, type: EmployeeTagType, note?: string | null, employee: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }, addedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, removedBy?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null };

export type EmployeeTagInfoShortFragment = { __typename?: 'EmployeeTagInfoShort', addedDate: any, removedDate?: any | null, type: EmployeeTagType, note?: string | null, employeeId: any, addedById?: any | null, removedById?: any | null };

export type GenerateTargetReportRequestMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type GenerateTargetReportRequestMutation = { __typename?: 'Mutation', generateTargetReportRequest: { __typename?: 'TargetReportGenerationRequestDTO', generationResult: boolean, createTargetReport: boolean } };

export type GenerateRankingReportMutationVariables = Exact<{
  reportId: Scalars['HashedId']['input'];
}>;


export type GenerateRankingReportMutation = { __typename?: 'Mutation', generateRankingReport: boolean };

export type CreateZipWithSelectedRankingReportMutationVariables = Exact<{
  reportIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
}>;


export type CreateZipWithSelectedRankingReportMutation = { __typename?: 'Mutation', createZipWithSelectedRankingReports: boolean };

export type FindReportsInDownloadsViewByCountryTypeQueryVariables = Exact<{
  countries: Array<Country> | Country;
  reportType: ReportType;
  pagination: CursorPaginationReportInput;
}>;


export type FindReportsInDownloadsViewByCountryTypeQuery = { __typename?: 'Query', findReportsInDownloadsViewByCountryAndType: { __typename?: 'ReportPaginationDTO', endCursorReportId?: any | null, endCursorReportDate?: any | null, hasNextPage: boolean, edges: Array<{ __typename?: 'ReportDTO', id: any, filename: string, format: string, type: ReportType, companyName?: string | null, country: Country, size: number, date: any, downloadLink: string, status: ReportStatus, createTargetReport?: boolean | null, creator?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } | null }> } };

export type FindTargetReportsByCountryAndCompanyQueryVariables = Exact<{
  country: Country;
  companyId: Scalars['HashedId']['input'];
}>;


export type FindTargetReportsByCountryAndCompanyQuery = { __typename?: 'Query', findTargetReportsByCountryAndCompany: Array<{ __typename?: 'ReportDTO', id: any, filename: string, format: string, type: ReportType, companyName?: string | null, country: Country, size: number, date: any, downloadLink: string, status: ReportStatus, createTargetReport?: boolean | null, creator?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } | null }> };

export type FindPossibleYearsAndCompaniesForRankingReportQueryVariables = Exact<{
  country?: InputMaybe<Country>;
}>;


export type FindPossibleYearsAndCompaniesForRankingReportQuery = { __typename?: 'Query', findPossibleYearsAndCompaniesForRankingReport: { __typename?: 'YearsAndCompaniesForRankingReportDTO', possibleYears: Array<number>, possibleCompanies: Array<{ __typename?: 'CompaniesForRankingReportDTO', companyId: any, companyName: string }> } };

export type GetRankingReportsByCountryAndFiltersQueryVariables = Exact<{
  countries: Array<Country> | Country;
  filters: RankingReportFilterInput;
  pagination: CursorPaginationReportInput;
}>;


export type GetRankingReportsByCountryAndFiltersQuery = { __typename?: 'Query', getRankingReportsByCountryAndFilters: { __typename?: 'ReportPaginationDTO', endCursorReportId?: any | null, endCursorReportDate?: any | null, hasNextPage: boolean, edges: Array<{ __typename?: 'ReportDTO', id: any, filename: string, format: string, type: ReportType, companyName?: string | null, country: Country, size: number, date: any, downloadLink: string, status: ReportStatus, createTargetReport?: boolean | null, creator?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } | null }> } };

export type ReportFragment = { __typename?: 'ReportDTO', id: any, filename: string, format: string, type: ReportType, companyName?: string | null, country: Country, size: number, date: any, downloadLink: string, status: ReportStatus, createTargetReport?: boolean | null, creator?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string } | null };

export type MeetingRequestOptionsQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type MeetingRequestOptionsQuery = { __typename?: 'Query', meetingRequestOptionsForEmployee: { __typename?: 'MeetingInviteOptionsExtended', possible: Array<MeetingType>, tagAssignmentIsInProgress: boolean, isAppraisalEnabled: boolean } };

export type ResignedEmployeesOfCompanyCountryQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country?: InputMaybe<Country>;
}>;


export type ResignedEmployeesOfCompanyCountryQuery = { __typename?: 'Query', resignedEmployeesOfCompanyCountry: { __typename?: 'ResignedViewEmployeesDTO', employeesWithWrongStatusOrMissingContractDTO: Array<{ __typename?: 'EmployeesWithWrongStatusOrMissingContractDTO', fullName: string, businessUnitId: any }>, resignedEmployees: Array<{ __typename?: 'ResignedEmployeeDto', id: any, firstName: string, lastName: string, level?: EmployeeLevelEnum | null, salary?: number | null, currency?: string | null, bonus?: number | null, startDate: any, endDate?: any | null, reason?: CancellationType | null, timezone: string, businessUnit: { __typename?: 'BusinessUnitTiny', id: any, name: string, displayName: string, company?: { __typename?: 'CompanyTiny', id: any, name?: string | null } | null }, toBePaid?: { __typename?: 'ToBePaid', amount: number, currency: Currency } | null }> } };

export type FindCountriesHrIsResponsibleOfQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCountriesHrIsResponsibleOfQuery = { __typename?: 'Query', findCountriesHrIsResponsibleOf: Array<Country> };

export type PossibleRevieweesByReviewerIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  companyId: Scalars['HashedId']['input'];
}>;


export type PossibleRevieweesByReviewerIdQuery = { __typename?: 'Query', possibleRevieweesByReviewerId: Array<{ __typename?: 'EmployeeWithBusinessUnit', id: any, firstName: string, lastName: string, businessUnit: { __typename?: 'EmbeddedBusinessUnit', id: any, name: string } }> };

export type CreateReviewerOfEmployeeMutationVariables = Exact<{
  revEmpInput: ReviewerOfEmployeesInput;
}>;


export type CreateReviewerOfEmployeeMutation = { __typename?: 'Mutation', createReviewerOfEmployee: { __typename?: 'ReviewerOfEmployees', id: any } };

export type DeleteReviewerOfEmployeeMutationVariables = Exact<{
  relationId: Scalars['HashedId']['input'];
}>;


export type DeleteReviewerOfEmployeeMutation = { __typename?: 'Mutation', deleteReviewerOfEmployee: boolean };

export type ReviewersByBuIdQueryVariables = Exact<{
  buId: Scalars['HashedId']['input'];
}>;


export type ReviewersByBuIdQuery = { __typename?: 'Query', reviewersRelationOfBusinessUnitId: Array<{ __typename?: 'ReviewerAndEmployee', id: any, fromDate: any, type: ReviewerOfEmployeeType, canDelete: boolean, reviewer: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, companyName?: string | null, buName: string, currentLevel?: string | null, avatarUrl?: string | null }, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, companyName?: string | null, buName: string, currentLevel?: string | null, avatarUrl?: string | null } }> };

export type ReviewersByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
}>;


export type ReviewersByCompanyIdQuery = { __typename?: 'Query', reviewersByCompanyId: Array<{ __typename?: 'ReviewerAndEmployee', id: any, fromDate: any, type: ReviewerOfEmployeeType, canDelete: boolean, reviewer: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, companyName?: string | null, buName: string, currentLevel?: string | null, avatarUrl?: string | null }, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, companyName?: string | null, buName: string, currentLevel?: string | null, avatarUrl?: string | null } }> };

export type AllReviewersByEmployeeIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type AllReviewersByEmployeeIdQuery = { __typename?: 'Query', allReviewersByEmployeeId: Array<{ __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null }> };

export type AddHrRoleToEmployeeMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  roleName: Scalars['String']['input'];
  hrVisibilityExcluded: Scalars['Boolean']['input'];
}>;


export type AddHrRoleToEmployeeMutation = { __typename?: 'Mutation', addHrRoleToEmployee: Array<number> };

export type RemoveHrRoleFromEmployeeMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  roleIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
  countryRoleName: Scalars['String']['input'];
}>;


export type RemoveHrRoleFromEmployeeMutation = { __typename?: 'Mutation', removeHrRoleFromEmployee: number };

export type RemoveDownloaderRoleFromEmployeeMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type RemoveDownloaderRoleFromEmployeeMutation = { __typename?: 'Mutation', removeDownloaderRoleFromEmployee: number };

export type AddDownloaderRoleToEmployeeMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type AddDownloaderRoleToEmployeeMutation = { __typename?: 'Mutation', addDownloaderRoleToEmployee: Array<number> };

export type SaveScoreGridMutationVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
  grid: ScoreGridInput;
}>;


export type SaveScoreGridMutation = { __typename?: 'Mutation', saveScoreGrid: { __typename?: 'ScoreGridDto', id: any, resultScore?: number | null, lastResultScore?: number | null, employeePreparationScore?: number | null, managerPreparationScore?: number | null, date: any, scoreGoals: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, employeeEvaluation?: number | null, reviewerEvaluation?: number | null, resultEvaluation?: number | null, lastResultEvaluation?: number | null }> } };

export type ScoreGridWithHistoryQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
  employeeId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type ScoreGridWithHistoryQuery = { __typename?: 'Query', isIdVWeightEnabled: boolean, scoreGridWithHistory: { __typename?: 'ScoreGridDto', id: any, resultScore?: number | null, lastResultScore?: number | null, employeePreparationScore?: number | null, managerPreparationScore?: number | null, date: any, scoreGoals: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, employeeEvaluation?: number | null, reviewerEvaluation?: number | null, resultEvaluation?: number | null, lastResultEvaluation?: number | null }> } };

export type EvaluationFromLastTwoAppraisalsQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type EvaluationFromLastTwoAppraisalsQuery = { __typename?: 'Query', evaluationFromLastTwoAppraisals?: { __typename?: 'ScoreGridsOverviewDTO', id: any, lastAppraisalDate: any, lastAppraisalEmplPrepDate?: any | null, priorAppraisalDate?: any | null, scoreGoals: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, employeeEvaluation?: number | null, resultEvaluation?: number | null, lastResultEvaluation?: number | null }> } | null };

export type ScoreGridFragmentFragment = { __typename?: 'ScoreGridDto', id: any, resultScore?: number | null, lastResultScore?: number | null, employeePreparationScore?: number | null, managerPreparationScore?: number | null, date: any, scoreGoals: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, employeeEvaluation?: number | null, reviewerEvaluation?: number | null, resultEvaluation?: number | null, lastResultEvaluation?: number | null }> };

export type ScoreGridsOverviewFragmentFragment = { __typename?: 'ScoreGridsOverviewDTO', id: any, lastAppraisalDate: any, lastAppraisalEmplPrepDate?: any | null, priorAppraisalDate?: any | null, scoreGoals: Array<{ __typename?: 'ScoreGoalDto', id: any, viewId: ScoreGoalType, employeeEvaluation?: number | null, resultEvaluation?: number | null, lastResultEvaluation?: number | null }> };

export type UpdateSelfreflectionQuestionMutationVariables = Exact<{
  input: SelfreflectionInput;
}>;


export type UpdateSelfreflectionQuestionMutation = { __typename?: 'Mutation', updateSelfreflectionQuestion: { __typename?: 'SelfreflectionQuestion', id: any, textId: string, value?: number | null, comment?: string | null, position: number, type: SelfReflectionQuestionType, meetingId: any, subItems: Array<{ __typename?: 'SelfreflectionQuestionBoolean', id: any, textId?: string | null, value?: boolean | null, position: number }> } };

export type UpdateSelfreflectionQuestionBooleanMutationVariables = Exact<{
  input: SelfreflectionQuestionBooleanInput;
}>;


export type UpdateSelfreflectionQuestionBooleanMutation = { __typename?: 'Mutation', updateSelfreflectionQuestionBoolean: { __typename?: 'SelfreflectionQuestionBoolean', id: any, textId?: string | null, value?: boolean | null, position: number } };

export type SelfreflectionQuestionsQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
}>;


export type SelfreflectionQuestionsQuery = { __typename?: 'Query', selfreflectionQuestions: Array<{ __typename?: 'SelfreflectionQuestion', id: any, textId: string, value?: number | null, comment?: string | null, position: number, type: SelfReflectionQuestionType, meetingId: any, subItems: Array<{ __typename?: 'SelfreflectionQuestionBoolean', id: any, textId?: string | null, value?: boolean | null, position: number }> }> };

export type SelfReflectionQuestionFragment = { __typename?: 'SelfreflectionQuestion', id: any, textId: string, value?: number | null, comment?: string | null, position: number, type: SelfReflectionQuestionType, meetingId: any, subItems: Array<{ __typename?: 'SelfreflectionQuestionBoolean', id: any, textId?: string | null, value?: boolean | null, position: number }> };

export type SelfReflectionSummaryQueryVariables = Exact<{
  businessUnitIds: Array<Scalars['HashedId']['input']> | Scalars['HashedId']['input'];
}>;


export type SelfReflectionSummaryQuery = { __typename?: 'Query', selfReflectionSummary: { __typename?: 'SelfReflectionSummary', totalParticipants: number, numberOfAnswers: number, projectHappiness: { __typename?: 'HappinessLevel', veryHappy: number, happy: number, neutral: number, unhappy: number, veryUnhappy: number } } };

export type RetrieveMySkillStatusMutationVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type RetrieveMySkillStatusMutation = { __typename?: 'Mutation', refreshMySkillStatus: boolean };

export type RefreshEmployeeSkillStatusMutationVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type RefreshEmployeeSkillStatusMutation = { __typename?: 'Mutation', refreshEmployeeSkillStatus: boolean };

export type RefreshSubordinatesOfCompanySkillStatusesMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
}>;


export type RefreshSubordinatesOfCompanySkillStatusesMutation = { __typename?: 'Mutation', refreshSubordinatesOfCompanySkillStatuses: boolean };

export type RefreshSubordinatesSkillStatusesMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  reviewer: Scalars['Boolean']['input'];
  buId?: InputMaybe<Scalars['HashedId']['input']>;
}>;


export type RefreshSubordinatesSkillStatusesMutation = { __typename?: 'Mutation', refreshSubordinatesSkillStatuses: boolean };

export type RefreshEmployeesOfCompanySkillStatusesMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type RefreshEmployeesOfCompanySkillStatusesMutation = { __typename?: 'Mutation', refreshEmployeesOfCompanySkillStatuses: boolean };

export type RefreshEmployeesOfBuSkillStatusesMutationVariables = Exact<{
  businessUnitId: Scalars['HashedId']['input'];
}>;


export type RefreshEmployeesOfBuSkillStatusesMutation = { __typename?: 'Mutation', refreshEmployeesOfBUSkillStatuses: boolean };

export type SendSkillStatusUpdateReminderEmailMutationVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type SendSkillStatusUpdateReminderEmailMutation = { __typename?: 'Mutation', sendSkillStatusUpdateReminderEmail: boolean };

export type GetPersonalSkillStatusInEmployeePreparationQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type GetPersonalSkillStatusInEmployeePreparationQuery = { __typename?: 'Query', getPersonalSkillStatusInEmployeePreparation?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null };

export type GetEmployeeSkillStatusInMeetingQueryVariables = Exact<{
  id: Scalars['HashedId']['input'];
}>;


export type GetEmployeeSkillStatusInMeetingQuery = { __typename?: 'Query', getEmployeeSkillStatusInMeeting?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null };

export type SkillStatusBlocksMeetingQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type SkillStatusBlocksMeetingQuery = { __typename?: 'Query', skillStatusBlocksMeeting: boolean };

export type RetrieveSkillStatusDataInMeetingInvitationQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
}>;


export type RetrieveSkillStatusDataInMeetingInvitationQuery = { __typename?: 'Query', retrieveSkillStatusDataInMeetingInvitation: { __typename?: 'SkillEmployeeStatusMeetingInvitationDto', isSkillStatusBlocker: boolean, retrievalError: boolean, skillEmployeeStatusDto?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null } };

export type SkillStatusFragmentFragment = { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean };

export type SubordinatesQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  buId?: InputMaybe<Scalars['HashedId']['input']>;
  reviewer: Scalars['Boolean']['input'];
  country: Country;
}>;


export type SubordinatesQuery = { __typename?: 'Query', employeeLevels: Array<EmployeeLevelEnum>, subordinates: Array<{ __typename?: 'EmployeeSubordinateDTO', id: any, firstName: string, lastName: string, avatarUrl?: string | null, companyName: string, country: Country, contractLevel: EmployeeLevelEnum, branchOfficeCode?: string | null, currencyForPayments: Currency, replyEntryDate: any, contractValidTo?: any | null, resultScore?: number | null, timezone: string, businessUnit: { __typename?: 'BusinessUnit', id: any, name: string }, salary?: { __typename?: 'Salary', id: any, amount: number, fromDate: any, toDate?: any | null, isTentative: boolean, isFulltime: boolean, note?: string | null, percentageOfWorktime: number, currency: Currency } | null, targetBonus?: { __typename?: 'TargetBonus', id: any, amount: number, fromDate: any, toDate?: any | null, isTentative: boolean, note?: string | null, currency: Currency } | null, careerPathEvaluation?: { __typename?: 'CareerPathEvaluation', salaryEvaluation: CareerPathEvaluationState, bonusEvaluation: CareerPathEvaluationState, summary: CareerPathEvaluationState, salary: number, targetBonus: number } | null, careerPath?: Array<{ __typename?: 'CareerPathDto', careerPathType: string, country: string, level: string, min: number, max?: number | null }> | null, skillStatus?: { __typename?: 'SkillEmployeeStatusDto', statusId: any, employeeId: any, skillStatus: SkillEmployeeStatusEnum, employeeExpireDate?: any | null, latestSyncDate: any, expired: boolean } | null }> };

export type SubordinateSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
  pagination: CursorPaginationSubordinateInput;
}>;


export type SubordinateSearchQuery = { __typename?: 'Query', subordinateSearch: { __typename?: 'SubordinateSearchPagination', endCursorId?: any | null, endCursorLegalFirstName?: string | null, endCursorLegalLastName?: string | null, hasNextPage: boolean, edges: Array<{ __typename?: 'EmployeeSearch', id: any, firstName: string, lastName: string, avatarUrl?: string | null, companyName: string, businessUnitName: string, contractLevel: EmployeeLevelEnum, replyEntryDate: any, contractValidTo?: any | null, employmentStatus: EmploymentStatus }> } };

export type EnableRankingSeasonForCompanyCountryMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type EnableRankingSeasonForCompanyCountryMutation = { __typename?: 'Mutation', enableRankingSeasonForCompanyCountry: boolean };

export type SaveRankingMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  talentsSeasonId: Scalars['HashedId']['input'];
  ranks: Array<RankInput> | RankInput;
}>;


export type SaveRankingMutation = { __typename?: 'Mutation', saveRanking: boolean };

export type DisableRankingSeasonForCompanyCountryMutationVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type DisableRankingSeasonForCompanyCountryMutation = { __typename?: 'Mutation', disableRankingSeasonForCompanyCountry: boolean };

export type UpdateRankingSeasonMutationVariables = Exact<{
  talentsSeasonInput: TalentsSeasonInput;
}>;


export type UpdateRankingSeasonMutation = { __typename?: 'Mutation', updateRankingSeason: boolean };

export type ConfirmRankingSeasonMutationVariables = Exact<{
  talentsSeasonId: Scalars['HashedId']['input'];
}>;


export type ConfirmRankingSeasonMutation = { __typename?: 'Mutation', confirmRankingSeason: boolean };

export type IsCultivatingTalentsEnabledForCompanyAndCountryQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type IsCultivatingTalentsEnabledForCompanyAndCountryQuery = { __typename?: 'Query', isCultivatingTalentsEnabledForCompanyAndCountry: boolean };

export type IsRankingEnabledForCompanyAndCountryQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type IsRankingEnabledForCompanyAndCountryQuery = { __typename?: 'Query', isRankingEnabledForCompanyAndCountry: boolean };

export type EmployeesAndTagsWithRankingDisabledQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type EmployeesAndTagsWithRankingDisabledQuery = { __typename?: 'Query', employeesAndTagsWithRankingDisabled: Array<{ __typename?: 'EmployeeAndTag', id: any, firstName: string, lastName: string, currentLevel?: string | null, avatarUrl?: string | null, buName: string, companyName?: string | null, tags: Array<{ __typename?: 'EmployeeTagDto', id?: any | null, type: string, addedDate: any, removedDate?: any | null, note?: string | null }> }> };

export type FindTalentsSeasonsYearsQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
}>;


export type FindTalentsSeasonsYearsQuery = { __typename?: 'Query', findTalentsSeasonsYears: Array<{ __typename?: 'TalentsSeasonYearDTO', companyId: any, country: Country, year: number, talentsSeasonId?: any | null, talentsSeasonStatus: TalentsSeasonStatus }> };

export type LiveBoardOrHistoryQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  year: Scalars['Int']['input'];
}>;


export type LiveBoardOrHistoryQuery = { __typename?: 'Query', liveBoardOrHistory: Array<{ __typename?: 'EmployeeWithRankAndTags', id: any, assessable: boolean, rank: number, previousRank?: number | null, evaluation?: number | null, latestEvaluation?: number | null, draftEvaluation?: number | null, previousCompanyRankData?: { __typename?: 'EmployeeRankDTO', employeeId: any, companyName: string, rank: number, total: number } | null, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel?: string | null, buName: string }, tags: Array<{ __typename?: 'EmployeeTagDto', id?: any | null, type: string, addedDate: any, removedDate?: any | null, note?: string | null, globalId?: string | null }> }> };

export type ImportExcelDataQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  year: Scalars['Int']['input'];
  excelData: Array<ExcelDataInput> | ExcelDataInput;
}>;


export type ImportExcelDataQuery = { __typename?: 'Query', importExcel: Array<{ __typename?: 'EmployeeWithRankAndTagsForExcel', id: any, assessable: boolean, rank: number, previousRank?: number | null, evaluation?: number | null, draftEvaluation?: number | null, latestEvaluation?: number | null, employee: { __typename?: 'EmployeeDisplayShortInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null, currentLevel?: string | null, buName: string }, tags: Array<{ __typename?: 'EmployeeTagDto', id?: any | null, globalId?: string | null, type: string, addedDate: any, removedDate?: any | null, note?: string | null }> }> };

export type TalentsSeasonSettingsQueryVariables = Exact<{
  companyId: Scalars['HashedId']['input'];
  country: Country;
  year: Scalars['Int']['input'];
}>;


export type TalentsSeasonSettingsQuery = { __typename?: 'Query', talentsSeasonSettings: { __typename?: 'TalentsSeasonSettingsDTO', talentsSeasonId?: any | null, companyId: any, country: Country, year: number, talentsSeasonStatus: TalentsSeasonStatus, lowPercentage: number, topPercentage: number, blockedChangesForLow: boolean, closingDate?: any | null, confirmationDate?: any | null, closingEmployee?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null, confirmationEmployee?: { __typename?: 'EmployeeDisplayTinyInfo', id: any, firstName: string, lastName: string, avatarUrl?: string | null } | null } };

export type CreateOrUpdateTargetCorrectionPaymentMutationVariables = Exact<{
  targetCorrectionPayment: TargetCorrectionPaymentInput;
}>;


export type CreateOrUpdateTargetCorrectionPaymentMutation = { __typename?: 'Mutation', createOrUpdateTargetCorrectionPayment?: { __typename?: 'TargetCorrectionPaymentDto', id: any, paymentDate: any, status: TargetCorrectionPaymentStatus, resultAmount?: number | null, comment: string, referenceYear: number, meetingId: any, paymentDateValid: boolean } | null };

export type DeleteTargetCorrectionPaymentMutationVariables = Exact<{
  targetCorrectionPaymentId: Scalars['HashedId']['input'];
}>;


export type DeleteTargetCorrectionPaymentMutation = { __typename?: 'Mutation', deleteTargetCorrectionPayment: { __typename?: 'DeleteOk', id: any } };

export type TargetCorrectionPaymentByMeetingIdQueryVariables = Exact<{
  meetingId: Scalars['HashedId']['input'];
}>;


export type TargetCorrectionPaymentByMeetingIdQuery = { __typename?: 'Query', targetCorrectionPaymentByMeetingId?: { __typename?: 'TargetCorrectionPaymentDto', id: any, paymentDate: any, status: TargetCorrectionPaymentStatus, resultAmount?: number | null, comment: string, referenceYear: number, meetingId: any, paymentDateValid: boolean } | null, targetCorrectionPaymentAllowedYears: { __typename?: 'TargetCorrectionPaymentAllowedYearsDto', currentYearAllowed: boolean, previousYearAllowed: boolean } };

export type IsFlexibleProrataManagementEnabledQueryVariables = Exact<{
  country: Country;
}>;


export type IsFlexibleProrataManagementEnabledQuery = { __typename?: 'Query', isFlexibleProrataManagementEnabled: boolean };

export type FindBonusByEmployeeIdInAppraisalSeasonOfMeetingQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
}>;


export type FindBonusByEmployeeIdInAppraisalSeasonOfMeetingQuery = { __typename?: 'Query', findBonusByEmployeeIdInAppraisalSeasonOfMeeting?: { __typename?: 'BonusBetweenAnnualBonusAndProrataDTO', id: any, bonusAmount: number, bonusStatus: FlexibleProrataBonusStatus, appraisalSeasonId: any, contractId: any, contractCurrency: Currency } | null };

export type FindPastYearFlexibleBonusByEmployeeIdAndMeetingIdQueryVariables = Exact<{
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
}>;


export type FindPastYearFlexibleBonusByEmployeeIdAndMeetingIdQuery = { __typename?: 'Query', findPastYearFlexibleBonusByEmployeeIdAndMeetingId?: { __typename?: 'BonusBetweenAnnualBonusAndProrataDTO', id: any, bonusAmount: number, bonusStatus: FlexibleProrataBonusStatus, appraisalSeasonId: any, contractId: any, contractCurrency: Currency } | null };

export type EditFlexibleBonusByEmployeeIdMutationVariables = Exact<{
  bonusAmount: Scalars['Float']['input'];
  employeeId: Scalars['HashedId']['input'];
  meetingId: Scalars['HashedId']['input'];
}>;


export type EditFlexibleBonusByEmployeeIdMutation = { __typename?: 'Mutation', editFlexibleBonusByEmployeeId: boolean };

export type SaveTargetBonusAmountDistributionMutationVariables = Exact<{
  inputs: Array<ObjectiveDistributedAmountInput> | ObjectiveDistributedAmountInput;
  meetingId: Scalars['HashedId']['input'];
}>;


export type SaveTargetBonusAmountDistributionMutation = { __typename?: 'Mutation', saveTargetBonusAmountDistribution: boolean };

export type RetrieveChatbotTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type RetrieveChatbotTokenQuery = { __typename?: 'Query', retrieveChatbotToken: string };

export type RetrieveChatbotUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type RetrieveChatbotUrlQuery = { __typename?: 'Query', retrieveChatbotUrl: string };

export type NetworksCompaniesCountriesYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type NetworksCompaniesCountriesYearsQuery = { __typename?: 'Query', networksCompaniesCountriesYears: Array<{ __typename?: 'GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries', networkId?: any | null, networkName: string, companies: Array<{ __typename?: 'GroupedCompanyWithLegalEntitiesAndCountries', companyId?: any | null, companyName: string, companyCountries: Array<{ __typename?: 'GroupedLegalEntityWithCountry', legalEntityId?: any | null, legalEntityName: string, country: string, years?: Array<number> | null }> }> }> };



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;


/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  Profile: ( PersonalProfile ) | ( PublicProfile );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AbstractEmployeeWithRankAndTags: ResolverTypeWrapper<AbstractEmployeeWithRankAndTags>;
  AbstractRelation: ResolverTypeWrapper<AbstractRelation>;
  ActiveHRBusinessPartnerDTO: ResolverTypeWrapper<ActiveHrBusinessPartnerDto>;
  ActivityListDTO: ResolverTypeWrapper<ActivityListDto>;
  ActivityListDataDTO: ResolverTypeWrapper<ActivityListDataDto>;
  ActivityListType: ActivityListType;
  AllowedMonetaryTargetsDTO: ResolverTypeWrapper<AllowedMonetaryTargetsDto>;
  AppraisalConfirmationInfo: ResolverTypeWrapper<AppraisalConfirmationInfo>;
  AppraisalDisplayInfo: ResolverTypeWrapper<AppraisalDisplayInfo>;
  AppraisalMeetingType: AppraisalMeetingType;
  AppraisalSeasonDTO: ResolverTypeWrapper<AppraisalSeasonDto>;
  AppraisalSeasonOpeningInfoDTO: ResolverTypeWrapper<AppraisalSeasonOpeningInfoDto>;
  AppraisalType: ResolverTypeWrapper<AppraisalType>;
  AppraisalWithFeedbackDTO: ResolverTypeWrapper<AppraisalWithFeedbackDto>;
  AppraisalWithFeedbackPagination: ResolverTypeWrapper<AppraisalWithFeedbackPagination>;
  AuthPayload: ResolverTypeWrapper<AuthPayload>;
  AuthorInput: AuthorInput;
  BOofCompanyDTO: ResolverTypeWrapper<BOofCompanyDto>;
  BUBOBUMcountersDTO: ResolverTypeWrapper<BubobuMcountersDto>;
  BUMOfBusinessUnitDTO: ResolverTypeWrapper<BumOfBusinessUnitDto>;
  BUMOfCompanyDTO: ResolverTypeWrapper<BumOfCompanyDto>;
  BUofCompanyDTO: ResolverTypeWrapper<BUofCompanyDto>;
  BonusBetweenAnnualBonusAndProrataDTO: ResolverTypeWrapper<BonusBetweenAnnualBonusAndProrataDto>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BranchOffice: ResolverTypeWrapper<BranchOffice>;
  BranchOfficeDTO: ResolverTypeWrapper<BranchOfficeDto>;
  BranchOfficeWithEmployeesDTO: ResolverTypeWrapper<BranchOfficeWithEmployeesDto>;
  Brand: ResolverTypeWrapper<Brand>;
  Bu: ResolverTypeWrapper<Bu>;
  BusinessPartnerOfCompany: ResolverTypeWrapper<BusinessPartnerOfCompany>;
  BusinessUnit: ResolverTypeWrapper<BusinessUnit>;
  BusinessUnitTiny: ResolverTypeWrapper<BusinessUnitTiny>;
  BusinessUnitWithManagersDTO: ResolverTypeWrapper<BusinessUnitWithManagersDto>;
  CancellationType: CancellationType;
  CareerPathDto: ResolverTypeWrapper<CareerPathDto>;
  CareerPathEvaluation: ResolverTypeWrapper<CareerPathEvaluation>;
  CareerPathEvaluationState: CareerPathEvaluationState;
  Change: ResolverTypeWrapper<Change>;
  ChangeError: ResolverTypeWrapper<ChangeError>;
  ChangeInput: ChangeInput;
  ChangeJSON: ChangeJson;
  ChangeResponseErrorObject: ResolverTypeWrapper<ChangeResponseErrorObject>;
  ChangeStatus: ChangeStatus;
  ChangeType: ChangeType;
  Children: ResolverTypeWrapper<Children>;
  Citizenship: ResolverTypeWrapper<Citizenship>;
  CompaniesForRankingReportDTO: ResolverTypeWrapper<CompaniesForRankingReportDto>;
  CompaniesForRankingReportInput: CompaniesForRankingReportInput;
  Company: ResolverTypeWrapper<Company>;
  CompanyAndBu: ResolverTypeWrapper<CompanyAndBu>;
  CompanyCar: ResolverTypeWrapper<CompanyCar>;
  CompanyManagerAppraisalMeetingStatus: CompanyManagerAppraisalMeetingStatus;
  CompanyManagerAppraisalMeetingStatusDTO: ResolverTypeWrapper<CompanyManagerAppraisalMeetingStatusDto>;
  CompanyManagerAppraisalMeetingStatusTableRowDTO: ResolverTypeWrapper<CompanyManagerAppraisalMeetingStatusTableRowDto>;
  CompanyRanking: ResolverTypeWrapper<CompanyRanking>;
  CompanyRankingSettingsDTO: ResolverTypeWrapper<CompanyRankingSettingsDto>;
  CompanyScope: CompanyScope;
  CompanySubordinate: ResolverTypeWrapper<CompanySubordinate>;
  CompanyTiny: ResolverTypeWrapper<CompanyTiny>;
  CompanyTinyWithName: ResolverTypeWrapper<CompanyTinyWithName>;
  Contract: ResolverTypeWrapper<Contract>;
  ContractChangeValidationEntry: ResolverTypeWrapper<ContractChangeValidationEntry>;
  ContractChangeValidationList: ResolverTypeWrapper<ContractChangeValidationList>;
  ContractEmployeeLevel: ResolverTypeWrapper<ContractEmployeeLevel>;
  ContractEmployeeLevelDTO: ResolverTypeWrapper<ContractEmployeeLevelDto>;
  ContractEmployeeLevelHistoryDTO: ResolverTypeWrapper<ContractEmployeeLevelHistoryDto>;
  ContractGovernmentJobTitle: ResolverTypeWrapper<ContractGovernmentJobTitle>;
  ContractType: ResolverTypeWrapper<ContractType>;
  ContractTypeEnum: ContractTypeEnum;
  Country: Country;
  CountryAndReportGenerationFlags: ResolverTypeWrapper<CountryAndReportGenerationFlags>;
  CountrySettingsDto: ResolverTypeWrapper<CountrySettingsDto>;
  CountryWithAgePyramidVisibleFlag: ResolverTypeWrapper<CountryWithAgePyramidVisibleFlag>;
  CountryWithBranchOfficeVisibleFlag: ResolverTypeWrapper<CountryWithBranchOfficeVisibleFlag>;
  CreateChangeResponse: ResolverTypeWrapper<CreateChangeResponse>;
  Currency: Currency;
  CurrencyConversionDTO: ResolverTypeWrapper<CurrencyConversionDto>;
  CurrencyConversionWithContractCurrencyDTO: ResolverTypeWrapper<CurrencyConversionWithContractCurrencyDto>;
  CurrentUser: ResolverTypeWrapper<CurrentUser>;
  CursorPaginationMeetingInput: CursorPaginationMeetingInput;
  CursorPaginationReportInput: CursorPaginationReportInput;
  CursorPaginationSubordinateInput: CursorPaginationSubordinateInput;
  DashboardListOfCompanies: ResolverTypeWrapper<DashboardListOfCompanies>;
  DashboardWorkforceCountersDTO: ResolverTypeWrapper<DashboardWorkforceCountersDto>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DeleteOk: ResolverTypeWrapper<DeleteOk>;
  DraftScoreGoalInput: DraftScoreGoalInput;
  DraftScoreGridInput: DraftScoreGridInput;
  Education: ResolverTypeWrapper<Education>;
  EmbeddedBusinessUnit: ResolverTypeWrapper<EmbeddedBusinessUnit>;
  EmergencyContact: ResolverTypeWrapper<EmergencyContact>;
  Employee: ResolverTypeWrapper<Employee>;
  EmployeeAddress: ResolverTypeWrapper<EmployeeAddress>;
  EmployeeAndAppraisalMeetings: ResolverTypeWrapper<EmployeeAndAppraisalMeetings>;
  EmployeeAndTag: ResolverTypeWrapper<EmployeeAndTag>;
  EmployeeCloseMeetingInput: EmployeeCloseMeetingInput;
  EmployeeConfirmPreparationInput: EmployeeConfirmPreparationInput;
  EmployeeDisplayShortInfo: ResolverTypeWrapper<EmployeeDisplayShortInfo>;
  EmployeeDisplayShortInfoMeetingInvite: ResolverTypeWrapper<EmployeeDisplayShortInfoMeetingInvite>;
  EmployeeDisplayShortInfoWithLastMeeting: ResolverTypeWrapper<EmployeeDisplayShortInfoWithLastMeeting>;
  EmployeeDisplayShortWithBuManager: ResolverTypeWrapper<EmployeeDisplayShortWithBuManager>;
  EmployeeDisplayTinyInfo: ResolverTypeWrapper<EmployeeDisplayTinyInfo>;
  EmployeeEmploymentStatusDTO: ResolverTypeWrapper<EmployeeEmploymentStatusDto>;
  EmployeeLevelEnum: EmployeeLevelEnum;
  EmployeeLevelWithDisplayOrder: ResolverTypeWrapper<EmployeeLevelWithDisplayOrder>;
  EmployeeLevelsSets: EmployeeLevelsSets;
  EmployeeNameSearchInfo: ResolverTypeWrapper<EmployeeNameSearchInfo>;
  EmployeeOnProbation: ResolverTypeWrapper<EmployeeOnProbation>;
  EmployeeRankDTO: ResolverTypeWrapper<EmployeeRankDto>;
  EmployeeRanking: ResolverTypeWrapper<EmployeeRanking>;
  EmployeeSearch: ResolverTypeWrapper<EmployeeSearch>;
  EmployeeSubordinateDTO: ResolverTypeWrapper<EmployeeSubordinateDto>;
  EmployeeTagDto: ResolverTypeWrapper<EmployeeTagDto>;
  EmployeeTagInfo: ResolverTypeWrapper<EmployeeTagInfo>;
  EmployeeTagInfoShort: ResolverTypeWrapper<EmployeeTagInfoShort>;
  EmployeeTagInfoTiny: ResolverTypeWrapper<EmployeeTagInfoTiny>;
  EmployeeTagType: EmployeeTagType;
  EmployeeWithBonus: ResolverTypeWrapper<EmployeeWithBonus>;
  EmployeeWithBusinessUnit: ResolverTypeWrapper<EmployeeWithBusinessUnit>;
  EmployeeWithEndingContract: ResolverTypeWrapper<EmployeeWithEndingContract>;
  EmployeeWithLatestAndDraftEvaluation: ResolverTypeWrapper<EmployeeWithLatestAndDraftEvaluation>;
  EmployeeWithLevelDTO: ResolverTypeWrapper<EmployeeWithLevelDto>;
  EmployeeWithRankAndTags: ResolverTypeWrapper<EmployeeWithRankAndTags>;
  EmployeeWithRankAndTagsForExcel: ResolverTypeWrapper<EmployeeWithRankAndTagsForExcel>;
  EmployeeWithRole: ResolverTypeWrapper<EmployeeWithRole>;
  EmployeesWithWrongStatusOrMissingContractDTO: ResolverTypeWrapper<EmployeesWithWrongStatusOrMissingContractDto>;
  EmploymentStatus: EmploymentStatus;
  ExcelDataInput: ExcelDataInput;
  ExecutedPayment: ResolverTypeWrapper<ExecutedPayment>;
  ExecutedPaymentDTO: ResolverTypeWrapper<ExecutedPaymentDto>;
  ExecutedPaymentHistoryDTO: ResolverTypeWrapper<ExecutedPaymentHistoryDto>;
  ExecutedPaymentType: ExecutedPaymentType;
  FeatureMaintenanceData: ResolverTypeWrapper<FeatureMaintenanceData>;
  FeatureToggle: ResolverTypeWrapper<FeatureToggle>;
  FlatCompanyWithLegalEntitiesAndCountries: ResolverTypeWrapper<FlatCompanyWithLegalEntitiesAndCountries>;
  FlexibleProrataBonusStatus: FlexibleProrataBonusStatus;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FullMeetingPreviewDTO: ResolverTypeWrapper<FullMeetingPreviewDto>;
  GecoProjectsInfo: ResolverTypeWrapper<GecoProjectsInfo>;
  GovernmentJobTitle: ResolverTypeWrapper<GovernmentJobTitle>;
  GovernmentJobTitleTinyDTO: ResolverTypeWrapper<GovernmentJobTitleTinyDto>;
  GovernmentJobTitleTinyInput: GovernmentJobTitleTinyInput;
  GroupedCompanyWithLegalEntitiesAndCountries: ResolverTypeWrapper<GroupedCompanyWithLegalEntitiesAndCountries>;
  GroupedLegalEntityWithCountry: ResolverTypeWrapper<GroupedLegalEntityWithCountry>;
  GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries: ResolverTypeWrapper<GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries>;
  HappinessLevel: ResolverTypeWrapper<HappinessLevel>;
  HashedId: ResolverTypeWrapper<Scalars['HashedId']['output']>;
  HiringOffice: ResolverTypeWrapper<HiringOffice>;
  HrManageMeetingInput: HrManageMeetingInput;
  HrSupportFeedbackTabFilter: HrSupportFeedbackTabFilter;
  IdvWeightDto: ResolverTypeWrapper<IdvWeightDto>;
  ImportNationalContractReferenceInput: ImportNationalContractReferenceInput;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InternationalAddress: ResolverTypeWrapper<InternationalAddress>;
  InternationalBankAccount: ResolverTypeWrapper<InternationalBankAccount>;
  KeyResultDTO: ResolverTypeWrapper<KeyResultDto>;
  KeyResultInput: KeyResultInput;
  KudosAppraisalInput: KudosAppraisalInput;
  KudosByReplyerFilterInput: KudosByReplyerFilterInput;
  KudosCompanyCountryVisibilityDTO: ResolverTypeWrapper<KudosCompanyCountryVisibilityDto>;
  KudosCompanyCountryVisibilityFilterInput: KudosCompanyCountryVisibilityFilterInput;
  KudosCompanyCountryVisibilityInput: KudosCompanyCountryVisibilityInput;
  KudosCompanyCountryVisibilityShowMoreDTO: ResolverTypeWrapper<KudosCompanyCountryVisibilityShowMoreDto>;
  KudosDTO: ResolverTypeWrapper<KudosDto>;
  KudosFilterInput: KudosFilterInput;
  KudosLegalEntityVisibilityDTO: ResolverTypeWrapper<KudosLegalEntityVisibilityDto>;
  KudosLegalEntityVisibilityFilterInput: KudosLegalEntityVisibilityFilterInput;
  KudosLegalEntityVisibilityInput: KudosLegalEntityVisibilityInput;
  KudosLegalEntityVisibilityShowMoreDTO: ResolverTypeWrapper<KudosLegalEntityVisibilityShowMoreDto>;
  KudosPaginationDTO: ResolverTypeWrapper<KudosPaginationDto>;
  KudosPaginationInput: KudosPaginationInput;
  KudosShowMoreDTO: ResolverTypeWrapper<KudosShowMoreDto>;
  KudosShowMoreInput: KudosShowMoreInput;
  KudosType: KudosType;
  KudosVisibilityShowMoreInput: KudosVisibilityShowMoreInput;
  KudosVisibilityStatusFilter: KudosVisibilityStatusFilter;
  KudosWithVisibilityFlagDTO: ResolverTypeWrapper<KudosWithVisibilityFlagDto>;
  LatestContractDTO: ResolverTypeWrapper<LatestContractDto>;
  LeaveEntitlement: ResolverTypeWrapper<LeaveEntitlement>;
  Leavers: ResolverTypeWrapper<Leavers>;
  LeaversByPeriod: ResolverTypeWrapper<LeaversByPeriod>;
  LegalEntity: ResolverTypeWrapper<LegalEntity>;
  LegalEntityTiny: ResolverTypeWrapper<LegalEntityTiny>;
  LocaleDTO: ResolverTypeWrapper<LocaleDto>;
  LoginInput: LoginInput;
  LogoutOk: ResolverTypeWrapper<LogoutOk>;
  ManagedCompany: ResolverTypeWrapper<ManagedCompany>;
  ManagerCloseMeetingInput: ManagerCloseMeetingInput;
  ManagerOfBusinessUnit: ResolverTypeWrapper<ManagerOfBusinessUnit>;
  ManagerOfCluster: ResolverTypeWrapper<ManagerOfCluster>;
  ManagerOfCompany: ResolverTypeWrapper<ManagerOfCompany>;
  ManagerOfNetwork: ResolverTypeWrapper<ManagerOfNetwork>;
  ManagingUnits: ResolverTypeWrapper<ManagingUnits>;
  Meeting: ResolverTypeWrapper<Meeting>;
  MeetingConclusionPdf: ResolverTypeWrapper<MeetingConclusionPdf>;
  MeetingEmbedAppraisal: ResolverTypeWrapper<MeetingEmbedAppraisal>;
  MeetingEmbedOther: ResolverTypeWrapper<MeetingEmbedOther>;
  MeetingHrFeedbackResult: MeetingHrFeedbackResult;
  MeetingInput: MeetingInput;
  MeetingInputAppraisal: MeetingInputAppraisal;
  MeetingInputOther: MeetingInputOther;
  MeetingInvitationStatus: ResolverTypeWrapper<MeetingInvitationStatus>;
  MeetingInviteInput: MeetingInviteInput;
  MeetingInviteOptions: ResolverTypeWrapper<MeetingInviteOptions>;
  MeetingInviteOptionsExtended: ResolverTypeWrapper<MeetingInviteOptionsExtended>;
  MeetingPdfStatus: MeetingPdfStatus;
  MeetingRequestDTO: ResolverTypeWrapper<MeetingRequestDto>;
  MeetingRequestStatus: MeetingRequestStatus;
  MeetingStatus: MeetingStatus;
  MeetingStep: ResolverTypeWrapper<MeetingStep>;
  MeetingStepInput: MeetingStepInput;
  MeetingStepStatus: MeetingStepStatus;
  MeetingStepType: MeetingStepType;
  MeetingStepViewId: MeetingStepViewId;
  MeetingTiny: ResolverTypeWrapper<MeetingTiny>;
  MeetingType: MeetingType;
  Mutation: ResolverTypeWrapper<{}>;
  NationalContractEmployeeLevelDTO: ResolverTypeWrapper<NationalContractEmployeeLevelDto>;
  NationalContractEmployeeLevelHistoryDTO: ResolverTypeWrapper<NationalContractEmployeeLevelHistoryDto>;
  NationalContractLevel: ResolverTypeWrapper<NationalContractLevel>;
  NationalContractLevelEnum: NationalContractLevelEnum;
  NationalContractReferenceDTO: ResolverTypeWrapper<NationalContractReferenceDto>;
  NationalContractReferenceLevelDTO: ResolverTypeWrapper<NationalContractReferenceLevelDto>;
  NationalContractReferenceWithTypeDTO: ResolverTypeWrapper<NationalContractReferenceWithTypeDto>;
  NationalContractType: NationalContractType;
  Network: ResolverTypeWrapper<Network>;
  NewEntries: ResolverTypeWrapper<NewEntries>;
  NewEntriesByPeriod: ResolverTypeWrapper<NewEntriesByPeriod>;
  NextBestActionMissingTargets: ResolverTypeWrapper<NextBestActionMissingTargets>;
  NextBestActivity: ResolverTypeWrapper<NextBestActivity>;
  NextBestActivityLeavingEmployees: ResolverTypeWrapper<NextBestActivityLeavingEmployees>;
  NextBestActivityLimitedContractEnding: ResolverTypeWrapper<NextBestActivityLimitedContractEnding>;
  NextBestActivityNoMeeting: ResolverTypeWrapper<NextBestActivityNoMeeting>;
  NextBestActivityProbationTalk: ResolverTypeWrapper<NextBestActivityProbationTalk>;
  NoteInfo: ResolverTypeWrapper<NoteInfo>;
  NoteInfoInput: NoteInfoInput;
  ObjectiveAttachmentInfoDTO: ResolverTypeWrapper<ObjectiveAttachmentInfoDto>;
  ObjectiveDTO: ResolverTypeWrapper<ObjectiveDto>;
  ObjectiveDistributedAmountInput: ObjectiveDistributedAmountInput;
  ObjectiveInput: ObjectiveInput;
  ObjectiveKeyResultDTO: ResolverTypeWrapper<ObjectiveKeyResultDto>;
  ObjectiveKeyResultInput: ObjectiveKeyResultInput;
  ObjectivePayment: ResolverTypeWrapper<ObjectivePayment>;
  ObjectivePaymentInput: ObjectivePaymentInput;
  ObjectivePaymentManualDeductionReason: ObjectivePaymentManualDeductionReason;
  ObjectivePaymentStatus: ObjectivePaymentStatus;
  ObjectiveStatus: ObjectiveStatus;
  ObjectiveTemplateDTO: ResolverTypeWrapper<ObjectiveTemplateDto>;
  ObjectiveTemplateInput: ObjectiveTemplateInput;
  OnboardingDataDTO: ResolverTypeWrapper<OnboardingDataDto>;
  OneOffPayment: ResolverTypeWrapper<OneOffPayment>;
  OneOffPaymentInput: OneOffPaymentInput;
  OneOffPaymentStatus: OneOffPaymentStatus;
  Option: ResolverTypeWrapper<Option>;
  PerBaseEntity: ResolverTypeWrapper<PerBaseEntity>;
  Period: Period;
  PermissionCheck: ResolverTypeWrapper<PermissionCheck>;
  PersonalProfile: ResolverTypeWrapper<PersonalProfile>;
  ProbationPeriodEnding: ResolverTypeWrapper<ProbationPeriodEnding>;
  ProbationPeriodEndingByPeriod: ResolverTypeWrapper<ProbationPeriodEndingByPeriod>;
  Profile: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Profile']>;
  PublicProfile: ResolverTypeWrapper<PublicProfile>;
  PyramidForecastDTO: ResolverTypeWrapper<PyramidForecastDto>;
  PyramidForecastFiltersDTO: ResolverTypeWrapper<PyramidForecastFiltersDto>;
  PyramidForecastInput: PyramidForecastInput;
  PyramidForecastValueDto: ResolverTypeWrapper<PyramidForecastValueDto>;
  PyramidForecastValues: ResolverTypeWrapper<PyramidForecastValues>;
  PyramidForecastWithFiltersDTO: ResolverTypeWrapper<PyramidForecastWithFiltersDto>;
  PyramidSelectorYearAndMonth: ResolverTypeWrapper<PyramidSelectorYearAndMonth>;
  PyramidType: PyramidType;
  PyramidValueDto: ResolverTypeWrapper<PyramidValueDto>;
  PyramidValueLevelDecrease: ResolverTypeWrapper<PyramidValueLevelDecrease>;
  Query: ResolverTypeWrapper<{}>;
  RankInput: RankInput;
  RankingLevel: RankingLevel;
  RankingReportFilterInput: RankingReportFilterInput;
  ReferencePyramid: ResolverTypeWrapper<ReferencePyramid>;
  ReferencePyramidDetail: ResolverTypeWrapper<ReferencePyramidDetail>;
  ReferencePyramidDetailsInput: ReferencePyramidDetailsInput;
  ReferencePyramidInput: ReferencePyramidInput;
  ReferencePyramidTemplateDTO: ResolverTypeWrapper<ReferencePyramidTemplateDto>;
  ReferencePyramidTemplateDetailDTO: ResolverTypeWrapper<ReferencePyramidTemplateDetailDto>;
  RemoveEmployeeTagInput: RemoveEmployeeTagInput;
  ReportDTO: ResolverTypeWrapper<ReportDto>;
  ReportPaginationDTO: ResolverTypeWrapper<ReportPaginationDto>;
  ReportStatus: ReportStatus;
  ReportType: ReportType;
  RescheduleMeetingInput: RescheduleMeetingInput;
  ResignedEmployeeDto: ResolverTypeWrapper<ResignedEmployeeDto>;
  ResignedViewEmployeesDTO: ResolverTypeWrapper<ResignedViewEmployeesDto>;
  ReviewerAndEmployee: ResolverTypeWrapper<ReviewerAndEmployee>;
  ReviewerOfEmployeeType: ReviewerOfEmployeeType;
  ReviewerOfEmployees: ResolverTypeWrapper<ReviewerOfEmployees>;
  ReviewerOfEmployeesInput: ReviewerOfEmployeesInput;
  Role: ResolverTypeWrapper<Role>;
  RoleName: RoleName;
  RoleOfUser: ResolverTypeWrapper<RoleOfUser>;
  Salary: ResolverTypeWrapper<Salary>;
  SalaryDTO: ResolverTypeWrapper<SalaryDto>;
  SalaryHistoryDTO: ResolverTypeWrapper<SalaryHistoryDto>;
  ScoreGoal: ResolverTypeWrapper<ScoreGoal>;
  ScoreGoalDto: ResolverTypeWrapper<ScoreGoalDto>;
  ScoreGoalInput: ScoreGoalInput;
  ScoreGoalType: ScoreGoalType;
  ScoreGrid: ResolverTypeWrapper<ScoreGrid>;
  ScoreGridDto: ResolverTypeWrapper<ScoreGridDto>;
  ScoreGridExcelDataInput: ScoreGridExcelDataInput;
  ScoreGridInput: ScoreGridInput;
  ScoreGridStatus: ScoreGridStatus;
  ScoreGridsOverviewDTO: ResolverTypeWrapper<ScoreGridsOverviewDto>;
  SelfReflectionQuestionType: SelfReflectionQuestionType;
  SelfReflectionSummary: ResolverTypeWrapper<SelfReflectionSummary>;
  SelfreflectionInput: SelfreflectionInput;
  SelfreflectionQuestion: ResolverTypeWrapper<SelfreflectionQuestion>;
  SelfreflectionQuestionBoolean: ResolverTypeWrapper<SelfreflectionQuestionBoolean>;
  SelfreflectionQuestionBooleanInput: SelfreflectionQuestionBooleanInput;
  SkillEmployeeStatusDto: ResolverTypeWrapper<SkillEmployeeStatusDto>;
  SkillEmployeeStatusEnum: SkillEmployeeStatusEnum;
  SkillEmployeeStatusMeetingInvitationDto: ResolverTypeWrapper<SkillEmployeeStatusMeetingInvitationDto>;
  SkipMeetingStepReason: SkipMeetingStepReason;
  SqsBuffer: ResolverTypeWrapper<SqsBuffer>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Subordinate: ResolverTypeWrapper<Subordinate>;
  SubordinateSearchPagination: ResolverTypeWrapper<SubordinateSearchPagination>;
  TalentsSeasonInput: TalentsSeasonInput;
  TalentsSeasonSettingsDTO: ResolverTypeWrapper<TalentsSeasonSettingsDto>;
  TalentsSeasonStatus: TalentsSeasonStatus;
  TalentsSeasonYearDTO: ResolverTypeWrapper<TalentsSeasonYearDto>;
  TargetBonus: ResolverTypeWrapper<TargetBonus>;
  TargetBonusDTO: ResolverTypeWrapper<TargetBonusDto>;
  TargetBonusHistoryDTO: ResolverTypeWrapper<TargetBonusHistoryDto>;
  TargetCorrectionPaymentAllowedYearsDto: ResolverTypeWrapper<TargetCorrectionPaymentAllowedYearsDto>;
  TargetCorrectionPaymentDto: ResolverTypeWrapper<TargetCorrectionPaymentDto>;
  TargetCorrectionPaymentInput: TargetCorrectionPaymentInput;
  TargetCorrectionPaymentStatus: TargetCorrectionPaymentStatus;
  TargetReportGenerationRequestDTO: ResolverTypeWrapper<TargetReportGenerationRequestDto>;
  TargetsCalculationHelperDTO: ResolverTypeWrapper<TargetsCalculationHelperDto>;
  TemporalBoundaries: ResolverTypeWrapper<TemporalBoundaries>;
  ToBePaid: ResolverTypeWrapper<ToBePaid>;
  UpdateNationalContractReferenceInput: UpdateNationalContractReferenceInput;
  UpdateNationalContractReferenceLevelInput: UpdateNationalContractReferenceLevelInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  User: ResolverTypeWrapper<User>;
  UserInfo: ResolverTypeWrapper<UserInfo>;
  WorkforceMovementCounters: ResolverTypeWrapper<WorkforceMovementCounters>;
  WorkforceMovementPeriodEnum: WorkforceMovementPeriodEnum;
  WorkforceMovementsEnum: WorkforceMovementsEnum;
  YearsAndCompaniesForRankingReportDTO: ResolverTypeWrapper<YearsAndCompaniesForRankingReportDto>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AbstractEmployeeWithRankAndTags: AbstractEmployeeWithRankAndTags;
  AbstractRelation: AbstractRelation;
  ActiveHRBusinessPartnerDTO: ActiveHrBusinessPartnerDto;
  ActivityListDTO: ActivityListDto;
  ActivityListDataDTO: ActivityListDataDto;
  AllowedMonetaryTargetsDTO: AllowedMonetaryTargetsDto;
  AppraisalConfirmationInfo: AppraisalConfirmationInfo;
  AppraisalDisplayInfo: AppraisalDisplayInfo;
  AppraisalSeasonDTO: AppraisalSeasonDto;
  AppraisalSeasonOpeningInfoDTO: AppraisalSeasonOpeningInfoDto;
  AppraisalType: AppraisalType;
  AppraisalWithFeedbackDTO: AppraisalWithFeedbackDto;
  AppraisalWithFeedbackPagination: AppraisalWithFeedbackPagination;
  AuthPayload: AuthPayload;
  AuthorInput: AuthorInput;
  BOofCompanyDTO: BOofCompanyDto;
  BUBOBUMcountersDTO: BubobuMcountersDto;
  BUMOfBusinessUnitDTO: BumOfBusinessUnitDto;
  BUMOfCompanyDTO: BumOfCompanyDto;
  BUofCompanyDTO: BUofCompanyDto;
  BonusBetweenAnnualBonusAndProrataDTO: BonusBetweenAnnualBonusAndProrataDto;
  Boolean: Scalars['Boolean']['output'];
  BranchOffice: BranchOffice;
  BranchOfficeDTO: BranchOfficeDto;
  BranchOfficeWithEmployeesDTO: BranchOfficeWithEmployeesDto;
  Brand: Brand;
  Bu: Bu;
  BusinessPartnerOfCompany: BusinessPartnerOfCompany;
  BusinessUnit: BusinessUnit;
  BusinessUnitTiny: BusinessUnitTiny;
  BusinessUnitWithManagersDTO: BusinessUnitWithManagersDto;
  CareerPathDto: CareerPathDto;
  CareerPathEvaluation: CareerPathEvaluation;
  Change: Change;
  ChangeError: ChangeError;
  ChangeInput: ChangeInput;
  ChangeJSON: ChangeJson;
  ChangeResponseErrorObject: ChangeResponseErrorObject;
  Children: Children;
  Citizenship: Citizenship;
  CompaniesForRankingReportDTO: CompaniesForRankingReportDto;
  CompaniesForRankingReportInput: CompaniesForRankingReportInput;
  Company: Company;
  CompanyAndBu: CompanyAndBu;
  CompanyCar: CompanyCar;
  CompanyManagerAppraisalMeetingStatusDTO: CompanyManagerAppraisalMeetingStatusDto;
  CompanyManagerAppraisalMeetingStatusTableRowDTO: CompanyManagerAppraisalMeetingStatusTableRowDto;
  CompanyRanking: CompanyRanking;
  CompanyRankingSettingsDTO: CompanyRankingSettingsDto;
  CompanySubordinate: CompanySubordinate;
  CompanyTiny: CompanyTiny;
  CompanyTinyWithName: CompanyTinyWithName;
  Contract: Contract;
  ContractChangeValidationEntry: ContractChangeValidationEntry;
  ContractChangeValidationList: ContractChangeValidationList;
  ContractEmployeeLevel: ContractEmployeeLevel;
  ContractEmployeeLevelDTO: ContractEmployeeLevelDto;
  ContractEmployeeLevelHistoryDTO: ContractEmployeeLevelHistoryDto;
  ContractGovernmentJobTitle: ContractGovernmentJobTitle;
  ContractType: ContractType;
  CountryAndReportGenerationFlags: CountryAndReportGenerationFlags;
  CountrySettingsDto: CountrySettingsDto;
  CountryWithAgePyramidVisibleFlag: CountryWithAgePyramidVisibleFlag;
  CountryWithBranchOfficeVisibleFlag: CountryWithBranchOfficeVisibleFlag;
  CreateChangeResponse: CreateChangeResponse;
  CurrencyConversionDTO: CurrencyConversionDto;
  CurrencyConversionWithContractCurrencyDTO: CurrencyConversionWithContractCurrencyDto;
  CurrentUser: CurrentUser;
  CursorPaginationMeetingInput: CursorPaginationMeetingInput;
  CursorPaginationReportInput: CursorPaginationReportInput;
  CursorPaginationSubordinateInput: CursorPaginationSubordinateInput;
  DashboardListOfCompanies: DashboardListOfCompanies;
  DashboardWorkforceCountersDTO: DashboardWorkforceCountersDto;
  DateTime: Scalars['DateTime']['output'];
  DeleteOk: DeleteOk;
  DraftScoreGoalInput: DraftScoreGoalInput;
  DraftScoreGridInput: DraftScoreGridInput;
  Education: Education;
  EmbeddedBusinessUnit: EmbeddedBusinessUnit;
  EmergencyContact: EmergencyContact;
  Employee: Employee;
  EmployeeAddress: EmployeeAddress;
  EmployeeAndAppraisalMeetings: EmployeeAndAppraisalMeetings;
  EmployeeAndTag: EmployeeAndTag;
  EmployeeCloseMeetingInput: EmployeeCloseMeetingInput;
  EmployeeConfirmPreparationInput: EmployeeConfirmPreparationInput;
  EmployeeDisplayShortInfo: EmployeeDisplayShortInfo;
  EmployeeDisplayShortInfoMeetingInvite: EmployeeDisplayShortInfoMeetingInvite;
  EmployeeDisplayShortInfoWithLastMeeting: EmployeeDisplayShortInfoWithLastMeeting;
  EmployeeDisplayShortWithBuManager: EmployeeDisplayShortWithBuManager;
  EmployeeDisplayTinyInfo: EmployeeDisplayTinyInfo;
  EmployeeEmploymentStatusDTO: EmployeeEmploymentStatusDto;
  EmployeeLevelWithDisplayOrder: EmployeeLevelWithDisplayOrder;
  EmployeeNameSearchInfo: EmployeeNameSearchInfo;
  EmployeeOnProbation: EmployeeOnProbation;
  EmployeeRankDTO: EmployeeRankDto;
  EmployeeRanking: EmployeeRanking;
  EmployeeSearch: EmployeeSearch;
  EmployeeSubordinateDTO: EmployeeSubordinateDto;
  EmployeeTagDto: EmployeeTagDto;
  EmployeeTagInfo: EmployeeTagInfo;
  EmployeeTagInfoShort: EmployeeTagInfoShort;
  EmployeeTagInfoTiny: EmployeeTagInfoTiny;
  EmployeeWithBonus: EmployeeWithBonus;
  EmployeeWithBusinessUnit: EmployeeWithBusinessUnit;
  EmployeeWithEndingContract: EmployeeWithEndingContract;
  EmployeeWithLatestAndDraftEvaluation: EmployeeWithLatestAndDraftEvaluation;
  EmployeeWithLevelDTO: EmployeeWithLevelDto;
  EmployeeWithRankAndTags: EmployeeWithRankAndTags;
  EmployeeWithRankAndTagsForExcel: EmployeeWithRankAndTagsForExcel;
  EmployeeWithRole: EmployeeWithRole;
  EmployeesWithWrongStatusOrMissingContractDTO: EmployeesWithWrongStatusOrMissingContractDto;
  ExcelDataInput: ExcelDataInput;
  ExecutedPayment: ExecutedPayment;
  ExecutedPaymentDTO: ExecutedPaymentDto;
  ExecutedPaymentHistoryDTO: ExecutedPaymentHistoryDto;
  FeatureMaintenanceData: FeatureMaintenanceData;
  FeatureToggle: FeatureToggle;
  FlatCompanyWithLegalEntitiesAndCountries: FlatCompanyWithLegalEntitiesAndCountries;
  Float: Scalars['Float']['output'];
  FullMeetingPreviewDTO: FullMeetingPreviewDto;
  GecoProjectsInfo: GecoProjectsInfo;
  GovernmentJobTitle: GovernmentJobTitle;
  GovernmentJobTitleTinyDTO: GovernmentJobTitleTinyDto;
  GovernmentJobTitleTinyInput: GovernmentJobTitleTinyInput;
  GroupedCompanyWithLegalEntitiesAndCountries: GroupedCompanyWithLegalEntitiesAndCountries;
  GroupedLegalEntityWithCountry: GroupedLegalEntityWithCountry;
  GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries: GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries;
  HappinessLevel: HappinessLevel;
  HashedId: Scalars['HashedId']['output'];
  HiringOffice: HiringOffice;
  HrManageMeetingInput: HrManageMeetingInput;
  HrSupportFeedbackTabFilter: HrSupportFeedbackTabFilter;
  IdvWeightDto: IdvWeightDto;
  ImportNationalContractReferenceInput: ImportNationalContractReferenceInput;
  Int: Scalars['Int']['output'];
  InternationalAddress: InternationalAddress;
  InternationalBankAccount: InternationalBankAccount;
  KeyResultDTO: KeyResultDto;
  KeyResultInput: KeyResultInput;
  KudosAppraisalInput: KudosAppraisalInput;
  KudosByReplyerFilterInput: KudosByReplyerFilterInput;
  KudosCompanyCountryVisibilityDTO: KudosCompanyCountryVisibilityDto;
  KudosCompanyCountryVisibilityFilterInput: KudosCompanyCountryVisibilityFilterInput;
  KudosCompanyCountryVisibilityInput: KudosCompanyCountryVisibilityInput;
  KudosCompanyCountryVisibilityShowMoreDTO: KudosCompanyCountryVisibilityShowMoreDto;
  KudosDTO: KudosDto;
  KudosFilterInput: KudosFilterInput;
  KudosLegalEntityVisibilityDTO: KudosLegalEntityVisibilityDto;
  KudosLegalEntityVisibilityFilterInput: KudosLegalEntityVisibilityFilterInput;
  KudosLegalEntityVisibilityInput: KudosLegalEntityVisibilityInput;
  KudosLegalEntityVisibilityShowMoreDTO: KudosLegalEntityVisibilityShowMoreDto;
  KudosPaginationDTO: KudosPaginationDto;
  KudosPaginationInput: KudosPaginationInput;
  KudosShowMoreDTO: KudosShowMoreDto;
  KudosShowMoreInput: KudosShowMoreInput;
  KudosVisibilityShowMoreInput: KudosVisibilityShowMoreInput;
  KudosVisibilityStatusFilter: KudosVisibilityStatusFilter;
  KudosWithVisibilityFlagDTO: KudosWithVisibilityFlagDto;
  LatestContractDTO: LatestContractDto;
  LeaveEntitlement: LeaveEntitlement;
  Leavers: Leavers;
  LeaversByPeriod: LeaversByPeriod;
  LegalEntity: LegalEntity;
  LegalEntityTiny: LegalEntityTiny;
  LocaleDTO: LocaleDto;
  LoginInput: LoginInput;
  LogoutOk: LogoutOk;
  ManagedCompany: ManagedCompany;
  ManagerCloseMeetingInput: ManagerCloseMeetingInput;
  ManagerOfBusinessUnit: ManagerOfBusinessUnit;
  ManagerOfCluster: ManagerOfCluster;
  ManagerOfCompany: ManagerOfCompany;
  ManagerOfNetwork: ManagerOfNetwork;
  ManagingUnits: ManagingUnits;
  Meeting: Meeting;
  MeetingConclusionPdf: MeetingConclusionPdf;
  MeetingEmbedAppraisal: MeetingEmbedAppraisal;
  MeetingEmbedOther: MeetingEmbedOther;
  MeetingInput: MeetingInput;
  MeetingInputAppraisal: MeetingInputAppraisal;
  MeetingInputOther: MeetingInputOther;
  MeetingInvitationStatus: MeetingInvitationStatus;
  MeetingInviteInput: MeetingInviteInput;
  MeetingInviteOptions: MeetingInviteOptions;
  MeetingInviteOptionsExtended: MeetingInviteOptionsExtended;
  MeetingRequestDTO: MeetingRequestDto;
  MeetingStep: MeetingStep;
  MeetingStepInput: MeetingStepInput;
  MeetingTiny: MeetingTiny;
  Mutation: {};
  NationalContractEmployeeLevelDTO: NationalContractEmployeeLevelDto;
  NationalContractEmployeeLevelHistoryDTO: NationalContractEmployeeLevelHistoryDto;
  NationalContractLevel: NationalContractLevel;
  NationalContractReferenceDTO: NationalContractReferenceDto;
  NationalContractReferenceLevelDTO: NationalContractReferenceLevelDto;
  NationalContractReferenceWithTypeDTO: NationalContractReferenceWithTypeDto;
  Network: Network;
  NewEntries: NewEntries;
  NewEntriesByPeriod: NewEntriesByPeriod;
  NextBestActionMissingTargets: NextBestActionMissingTargets;
  NextBestActivity: NextBestActivity;
  NextBestActivityLeavingEmployees: NextBestActivityLeavingEmployees;
  NextBestActivityLimitedContractEnding: NextBestActivityLimitedContractEnding;
  NextBestActivityNoMeeting: NextBestActivityNoMeeting;
  NextBestActivityProbationTalk: NextBestActivityProbationTalk;
  NoteInfo: NoteInfo;
  NoteInfoInput: NoteInfoInput;
  ObjectiveAttachmentInfoDTO: ObjectiveAttachmentInfoDto;
  ObjectiveDTO: ObjectiveDto;
  ObjectiveDistributedAmountInput: ObjectiveDistributedAmountInput;
  ObjectiveInput: ObjectiveInput;
  ObjectiveKeyResultDTO: ObjectiveKeyResultDto;
  ObjectiveKeyResultInput: ObjectiveKeyResultInput;
  ObjectivePayment: ObjectivePayment;
  ObjectivePaymentInput: ObjectivePaymentInput;
  ObjectiveTemplateDTO: ObjectiveTemplateDto;
  ObjectiveTemplateInput: ObjectiveTemplateInput;
  OnboardingDataDTO: OnboardingDataDto;
  OneOffPayment: OneOffPayment;
  OneOffPaymentInput: OneOffPaymentInput;
  Option: Option;
  PerBaseEntity: PerBaseEntity;
  Period: Period;
  PermissionCheck: PermissionCheck;
  PersonalProfile: PersonalProfile;
  ProbationPeriodEnding: ProbationPeriodEnding;
  ProbationPeriodEndingByPeriod: ProbationPeriodEndingByPeriod;
  Profile: ResolversInterfaceTypes<ResolversParentTypes>['Profile'];
  PublicProfile: PublicProfile;
  PyramidForecastDTO: PyramidForecastDto;
  PyramidForecastFiltersDTO: PyramidForecastFiltersDto;
  PyramidForecastInput: PyramidForecastInput;
  PyramidForecastValueDto: PyramidForecastValueDto;
  PyramidForecastValues: PyramidForecastValues;
  PyramidForecastWithFiltersDTO: PyramidForecastWithFiltersDto;
  PyramidSelectorYearAndMonth: PyramidSelectorYearAndMonth;
  PyramidValueDto: PyramidValueDto;
  PyramidValueLevelDecrease: PyramidValueLevelDecrease;
  Query: {};
  RankInput: RankInput;
  RankingReportFilterInput: RankingReportFilterInput;
  ReferencePyramid: ReferencePyramid;
  ReferencePyramidDetail: ReferencePyramidDetail;
  ReferencePyramidDetailsInput: ReferencePyramidDetailsInput;
  ReferencePyramidInput: ReferencePyramidInput;
  ReferencePyramidTemplateDTO: ReferencePyramidTemplateDto;
  ReferencePyramidTemplateDetailDTO: ReferencePyramidTemplateDetailDto;
  RemoveEmployeeTagInput: RemoveEmployeeTagInput;
  ReportDTO: ReportDto;
  ReportPaginationDTO: ReportPaginationDto;
  RescheduleMeetingInput: RescheduleMeetingInput;
  ResignedEmployeeDto: ResignedEmployeeDto;
  ResignedViewEmployeesDTO: ResignedViewEmployeesDto;
  ReviewerAndEmployee: ReviewerAndEmployee;
  ReviewerOfEmployees: ReviewerOfEmployees;
  ReviewerOfEmployeesInput: ReviewerOfEmployeesInput;
  Role: Role;
  RoleOfUser: RoleOfUser;
  Salary: Salary;
  SalaryDTO: SalaryDto;
  SalaryHistoryDTO: SalaryHistoryDto;
  ScoreGoal: ScoreGoal;
  ScoreGoalDto: ScoreGoalDto;
  ScoreGoalInput: ScoreGoalInput;
  ScoreGrid: ScoreGrid;
  ScoreGridDto: ScoreGridDto;
  ScoreGridExcelDataInput: ScoreGridExcelDataInput;
  ScoreGridInput: ScoreGridInput;
  ScoreGridsOverviewDTO: ScoreGridsOverviewDto;
  SelfReflectionSummary: SelfReflectionSummary;
  SelfreflectionInput: SelfreflectionInput;
  SelfreflectionQuestion: SelfreflectionQuestion;
  SelfreflectionQuestionBoolean: SelfreflectionQuestionBoolean;
  SelfreflectionQuestionBooleanInput: SelfreflectionQuestionBooleanInput;
  SkillEmployeeStatusDto: SkillEmployeeStatusDto;
  SkillEmployeeStatusMeetingInvitationDto: SkillEmployeeStatusMeetingInvitationDto;
  SqsBuffer: SqsBuffer;
  String: Scalars['String']['output'];
  Subordinate: Subordinate;
  SubordinateSearchPagination: SubordinateSearchPagination;
  TalentsSeasonInput: TalentsSeasonInput;
  TalentsSeasonSettingsDTO: TalentsSeasonSettingsDto;
  TalentsSeasonYearDTO: TalentsSeasonYearDto;
  TargetBonus: TargetBonus;
  TargetBonusDTO: TargetBonusDto;
  TargetBonusHistoryDTO: TargetBonusHistoryDto;
  TargetCorrectionPaymentAllowedYearsDto: TargetCorrectionPaymentAllowedYearsDto;
  TargetCorrectionPaymentDto: TargetCorrectionPaymentDto;
  TargetCorrectionPaymentInput: TargetCorrectionPaymentInput;
  TargetReportGenerationRequestDTO: TargetReportGenerationRequestDto;
  TargetsCalculationHelperDTO: TargetsCalculationHelperDto;
  TemporalBoundaries: TemporalBoundaries;
  ToBePaid: ToBePaid;
  UpdateNationalContractReferenceInput: UpdateNationalContractReferenceInput;
  UpdateNationalContractReferenceLevelInput: UpdateNationalContractReferenceLevelInput;
  Upload: Scalars['Upload']['output'];
  User: User;
  UserInfo: UserInfo;
  WorkforceMovementCounters: WorkforceMovementCounters;
  YearsAndCompaniesForRankingReportDTO: YearsAndCompaniesForRankingReportDto;
};

export type AbstractEmployeeWithRankAndTagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AbstractEmployeeWithRankAndTags'] = ResolversParentTypes['AbstractEmployeeWithRankAndTags']> = {
  assessable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  draftEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeDisplayShortInfo'], ParentType, ContextType>;
  evaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evaluationMeetingId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  latestEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previousCompanyRankData?: Resolver<Maybe<ResolversTypes['EmployeeRankDTO']>, ParentType, ContextType>;
  previousRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['EmployeeTagDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AbstractRelationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AbstractRelation'] = ResolversParentTypes['AbstractRelation']> = {
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActiveHrBusinessPartnerDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActiveHRBusinessPartnerDTO'] = ResolversParentTypes['ActiveHRBusinessPartnerDTO']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeDisplayShortInfo'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityListDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityListDTO'] = ResolversParentTypes['ActivityListDTO']> = {
  data?: Resolver<Array<ResolversTypes['ActivityListDataDTO']>, ParentType, ContextType>;
  length?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ActivityListType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityListDataDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityListDataDTO'] = ResolversParentTypes['ActivityListDataDTO']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllowedMonetaryTargetsDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllowedMonetaryTargetsDTO'] = ResolversParentTypes['AllowedMonetaryTargetsDTO']> = {
  newTargetsAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pastTargetsAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppraisalConfirmationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppraisalConfirmationInfo'] = ResolversParentTypes['AppraisalConfirmationInfo']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  discussedWith?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  forceConfirmedBy?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  forceConfirmedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppraisalDisplayInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppraisalDisplayInfo'] = ResolversParentTypes['AppraisalDisplayInfo']> = {
  appraisalSeason?: Resolver<ResolversTypes['AppraisalSeasonDTO'], ParentType, ContextType>;
  companyNameOfMeeting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conclusionPdf?: Resolver<Maybe<ResolversTypes['MeetingConclusionPdf']>, ParentType, ContextType>;
  confirmation?: Resolver<Maybe<ResolversTypes['AppraisalConfirmationInfo']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  hrDisputeComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hrFeedBack?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hrResult?: Resolver<ResolversTypes['MeetingHrFeedbackResult'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  meetingStatus?: Resolver<ResolversTypes['MeetingStatus'], ParentType, ContextType>;
  meetingType?: Resolver<ResolversTypes['MeetingType'], ParentType, ContextType>;
  reviewer?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeetingInvitationStatus'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AppraisalType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppraisalSeasonDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppraisalSeasonDTO'] = ResolversParentTypes['AppraisalSeasonDTO']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppraisalSeasonOpeningInfoDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppraisalSeasonOpeningInfoDTO'] = ResolversParentTypes['AppraisalSeasonOpeningInfoDTO']> = {
  currentAppraisalSeasonOpeningMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currentAppraisalSeasonOpeningYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currentAppraisalSeasonYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  defaultAppraisalSeasonOpeningMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  defaultCountryTimezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nextAppraisalSeasonOpeningMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nextAppraisalSeasonOpeningYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nextAppraisalSeasonYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppraisalTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppraisalType'] = ResolversParentTypes['AppraisalType']> = {
  name?: Resolver<ResolversTypes['AppraisalMeetingType'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['SkipMeetingStepReason']>, ParentType, ContextType>;
  skippedSteps?: Resolver<Array<ResolversTypes['MeetingStepViewId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppraisalWithFeedbackDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppraisalWithFeedbackDTO'] = ResolversParentTypes['AppraisalWithFeedbackDTO']> = {
  appraisalSeason?: Resolver<ResolversTypes['AppraisalSeasonDTO'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  conclusionPdf?: Resolver<ResolversTypes['MeetingConclusionPdf'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  discussedWith?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  employeeConfirmationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  hrDisputeComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hrFeedback?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hrResult?: Resolver<ResolversTypes['MeetingHrFeedbackResult'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  managerConfirmationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  meetingType?: Resolver<ResolversTypes['MeetingType'], ParentType, ContextType>;
  replyer?: Resolver<ResolversTypes['EmployeeDisplayTinyInfo'], ParentType, ContextType>;
  reviewer?: Resolver<ResolversTypes['EmployeeDisplayTinyInfo'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeetingStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppraisalWithFeedbackPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppraisalWithFeedbackPagination'] = ResolversParentTypes['AppraisalWithFeedbackPagination']> = {
  edges?: Resolver<Array<ResolversTypes['AppraisalWithFeedbackDTO']>, ParentType, ContextType>;
  endCursorConfirmationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  endCursorMeetingId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthPayload'] = ResolversParentTypes['AuthPayload']> = {
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['CurrentUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BOofCompanyDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BOofCompanyDTO'] = ResolversParentTypes['BOofCompanyDTO']> = {
  branchOfficesWithEmployees?: Resolver<Array<ResolversTypes['BranchOfficeWithEmployeesDTO']>, ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BubobuMcountersDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BUBOBUMcountersDTO'] = ResolversParentTypes['BUBOBUMcountersDTO']> = {
  branchOffice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  buManagers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BumOfBusinessUnitDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BUMOfBusinessUnitDTO'] = ResolversParentTypes['BUMOfBusinessUnitDTO']> = {
  buManagers?: Resolver<Array<ResolversTypes['EmployeeWithLevelDTO']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnitTiny'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BumOfCompanyDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BUMOfCompanyDTO'] = ResolversParentTypes['BUMOfCompanyDTO']> = {
  buManagers?: Resolver<Array<ResolversTypes['BUMOfBusinessUnitDTO']>, ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BUofCompanyDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BUofCompanyDTO'] = ResolversParentTypes['BUofCompanyDTO']> = {
  businessUnitsWithManagers?: Resolver<Array<ResolversTypes['BusinessUnitWithManagersDTO']>, ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BonusBetweenAnnualBonusAndProrataDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BonusBetweenAnnualBonusAndProrataDTO'] = ResolversParentTypes['BonusBetweenAnnualBonusAndProrataDTO']> = {
  appraisalSeasonId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  bonusAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bonusStatus?: Resolver<ResolversTypes['FlexibleProrataBonusStatus'], ParentType, ContextType>;
  contractCurrency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BranchOfficeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchOffice'] = ResolversParentTypes['BranchOffice']> = {
  address?: Resolver<ResolversTypes['InternationalAddress'], ParentType, ContextType>;
  addressId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employees?: Resolver<Maybe<Array<ResolversTypes['Employee']>>, ParentType, ContextType>;
  hiringOffice?: Resolver<Maybe<ResolversTypes['HiringOffice']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BranchOfficeDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchOfficeDTO'] = ResolversParentTypes['BranchOfficeDTO']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BranchOfficeWithEmployeesDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchOfficeWithEmployeesDTO'] = ResolversParentTypes['BranchOfficeWithEmployeesDTO']> = {
  branchOffice?: Resolver<ResolversTypes['BranchOfficeDTO'], ParentType, ContextType>;
  employees?: Resolver<Array<ResolversTypes['EmployeeWithLevelDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandResolvers<ContextType = any, ParentType extends ResolversParentTypes['Brand'] = ResolversParentTypes['Brand']> = {
  companies?: Resolver<Maybe<Array<ResolversTypes['Company']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bu'] = ResolversParentTypes['Bu']> = {
  buId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAllBu?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessPartnerOfCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessPartnerOfCompany'] = ResolversParentTypes['BusinessPartnerOfCompany']> = {
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUnit'] = ResolversParentTypes['BusinessUnit']> = {
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employees?: Resolver<Maybe<Array<ResolversTypes['Employee']>>, ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  managers?: Resolver<Maybe<Array<ResolversTypes['ManagerOfBusinessUnit']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUnitTinyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUnitTiny'] = ResolversParentTypes['BusinessUnitTiny']> = {
  company?: Resolver<Maybe<ResolversTypes['CompanyTiny']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isExpired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUnitWithManagersDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUnitWithManagersDTO'] = ResolversParentTypes['BusinessUnitWithManagersDTO']> = {
  buManagers?: Resolver<Array<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnitTiny'], ParentType, ContextType>;
  numberOfEmployees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CareerPathDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CareerPathDto'] = ResolversParentTypes['CareerPathDto']> = {
  careerPathType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CareerPathEvaluationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CareerPathEvaluation'] = ResolversParentTypes['CareerPathEvaluation']> = {
  bonusEvaluation?: Resolver<ResolversTypes['CareerPathEvaluationState'], ParentType, ContextType>;
  salary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  salaryEvaluation?: Resolver<ResolversTypes['CareerPathEvaluationState'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['CareerPathEvaluationState'], ParentType, ContextType>;
  targetBonus?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Change'] = ResolversParentTypes['Change']> = {
  changes?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ChangeStatus']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ChangeType']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeError'] = ResolversParentTypes['ChangeError']> = {
  bonus?: Resolver<Maybe<ResolversTypes['ChangeResponseErrorObject']>, ParentType, ContextType>;
  employeeLevel?: Resolver<Maybe<ResolversTypes['ChangeResponseErrorObject']>, ParentType, ContextType>;
  governmentJobTitle?: Resolver<Maybe<ResolversTypes['ChangeResponseErrorObject']>, ParentType, ContextType>;
  nationalReferenceLevel?: Resolver<Maybe<ResolversTypes['ChangeResponseErrorObject']>, ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['ChangeResponseErrorObject']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['ChangeResponseErrorObject']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeResponseErrorObjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeResponseErrorObject'] = ResolversParentTypes['ChangeResponseErrorObject']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  props?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChildrenResolvers<ContextType = any, ParentType extends ResolversParentTypes['Children'] = ResolversParentTypes['Children']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CitizenshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Citizenship'] = ResolversParentTypes['Citizenship']> = {
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayOrder?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompaniesForRankingReportDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompaniesForRankingReportDTO'] = ResolversParentTypes['CompaniesForRankingReportDTO']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company']> = {
  brand?: Resolver<Maybe<ResolversTypes['Brand']>, ParentType, ContextType>;
  businessPartners?: Resolver<Maybe<Array<ResolversTypes['BusinessPartnerOfCompany']>>, ParentType, ContextType>;
  businessUnits?: Resolver<Array<ResolversTypes['BusinessUnit']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyRankings?: Resolver<Array<ResolversTypes['CompanyRanking']>, ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isSharedService?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  managers?: Resolver<Maybe<Array<ResolversTypes['ManagerOfCompany']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['Network'], ParentType, ContextType>;
  reviewers?: Resolver<Maybe<Array<ResolversTypes['ReviewerOfEmployees']>>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAndBuResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyAndBu'] = ResolversParentTypes['CompanyAndBu']> = {
  bu?: Resolver<Array<ResolversTypes['Bu']>, ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyCarResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyCar'] = ResolversParentTypes['CompanyCar']> = {
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deduction?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyManagerAppraisalMeetingStatusDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyManagerAppraisalMeetingStatusDTO'] = ResolversParentTypes['CompanyManagerAppraisalMeetingStatusDTO']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  ongoingAppraisalUpdateAfterLatestConfirmedMeetingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rows?: Resolver<Array<ResolversTypes['CompanyManagerAppraisalMeetingStatusTableRowDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyManagerAppraisalMeetingStatusTableRowDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyManagerAppraisalMeetingStatusTableRowDTO'] = ResolversParentTypes['CompanyManagerAppraisalMeetingStatusTableRowDTO']> = {
  buManagers?: Resolver<Array<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnitTiny'], ParentType, ContextType>;
  confirmedOrLatestMeetingConclusionPdf?: Resolver<Maybe<ResolversTypes['MeetingConclusionPdf']>, ParentType, ContextType>;
  confirmedOrLatestMeetingId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  confirmedOrLatestMeetingType?: Resolver<Maybe<ResolversTypes['MeetingType']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeWithLevelDTO'], ParentType, ContextType>;
  office?: Resolver<Maybe<ResolversTypes['BranchOfficeDTO']>, ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CompanyManagerAppraisalMeetingStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyRankingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyRanking'] = ResolversParentTypes['CompanyRanking']> = {
  closed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  employeeRankings?: Resolver<Array<ResolversTypes['EmployeeRanking']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyRankingSettingsDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyRankingSettingsDTO'] = ResolversParentTypes['CompanyRankingSettingsDTO']> = {
  lowPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lowPercentageIsBlocker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rankingIsDisabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tagAssignmentIsInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  topPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanySubordinateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanySubordinate'] = ResolversParentTypes['CompanySubordinate']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  careerPath?: Resolver<Maybe<Array<ResolversTypes['CareerPathDto']>>, ParentType, ContextType>;
  careerPathEvaluation?: Resolver<Maybe<ResolversTypes['CareerPathEvaluation']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractValidTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  currencyForPayments?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  resultScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skillStatus?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType>;
  targetBonus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyTinyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyTiny'] = ResolversParentTypes['CompanyTiny']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyTinyWithNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyTinyWithName'] = ResolversParentTypes['CompanyTinyWithName']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contract'] = ResolversParentTypes['Contract']> = {
  annualSalary?: Resolver<Array<ResolversTypes['Salary']>, ParentType, ContextType>;
  cancellationFrom?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  cancellationTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  cancellationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyCars?: Resolver<Array<ResolversTypes['CompanyCar']>, ParentType, ContextType>;
  contractGovernmentJobTitles?: Resolver<Array<ResolversTypes['ContractGovernmentJobTitle']>, ParentType, ContextType>;
  contractType?: Resolver<Array<ResolversTypes['ContractType']>, ParentType, ContextType>;
  currencyForPayments?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentAnnualSalary?: Resolver<ResolversTypes['Salary'], ParentType, ContextType>;
  currentContractEmployeeLevel?: Resolver<ResolversTypes['ContractEmployeeLevel'], ParentType, ContextType>;
  currentEmployeeLevel?: Resolver<ResolversTypes['ContractEmployeeLevel'], ParentType, ContextType>;
  currentLeaveEntitlement?: Resolver<ResolversTypes['LeaveEntitlement'], ParentType, ContextType>;
  currentTargetBonus?: Resolver<ResolversTypes['TargetBonus'], ParentType, ContextType>;
  employee?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType>;
  employeeLevels?: Resolver<Array<ResolversTypes['ContractEmployeeLevel']>, ParentType, ContextType>;
  executedPayments?: Resolver<Array<ResolversTypes['ExecutedPayment']>, ParentType, ContextType>;
  flexibleBenefit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  leaveEntitlement?: Resolver<Array<ResolversTypes['LeaveEntitlement']>, ParentType, ContextType>;
  legalEntity?: Resolver<ResolversTypes['LegalEntity'], ParentType, ContextType>;
  nationalContractEmployeeLevels?: Resolver<Array<ResolversTypes['NationalContractLevel']>, ParentType, ContextType>;
  probationPeriodEndDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  retentionPeriodEndDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  tagHistory?: Resolver<Maybe<Array<ResolversTypes['EmployeeTagInfo']>>, ParentType, ContextType>;
  targetBonus?: Resolver<Maybe<Array<ResolversTypes['TargetBonus']>>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatesRestrictedTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  validFrom?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractChangeValidationEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContractChangeValidationEntry'] = ResolversParentTypes['ContractChangeValidationEntry']> = {
  bonus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employeeLevel?: Resolver<Maybe<ResolversTypes['EmployeeLevelEnum']>, ParentType, ContextType>;
  governmentJobTitle?: Resolver<Maybe<ResolversTypes['GovernmentJobTitleTinyDTO']>, ParentType, ContextType>;
  nationalContractLevel?: Resolver<Maybe<ResolversTypes['NationalContractLevelEnum']>, ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractChangeValidationListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContractChangeValidationList'] = ResolversParentTypes['ContractChangeValidationList']> = {
  validationEntries?: Resolver<Array<ResolversTypes['ContractChangeValidationEntry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractEmployeeLevelResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContractEmployeeLevel'] = ResolversParentTypes['ContractEmployeeLevel']> = {
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractEmployeeLevelDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContractEmployeeLevelDTO'] = ResolversParentTypes['ContractEmployeeLevelDTO']> = {
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractEmployeeLevelHistoryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContractEmployeeLevelHistoryDTO'] = ResolversParentTypes['ContractEmployeeLevelHistoryDTO']> = {
  contractEmployeeLevelHistory?: Resolver<Array<ResolversTypes['ContractEmployeeLevelDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractGovernmentJobTitleResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContractGovernmentJobTitle'] = ResolversParentTypes['ContractGovernmentJobTitle']> = {
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  governmentJobTitle?: Resolver<ResolversTypes['GovernmentJobTitle'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContractType'] = ResolversParentTypes['ContractType']> = {
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  typeOfContract?: Resolver<ResolversTypes['ContractTypeEnum'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryAndReportGenerationFlagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryAndReportGenerationFlags'] = ResolversParentTypes['CountryAndReportGenerationFlags']> = {
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  createBigReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createPyramidReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createSmallReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createTargetReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountrySettingsDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountrySettingsDto'] = ResolversParentTypes['CountrySettingsDto']> = {
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  createTargetReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cutOffDay?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  defaultKudosFeatureEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  defaultRankingLowPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  defaultRankingLowPercentageIsBlocker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  defaultRankingRankingIsDisabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  defaultRankingTopPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  employeeLevelsSet?: Resolver<ResolversTypes['EmployeeLevelsSets'], ParentType, ContextType>;
  flexibleProrataManagementEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasGovernmentJobTitleReferenceLevel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasNationalContractReferenceLevel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isAgePyramidVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isBranchOfficeVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDateOfBirthVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeductionEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isIdVWeightEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMonthlySalaryDisplayed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maintainTagHistory?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  monthlySalaryMonthsInYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentsAndChangesDisclaimerVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  selfReflectionAndEvaluationAlwaysVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  skillStatusBlocker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryWithAgePyramidVisibleFlagResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryWithAgePyramidVisibleFlag'] = ResolversParentTypes['CountryWithAgePyramidVisibleFlag']> = {
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  isAgePyramidVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryWithBranchOfficeVisibleFlagResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryWithBranchOfficeVisibleFlag'] = ResolversParentTypes['CountryWithBranchOfficeVisibleFlag']> = {
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  isBranchOfficeVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateChangeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateChangeResponse'] = ResolversParentTypes['CreateChangeResponse']> = {
  change?: Resolver<Maybe<ResolversTypes['Change']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['ChangeError']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyConversionDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyConversionDTO'] = ResolversParentTypes['CurrencyConversionDTO']> = {
  conversionRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  startingCurrency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  targetCurrency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyConversionWithContractCurrencyDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyConversionWithContractCurrencyDTO'] = ResolversParentTypes['CurrencyConversionWithContractCurrencyDTO']> = {
  contractCurrency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  currencyConversionData?: Resolver<Array<ResolversTypes['CurrencyConversionDTO']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentUser'] = ResolversParentTypes['CurrentUser']> = {
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['RoleName']>>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardListOfCompaniesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DashboardListOfCompanies'] = ResolversParentTypes['DashboardListOfCompanies']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countries?: Resolver<Array<ResolversTypes['Country']>, ParentType, ContextType>;
  rolesOnCompany?: Resolver<Array<ResolversTypes['RoleName']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardWorkforceCountersDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DashboardWorkforceCountersDTO'] = ResolversParentTypes['DashboardWorkforceCountersDTO']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  totalEmployees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  workforceMovementCounters?: Resolver<Array<ResolversTypes['WorkforceMovementCounters']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeleteOkResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOk'] = ResolversParentTypes['DeleteOk']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EducationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Education'] = ResolversParentTypes['Education']> = {
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  grade?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isHighestEducation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officialDegreeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmbeddedBusinessUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmbeddedBusinessUnit'] = ResolversParentTypes['EmbeddedBusinessUnit']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmergencyContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmergencyContact'] = ResolversParentTypes['EmergencyContact']> = {
  contactRelationship?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contactType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employee'] = ResolversParentTypes['Employee']> = {
  academicTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Array<ResolversTypes['EmployeeAddress']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankAccount?: Resolver<Maybe<ResolversTypes['InternationalBankAccount']>, ParentType, ContextType>;
  branchOffice?: Resolver<ResolversTypes['BranchOffice'], ParentType, ContextType>;
  branchOfficeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  businessPartnerOfCompanies?: Resolver<Maybe<Array<ResolversTypes['BusinessPartnerOfCompany']>>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnit'], ParentType, ContextType>;
  businessUnitId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  careerPath?: Resolver<Maybe<Array<ResolversTypes['CareerPathDto']>>, ParentType, ContextType>;
  careerPathEvaluation?: Resolver<Maybe<ResolversTypes['CareerPathEvaluation']>, ParentType, ContextType>;
  changes?: Resolver<Array<ResolversTypes['Change']>, ParentType, ContextType>;
  chosenFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  citizenships?: Resolver<Array<ResolversTypes['Citizenship']>, ParentType, ContextType>;
  contracts?: Resolver<Maybe<Array<ResolversTypes['Contract']>>, ParentType, ContextType>;
  currentContract?: Resolver<Maybe<ResolversTypes['Contract']>, ParentType, ContextType>;
  currentEmployeeLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  education?: Resolver<Array<ResolversTypes['Education']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emergencyContacts?: Resolver<Array<ResolversTypes['EmergencyContact']>, ParentType, ContextType>;
  employeeRankings?: Resolver<Array<ResolversTypes['EmployeeRanking']>, ParentType, ContextType>;
  employmentStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  forcedMeetings?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  legalFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalLastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  managerMeetings?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType>;
  managerOfBusinessUnits?: Resolver<Maybe<Array<ResolversTypes['ManagerOfBusinessUnit']>>, ParentType, ContextType>;
  managerOfClusters?: Resolver<Maybe<Array<ResolversTypes['ManagerOfCluster']>>, ParentType, ContextType>;
  managerOfCompanies?: Resolver<Maybe<Array<ResolversTypes['ManagerOfCompany']>>, ParentType, ContextType>;
  managerOfNetworks?: Resolver<Maybe<Array<ResolversTypes['ManagerOfNetwork']>>, ParentType, ContextType>;
  meetings?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType>;
  partnerMeetings?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType>;
  privateEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  replyerGrids?: Resolver<Array<ResolversTypes['ScoreGrid']>, ParentType, ContextType>;
  reviewerOf?: Resolver<Maybe<Array<ResolversTypes['ReviewerOfEmployees']>>, ParentType, ContextType>;
  reviewers?: Resolver<Maybe<Array<ResolversTypes['ReviewerOfEmployees']>>, ParentType, ContextType>;
  selfReflection?: Resolver<Maybe<Array<ResolversTypes['SelfreflectionQuestion']>>, ParentType, ContextType>;
  skillCenterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subordinates?: Resolver<Maybe<Array<ResolversTypes['Employee']>>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeAddress'] = ResolversParentTypes['EmployeeAddress']> = {
  address?: Resolver<Maybe<ResolversTypes['InternationalAddress']>, ParentType, ContextType>;
  addressId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeAndAppraisalMeetingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeAndAppraisalMeetings'] = ResolversParentTypes['EmployeeAndAppraisalMeetings']> = {
  appraisal?: Resolver<Maybe<ResolversTypes['AppraisalDisplayInfo']>, ParentType, ContextType>;
  branchOfficeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeDisplayShortWithBuManager'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  mandatory?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  meetingToDoInCurrentAppraisalSeason?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  skillStatus?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeetingInvitationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeAndTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeAndTag'] = ResolversParentTypes['EmployeeAndTag']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['EmployeeTagDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeDisplayShortInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeDisplayShortInfo'] = ResolversParentTypes['EmployeeDisplayShortInfo']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeDisplayShortInfoMeetingInviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeDisplayShortInfoMeetingInvite'] = ResolversParentTypes['EmployeeDisplayShortInfoMeetingInvite']> = {
  employees?: Resolver<Array<ResolversTypes['EmployeeDisplayShortInfo']>, ParentType, ContextType>;
  queriedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeDisplayShortInfoWithLastMeetingResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeDisplayShortInfoWithLastMeeting'] = ResolversParentTypes['EmployeeDisplayShortInfoWithLastMeeting']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastCompletedMeeting?: Resolver<Maybe<ResolversTypes['MeetingTiny']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeDisplayShortWithBuManagerResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeDisplayShortWithBuManager'] = ResolversParentTypes['EmployeeDisplayShortWithBuManager']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  managers?: Resolver<Maybe<Array<ResolversTypes['EmployeeDisplayTinyInfo']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeDisplayTinyInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeDisplayTinyInfo'] = ResolversParentTypes['EmployeeDisplayTinyInfo']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeEmploymentStatusDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeEmploymentStatusDTO'] = ResolversParentTypes['EmployeeEmploymentStatusDTO']> = {
  currentBonusAfterFirstJanuary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  futureChangesForeseenByContract?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  openChanges?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeLevelWithDisplayOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeLevelWithDisplayOrder'] = ResolversParentTypes['EmployeeLevelWithDisplayOrder']> = {
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeNameSearchInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeNameSearchInfo'] = ResolversParentTypes['EmployeeNameSearchInfo']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chosenFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  legalFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalLastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeOnProbationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeOnProbation'] = ResolversParentTypes['EmployeeOnProbation']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  inSecondHalfOfProbationPeriod?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  probationEndDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeRankDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeRankDTO'] = ResolversParentTypes['EmployeeRankDTO']> = {
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeRankingResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeRanking'] = ResolversParentTypes['EmployeeRanking']> = {
  companyRanking?: Resolver<ResolversTypes['CompanyRanking'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  exclusion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  exclusionReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flag?: Resolver<ResolversTypes['RankingLevel'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  rang?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeSearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeSearch'] = ResolversParentTypes['EmployeeSearch']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessUnitName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contractLevel?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  contractValidTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  employmentStatus?: Resolver<ResolversTypes['EmploymentStatus'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeSubordinateDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeSubordinateDTO'] = ResolversParentTypes['EmployeeSubordinateDTO']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  branchOfficeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnit'], ParentType, ContextType>;
  careerPath?: Resolver<Maybe<Array<ResolversTypes['CareerPathDto']>>, ParentType, ContextType>;
  careerPathEvaluation?: Resolver<Maybe<ResolversTypes['CareerPathEvaluation']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contractLevel?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  contractValidTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  currencyForPayments?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  resultScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['Salary']>, ParentType, ContextType>;
  skillStatus?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType>;
  targetBonus?: Resolver<Maybe<ResolversTypes['TargetBonus']>, ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeTagDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeTagDto'] = ResolversParentTypes['EmployeeTagDto']> = {
  addedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  globalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  temporary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeTagInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeTagInfo'] = ResolversParentTypes['EmployeeTagInfo']> = {
  addedBy?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  addedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeDisplayTinyInfo'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removedBy?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  removedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EmployeeTagType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeTagInfoShortResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeTagInfoShort'] = ResolversParentTypes['EmployeeTagInfoShort']> = {
  addedById?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  addedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removedById?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  removedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EmployeeTagType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeTagInfoTinyResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeTagInfoTiny'] = ResolversParentTypes['EmployeeTagInfoTiny']> = {
  addedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EmployeeTagType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeWithBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeWithBonus'] = ResolversParentTypes['EmployeeWithBonus']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  objectiveAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  targetBonus?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeWithBusinessUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeWithBusinessUnit'] = ResolversParentTypes['EmployeeWithBusinessUnit']> = {
  businessUnit?: Resolver<ResolversTypes['EmbeddedBusinessUnit'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeWithEndingContractResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeWithEndingContract'] = ResolversParentTypes['EmployeeWithEndingContract']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endOfContract?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeWithLatestAndDraftEvaluationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeWithLatestAndDraftEvaluation'] = ResolversParentTypes['EmployeeWithLatestAndDraftEvaluation']> = {
  businessUnit?: Resolver<ResolversTypes['BusinessUnitTiny'], ParentType, ContextType>;
  draftEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeDisplayShortInfo'], ParentType, ContextType>;
  existingDraftEvaluation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  existingLatestEvaluation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  globalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  latestEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scoreGoals?: Resolver<Maybe<Array<ResolversTypes['ScoreGoalDto']>>, ParentType, ContextType>;
  scoreGridStatus?: Resolver<Maybe<ResolversTypes['ScoreGridStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeWithLevelDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeWithLevelDTO'] = ResolversParentTypes['EmployeeWithLevelDTO']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentLevel?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeWithRankAndTagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeWithRankAndTags'] = ResolversParentTypes['EmployeeWithRankAndTags']> = {
  assessable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  draftEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeDisplayShortInfo'], ParentType, ContextType>;
  evaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evaluationMeetingId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  latestEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previousCompanyRankData?: Resolver<Maybe<ResolversTypes['EmployeeRankDTO']>, ParentType, ContextType>;
  previousRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['EmployeeTagDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeWithRankAndTagsForExcelResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeWithRankAndTagsForExcel'] = ResolversParentTypes['EmployeeWithRankAndTagsForExcel']> = {
  assessable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  draftEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeDisplayShortInfo'], ParentType, ContextType>;
  evaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evaluationMeetingId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  latestEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previousCompanyRankData?: Resolver<Maybe<ResolversTypes['EmployeeRankDTO']>, ParentType, ContextType>;
  previousRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['EmployeeTagDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeWithRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeWithRole'] = ResolversParentTypes['EmployeeWithRole']> = {
  assignedTo?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasDownloaderRole?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hrRoleOfUser?: Resolver<Array<ResolversTypes['RoleOfUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeesWithWrongStatusOrMissingContractDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeesWithWrongStatusOrMissingContractDTO'] = ResolversParentTypes['EmployeesWithWrongStatusOrMissingContractDTO']> = {
  businessUnitId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecutedPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutedPayment'] = ResolversParentTypes['ExecutedPayment']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  referenceYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ExecutedPaymentType'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecutedPaymentDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutedPaymentDTO'] = ResolversParentTypes['ExecutedPaymentDTO']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  referenceYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ExecutedPaymentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExecutedPaymentHistoryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutedPaymentHistoryDTO'] = ResolversParentTypes['ExecutedPaymentHistoryDTO']> = {
  executedPayments?: Resolver<Array<ResolversTypes['ExecutedPaymentDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureMaintenanceDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureMaintenanceData'] = ResolversParentTypes['FeatureMaintenanceData']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureToggleResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureToggle'] = ResolversParentTypes['FeatureToggle']> = {
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlatCompanyWithLegalEntitiesAndCountriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlatCompanyWithLegalEntitiesAndCountries'] = ResolversParentTypes['FlatCompanyWithLegalEntitiesAndCountries']> = {
  companyId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalEntityId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  legalEntityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  networkName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FullMeetingPreviewDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['FullMeetingPreviewDTO'] = ResolversParentTypes['FullMeetingPreviewDTO']> = {
  contractChanges?: Resolver<Array<ResolversTypes['Change']>, ParentType, ContextType>;
  latestContract?: Resolver<ResolversTypes['LatestContractDTO'], ParentType, ContextType>;
  meeting?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType>;
  objectivePayment?: Resolver<Maybe<ResolversTypes['ObjectivePayment']>, ParentType, ContextType>;
  objectives?: Resolver<Array<ResolversTypes['ObjectiveDTO']>, ParentType, ContextType>;
  oneOffPayment?: Resolver<Maybe<ResolversTypes['OneOffPayment']>, ParentType, ContextType>;
  salaryOfYear?: Resolver<Array<ResolversTypes['Salary']>, ParentType, ContextType>;
  scoreGrid?: Resolver<Maybe<ResolversTypes['ScoreGridDto']>, ParentType, ContextType>;
  selfReflectionQuestions?: Resolver<Array<ResolversTypes['SelfreflectionQuestion']>, ParentType, ContextType>;
  targetBonusOfYear?: Resolver<Array<ResolversTypes['TargetBonus']>, ParentType, ContextType>;
  targetCorrectionPayment?: Resolver<Maybe<ResolversTypes['TargetCorrectionPaymentDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GecoProjectsInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GecoProjectsInfo'] = ResolversParentTypes['GecoProjectsInfo']> = {
  bookedTimeInPercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  projectName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GovernmentJobTitleResolvers<ContextType = any, ParentType extends ResolversParentTypes['GovernmentJobTitle'] = ResolversParentTypes['GovernmentJobTitle']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  department?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  hiringOffice?: Resolver<ResolversTypes['HiringOffice'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  monthlySalaryMaximum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  monthlySalaryMinimum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GovernmentJobTitleTinyDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GovernmentJobTitleTinyDTO'] = ResolversParentTypes['GovernmentJobTitleTinyDTO']> = {
  department?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hiringOfficeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupedCompanyWithLegalEntitiesAndCountriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupedCompanyWithLegalEntitiesAndCountries'] = ResolversParentTypes['GroupedCompanyWithLegalEntitiesAndCountries']> = {
  companyCountries?: Resolver<Array<ResolversTypes['GroupedLegalEntityWithCountry']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupedLegalEntityWithCountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupedLegalEntityWithCountry'] = ResolversParentTypes['GroupedLegalEntityWithCountry']> = {
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalEntityId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  legalEntityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  years?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupedNetworkWithCompaniesWithLegalEntitiesAndCountriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries'] = ResolversParentTypes['GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries']> = {
  companies?: Resolver<Array<ResolversTypes['GroupedCompanyWithLegalEntitiesAndCountries']>, ParentType, ContextType>;
  networkId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  networkName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HappinessLevelResolvers<ContextType = any, ParentType extends ResolversParentTypes['HappinessLevel'] = ResolversParentTypes['HappinessLevel']> = {
  happy?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  neutral?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unhappy?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  veryHappy?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  veryUnhappy?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface HashedIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['HashedId'], any> {
  name: 'HashedId';
}

export type HiringOfficeResolvers<ContextType = any, ParentType extends ResolversParentTypes['HiringOffice'] = ResolversParentTypes['HiringOffice']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdvWeightDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdvWeightDto'] = ResolversParentTypes['IdvWeightDto']> = {
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['ScoreGoalType'], ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternationalAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternationalAddress'] = ResolversParentTypes['InternationalAddress']> = {
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  branchOffice?: Resolver<Maybe<ResolversTypes['BranchOffice']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['Country']>, ParentType, ContextType>;
  employeeAddress?: Resolver<Maybe<ResolversTypes['EmployeeAddress']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stateRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  zipPostalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternationalBankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternationalBankAccount'] = ResolversParentTypes['InternationalBankAccount']> = {
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  agency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankSortCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bicSwift?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employee?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType>;
  iban?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeyResultDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeyResultDTO'] = ResolversParentTypes['KeyResultDTO']> = {
  completed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  globalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KudosCompanyCountryVisibilityDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KudosCompanyCountryVisibilityDTO'] = ResolversParentTypes['KudosCompanyCountryVisibilityDTO']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  kudosEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KudosCompanyCountryVisibilityShowMoreDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KudosCompanyCountryVisibilityShowMoreDTO'] = ResolversParentTypes['KudosCompanyCountryVisibilityShowMoreDTO']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kudosCompanyCountryVisibilityList?: Resolver<Array<ResolversTypes['KudosCompanyCountryVisibilityDTO']>, ParentType, ContextType>;
  nextOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KudosDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KudosDTO'] = ResolversParentTypes['KudosDTO']> = {
  author?: Resolver<Maybe<ResolversTypes['EmployeeDisplayShortInfo']>, ParentType, ContextType>;
  authorId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deletable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employee?: Resolver<Maybe<ResolversTypes['EmployeeDisplayShortInfo']>, ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['KudosType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KudosLegalEntityVisibilityDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KudosLegalEntityVisibilityDTO'] = ResolversParentTypes['KudosLegalEntityVisibilityDTO']> = {
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  kudosEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legalEntityId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  legalEntityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KudosLegalEntityVisibilityShowMoreDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KudosLegalEntityVisibilityShowMoreDTO'] = ResolversParentTypes['KudosLegalEntityVisibilityShowMoreDTO']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kudosLegalEntityVisibilityList?: Resolver<Array<ResolversTypes['KudosLegalEntityVisibilityDTO']>, ParentType, ContextType>;
  nextOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KudosPaginationDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KudosPaginationDTO'] = ResolversParentTypes['KudosPaginationDTO']> = {
  currentPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kudos?: Resolver<Array<ResolversTypes['KudosDTO']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KudosShowMoreDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KudosShowMoreDTO'] = ResolversParentTypes['KudosShowMoreDTO']> = {
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kudos?: Resolver<Array<ResolversTypes['KudosDTO']>, ParentType, ContextType>;
  nextOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KudosWithVisibilityFlagDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['KudosWithVisibilityFlagDTO'] = ResolversParentTypes['KudosWithVisibilityFlagDTO']> = {
  employeeOptedOut?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKudosEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kudosPagination?: Resolver<ResolversTypes['KudosPaginationDTO'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LatestContractDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LatestContractDTO'] = ResolversParentTypes['LatestContractDTO']> = {
  annualSalary?: Resolver<Maybe<ResolversTypes['Salary']>, ParentType, ContextType>;
  cancellationFrom?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  cancellationTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  cancellationType?: Resolver<Maybe<ResolversTypes['CancellationType']>, ParentType, ContextType>;
  companyCar?: Resolver<Maybe<ResolversTypes['CompanyCar']>, ParentType, ContextType>;
  contractGovernmentJobTitle?: Resolver<Maybe<ResolversTypes['ContractGovernmentJobTitle']>, ParentType, ContextType>;
  contractType?: Resolver<ResolversTypes['ContractType'], ParentType, ContextType>;
  currencyForPayments?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  employeeLevel?: Resolver<Maybe<ResolversTypes['ContractEmployeeLevel']>, ParentType, ContextType>;
  executedPayments?: Resolver<Maybe<Array<ResolversTypes['ExecutedPayment']>>, ParentType, ContextType>;
  flexibleBenefit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hasNationalContract?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  isDeductionEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMonthlySalaryDisplayed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  leaveEntitlement?: Resolver<Maybe<ResolversTypes['LeaveEntitlement']>, ParentType, ContextType>;
  legalEntity?: Resolver<ResolversTypes['LegalEntity'], ParentType, ContextType>;
  monthlySalaryMonthsInYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nationalContractLevel?: Resolver<Maybe<ResolversTypes['NationalContractLevel']>, ParentType, ContextType>;
  nationalContractReferenceLevel?: Resolver<Maybe<ResolversTypes['NationalContractReferenceDTO']>, ParentType, ContextType>;
  probationPeriodEndDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  targetBonus?: Resolver<Maybe<ResolversTypes['TargetBonus']>, ParentType, ContextType>;
  updatesRestrictedTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  validFrom?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  validTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaveEntitlementResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeaveEntitlement'] = ResolversParentTypes['LeaveEntitlement']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaversResolvers<ContextType = any, ParentType extends ResolversParentTypes['Leavers'] = ResolversParentTypes['Leavers']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnitTiny'], ParentType, ContextType>;
  contractCancellationTo?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  contractCancellationType?: Resolver<ResolversTypes['CancellationType'], ParentType, ContextType>;
  contractType?: Resolver<ResolversTypes['ContractTypeEnum'], ParentType, ContextType>;
  contractValidFrom?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leaverLevel?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaversByPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeaversByPeriod'] = ResolversParentTypes['LeaversByPeriod']> = {
  currentMonth?: Resolver<Array<ResolversTypes['Leavers']>, ParentType, ContextType>;
  nextMonth?: Resolver<Array<ResolversTypes['Leavers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegalEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalEntity'] = ResolversParentTypes['LegalEntity']> = {
  contracts?: Resolver<Maybe<Array<ResolversTypes['Contract']>>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegalEntityTinyResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalEntityTiny'] = ResolversParentTypes['LegalEntityTiny']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocaleDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocaleDTO'] = ResolversParentTypes['LocaleDTO']> = {
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoutOkResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutOk'] = ResolversParentTypes['LogoutOk']> = {
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagedCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedCompany'] = ResolversParentTypes['ManagedCompany']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  editable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagerOfBusinessUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagerOfBusinessUnit'] = ResolversParentTypes['ManagerOfBusinessUnit']> = {
  businessUnit?: Resolver<Array<ResolversTypes['BusinessUnit']>, ParentType, ContextType>;
  businessUnitId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagerOfClusterResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagerOfCluster'] = ResolversParentTypes['ManagerOfCluster']> = {
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['Network'], ParentType, ContextType>;
  networkId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagerOfCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagerOfCompany'] = ResolversParentTypes['ManagerOfCompany']> = {
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagerOfNetworkResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagerOfNetwork'] = ResolversParentTypes['ManagerOfNetwork']> = {
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['Network'], ParentType, ContextType>;
  networkId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagingUnitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagingUnits'] = ResolversParentTypes['ManagingUnits']> = {
  companies?: Resolver<Maybe<Array<ResolversTypes['Company']>>, ParentType, ContextType>;
  networks?: Resolver<Maybe<Array<ResolversTypes['Network']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Meeting'] = ResolversParentTypes['Meeting']> = {
  activeMeetingStep?: Resolver<Maybe<ResolversTypes['MeetingStep']>, ParentType, ContextType>;
  activityListEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  additionalParticipants?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allowedMonetaryTargets?: Resolver<ResolversTypes['AllowedMonetaryTargetsDTO'], ParentType, ContextType>;
  appraisal?: Resolver<Maybe<ResolversTypes['MeetingEmbedAppraisal']>, ParentType, ContextType>;
  appraisalSeason?: Resolver<ResolversTypes['AppraisalSeasonDTO'], ParentType, ContextType>;
  conclusionPdfDownloadToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  conclusionPdfFileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  conclusionPdfStatus?: Resolver<ResolversTypes['MeetingPdfStatus'], ParentType, ContextType>;
  confirmationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  displayDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  employeePreparationActiveStep?: Resolver<Maybe<ResolversTypes['MeetingStep']>, ParentType, ContextType>;
  employeePreparationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  employeePrepared?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  forceConfirmationEmployee?: Resolver<Maybe<ResolversTypes['EmployeeDisplayShortInfo']>, ParentType, ContextType>;
  forceConfirmationEmployeeId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  forceConfirmationReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasEvaluationScore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isLoggedUserCompanyManagerOfAppraisalSeasonCompany?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMigrated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isReplyerActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managerConfirmationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  managerPreparationActiveStep?: Resolver<Maybe<ResolversTypes['MeetingStep']>, ParentType, ContextType>;
  managerPrepared?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  meetingSteps?: Resolver<Maybe<Array<ResolversTypes['MeetingStep']>>, ParentType, ContextType>;
  nextPaymentCycle?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  nonParticipants?: Resolver<Array<ResolversTypes['EmployeeWithBusinessUnit']>, ParentType, ContextType>;
  objectivePayment?: Resolver<Maybe<ResolversTypes['ObjectivePayment']>, ParentType, ContextType>;
  oneOffPayment?: Resolver<Maybe<ResolversTypes['OneOffPayment']>, ParentType, ContextType>;
  other?: Resolver<Maybe<ResolversTypes['MeetingEmbedOther']>, ParentType, ContextType>;
  partner?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType>;
  partnerId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  preparationPdfDownloadToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  preparationPdfFileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  preparationPdfStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reasonForMeetingCancel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requiresSpecialHandlingOfLowTag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rescheduleNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviewer?: Resolver<Maybe<ResolversTypes['EmployeeDisplayShortInfo']>, ParentType, ContextType>;
  selfReflection?: Resolver<Maybe<Array<ResolversTypes['SelfreflectionQuestion']>>, ParentType, ContextType>;
  selfReflectionAndEvaluationVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeetingStatus'], ParentType, ContextType>;
  targetsCalculationHelper?: Resolver<ResolversTypes['TargetsCalculationHelperDTO'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MeetingType'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingConclusionPdfResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingConclusionPdf'] = ResolversParentTypes['MeetingConclusionPdf']> = {
  downloadToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeetingPdfStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingEmbedAppraisalResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingEmbedAppraisal'] = ResolversParentTypes['MeetingEmbedAppraisal']> = {
  emailText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employeeGeneralFeedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employeeSelfReflectionDev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employeeSelfReflectionDevScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  employeeSelfReflectionPerf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employeeSelfReflectionPerfScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evaluationShared?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  feedbackForHR?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hrDisputeComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hrResult?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  meetingGeneralFeedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonForReducedSteps?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviewerGeneralFeedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selfReflectionShared?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  shareWithHR?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  targetCommentsShared?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingEmbedOtherResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingEmbedOther'] = ResolversParentTypes['MeetingEmbedOther']> = {
  agenda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notesEmployee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notesManager?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  protocol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingInvitationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingInvitationStatus'] = ResolversParentTypes['MeetingInvitationStatus']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingInviteOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingInviteOptions'] = ResolversParentTypes['MeetingInviteOptions']> = {
  possible?: Resolver<Array<ResolversTypes['MeetingType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingInviteOptionsExtendedResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingInviteOptionsExtended'] = ResolversParentTypes['MeetingInviteOptionsExtended']> = {
  isAppraisalEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  possible?: Resolver<Array<ResolversTypes['MeetingType']>, ParentType, ContextType>;
  tagAssignmentIsInProgress?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingRequestDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingRequestDTO'] = ResolversParentTypes['MeetingRequestDTO']> = {
  appraisalSeason?: Resolver<ResolversTypes['AppraisalSeasonDTO'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isRequestValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes['MeetingTiny']>, ParentType, ContextType>;
  reasonForRequest?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reasonOfRejection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  requester?: Resolver<ResolversTypes['EmployeeDisplayTinyInfo'], ParentType, ContextType>;
  reviewer?: Resolver<ResolversTypes['EmployeeDisplayTinyInfo'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeetingRequestStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MeetingType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingStep'] = ResolversParentTypes['MeetingStep']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  meeting?: Resolver<Maybe<ResolversTypes['Meeting']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeetingStepStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MeetingStepType'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  viewId?: Resolver<ResolversTypes['MeetingStepViewId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MeetingTinyResolvers<ContextType = any, ParentType extends ResolversParentTypes['MeetingTiny'] = ResolversParentTypes['MeetingTiny']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptRequestedMeeting?: Resolver<ResolversTypes['MeetingRequestDTO'], ParentType, ContextType, RequireFields<MutationAcceptRequestedMeetingArgs, 'meetingInput' | 'requestedMeetingId'>>;
  addDownloaderRoleToEmployee?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationAddDownloaderRoleToEmployeeArgs, 'employeeId'>>;
  addEmployeeTag?: Resolver<ResolversTypes['EmployeeTagInfoShort'], ParentType, ContextType, RequireFields<MutationAddEmployeeTagArgs, 'employeeId' | 'type'>>;
  addEntryLevelLowTag?: Resolver<ResolversTypes['EmployeeTagInfoShort'], ParentType, ContextType, RequireFields<MutationAddEntryLevelLowTagArgs, 'employeeId'>>;
  addHrRoleToEmployee?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationAddHrRoleToEmployeeArgs, 'employeeId' | 'hrVisibilityExcluded' | 'roleName'>>;
  cancelMeeting?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType, RequireFields<MutationCancelMeetingArgs, 'employeeId' | 'meetingId' | 'reasonForMeetingCancel'>>;
  changeLocale?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChangeLocaleArgs, 'employeeId' | 'locale'>>;
  changeNameDisplayPreference?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChangeNameDisplayPreferenceArgs, 'employeeId' | 'nameDisplayPreference'>>;
  changeTimezone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChangeTimezoneArgs, 'employeeId' | 'timezone'>>;
  closeOutdatedTargets?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCloseOutdatedTargetsArgs, 'meetingId'>>;
  confirmRankingSeason?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationConfirmRankingSeasonArgs, 'talentsSeasonId'>>;
  confirmTagAssignmentForCompanyCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationConfirmTagAssignmentForCompanyCountryArgs, 'companyId' | 'country'>>;
  createAttentionPoint?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateAttentionPointArgs, 'description' | 'employeeId'>>;
  createCompanyRanking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateCompanyRankingArgs, 'companyId' | 'year'>>;
  createHRBPRelation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateHrbpRelationArgs, 'companyIds' | 'employeeId'>>;
  createKudos?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateKudosArgs, 'description' | 'employeeId'>>;
  createOrUpdateChange?: Resolver<ResolversTypes['CreateChangeResponse'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateChangeArgs, 'change' | 'employeeId'>>;
  createOrUpdateDraftScoreGrid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateDraftScoreGridArgs, 'companyId' | 'country' | 'draftScoreGridInput' | 'employeeId'>>;
  createOrUpdateObjectivePayment?: Resolver<ResolversTypes['ObjectivePayment'], ParentType, ContextType, RequireFields<MutationCreateOrUpdateObjectivePaymentArgs, 'objectivePayment'>>;
  createOrUpdateOneOffPayment?: Resolver<Maybe<ResolversTypes['OneOffPayment']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateOneOffPaymentArgs, 'oneOffPayment'>>;
  createOrUpdateTargetCorrectionPayment?: Resolver<Maybe<ResolversTypes['TargetCorrectionPaymentDto']>, ParentType, ContextType, RequireFields<MutationCreateOrUpdateTargetCorrectionPaymentArgs, 'targetCorrectionPayment'>>;
  createReviewerOfEmployee?: Resolver<ResolversTypes['ReviewerOfEmployees'], ParentType, ContextType, RequireFields<MutationCreateReviewerOfEmployeeArgs, 'revEmpInput'>>;
  createZipWithSelectedRankingReports?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateZipWithSelectedRankingReportsArgs, 'reportIds'>>;
  declineRequestedMeeting?: Resolver<ResolversTypes['MeetingRequestDTO'], ParentType, ContextType, RequireFields<MutationDeclineRequestedMeetingArgs, 'reasonOfRejection' | 'requestedMeetingId'>>;
  deleteAttentionPoint?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteAttentionPointArgs, 'attentionPointId'>>;
  deleteChange?: Resolver<ResolversTypes['DeleteOk'], ParentType, ContextType, RequireFields<MutationDeleteChangeArgs, 'changeId' | 'employeeId'>>;
  deleteHRBPRelation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteHrbpRelationArgs, 'id'>>;
  deleteKudos?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteKudosArgs, 'kudosId'>>;
  deleteKudosCompanyCountryVisibility?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteKudosCompanyCountryVisibilityArgs, 'kudosCompanyCountryVisibilityId'>>;
  deleteObjectiveInMeeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteObjectiveInMeetingArgs, 'globalId' | 'meetingId'>>;
  deleteOneOffPayment?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationDeleteOneOffPaymentArgs, 'oneOffPaymentId'>>;
  deleteReferencedPyramids?: Resolver<ResolversTypes['DeleteOk'], ParentType, ContextType, RequireFields<MutationDeleteReferencedPyramidsArgs, 'companyId' | 'referencePyramidId'>>;
  deleteReviewerOfEmployee?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteReviewerOfEmployeeArgs, 'relationId'>>;
  deleteTargetCorrectionPayment?: Resolver<ResolversTypes['DeleteOk'], ParentType, ContextType, RequireFields<MutationDeleteTargetCorrectionPaymentArgs, 'targetCorrectionPaymentId'>>;
  deleteTargetTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteTargetTemplateArgs, 'companyId' | 'country' | 'objectiveId'>>;
  disableRankingSeasonForCompanyCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDisableRankingSeasonForCompanyCountryArgs, 'companyId' | 'country'>>;
  dismissObjectiveInMeeting?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType, RequireFields<MutationDismissObjectiveInMeetingArgs, 'id' | 'meetingId'>>;
  duplicateAndDismissObjectiveInMeeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDuplicateAndDismissObjectiveInMeetingArgs, 'meetingId' | 'objective'>>;
  duplicateObjectiveInMeeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDuplicateObjectiveInMeetingArgs, 'globalId' | 'meetingId'>>;
  duplicateTargetTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDuplicateTargetTemplateArgs, 'companyId' | 'country' | 'objectiveId'>>;
  editFlexibleBonusByEmployeeId?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationEditFlexibleBonusByEmployeeIdArgs, 'bonusAmount' | 'employeeId' | 'meetingId'>>;
  employeeCloseMeeting?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationEmployeeCloseMeetingArgs, 'closeMeetingInput'>>;
  employeeConfirmPreparation?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationEmployeeConfirmPreparationArgs, 'input' | 'meetingId'>>;
  enableRankingSeasonForCompanyCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationEnableRankingSeasonForCompanyCountryArgs, 'companyId' | 'country'>>;
  generateRankingReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationGenerateRankingReportArgs, 'reportId'>>;
  generateTargetReportRequest?: Resolver<ResolversTypes['TargetReportGenerationRequestDTO'], ParentType, ContextType, RequireFields<MutationGenerateTargetReportRequestArgs, 'companyId' | 'country'>>;
  hrManageMeeting?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationHrManageMeetingArgs, 'hrManageMeetingInput'>>;
  importScoreGrids?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationImportScoreGridsArgs, 'buIds' | 'companyId' | 'country' | 'excelData'>>;
  importSelectableNationalContractReferenceLevels?: Resolver<Array<ResolversTypes['NationalContractReferenceWithTypeDTO']>, ParentType, ContextType, RequireFields<MutationImportSelectableNationalContractReferenceLevelsArgs, 'input'>>;
  inviteToAppraisalMeeting?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationInviteToAppraisalMeetingArgs, 'meetingInput'>>;
  login?: Resolver<Maybe<ResolversTypes['AuthPayload']>, ParentType, ContextType, RequireFields<MutationLoginArgs, 'user'>>;
  logout?: Resolver<Maybe<ResolversTypes['LogoutOk']>, ParentType, ContextType, RequireFields<MutationLogoutArgs, 'doLogout'>>;
  managerCloseMeeting?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationManagerCloseMeetingArgs, 'closeMeetingInput'>>;
  managerConfirmPreparation?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationManagerConfirmPreparationArgs, 'meetingId'>>;
  managerForceMeetingConfirmation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationManagerForceMeetingConfirmationArgs, 'meetingId' | 'reason'>>;
  otherMeetingConfirmAsManager?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationOtherMeetingConfirmAsManagerArgs, 'employeeId' | 'meetingId' | 'protocol' | 'reviewerEmployeeId'>>;
  otherMeetingFinishPreparation?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationOtherMeetingFinishPreparationArgs, 'asManager' | 'employeeId' | 'meetingId' | 'notes' | 'reviewerEmployeeId'>>;
  otherMeetingInvite?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationOtherMeetingInviteArgs, 'meetingInput'>>;
  reactiveObjectiveInMeeting?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType, RequireFields<MutationReactiveObjectiveInMeetingArgs, 'id' | 'meetingId'>>;
  refreshEmployeeSkillStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRefreshEmployeeSkillStatusArgs, 'id'>>;
  refreshEmployeesOfBUSkillStatuses?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRefreshEmployeesOfBuSkillStatusesArgs, 'businessUnitId'>>;
  refreshEmployeesOfCompanySkillStatuses?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRefreshEmployeesOfCompanySkillStatusesArgs, 'companyId' | 'country'>>;
  refreshMySkillStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRefreshMySkillStatusArgs, 'id'>>;
  refreshSubordinatesOfCompanySkillStatuses?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRefreshSubordinatesOfCompanySkillStatusesArgs, 'companyId'>>;
  refreshSubordinatesSkillStatuses?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRefreshSubordinatesSkillStatusesArgs, 'companyId' | 'reviewer'>>;
  removeDownloaderRoleFromEmployee?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationRemoveDownloaderRoleFromEmployeeArgs, 'employeeId'>>;
  removeEmployeeTag?: Resolver<ResolversTypes['EmployeeTagInfoShort'], ParentType, ContextType, RequireFields<MutationRemoveEmployeeTagArgs, 'removeEmployeeTagInput'>>;
  removeHrRoleFromEmployee?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationRemoveHrRoleFromEmployeeArgs, 'countryRoleName' | 'employeeId' | 'roleIds'>>;
  requestMeetingAsEmployee?: Resolver<ResolversTypes['MeetingRequestDTO'], ParentType, ContextType, RequireFields<MutationRequestMeetingAsEmployeeArgs, 'meetingReason' | 'meetingType' | 'requesterId' | 'reviewerId'>>;
  rescheduleMeeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRescheduleMeetingArgs, 'rescheduleInput'>>;
  saveObjective?: Resolver<ResolversTypes['ObjectiveDTO'], ParentType, ContextType, RequireFields<MutationSaveObjectiveArgs, 'employeeId' | 'objective'>>;
  saveObjectiveInMeeting?: Resolver<ResolversTypes['ObjectiveDTO'], ParentType, ContextType, RequireFields<MutationSaveObjectiveInMeetingArgs, 'meetingId' | 'objective'>>;
  savePyramidForecast?: Resolver<Array<ResolversTypes['PyramidForecastDTO']>, ParentType, ContextType, RequireFields<MutationSavePyramidForecastArgs, 'companyId' | 'pyramidForecasts'>>;
  saveRanking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSaveRankingArgs, 'companyId' | 'ranks' | 'talentsSeasonId'>>;
  saveScoreGrid?: Resolver<ResolversTypes['ScoreGridDto'], ParentType, ContextType, RequireFields<MutationSaveScoreGridArgs, 'grid' | 'meetingId'>>;
  saveTargetBonusAmountDistribution?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSaveTargetBonusAmountDistributionArgs, 'meetingId' | 'objectivesDistributedAmountInput'>>;
  saveTargetTemplate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSaveTargetTemplateArgs, 'companyId' | 'country' | 'objective'>>;
  sendSkillStatusUpdateReminderEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendSkillStatusUpdateReminderEmailArgs, 'employeeId'>>;
  setCutoffDayForCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetCutoffDayForCountryArgs, 'country' | 'cutoffDay'>>;
  setDisableRankingForCompanyCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetDisableRankingForCompanyCountryArgs, 'companyId' | 'country' | 'isDisabled'>>;
  setIsTagAssignmentInProgressForCompanyCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetIsTagAssignmentInProgressForCompanyCountryArgs, 'companyId' | 'country' | 'isEnabled'>>;
  setKudosCompanyCountryVisibility?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetKudosCompanyCountryVisibilityArgs, 'kudosCompanyCountryVisibilityInput'>>;
  setKudosLegalEntityVisibility?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetKudosLegalEntityVisibilityArgs, 'kudosLegalEntityVisibilityInput'>>;
  setLowPercentageForCompanyCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetLowPercentageForCompanyCountryArgs, 'companyId' | 'country' | 'lowPercentage'>>;
  setLowPercentageIsBlockerForCompanyCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetLowPercentageIsBlockerForCompanyCountryArgs, 'companyId' | 'country' | 'lowPercentageIsBlocker'>>;
  setNextAppraisalSeasonOpeningDate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetNextAppraisalSeasonOpeningDateArgs, 'companyId' | 'country' | 'openingMonth' | 'openingYear' | 'year'>>;
  setNextMeetingStep?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationSetNextMeetingStepArgs, 'currentStepStatus' | 'id' | 'nextStepId' | 'stepType'>>;
  setTopPercentageForCompanyCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetTopPercentageForCompanyCountryArgs, 'companyId' | 'country' | 'topPercentage'>>;
  takeOver?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationTakeOverArgs, 'meetingId'>>;
  updateEmployeeOptOutValue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateEmployeeOptOutValueArgs, 'employeeId' | 'newOptOutValue'>>;
  updateMeetingFeedback?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<MutationUpdateMeetingFeedbackArgs, 'feedback' | 'meetingId'>>;
  updateMeetingNotes?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateMeetingNotesArgs, 'meetingId' | 'notes'>>;
  updateMeetingStep?: Resolver<ResolversTypes['MeetingStep'], ParentType, ContextType, RequireFields<MutationUpdateMeetingStepArgs, 'id' | 'newStepStatus'>>;
  updateMyOptOutValue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateMyOptOutValueArgs, 'newOptOutValue'>>;
  updateOnboardingDate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updateRankingSeason?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateRankingSeasonArgs, 'talentsSeasonInput'>>;
  updateReferencedPyramids?: Resolver<ResolversTypes['ReferencePyramid'], ParentType, ContextType, RequireFields<MutationUpdateReferencedPyramidsArgs, 'referencePyramid'>>;
  updateSelectableNationalContractReferenceLevels?: Resolver<ResolversTypes['NationalContractReferenceWithTypeDTO'], ParentType, ContextType, RequireFields<MutationUpdateSelectableNationalContractReferenceLevelsArgs, 'input'>>;
  updateSelfreflectionQuestion?: Resolver<ResolversTypes['SelfreflectionQuestion'], ParentType, ContextType, RequireFields<MutationUpdateSelfreflectionQuestionArgs, 'selfreflectionQuestion'>>;
  updateSelfreflectionQuestionBoolean?: Resolver<ResolversTypes['SelfreflectionQuestionBoolean'], ParentType, ContextType, RequireFields<MutationUpdateSelfreflectionQuestionBooleanArgs, 'selfreflectionQuestionBoolean'>>;
  uploadObjectiveAttachment?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUploadObjectiveAttachmentArgs, 'employeeIdOfMeetingNotLoggedInEmployeeId' | 'file'>>;
  withdrawRequestedMeeting?: Resolver<ResolversTypes['DeleteOk'], ParentType, ContextType, RequireFields<MutationWithdrawRequestedMeetingArgs, 'employeeId' | 'requestId'>>;
};

export type NationalContractEmployeeLevelDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['NationalContractEmployeeLevelDTO'] = ResolversParentTypes['NationalContractEmployeeLevelDTO']> = {
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['NationalContractLevelEnum'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['NationalContractType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NationalContractEmployeeLevelHistoryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['NationalContractEmployeeLevelHistoryDTO'] = ResolversParentTypes['NationalContractEmployeeLevelHistoryDTO']> = {
  nationalContractEmployeeLevelHistory?: Resolver<Array<ResolversTypes['NationalContractEmployeeLevelDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NationalContractLevelResolvers<ContextType = any, ParentType extends ResolversParentTypes['NationalContractLevel'] = ResolversParentTypes['NationalContractLevel']> = {
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['NationalContractLevelEnum'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['NationalContractType'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NationalContractReferenceDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['NationalContractReferenceDTO'] = ResolversParentTypes['NationalContractReferenceDTO']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  levels?: Resolver<Array<ResolversTypes['NationalContractReferenceLevelDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NationalContractReferenceLevelDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['NationalContractReferenceLevelDTO'] = ResolversParentTypes['NationalContractReferenceLevelDTO']> = {
  displayOrder?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minSalary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  selectable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NationalContractReferenceWithTypeDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['NationalContractReferenceWithTypeDTO'] = ResolversParentTypes['NationalContractReferenceWithTypeDTO']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  levels?: Resolver<Array<ResolversTypes['NationalContractReferenceLevelDTO']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['NationalContractType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NetworkResolvers<ContextType = any, ParentType extends ResolversParentTypes['Network'] = ResolversParentTypes['Network']> = {
  clusterManagers?: Resolver<Maybe<Array<ResolversTypes['ManagerOfCluster']>>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companies?: Resolver<Maybe<Array<ResolversTypes['Company']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkManagers?: Resolver<Maybe<Array<ResolversTypes['ManagerOfNetwork']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewEntriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewEntries'] = ResolversParentTypes['NewEntries']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnitTiny'], ParentType, ContextType>;
  contractValidFrom?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentLevel?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewEntriesByPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewEntriesByPeriod'] = ResolversParentTypes['NewEntriesByPeriod']> = {
  currentMonth?: Resolver<Array<ResolversTypes['NewEntries']>, ParentType, ContextType>;
  previousMonth?: Resolver<Array<ResolversTypes['NewEntries']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NextBestActionMissingTargetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextBestActionMissingTargets'] = ResolversParentTypes['NextBestActionMissingTargets']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  employees?: Resolver<Array<ResolversTypes['EmployeeWithBonus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NextBestActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextBestActivity'] = ResolversParentTypes['NextBestActivity']> = {
  expiringLimitedContracts?: Resolver<ResolversTypes['NextBestActivityLimitedContractEnding'], ParentType, ContextType, RequireFields<NextBestActivityExpiringLimitedContractsArgs, 'period'>>;
  leavingSoon?: Resolver<ResolversTypes['NextBestActivityLeavingEmployees'], ParentType, ContextType, RequireFields<NextBestActivityLeavingSoonArgs, 'period'>>;
  missingTargets?: Resolver<ResolversTypes['NextBestActionMissingTargets'], ParentType, ContextType>;
  noMeeting?: Resolver<ResolversTypes['NextBestActivityNoMeeting'], ParentType, ContextType, RequireFields<NextBestActivityNoMeetingArgs, 'since'>>;
  onProbation?: Resolver<ResolversTypes['NextBestActivityProbationTalk'], ParentType, ContextType, RequireFields<NextBestActivityOnProbationArgs, 'onlyEmployeesInSecondHalfOfProbationPeriod'>>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NextBestActivityLeavingEmployeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextBestActivityLeavingEmployees'] = ResolversParentTypes['NextBestActivityLeavingEmployees']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  employees?: Resolver<Array<ResolversTypes['EmployeeWithEndingContract']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NextBestActivityLimitedContractEndingResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextBestActivityLimitedContractEnding'] = ResolversParentTypes['NextBestActivityLimitedContractEnding']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  employees?: Resolver<Array<ResolversTypes['EmployeeWithEndingContract']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NextBestActivityNoMeetingResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextBestActivityNoMeeting'] = ResolversParentTypes['NextBestActivityNoMeeting']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  employees?: Resolver<Array<ResolversTypes['EmployeeDisplayShortInfoWithLastMeeting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NextBestActivityProbationTalkResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextBestActivityProbationTalk'] = ResolversParentTypes['NextBestActivityProbationTalk']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  employees?: Resolver<Array<ResolversTypes['EmployeeOnProbation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoteInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoteInfo'] = ResolversParentTypes['NoteInfo']> = {
  author?: Resolver<ResolversTypes['EmployeeDisplayTinyInfo'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  globalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ObjectiveAttachmentInfoDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObjectiveAttachmentInfoDTO'] = ResolversParentTypes['ObjectiveAttachmentInfoDTO']> = {
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attachmentDownloadToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ObjectiveDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObjectiveDTO'] = ResolversParentTypes['ObjectiveDTO']> = {
  achievedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  appraisalSeason?: Resolver<ResolversTypes['AppraisalSeasonDTO'], ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attachmentDownloadToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  due?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  globalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  keyResults?: Resolver<Array<ResolversTypes['KeyResultDTO']>, ParentType, ContextType>;
  noteList?: Resolver<Array<ResolversTypes['NoteInfo']>, ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ObjectiveStatus'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  taskNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ObjectiveKeyResultDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObjectiveKeyResultDTO'] = ResolversParentTypes['ObjectiveKeyResultDTO']> = {
  displayOrder?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  globalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ObjectivePaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObjectivePayment'] = ResolversParentTypes['ObjectivePayment']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deduction?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deductionReason?: Resolver<Maybe<ResolversTypes['ObjectivePaymentManualDeductionReason']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  meetingId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  paymentDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  paymentDateValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ObjectivePaymentStatus']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ObjectiveTemplateDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObjectiveTemplateDTO'] = ResolversParentTypes['ObjectiveTemplateDTO']> = {
  creator?: Resolver<ResolversTypes['EmployeeDisplayTinyInfo'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastEditedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastModifier?: Resolver<ResolversTypes['EmployeeDisplayTinyInfo'], ParentType, ContextType>;
  objectiveKeyResults?: Resolver<Array<ResolversTypes['ObjectiveKeyResultDTO']>, ParentType, ContextType>;
  objectiveNotes?: Resolver<Array<ResolversTypes['NoteInfo']>, ParentType, ContextType>;
  objectiveTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingDataDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingDataDTO'] = ResolversParentTypes['OnboardingDataDTO']> = {
  authUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  damUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  queryParamsString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  redirectUrlQueryParamName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  setCookieUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OneOffPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OneOffPayment'] = ResolversParentTypes['OneOffPayment']> = {
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  meetingId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  paymentDateValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  resultAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OneOffPaymentStatus'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Option'] = ResolversParentTypes['Option']> = {
  children?: Resolver<Maybe<Array<ResolversTypes['Children']>>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PerBaseEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerBaseEntity'] = ResolversParentTypes['PerBaseEntity']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PermissionCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['PermissionCheck'] = ResolversParentTypes['PermissionCheck']> = {
  permit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonalProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonalProfile'] = ResolversParentTypes['PersonalProfile']> = {
  academicTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityListEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  address?: Resolver<Array<ResolversTypes['EmployeeAddress']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankAccount?: Resolver<Maybe<ResolversTypes['InternationalBankAccount']>, ParentType, ContextType>;
  branchOfficeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessUnit?: Resolver<Maybe<ResolversTypes['BusinessUnit']>, ParentType, ContextType>;
  chosenFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  citizenships?: Resolver<Array<ResolversTypes['Citizenship']>, ParentType, ContextType>;
  currentContractLevel?: Resolver<Maybe<ResolversTypes['ContractEmployeeLevel']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  education?: Resolver<Array<ResolversTypes['Education']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emergencyContacts?: Resolver<Array<ResolversTypes['EmergencyContact']>, ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  employeeTimezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employmentStatus?: Resolver<ResolversTypes['EmploymentStatus'], ParentType, ContextType>;
  legalFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalLastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  privateEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  skillCenterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skillStatus?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProbationPeriodEndingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProbationPeriodEnding'] = ResolversParentTypes['ProbationPeriodEnding']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnitTiny'], ParentType, ContextType>;
  currentLevel?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  probationPeriodEndDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProbationPeriodEndingByPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProbationPeriodEndingByPeriod'] = ResolversParentTypes['ProbationPeriodEndingByPeriod']> = {
  currentMonth?: Resolver<Array<ResolversTypes['ProbationPeriodEnding']>, ParentType, ContextType>;
  nextMonth?: Resolver<Array<ResolversTypes['ProbationPeriodEnding']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']> = {
  __resolveType: TypeResolveFn<'PersonalProfile' | 'PublicProfile', ParentType, ContextType>;
  academicTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityListEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  branchOfficeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentContractLevel?: Resolver<Maybe<ResolversTypes['ContractEmployeeLevel']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  education?: Resolver<Array<ResolversTypes['Education']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  employeeTimezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employmentStatus?: Resolver<ResolversTypes['EmploymentStatus'], ParentType, ContextType>;
  legalFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalLastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  skillCenterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skillStatus?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PublicProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicProfile'] = ResolversParentTypes['PublicProfile']> = {
  academicTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityListEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  branchOfficeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessUnit?: Resolver<Maybe<ResolversTypes['BusinessUnit']>, ParentType, ContextType>;
  chosenFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  currentContractLevel?: Resolver<Maybe<ResolversTypes['ContractEmployeeLevel']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  editable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  education?: Resolver<Array<ResolversTypes['Education']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  employeeTimezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employmentStatus?: Resolver<ResolversTypes['EmploymentStatus'], ParentType, ContextType>;
  legalFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalLastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  meetings?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  skillCenterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skillStatus?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PyramidForecastDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PyramidForecastDTO'] = ResolversParentTypes['PyramidForecastDTO']> = {
  age?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bonus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  businessUnitId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  businessUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  careerPath?: Resolver<Maybe<ResolversTypes['CareerPathEvaluation']>, ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  currencyForPayments?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  currentEmployeeLevel?: Resolver<Maybe<ResolversTypes['EmployeeLevelEnum']>, ParentType, ContextType>;
  dateOfLevelChange?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  employeeFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employeeId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  employeeTimezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  forecastDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  forecastEndDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  forecastId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  levelChange?: Resolver<Maybe<ResolversTypes['EmployeeLevelEnum']>, ParentType, ContextType>;
  newHiringFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['EmployeeTagType']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PyramidForecastFiltersDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PyramidForecastFiltersDTO'] = ResolversParentTypes['PyramidForecastFiltersDTO']> = {
  businessUnits?: Resolver<Array<ResolversTypes['BusinessUnitTiny']>, ParentType, ContextType>;
  employees?: Resolver<Array<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PyramidForecastValueDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PyramidForecastValueDto'] = ResolversParentTypes['PyramidForecastValueDto']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PyramidForecastValuesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PyramidForecastValues'] = ResolversParentTypes['PyramidForecastValues']> = {
  ageValues?: Resolver<Array<ResolversTypes['PyramidForecastValueDto']>, ParentType, ContextType>;
  decrease?: Resolver<Array<ResolversTypes['PyramidValueLevelDecrease']>, ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['PyramidForecastValueDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PyramidForecastWithFiltersDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PyramidForecastWithFiltersDTO'] = ResolversParentTypes['PyramidForecastWithFiltersDTO']> = {
  activeEmployees?: Resolver<Array<ResolversTypes['PyramidForecastDTO']>, ParentType, ContextType>;
  careerPath?: Resolver<Maybe<Array<ResolversTypes['CareerPathDto']>>, ParentType, ContextType>;
  filters?: Resolver<ResolversTypes['PyramidForecastFiltersDTO'], ParentType, ContextType>;
  newHirings?: Resolver<Array<ResolversTypes['PyramidForecastDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PyramidSelectorYearAndMonthResolvers<ContextType = any, ParentType extends ResolversParentTypes['PyramidSelectorYearAndMonth'] = ResolversParentTypes['PyramidSelectorYearAndMonth']> = {
  options?: Resolver<Maybe<Array<ResolversTypes['Option']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PyramidValueDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PyramidValueDto'] = ResolversParentTypes['PyramidValueDto']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  displayOrder?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PyramidValueLevelDecreaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PyramidValueLevelDecrease'] = ResolversParentTypes['PyramidValueLevelDecrease']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  activeEmployeesOfCompany?: Resolver<Maybe<Array<ResolversTypes['EmployeeWithBusinessUnit']>>, ParentType, ContextType, RequireFields<QueryActiveEmployeesOfCompanyArgs, 'companyId'>>;
  activeEmployeesOfCompanyWithoutPartners?: Resolver<Maybe<Array<ResolversTypes['EmployeeWithBusinessUnit']>>, ParentType, ContextType, RequireFields<QueryActiveEmployeesOfCompanyWithoutPartnersArgs, 'companyId'>>;
  activeEmployeesSearch?: Resolver<Array<ResolversTypes['EmployeeSearch']>, ParentType, ContextType, RequireFields<QueryActiveEmployeesSearchArgs, 'kudosView' | 'search'>>;
  activeSubordinatesOfBuManager?: Resolver<Array<ResolversTypes['EmployeeWithBusinessUnit']>, ParentType, ContextType, RequireFields<QueryActiveSubordinatesOfBuManagerArgs, 'buId'>>;
  addressChangesByEmployee?: Resolver<Maybe<Array<ResolversTypes['Change']>>, ParentType, ContextType, RequireFields<QueryAddressChangesByEmployeeArgs, 'employeeId'>>;
  allReviewersByEmployeeId?: Resolver<Array<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType, RequireFields<QueryAllReviewersByEmployeeIdArgs, 'employeeId'>>;
  anyone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  appraisalSeasonOptionByEmployeeId?: Resolver<ResolversTypes['AppraisalSeasonDTO'], ParentType, ContextType, RequireFields<QueryAppraisalSeasonOptionByEmployeeIdArgs, 'employeeId'>>;
  appraisalsOfEmployeeByYear?: Resolver<Array<ResolversTypes['AppraisalDisplayInfo']>, ParentType, ContextType, RequireFields<QueryAppraisalsOfEmployeeByYearArgs, 'appraisalSeasonYear' | 'employeeId' | 'latestMeetingId'>>;
  areKudosVisibleForMe?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  branchOfficeByEmployee?: Resolver<ResolversTypes['BranchOffice'], ParentType, ContextType, RequireFields<QueryBranchOfficeByEmployeeArgs, 'employeeId'>>;
  careerPath?: Resolver<Maybe<Array<ResolversTypes['CareerPathDto']>>, ParentType, ContextType, RequireFields<QueryCareerPathArgs, 'country'>>;
  careerPathEvaluation?: Resolver<Maybe<ResolversTypes['CareerPathEvaluation']>, ParentType, ContextType, RequireFields<QueryCareerPathEvaluationArgs, 'employeeId'>>;
  careerPathEvaluationByMeetingId?: Resolver<Maybe<ResolversTypes['CareerPathEvaluation']>, ParentType, ContextType, RequireFields<QueryCareerPathEvaluationByMeetingIdArgs, 'meetingId'>>;
  checkChatbotPermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  checkCompanyManagerOfCompany?: Resolver<ResolversTypes['PermissionCheck'], ParentType, ContextType, RequireFields<QueryCheckCompanyManagerOfCompanyArgs, 'companyId'>>;
  checkOnboardingPermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  checkVisibilityOnboarding?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  companiesAndBusinessUnitsByEmployee?: Resolver<Array<ResolversTypes['CompanyAndBu']>, ParentType, ContextType, RequireFields<QueryCompaniesAndBusinessUnitsByEmployeeArgs, 'id'>>;
  companiesOfUser?: Resolver<Array<ResolversTypes['ManagedCompany']>, ParentType, ContextType>;
  companyManagerDashboardASYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardAsYearArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardAppraisalMeetingStatus?: Resolver<ResolversTypes['CompanyManagerAppraisalMeetingStatusDTO'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardAppraisalMeetingStatusArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardBoOfCompany?: Resolver<ResolversTypes['BOofCompanyDTO'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardBoOfCompanyArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardBuOfCompany?: Resolver<ResolversTypes['BUofCompanyDTO'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardBuOfCompanyArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardBubobumCounters?: Resolver<ResolversTypes['BUBOBUMcountersDTO'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardBubobumCountersArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardBumOfCompany?: Resolver<ResolversTypes['BUMOfCompanyDTO'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardBumOfCompanyArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardListOfCompanies?: Resolver<Array<ResolversTypes['DashboardListOfCompanies']>, ParentType, ContextType>;
  companyManagerDashboardPartialVisibility?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardPartialVisibilityArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardWorkforceCounters?: Resolver<ResolversTypes['DashboardWorkforceCountersDTO'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardWorkforceCountersArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardWorkforceLeavers?: Resolver<ResolversTypes['LeaversByPeriod'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardWorkforceLeaversArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardWorkforceNewEntries?: Resolver<ResolversTypes['NewEntriesByPeriod'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardWorkforceNewEntriesArgs, 'companyId' | 'userDashboardRoles'>>;
  companyManagerDashboardWorkforceProbationPeriodEnding?: Resolver<ResolversTypes['ProbationPeriodEndingByPeriod'], ParentType, ContextType, RequireFields<QueryCompanyManagerDashboardWorkforceProbationPeriodEndingArgs, 'companyId' | 'userDashboardRoles'>>;
  companyPartners?: Resolver<Array<ResolversTypes['Employee']>, ParentType, ContextType, RequireFields<QueryCompanyPartnersArgs, 'employeeId'>>;
  companyRankingSettingsForCountry?: Resolver<ResolversTypes['CompanyRankingSettingsDTO'], ParentType, ContextType, RequireFields<QueryCompanyRankingSettingsForCountryArgs, 'companyId' | 'country'>>;
  companyRankings?: Resolver<Array<ResolversTypes['EmployeeRanking']>, ParentType, ContextType, RequireFields<QueryCompanyRankingsArgs, 'companyId'>>;
  companySearch?: Resolver<Array<ResolversTypes['CompanyTiny']>, ParentType, ContextType, RequireFields<QueryCompanySearchArgs, 'companyScope' | 'limit' | 'search'>>;
  contractChangeValidationList?: Resolver<ResolversTypes['ContractChangeValidationList'], ParentType, ContextType, RequireFields<QueryContractChangeValidationListArgs, 'employeeId'>>;
  contractChangesByEmployee?: Resolver<Array<ResolversTypes['Change']>, ParentType, ContextType, RequireFields<QueryContractChangesByEmployeeArgs, 'employeeId'>>;
  contractEmployeeLevelsByContractId?: Resolver<ResolversTypes['ContractEmployeeLevelHistoryDTO'], ParentType, ContextType, RequireFields<QueryContractEmployeeLevelsByContractIdArgs, 'id'>>;
  contractEmployeeLevelsByEmployeeId?: Resolver<ResolversTypes['ContractEmployeeLevelHistoryDTO'], ParentType, ContextType, RequireFields<QueryContractEmployeeLevelsByEmployeeIdArgs, 'employeeId'>>;
  contractGovernmentJobTitleHistoryByEmployeeId?: Resolver<Array<ResolversTypes['ContractGovernmentJobTitle']>, ParentType, ContextType, RequireFields<QueryContractGovernmentJobTitleHistoryByEmployeeIdArgs, 'employeeId'>>;
  contractsInYear?: Resolver<Array<ResolversTypes['Contract']>, ParentType, ContextType, RequireFields<QueryContractsInYearArgs, 'employeeId' | 'year'>>;
  countriesOfLegalEntities?: Resolver<Maybe<Array<ResolversTypes['Country']>>, ParentType, ContextType>;
  currentAppraisalSeason?: Resolver<ResolversTypes['AppraisalSeasonDTO'], ParentType, ContextType, RequireFields<QueryCurrentAppraisalSeasonArgs, 'companyId' | 'country'>>;
  currentContract?: Resolver<ResolversTypes['LatestContractDTO'], ParentType, ContextType, RequireFields<QueryCurrentContractArgs, 'employeeId'>>;
  currentContractsHistory?: Resolver<ResolversTypes['Contract'], ParentType, ContextType, RequireFields<QueryCurrentContractsHistoryArgs, 'employeeId'>>;
  educationChangesByEmployee?: Resolver<Maybe<Array<ResolversTypes['Change']>>, ParentType, ContextType, RequireFields<QueryEducationChangesByEmployeeArgs, 'employeeId'>>;
  employee?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType, RequireFields<QueryEmployeeArgs, 'checkPermissions' | 'id'>>;
  employeeDisplayShortInfoByEmployeeId?: Resolver<Maybe<ResolversTypes['EmployeeDisplayShortInfo']>, ParentType, ContextType, RequireFields<QueryEmployeeDisplayShortInfoByEmployeeIdArgs, 'id'>>;
  employeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager?: Resolver<Maybe<ResolversTypes['EmployeeDisplayShortInfoMeetingInvite']>, ParentType, ContextType>;
  employeeDisplayTinyInfoByEmployeeId?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType, RequireFields<QueryEmployeeDisplayTinyInfoByEmployeeIdArgs, 'id'>>;
  employeeHasOngoingAppraisal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryEmployeeHasOngoingAppraisalArgs, 'replyerId'>>;
  employees?: Resolver<Maybe<Array<ResolversTypes['Employee']>>, ParentType, ContextType>;
  employeesAndTags?: Resolver<Array<ResolversTypes['EmployeeAndTag']>, ParentType, ContextType, RequireFields<QueryEmployeesAndTagsArgs, 'companyId' | 'country'>>;
  employeesAndTagsWithRankingDisabled?: Resolver<Array<ResolversTypes['EmployeeAndTag']>, ParentType, ContextType, RequireFields<QueryEmployeesAndTagsWithRankingDisabledArgs, 'companyId' | 'country'>>;
  employeesWithHrOrDownloaderRole?: Resolver<Array<ResolversTypes['EmployeeWithRole']>, ParentType, ContextType>;
  employmentStatusOfEmployee?: Resolver<ResolversTypes['EmployeeEmploymentStatusDTO'], ParentType, ContextType, RequireFields<QueryEmploymentStatusOfEmployeeArgs, 'employeeId'>>;
  evaluationFromLastTwoAppraisals?: Resolver<Maybe<ResolversTypes['ScoreGridsOverviewDTO']>, ParentType, ContextType, RequireFields<QueryEvaluationFromLastTwoAppraisalsArgs, 'employeeId'>>;
  excecutedPaymentsByContractId?: Resolver<ResolversTypes['ExecutedPaymentHistoryDTO'], ParentType, ContextType, RequireFields<QueryExcecutedPaymentsByContractIdArgs, 'id'>>;
  excecutedPaymentsByEmployeeId?: Resolver<ResolversTypes['ExecutedPaymentHistoryDTO'], ParentType, ContextType, RequireFields<QueryExcecutedPaymentsByEmployeeIdArgs, 'employeeId'>>;
  existingDevObjectivesToBeClosedInMeeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryExistingDevObjectivesToBeClosedInMeetingArgs, 'meetingId'>>;
  featureDisclaimerData?: Resolver<Maybe<ResolversTypes['FeatureMaintenanceData']>, ParentType, ContextType>;
  featureToggles?: Resolver<Array<ResolversTypes['FeatureToggle']>, ParentType, ContextType>;
  findActiveLegalEntities?: Resolver<Array<ResolversTypes['LegalEntity']>, ParentType, ContextType, Partial<QueryFindActiveLegalEntitiesArgs>>;
  findBonusByEmployeeIdInAppraisalSeasonOfMeeting?: Resolver<Maybe<ResolversTypes['BonusBetweenAnnualBonusAndProrataDTO']>, ParentType, ContextType, RequireFields<QueryFindBonusByEmployeeIdInAppraisalSeasonOfMeetingArgs, 'employeeId' | 'meetingId'>>;
  findCompaniesAndCountriesByCompanyManager?: Resolver<Array<ResolversTypes['GroupedCompanyWithLegalEntitiesAndCountries']>, ParentType, ContextType, Partial<QueryFindCompaniesAndCountriesByCompanyManagerArgs>>;
  findCompaniesAndCountriesByCompanyManagerOrResponsible?: Resolver<Array<ResolversTypes['GroupedCompanyWithLegalEntitiesAndCountries']>, ParentType, ContextType>;
  findCompaniesAndCountriesByManagerOrResponsible?: Resolver<Array<ResolversTypes['GroupedCompanyWithLegalEntitiesAndCountries']>, ParentType, ContextType, RequireFields<QueryFindCompaniesAndCountriesByManagerOrResponsibleArgs, 'businessPartnerVisibility'>>;
  findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP?: Resolver<Array<ResolversTypes['GroupedCompanyWithLegalEntitiesAndCountries']>, ParentType, ContextType>;
  findCompaniesAndCountriesByResponsible?: Resolver<Array<ResolversTypes['GroupedCompanyWithLegalEntitiesAndCountries']>, ParentType, ContextType>;
  findCompaniesByManagerOrResponsible?: Resolver<Array<ResolversTypes['CompanyTiny']>, ParentType, ContextType, RequireFields<QueryFindCompaniesByManagerOrResponsibleArgs, 'businessPartnerVisibility'>>;
  findCountriesHrIsResponsibleOf?: Resolver<Array<ResolversTypes['Country']>, ParentType, ContextType>;
  findCurrentBusinessUnitsByCompanyId?: Resolver<Array<ResolversTypes['BusinessUnitTiny']>, ParentType, ContextType, RequireFields<QueryFindCurrentBusinessUnitsByCompanyIdArgs, 'companyId' | 'country'>>;
  findPastYearFlexibleBonusByEmployeeIdAndMeetingId?: Resolver<Maybe<ResolversTypes['BonusBetweenAnnualBonusAndProrataDTO']>, ParentType, ContextType, RequireFields<QueryFindPastYearFlexibleBonusByEmployeeIdAndMeetingIdArgs, 'employeeId' | 'meetingId'>>;
  findPossibleYearsAndCompaniesForRankingReport?: Resolver<ResolversTypes['YearsAndCompaniesForRankingReportDTO'], ParentType, ContextType, Partial<QueryFindPossibleYearsAndCompaniesForRankingReportArgs>>;
  findReportsInDownloadsViewByCountryAndType?: Resolver<ResolversTypes['ReportPaginationDTO'], ParentType, ContextType, RequireFields<QueryFindReportsInDownloadsViewByCountryAndTypeArgs, 'countries' | 'pagination' | 'reportType'>>;
  findTalentsSeasonsYears?: Resolver<Array<ResolversTypes['TalentsSeasonYearDTO']>, ParentType, ContextType, RequireFields<QueryFindTalentsSeasonsYearsArgs, 'companyId' | 'country'>>;
  findTargetReportsByCountryAndCompany?: Resolver<Array<ResolversTypes['ReportDTO']>, ParentType, ContextType, RequireFields<QueryFindTargetReportsByCountryAndCompanyArgs, 'companyId' | 'country'>>;
  findUserManagerRolesByCompany?: Resolver<Array<ResolversTypes['RoleName']>, ParentType, ContextType, RequireFields<QueryFindUserManagerRolesByCompanyArgs, 'companyId'>>;
  findUserManagerRolesByEmployee?: Resolver<Array<ResolversTypes['RoleName']>, ParentType, ContextType, RequireFields<QueryFindUserManagerRolesByEmployeeArgs, 'employeeId'>>;
  fullMeetingPreview?: Resolver<ResolversTypes['FullMeetingPreviewDTO'], ParentType, ContextType, RequireFields<QueryFullMeetingPreviewArgs, 'employeeId' | 'isAppraisalUpdate' | 'meetingId'>>;
  getAllAttentionPoints?: Resolver<ResolversTypes['KudosShowMoreDTO'], ParentType, ContextType, RequireFields<QueryGetAllAttentionPointsArgs, 'filters'>>;
  getAllKudos?: Resolver<ResolversTypes['KudosShowMoreDTO'], ParentType, ContextType, RequireFields<QueryGetAllKudosArgs, 'filters'>>;
  getAppraisalSeasonOpeningInfo?: Resolver<ResolversTypes['AppraisalSeasonOpeningInfoDTO'], ParentType, ContextType, RequireFields<QueryGetAppraisalSeasonOpeningInfoArgs, 'companyId' | 'country'>>;
  getAppraisalsWithFeedbackByCountryAndFilters?: Resolver<ResolversTypes['AppraisalWithFeedbackPagination'], ParentType, ContextType, RequireFields<QueryGetAppraisalsWithFeedbackByCountryAndFiltersArgs, 'country' | 'filters' | 'pagination'>>;
  getAppraisalsWithFeedbackToResolveCounterByCountry?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetAppraisalsWithFeedbackToResolveCounterByCountryArgs, 'country'>>;
  getAttentionPointsForEmployee?: Resolver<ResolversTypes['KudosPaginationDTO'], ParentType, ContextType, RequireFields<QueryGetAttentionPointsForEmployeeArgs, 'employeeId' | 'pagination'>>;
  getCountriesAndReportGenerationFlags?: Resolver<Array<ResolversTypes['CountryAndReportGenerationFlags']>, ParentType, ContextType>;
  getCountriesList?: Resolver<Array<ResolversTypes['Country']>, ParentType, ContextType>;
  getCountriesWhereReportGenerationIsActive?: Resolver<Array<ResolversTypes['Country']>, ParentType, ContextType, RequireFields<QueryGetCountriesWhereReportGenerationIsActiveArgs, 'reportType'>>;
  getCountriesWithAgePyramidVisibleFlag?: Resolver<Array<ResolversTypes['CountryWithAgePyramidVisibleFlag']>, ParentType, ContextType>;
  getCountriesWithBranchOfficeVisibleFlag?: Resolver<Array<ResolversTypes['CountryWithBranchOfficeVisibleFlag']>, ParentType, ContextType>;
  getCountryEmployeeLevels?: Resolver<Array<ResolversTypes['EmployeeLevelEnum']>, ParentType, ContextType, RequireFields<QueryGetCountryEmployeeLevelsArgs, 'country'>>;
  getCountryEmployeeLevelsWithOrder?: Resolver<Array<ResolversTypes['EmployeeLevelWithDisplayOrder']>, ParentType, ContextType, RequireFields<QueryGetCountryEmployeeLevelsWithOrderArgs, 'country'>>;
  getCountrySettings?: Resolver<ResolversTypes['CountrySettingsDto'], ParentType, ContextType, RequireFields<QueryGetCountrySettingsArgs, 'country'>>;
  getCurrencyConversionsByEmployee?: Resolver<ResolversTypes['CurrencyConversionWithContractCurrencyDTO'], ParentType, ContextType, RequireFields<QueryGetCurrencyConversionsByEmployeeArgs, 'employeeId'>>;
  getDraftOrLatestScoreGridByEmployee?: Resolver<Maybe<ResolversTypes['ScoreGridDto']>, ParentType, ContextType, RequireFields<QueryGetDraftOrLatestScoreGridByEmployeeArgs, 'companyId' | 'country' | 'employeeId'>>;
  getEmployeeSkillStatusInMeeting?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType, RequireFields<QueryGetEmployeeSkillStatusInMeetingArgs, 'id'>>;
  getEmployeesWithLatestAndDraftScoreGrid?: Resolver<Array<ResolversTypes['EmployeeWithLatestAndDraftEvaluation']>, ParentType, ContextType, RequireFields<QueryGetEmployeesWithLatestAndDraftScoreGridArgs, 'companyId' | 'country'>>;
  getHrBusinessPartnersByCountry?: Resolver<Array<ResolversTypes['ActiveHRBusinessPartnerDTO']>, ParentType, ContextType, RequireFields<QueryGetHrBusinessPartnersByCountryArgs, 'country'>>;
  getIdVWeightsByCountry?: Resolver<Array<ResolversTypes['IdvWeightDto']>, ParentType, ContextType, RequireFields<QueryGetIdVWeightsByCountryArgs, 'companyId' | 'country'>>;
  getKudosCompanyCountryVisibilityData?: Resolver<ResolversTypes['KudosCompanyCountryVisibilityShowMoreDTO'], ParentType, ContextType, RequireFields<QueryGetKudosCompanyCountryVisibilityDataArgs, 'filters'>>;
  getKudosForEmployee?: Resolver<ResolversTypes['KudosWithVisibilityFlagDTO'], ParentType, ContextType, RequireFields<QueryGetKudosForEmployeeArgs, 'employeeId' | 'pagination'>>;
  getKudosForEmployeeInAppraisal?: Resolver<ResolversTypes['KudosWithVisibilityFlagDTO'], ParentType, ContextType, RequireFields<QueryGetKudosForEmployeeInAppraisalArgs, 'appraisalInput' | 'employeeId'>>;
  getKudosGivenByReplyer?: Resolver<ResolversTypes['KudosShowMoreDTO'], ParentType, ContextType, RequireFields<QueryGetKudosGivenByReplyerArgs, 'filters'>>;
  getKudosLegalEntityVisibilityData?: Resolver<ResolversTypes['KudosLegalEntityVisibilityShowMoreDTO'], ParentType, ContextType, RequireFields<QueryGetKudosLegalEntityVisibilityDataArgs, 'filters'>>;
  getKudosReceivedByMe?: Resolver<ResolversTypes['KudosWithVisibilityFlagDTO'], ParentType, ContextType, RequireFields<QueryGetKudosReceivedByMeArgs, 'pagination'>>;
  getLatestScoreGridByEmployee?: Resolver<Maybe<ResolversTypes['ScoreGridDto']>, ParentType, ContextType, RequireFields<QueryGetLatestScoreGridByEmployeeArgs, 'companyId' | 'country' | 'employeeId'>>;
  getMeetingRequest?: Resolver<ResolversTypes['MeetingRequestDTO'], ParentType, ContextType, RequireFields<QueryGetMeetingRequestArgs, 'meetingRequestId'>>;
  getMeetingRequestsByCompanyCountry?: Resolver<Array<ResolversTypes['MeetingRequestDTO']>, ParentType, ContextType, RequireFields<QueryGetMeetingRequestsByCompanyCountryArgs, 'companyId' | 'country'>>;
  getMeetingRequestsByRequester?: Resolver<Array<ResolversTypes['MeetingRequestDTO']>, ParentType, ContextType, RequireFields<QueryGetMeetingRequestsByRequesterArgs, 'requesterId'>>;
  getMeetingRequestsByReviewer?: Resolver<Array<ResolversTypes['MeetingRequestDTO']>, ParentType, ContextType, RequireFields<QueryGetMeetingRequestsByReviewerArgs, 'reviewerId'>>;
  getOnboardingData?: Resolver<ResolversTypes['OnboardingDataDTO'], ParentType, ContextType, RequireFields<QueryGetOnboardingDataArgs, 'iframeId'>>;
  getPersonalSkillStatusInEmployeePreparation?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType, RequireFields<QueryGetPersonalSkillStatusInEmployeePreparationArgs, 'id'>>;
  getPossibleCompaniesForCreateNewHrBusinessPartner?: Resolver<Array<ResolversTypes['CompanyTinyWithName']>, ParentType, ContextType>;
  getRankingReportsByCountryAndFilters?: Resolver<ResolversTypes['ReportPaginationDTO'], ParentType, ContextType, RequireFields<QueryGetRankingReportsByCountryAndFiltersArgs, 'countries' | 'filters' | 'pagination'>>;
  getSelectableNationalContractReferences?: Resolver<Array<ResolversTypes['NationalContractReferenceWithTypeDTO']>, ParentType, ContextType>;
  getTargetsTemplates?: Resolver<Array<ResolversTypes['ObjectiveTemplateDTO']>, ParentType, ContextType, RequireFields<QueryGetTargetsTemplatesArgs, 'employeeId'>>;
  governmentJobTitlesByEmployeeId?: Resolver<Array<ResolversTypes['GovernmentJobTitle']>, ParentType, ContextType, RequireFields<QueryGovernmentJobTitlesByEmployeeIdArgs, 'employeeId'>>;
  governmentJobTitlesByHiringOfficeId?: Resolver<Array<ResolversTypes['GovernmentJobTitle']>, ParentType, ContextType, RequireFields<QueryGovernmentJobTitlesByHiringOfficeIdArgs, 'hiringOfficeId'>>;
  hasCountryNationalContractReferenceLevel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryHasCountryNationalContractReferenceLevelArgs, 'country'>>;
  importExcel?: Resolver<Array<ResolversTypes['EmployeeWithRankAndTagsForExcel']>, ParentType, ContextType, RequireFields<QueryImportExcelArgs, 'companyId' | 'country' | 'excelData' | 'year'>>;
  isActivityListEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsActivityListEnabledArgs, 'country'>>;
  isAgePyramidVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsAgePyramidVisibleArgs, 'country'>>;
  isBonusValidationEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsBonusValidationEnabledArgs, 'country'>>;
  isCareerPathEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsCareerPathEnabledArgs, 'country'>>;
  isCultivatingTalentsEnabledForCompanyAndCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsCultivatingTalentsEnabledForCompanyAndCountryArgs, 'companyId' | 'country'>>;
  isEmployeeLevelValidationEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsEmployeeLevelValidationEnabledArgs, 'country'>>;
  isFlexibleProrataManagementEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsFlexibleProrataManagementEnabledArgs, 'country'>>;
  isIdVWeightEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsIdVWeightEnabledArgs, 'country'>>;
  isOneOffPaymentNotAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsOneOffPaymentNotAllowedArgs, 'meetingId'>>;
  isRankingEnabledForCompanyAndCountry?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsRankingEnabledForCompanyAndCountryArgs, 'companyId' | 'country'>>;
  isSkillStatusBlocker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsSkillStatusBlockerArgs, 'country'>>;
  justAuthorized?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalEntitySearch?: Resolver<Array<ResolversTypes['LegalEntityTiny']>, ParentType, ContextType, RequireFields<QueryLegalEntitySearchArgs, 'limit' | 'search'>>;
  liveBoardOrHistory?: Resolver<Array<ResolversTypes['EmployeeWithRankAndTags']>, ParentType, ContextType, RequireFields<QueryLiveBoardOrHistoryArgs, 'companyId' | 'country' | 'year'>>;
  locales?: Resolver<Array<ResolversTypes['LocaleDTO']>, ParentType, ContextType>;
  managerOf?: Resolver<ResolversTypes['ManagingUnits'], ParentType, ContextType, RequireFields<QueryManagerOfArgs, 'managerId'>>;
  managerOnly?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  me?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  meeting?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<QueryMeetingArgs, 'id'>>;
  meetingEmployeePreparation?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<QueryMeetingEmployeePreparationArgs, 'id'>>;
  meetingInviteOptionsForEmployee?: Resolver<ResolversTypes['MeetingInviteOptionsExtended'], ParentType, ContextType, RequireFields<QueryMeetingInviteOptionsForEmployeeArgs, 'employeeId'>>;
  meetingManagerPreparation?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<QueryMeetingManagerPreparationArgs, 'id'>>;
  meetingPdfStatus?: Resolver<ResolversTypes['Meeting'], ParentType, ContextType, RequireFields<QueryMeetingPdfStatusArgs, 'id'>>;
  meetingRequestOptionsForEmployee?: Resolver<ResolversTypes['MeetingInviteOptionsExtended'], ParentType, ContextType, RequireFields<QueryMeetingRequestOptionsForEmployeeArgs, 'employeeId'>>;
  meetingStep?: Resolver<Maybe<ResolversTypes['MeetingStep']>, ParentType, ContextType, RequireFields<QueryMeetingStepArgs, 'id'>>;
  meetingsByManager?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<QueryMeetingsByManagerArgs, 'managerId'>>;
  meetingsByReplyer?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<QueryMeetingsByReplyerArgs, 'replyerId'>>;
  meetingsHistoryByReplyer?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<QueryMeetingsHistoryByReplyerArgs, 'replyerId'>>;
  mostBookedGecoProjectsOfEmployee?: Resolver<Array<ResolversTypes['GecoProjectsInfo']>, ParentType, ContextType, RequireFields<QueryMostBookedGecoProjectsOfEmployeeArgs, 'employeeId' | 'endDate' | 'startDate'>>;
  myprofile?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType>;
  nameSearch?: Resolver<Array<ResolversTypes['EmployeeNameSearchInfo']>, ParentType, ContextType, RequireFields<QueryNameSearchArgs, 'rawInput'>>;
  nameSearchForHRBPSelect?: Resolver<Array<ResolversTypes['EmployeeNameSearchInfo']>, ParentType, ContextType, RequireFields<QueryNameSearchForHrbpSelectArgs, 'country' | 'limit' | 'rawInput'>>;
  nationalContractEmployeeLevelsByContractId?: Resolver<ResolversTypes['NationalContractEmployeeLevelHistoryDTO'], ParentType, ContextType, RequireFields<QueryNationalContractEmployeeLevelsByContractIdArgs, 'id'>>;
  nationalContractEmployeeLevelsByEmployeeId?: Resolver<ResolversTypes['NationalContractEmployeeLevelHistoryDTO'], ParentType, ContextType, RequireFields<QueryNationalContractEmployeeLevelsByEmployeeIdArgs, 'employeeId'>>;
  networksCompaniesCountriesYears?: Resolver<Array<ResolversTypes['GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries']>, ParentType, ContextType>;
  nextBestActivity?: Resolver<ResolversTypes['NextBestActivity'], ParentType, ContextType, RequireFields<QueryNextBestActivityArgs, 'businessUnitIds' | 'includeBusinessUnitManager'>>;
  nonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeeting?: Resolver<Array<ResolversTypes['EmployeeAndAppraisalMeetings']>, ParentType, ContextType, RequireFields<QueryNonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingArgs, 'businessUnitId'>>;
  nonManagerEmployeesOfCompanyWithCurrentAppraisalMeeting?: Resolver<Array<ResolversTypes['EmployeeAndAppraisalMeetings']>, ParentType, ContextType, RequireFields<QueryNonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingArgs, 'companyId' | 'country'>>;
  nonParticipantsOptionsForEmployee?: Resolver<Array<ResolversTypes['EmployeeWithBusinessUnit']>, ParentType, ContextType, RequireFields<QueryNonParticipantsOptionsForEmployeeArgs, 'employeeId'>>;
  objectivePaymentByMeeting?: Resolver<Maybe<ResolversTypes['ObjectivePayment']>, ParentType, ContextType, RequireFields<QueryObjectivePaymentByMeetingArgs, 'id'>>;
  objectivesDtoList?: Resolver<Array<ResolversTypes['ObjectiveDTO']>, ParentType, ContextType, RequireFields<QueryObjectivesDtoListArgs, 'employeeId'>>;
  objectivesInMeeting?: Resolver<Array<ResolversTypes['ObjectiveDTO']>, ParentType, ContextType, RequireFields<QueryObjectivesInMeetingArgs, 'meetingId'>>;
  objectivesWithAttachmentsFromMeeting?: Resolver<Array<ResolversTypes['ObjectiveAttachmentInfoDTO']>, ParentType, ContextType, RequireFields<QueryObjectivesWithAttachmentsFromMeetingArgs, 'meetingId'>>;
  oneOffPayment?: Resolver<Maybe<ResolversTypes['OneOffPayment']>, ParentType, ContextType, RequireFields<QueryOneOffPaymentArgs, 'id'>>;
  oneOffPaymentByMeetingId?: Resolver<Maybe<ResolversTypes['OneOffPayment']>, ParentType, ContextType, RequireFields<QueryOneOffPaymentByMeetingIdArgs, 'meetingId'>>;
  personalProfile?: Resolver<ResolversTypes['PersonalProfile'], ParentType, ContextType, RequireFields<QueryPersonalProfileArgs, 'id'>>;
  possibleRevieweesByReviewerId?: Resolver<Array<ResolversTypes['EmployeeWithBusinessUnit']>, ParentType, ContextType, RequireFields<QueryPossibleRevieweesByReviewerIdArgs, 'companyId' | 'employeeId'>>;
  publicProfile?: Resolver<ResolversTypes['PublicProfile'], ParentType, ContextType, RequireFields<QueryPublicProfileArgs, 'id'>>;
  pyramidForecastValueSelector?: Resolver<ResolversTypes['PyramidSelectorYearAndMonth'], ParentType, ContextType, RequireFields<QueryPyramidForecastValueSelectorArgs, 'companyId' | 'country'>>;
  pyramidForecastValues?: Resolver<ResolversTypes['PyramidForecastValues'], ParentType, ContextType, RequireFields<QueryPyramidForecastValuesArgs, 'companyId' | 'country' | 'month' | 'year'>>;
  pyramidForecastWithFilters?: Resolver<ResolversTypes['PyramidForecastWithFiltersDTO'], ParentType, ContextType, RequireFields<QueryPyramidForecastWithFiltersArgs, 'companyId' | 'country'>>;
  pyramidPastValueSelector?: Resolver<ResolversTypes['PyramidSelectorYearAndMonth'], ParentType, ContextType, RequireFields<QueryPyramidPastValueSelectorArgs, 'companyId' | 'country' | 'pyramidType'>>;
  pyramidPastValues?: Resolver<Array<ResolversTypes['PyramidValueDto']>, ParentType, ContextType, RequireFields<QueryPyramidPastValuesArgs, 'companyId' | 'country' | 'month' | 'pyramidType' | 'year'>>;
  pyramidValues?: Resolver<Array<ResolversTypes['PyramidValueDto']>, ParentType, ContextType, RequireFields<QueryPyramidValuesArgs, 'companyId' | 'country' | 'pyramidType'>>;
  referencedPyramidsByCompanyIdAndCountry?: Resolver<Maybe<ResolversTypes['ReferencePyramid']>, ParentType, ContextType, RequireFields<QueryReferencedPyramidsByCompanyIdAndCountryArgs, 'companyId' | 'country' | 'pyramidType'>>;
  referencedPyramidsTemplateByCountryAndType?: Resolver<Maybe<Array<ResolversTypes['ReferencePyramidTemplateDTO']>>, ParentType, ContextType, RequireFields<QueryReferencedPyramidsTemplateByCountryAndTypeArgs, 'country' | 'referencePyramidType'>>;
  replyerOnly?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resignedContract?: Resolver<Maybe<ResolversTypes['LatestContractDTO']>, ParentType, ContextType, RequireFields<QueryResignedContractArgs, 'employeeId'>>;
  resignedEmployeeCareerPathEvaluation?: Resolver<Maybe<ResolversTypes['CareerPathEvaluation']>, ParentType, ContextType, RequireFields<QueryResignedEmployeeCareerPathEvaluationArgs, 'employeeId'>>;
  resignedEmployeePublicProfile?: Resolver<ResolversTypes['PublicProfile'], ParentType, ContextType, RequireFields<QueryResignedEmployeePublicProfileArgs, 'id'>>;
  resignedEmployeesOfCompany?: Resolver<ResolversTypes['ResignedViewEmployeesDTO'], ParentType, ContextType, RequireFields<QueryResignedEmployeesOfCompanyArgs, 'companyId'>>;
  resignedEmployeesOfCompanyCountry?: Resolver<ResolversTypes['ResignedViewEmployeesDTO'], ParentType, ContextType, RequireFields<QueryResignedEmployeesOfCompanyCountryArgs, 'companyId'>>;
  retrieveActivityListData?: Resolver<Maybe<Array<ResolversTypes['ActivityListDataDTO']>>, ParentType, ContextType, RequireFields<QueryRetrieveActivityListDataArgs, 'employeeId' | 'length' | 'page' | 'type'>>;
  retrieveActivityListInitialData?: Resolver<Array<ResolversTypes['ActivityListDTO']>, ParentType, ContextType, RequireFields<QueryRetrieveActivityListInitialDataArgs, 'employeeId'>>;
  retrieveChatbotToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  retrieveChatbotUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  retrieveSkillStatusDataInMeetingInvitation?: Resolver<ResolversTypes['SkillEmployeeStatusMeetingInvitationDto'], ParentType, ContextType, RequireFields<QueryRetrieveSkillStatusDataInMeetingInvitationArgs, 'employeeId'>>;
  reviewersByCompanyId?: Resolver<Array<ResolversTypes['ReviewerAndEmployee']>, ParentType, ContextType, RequireFields<QueryReviewersByCompanyIdArgs, 'companyId'>>;
  reviewersRelationOfBusinessUnitId?: Resolver<Array<ResolversTypes['ReviewerAndEmployee']>, ParentType, ContextType, RequireFields<QueryReviewersRelationOfBusinessUnitIdArgs, 'buId'>>;
  salaryByContractId?: Resolver<ResolversTypes['SalaryHistoryDTO'], ParentType, ContextType, RequireFields<QuerySalaryByContractIdArgs, 'id'>>;
  salaryByEmployeeId?: Resolver<ResolversTypes['SalaryHistoryDTO'], ParentType, ContextType, RequireFields<QuerySalaryByEmployeeIdArgs, 'employeeId'>>;
  salaryOfYear?: Resolver<Array<ResolversTypes['Salary']>, ParentType, ContextType, RequireFields<QuerySalaryOfYearArgs, 'employeeId' | 'includeAll' | 'year'>>;
  scheduledMeetingsByManager?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<QueryScheduledMeetingsByManagerArgs, 'managerId' | 'year'>>;
  scoreGridWithHistory?: Resolver<ResolversTypes['ScoreGridDto'], ParentType, ContextType, RequireFields<QueryScoreGridWithHistoryArgs, 'employeeId' | 'meetingId'>>;
  selfReflectionSummary?: Resolver<ResolversTypes['SelfReflectionSummary'], ParentType, ContextType, RequireFields<QuerySelfReflectionSummaryArgs, 'businessUnitIds'>>;
  selfreflectionQuestions?: Resolver<Array<ResolversTypes['SelfreflectionQuestion']>, ParentType, ContextType, RequireFields<QuerySelfreflectionQuestionsArgs, 'employeeId' | 'meetingId'>>;
  skillStatusBlocksMeeting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QuerySkillStatusBlocksMeetingArgs, 'meetingId'>>;
  subOrdinatesByEmployee?: Resolver<Array<ResolversTypes['Employee']>, ParentType, ContextType, RequireFields<QuerySubOrdinatesByEmployeeArgs, 'id'>>;
  subordinateMeetings?: Resolver<Array<ResolversTypes['Meeting']>, ParentType, ContextType, RequireFields<QuerySubordinateMeetingsArgs, 'managerId'>>;
  subordinateOfCompany?: Resolver<Array<ResolversTypes['CompanySubordinate']>, ParentType, ContextType, RequireFields<QuerySubordinateOfCompanyArgs, 'companyId'>>;
  subordinateSearch?: Resolver<ResolversTypes['SubordinateSearchPagination'], ParentType, ContextType, RequireFields<QuerySubordinateSearchArgs, 'pagination' | 'search'>>;
  subordinates?: Resolver<Array<ResolversTypes['EmployeeSubordinateDTO']>, ParentType, ContextType, RequireFields<QuerySubordinatesArgs, 'companyId' | 'reviewer'>>;
  tagHistoryOfEmployee?: Resolver<Array<ResolversTypes['EmployeeTagInfo']>, ParentType, ContextType, RequireFields<QueryTagHistoryOfEmployeeArgs, 'employeeId'>>;
  tagHistoryOfEmployeeUntilReplyEntryDate?: Resolver<Array<ResolversTypes['EmployeeTagInfo']>, ParentType, ContextType, RequireFields<QueryTagHistoryOfEmployeeUntilReplyEntryDateArgs, 'employeeId'>>;
  tagHistoryOfResignedEmployeeUntilReplyEntryDate?: Resolver<Array<ResolversTypes['EmployeeTagInfo']>, ParentType, ContextType, RequireFields<QueryTagHistoryOfResignedEmployeeUntilReplyEntryDateArgs, 'employeeId'>>;
  talentsSeasonSettings?: Resolver<ResolversTypes['TalentsSeasonSettingsDTO'], ParentType, ContextType, RequireFields<QueryTalentsSeasonSettingsArgs, 'companyId' | 'country' | 'year'>>;
  targetBonusByContractId?: Resolver<ResolversTypes['TargetBonusHistoryDTO'], ParentType, ContextType, RequireFields<QueryTargetBonusByContractIdArgs, 'id'>>;
  targetBonusByEmployeeId?: Resolver<ResolversTypes['TargetBonusHistoryDTO'], ParentType, ContextType, RequireFields<QueryTargetBonusByEmployeeIdArgs, 'employeeId'>>;
  targetBonusOfYear?: Resolver<Array<ResolversTypes['TargetBonus']>, ParentType, ContextType, RequireFields<QueryTargetBonusOfYearArgs, 'employeeId' | 'includeAll' | 'year'>>;
  targetCorrectionPayment?: Resolver<Maybe<ResolversTypes['TargetCorrectionPaymentDto']>, ParentType, ContextType, RequireFields<QueryTargetCorrectionPaymentArgs, 'id'>>;
  targetCorrectionPaymentAllowedYears?: Resolver<ResolversTypes['TargetCorrectionPaymentAllowedYearsDto'], ParentType, ContextType, RequireFields<QueryTargetCorrectionPaymentAllowedYearsArgs, 'meetingId'>>;
  targetCorrectionPaymentByMeetingId?: Resolver<Maybe<ResolversTypes['TargetCorrectionPaymentDto']>, ParentType, ContextType, RequireFields<QueryTargetCorrectionPaymentByMeetingIdArgs, 'meetingId'>>;
  targetTemplatesOfCompany?: Resolver<Array<ResolversTypes['ObjectiveTemplateDTO']>, ParentType, ContextType, RequireFields<QueryTargetTemplatesOfCompanyArgs, 'companyId' | 'country'>>;
};

export type ReferencePyramidResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferencePyramid'] = ResolversParentTypes['ReferencePyramid']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  referencePyramidDetails?: Resolver<Maybe<Array<ResolversTypes['ReferencePyramidDetail']>>, ParentType, ContextType>;
  referencePyramidType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferencePyramidDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferencePyramidDetail'] = ResolversParentTypes['ReferencePyramidDetail']> = {
  displayOrder?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  limitType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  range?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referencePyramid?: Resolver<Maybe<ResolversTypes['ReferencePyramid']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferencePyramidTemplateDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferencePyramidTemplateDTO'] = ResolversParentTypes['ReferencePyramidTemplateDTO']> = {
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  referencePyramidTemplateDetails?: Resolver<Maybe<Array<ResolversTypes['ReferencePyramidTemplateDetailDTO']>>, ParentType, ContextType>;
  referencePyramidType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferencePyramidTemplateDetailDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferencePyramidTemplateDetailDTO'] = ResolversParentTypes['ReferencePyramidTemplateDetailDTO']> = {
  displayOrder?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  limitType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  range?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referencePyramidTemplate?: Resolver<Maybe<ResolversTypes['ReferencePyramidTemplateDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportDTO'] = ResolversParentTypes['ReportDTO']> = {
  companyId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  createTargetReport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  downloadLink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReportStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ReportType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportPaginationDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportPaginationDTO'] = ResolversParentTypes['ReportPaginationDTO']> = {
  edges?: Resolver<Array<ResolversTypes['ReportDTO']>, ParentType, ContextType>;
  endCursorReportDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  endCursorReportId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResignedEmployeeDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResignedEmployeeDto'] = ResolversParentTypes['ResignedEmployeeDto']> = {
  bonus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnitTiny'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['EmployeeLevelEnum']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['CancellationType']>, ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toBePaid?: Resolver<Maybe<ResolversTypes['ToBePaid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResignedViewEmployeesDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResignedViewEmployeesDTO'] = ResolversParentTypes['ResignedViewEmployeesDTO']> = {
  employeesWithWrongStatusOrMissingContractDTO?: Resolver<Array<ResolversTypes['EmployeesWithWrongStatusOrMissingContractDTO']>, ParentType, ContextType>;
  resignedEmployees?: Resolver<Array<ResolversTypes['ResignedEmployeeDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewerAndEmployeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewerAndEmployee'] = ResolversParentTypes['ReviewerAndEmployee']> = {
  canDelete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['EmployeeDisplayShortInfo'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  reviewer?: Resolver<ResolversTypes['EmployeeDisplayShortInfo'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ReviewerOfEmployeeType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewerOfEmployeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewerOfEmployees'] = ResolversParentTypes['ReviewerOfEmployees']> = {
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  reviewer?: Resolver<Array<ResolversTypes['Employee']>, ParentType, ContextType>;
  reviewerId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ReviewerOfEmployeeType'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleOfUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleOfUser'] = ResolversParentTypes['RoleOfUser']> = {
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Salary'] = ResolversParentTypes['Salary']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isFulltime?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentageOfWorktime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalaryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalaryDTO'] = ResolversParentTypes['SalaryDTO']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isFulltime?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentageOfWorktime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalaryHistoryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalaryHistoryDTO'] = ResolversParentTypes['SalaryHistoryDTO']> = {
  salaryHistory?: Resolver<Array<ResolversTypes['SalaryDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreGoalResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreGoal'] = ResolversParentTypes['ScoreGoal']> = {
  employeeEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastResultEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resultEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reviewerEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scoreGrid?: Resolver<Maybe<ResolversTypes['ScoreGrid']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  viewId?: Resolver<ResolversTypes['ScoreGoalType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreGoalDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreGoalDto'] = ResolversParentTypes['ScoreGoalDto']> = {
  employeeEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastResultEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resultEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reviewerEvaluation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  viewId?: Resolver<ResolversTypes['ScoreGoalType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreGridResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreGrid'] = ResolversParentTypes['ScoreGrid']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employeePreparationScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  managerPreparationScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resultScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scoreGoals?: Resolver<Array<ResolversTypes['ScoreGoal']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreGridDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreGridDto'] = ResolversParentTypes['ScoreGridDto']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employeePreparationScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastResultScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  managerPreparationScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resultScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scoreGoals?: Resolver<Array<ResolversTypes['ScoreGoalDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreGridsOverviewDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreGridsOverviewDTO'] = ResolversParentTypes['ScoreGridsOverviewDTO']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastAppraisalDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastAppraisalEmplPrepDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  priorAppraisalDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  scoreGoals?: Resolver<Array<ResolversTypes['ScoreGoalDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelfReflectionSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelfReflectionSummary'] = ResolversParentTypes['SelfReflectionSummary']> = {
  numberOfAnswers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  projectHappiness?: Resolver<ResolversTypes['HappinessLevel'], ParentType, ContextType>;
  totalParticipants?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelfreflectionQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelfreflectionQuestion'] = ResolversParentTypes['SelfreflectionQuestion']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employee?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  meetingId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subItems?: Resolver<Array<ResolversTypes['SelfreflectionQuestionBoolean']>, ParentType, ContextType>;
  textId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SelfReflectionQuestionType'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelfreflectionQuestionBooleanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelfreflectionQuestionBoolean'] = ResolversParentTypes['SelfreflectionQuestionBoolean']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  selfreflectionQuestion?: Resolver<Maybe<ResolversTypes['SelfreflectionQuestion']>, ParentType, ContextType>;
  textId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SkillEmployeeStatusDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SkillEmployeeStatusDto'] = ResolversParentTypes['SkillEmployeeStatusDto']> = {
  employeeExpireDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  expired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  latestSyncDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  skillStatus?: Resolver<ResolversTypes['SkillEmployeeStatusEnum'], ParentType, ContextType>;
  statusId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SkillEmployeeStatusMeetingInvitationDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SkillEmployeeStatusMeetingInvitationDto'] = ResolversParentTypes['SkillEmployeeStatusMeetingInvitationDto']> = {
  isSkillStatusBlocker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  retrievalError?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  skillEmployeeStatusDto?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SqsBufferResolvers<ContextType = any, ParentType extends ResolversParentTypes['SqsBuffer'] = ResolversParentTypes['SqsBuffer']> = {
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubordinateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subordinate'] = ResolversParentTypes['Subordinate']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessUnit?: Resolver<ResolversTypes['BusinessUnit'], ParentType, ContextType>;
  careerPath?: Resolver<Maybe<Array<ResolversTypes['CareerPathDto']>>, ParentType, ContextType>;
  careerPathEvaluation?: Resolver<Maybe<ResolversTypes['CareerPathEvaluation']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contractLevel?: Resolver<ResolversTypes['EmployeeLevelEnum'], ParentType, ContextType>;
  contractValidTo?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  currencyForPayments?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  replyEntryDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  resultScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salary?: Resolver<Maybe<ResolversTypes['Salary']>, ParentType, ContextType>;
  skillStatus?: Resolver<Maybe<ResolversTypes['SkillEmployeeStatusDto']>, ParentType, ContextType>;
  targetBonus?: Resolver<Maybe<ResolversTypes['TargetBonus']>, ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubordinateSearchPaginationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubordinateSearchPagination'] = ResolversParentTypes['SubordinateSearchPagination']> = {
  edges?: Resolver<Array<ResolversTypes['EmployeeSearch']>, ParentType, ContextType>;
  endCursorId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  endCursorLegalFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCursorLegalLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TalentsSeasonSettingsDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TalentsSeasonSettingsDTO'] = ResolversParentTypes['TalentsSeasonSettingsDTO']> = {
  blockedChangesForLow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  closingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  closingEmployee?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  confirmationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  confirmationEmployee?: Resolver<Maybe<ResolversTypes['EmployeeDisplayTinyInfo']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  lowPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  talentsSeasonId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  talentsSeasonStatus?: Resolver<ResolversTypes['TalentsSeasonStatus'], ParentType, ContextType>;
  topPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TalentsSeasonYearDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TalentsSeasonYearDTO'] = ResolversParentTypes['TalentsSeasonYearDTO']> = {
  companyId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['Country'], ParentType, ContextType>;
  talentsSeasonId?: Resolver<Maybe<ResolversTypes['HashedId']>, ParentType, ContextType>;
  talentsSeasonStatus?: Resolver<ResolversTypes['TalentsSeasonStatus'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetBonus'] = ResolversParentTypes['TargetBonus']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetBonusDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetBonusDTO'] = ResolversParentTypes['TargetBonusDTO']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  isTentative?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetBonusHistoryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetBonusHistoryDTO'] = ResolversParentTypes['TargetBonusHistoryDTO']> = {
  targetBonusHistory?: Resolver<Array<ResolversTypes['TargetBonusDTO']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetCorrectionPaymentAllowedYearsDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetCorrectionPaymentAllowedYearsDto'] = ResolversParentTypes['TargetCorrectionPaymentAllowedYearsDto']> = {
  currentYearAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  previousYearAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetCorrectionPaymentDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetCorrectionPaymentDto'] = ResolversParentTypes['TargetCorrectionPaymentDto']> = {
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  meetingId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  paymentDateValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  referenceYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  resultAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TargetCorrectionPaymentStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetReportGenerationRequestDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetReportGenerationRequestDTO'] = ResolversParentTypes['TargetReportGenerationRequestDTO']> = {
  createTargetReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  generationResult?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TargetsCalculationHelperDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetsCalculationHelperDTO'] = ResolversParentTypes['TargetsCalculationHelperDTO']> = {
  newTargetsReferenceYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pastTargetsReferenceYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemporalBoundariesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemporalBoundaries'] = ResolversParentTypes['TemporalBoundaries']> = {
  fromDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToBePaidResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToBePaid'] = ResolversParentTypes['ToBePaid']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employee?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  kudosOptOut?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameDisplayPreference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboardingDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['RoleName']>>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInfo'] = ResolversParentTypes['UserInfo']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyForPayments?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentEmployeeLevel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employeeId?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['HashedId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  managedBusinessUnits?: Resolver<Array<ResolversTypes['BusinessUnitTiny']>, ParentType, ContextType>;
  managedCompanies?: Resolver<Array<ResolversTypes['CompanyTiny']>, ParentType, ContextType>;
  nameDisplayPreference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['RoleName']>>, ParentType, ContextType>;
  skillCenterUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkforceMovementCountersResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkforceMovementCounters'] = ResolversParentTypes['WorkforceMovementCounters']> = {
  currentMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nextMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  previousMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  workforceMovementType?: Resolver<ResolversTypes['WorkforceMovementsEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YearsAndCompaniesForRankingReportDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['YearsAndCompaniesForRankingReportDTO'] = ResolversParentTypes['YearsAndCompaniesForRankingReportDTO']> = {
  possibleCompanies?: Resolver<Array<ResolversTypes['CompaniesForRankingReportDTO']>, ParentType, ContextType>;
  possibleYears?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AbstractEmployeeWithRankAndTags?: AbstractEmployeeWithRankAndTagsResolvers<ContextType>;
  AbstractRelation?: AbstractRelationResolvers<ContextType>;
  ActiveHRBusinessPartnerDTO?: ActiveHrBusinessPartnerDtoResolvers<ContextType>;
  ActivityListDTO?: ActivityListDtoResolvers<ContextType>;
  ActivityListDataDTO?: ActivityListDataDtoResolvers<ContextType>;
  AllowedMonetaryTargetsDTO?: AllowedMonetaryTargetsDtoResolvers<ContextType>;
  AppraisalConfirmationInfo?: AppraisalConfirmationInfoResolvers<ContextType>;
  AppraisalDisplayInfo?: AppraisalDisplayInfoResolvers<ContextType>;
  AppraisalSeasonDTO?: AppraisalSeasonDtoResolvers<ContextType>;
  AppraisalSeasonOpeningInfoDTO?: AppraisalSeasonOpeningInfoDtoResolvers<ContextType>;
  AppraisalType?: AppraisalTypeResolvers<ContextType>;
  AppraisalWithFeedbackDTO?: AppraisalWithFeedbackDtoResolvers<ContextType>;
  AppraisalWithFeedbackPagination?: AppraisalWithFeedbackPaginationResolvers<ContextType>;
  AuthPayload?: AuthPayloadResolvers<ContextType>;
  BOofCompanyDTO?: BOofCompanyDtoResolvers<ContextType>;
  BUBOBUMcountersDTO?: BubobuMcountersDtoResolvers<ContextType>;
  BUMOfBusinessUnitDTO?: BumOfBusinessUnitDtoResolvers<ContextType>;
  BUMOfCompanyDTO?: BumOfCompanyDtoResolvers<ContextType>;
  BUofCompanyDTO?: BUofCompanyDtoResolvers<ContextType>;
  BonusBetweenAnnualBonusAndProrataDTO?: BonusBetweenAnnualBonusAndProrataDtoResolvers<ContextType>;
  BranchOffice?: BranchOfficeResolvers<ContextType>;
  BranchOfficeDTO?: BranchOfficeDtoResolvers<ContextType>;
  BranchOfficeWithEmployeesDTO?: BranchOfficeWithEmployeesDtoResolvers<ContextType>;
  Brand?: BrandResolvers<ContextType>;
  Bu?: BuResolvers<ContextType>;
  BusinessPartnerOfCompany?: BusinessPartnerOfCompanyResolvers<ContextType>;
  BusinessUnit?: BusinessUnitResolvers<ContextType>;
  BusinessUnitTiny?: BusinessUnitTinyResolvers<ContextType>;
  BusinessUnitWithManagersDTO?: BusinessUnitWithManagersDtoResolvers<ContextType>;
  CareerPathDto?: CareerPathDtoResolvers<ContextType>;
  CareerPathEvaluation?: CareerPathEvaluationResolvers<ContextType>;
  Change?: ChangeResolvers<ContextType>;
  ChangeError?: ChangeErrorResolvers<ContextType>;
  ChangeResponseErrorObject?: ChangeResponseErrorObjectResolvers<ContextType>;
  Children?: ChildrenResolvers<ContextType>;
  Citizenship?: CitizenshipResolvers<ContextType>;
  CompaniesForRankingReportDTO?: CompaniesForRankingReportDtoResolvers<ContextType>;
  Company?: CompanyResolvers<ContextType>;
  CompanyAndBu?: CompanyAndBuResolvers<ContextType>;
  CompanyCar?: CompanyCarResolvers<ContextType>;
  CompanyManagerAppraisalMeetingStatusDTO?: CompanyManagerAppraisalMeetingStatusDtoResolvers<ContextType>;
  CompanyManagerAppraisalMeetingStatusTableRowDTO?: CompanyManagerAppraisalMeetingStatusTableRowDtoResolvers<ContextType>;
  CompanyRanking?: CompanyRankingResolvers<ContextType>;
  CompanyRankingSettingsDTO?: CompanyRankingSettingsDtoResolvers<ContextType>;
  CompanySubordinate?: CompanySubordinateResolvers<ContextType>;
  CompanyTiny?: CompanyTinyResolvers<ContextType>;
  CompanyTinyWithName?: CompanyTinyWithNameResolvers<ContextType>;
  Contract?: ContractResolvers<ContextType>;
  ContractChangeValidationEntry?: ContractChangeValidationEntryResolvers<ContextType>;
  ContractChangeValidationList?: ContractChangeValidationListResolvers<ContextType>;
  ContractEmployeeLevel?: ContractEmployeeLevelResolvers<ContextType>;
  ContractEmployeeLevelDTO?: ContractEmployeeLevelDtoResolvers<ContextType>;
  ContractEmployeeLevelHistoryDTO?: ContractEmployeeLevelHistoryDtoResolvers<ContextType>;
  ContractGovernmentJobTitle?: ContractGovernmentJobTitleResolvers<ContextType>;
  ContractType?: ContractTypeResolvers<ContextType>;
  CountryAndReportGenerationFlags?: CountryAndReportGenerationFlagsResolvers<ContextType>;
  CountrySettingsDto?: CountrySettingsDtoResolvers<ContextType>;
  CountryWithAgePyramidVisibleFlag?: CountryWithAgePyramidVisibleFlagResolvers<ContextType>;
  CountryWithBranchOfficeVisibleFlag?: CountryWithBranchOfficeVisibleFlagResolvers<ContextType>;
  CreateChangeResponse?: CreateChangeResponseResolvers<ContextType>;
  CurrencyConversionDTO?: CurrencyConversionDtoResolvers<ContextType>;
  CurrencyConversionWithContractCurrencyDTO?: CurrencyConversionWithContractCurrencyDtoResolvers<ContextType>;
  CurrentUser?: CurrentUserResolvers<ContextType>;
  DashboardListOfCompanies?: DashboardListOfCompaniesResolvers<ContextType>;
  DashboardWorkforceCountersDTO?: DashboardWorkforceCountersDtoResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DeleteOk?: DeleteOkResolvers<ContextType>;
  Education?: EducationResolvers<ContextType>;
  EmbeddedBusinessUnit?: EmbeddedBusinessUnitResolvers<ContextType>;
  EmergencyContact?: EmergencyContactResolvers<ContextType>;
  Employee?: EmployeeResolvers<ContextType>;
  EmployeeAddress?: EmployeeAddressResolvers<ContextType>;
  EmployeeAndAppraisalMeetings?: EmployeeAndAppraisalMeetingsResolvers<ContextType>;
  EmployeeAndTag?: EmployeeAndTagResolvers<ContextType>;
  EmployeeDisplayShortInfo?: EmployeeDisplayShortInfoResolvers<ContextType>;
  EmployeeDisplayShortInfoMeetingInvite?: EmployeeDisplayShortInfoMeetingInviteResolvers<ContextType>;
  EmployeeDisplayShortInfoWithLastMeeting?: EmployeeDisplayShortInfoWithLastMeetingResolvers<ContextType>;
  EmployeeDisplayShortWithBuManager?: EmployeeDisplayShortWithBuManagerResolvers<ContextType>;
  EmployeeDisplayTinyInfo?: EmployeeDisplayTinyInfoResolvers<ContextType>;
  EmployeeEmploymentStatusDTO?: EmployeeEmploymentStatusDtoResolvers<ContextType>;
  EmployeeLevelWithDisplayOrder?: EmployeeLevelWithDisplayOrderResolvers<ContextType>;
  EmployeeNameSearchInfo?: EmployeeNameSearchInfoResolvers<ContextType>;
  EmployeeOnProbation?: EmployeeOnProbationResolvers<ContextType>;
  EmployeeRankDTO?: EmployeeRankDtoResolvers<ContextType>;
  EmployeeRanking?: EmployeeRankingResolvers<ContextType>;
  EmployeeSearch?: EmployeeSearchResolvers<ContextType>;
  EmployeeSubordinateDTO?: EmployeeSubordinateDtoResolvers<ContextType>;
  EmployeeTagDto?: EmployeeTagDtoResolvers<ContextType>;
  EmployeeTagInfo?: EmployeeTagInfoResolvers<ContextType>;
  EmployeeTagInfoShort?: EmployeeTagInfoShortResolvers<ContextType>;
  EmployeeTagInfoTiny?: EmployeeTagInfoTinyResolvers<ContextType>;
  EmployeeWithBonus?: EmployeeWithBonusResolvers<ContextType>;
  EmployeeWithBusinessUnit?: EmployeeWithBusinessUnitResolvers<ContextType>;
  EmployeeWithEndingContract?: EmployeeWithEndingContractResolvers<ContextType>;
  EmployeeWithLatestAndDraftEvaluation?: EmployeeWithLatestAndDraftEvaluationResolvers<ContextType>;
  EmployeeWithLevelDTO?: EmployeeWithLevelDtoResolvers<ContextType>;
  EmployeeWithRankAndTags?: EmployeeWithRankAndTagsResolvers<ContextType>;
  EmployeeWithRankAndTagsForExcel?: EmployeeWithRankAndTagsForExcelResolvers<ContextType>;
  EmployeeWithRole?: EmployeeWithRoleResolvers<ContextType>;
  EmployeesWithWrongStatusOrMissingContractDTO?: EmployeesWithWrongStatusOrMissingContractDtoResolvers<ContextType>;
  ExecutedPayment?: ExecutedPaymentResolvers<ContextType>;
  ExecutedPaymentDTO?: ExecutedPaymentDtoResolvers<ContextType>;
  ExecutedPaymentHistoryDTO?: ExecutedPaymentHistoryDtoResolvers<ContextType>;
  FeatureMaintenanceData?: FeatureMaintenanceDataResolvers<ContextType>;
  FeatureToggle?: FeatureToggleResolvers<ContextType>;
  FlatCompanyWithLegalEntitiesAndCountries?: FlatCompanyWithLegalEntitiesAndCountriesResolvers<ContextType>;
  FullMeetingPreviewDTO?: FullMeetingPreviewDtoResolvers<ContextType>;
  GecoProjectsInfo?: GecoProjectsInfoResolvers<ContextType>;
  GovernmentJobTitle?: GovernmentJobTitleResolvers<ContextType>;
  GovernmentJobTitleTinyDTO?: GovernmentJobTitleTinyDtoResolvers<ContextType>;
  GroupedCompanyWithLegalEntitiesAndCountries?: GroupedCompanyWithLegalEntitiesAndCountriesResolvers<ContextType>;
  GroupedLegalEntityWithCountry?: GroupedLegalEntityWithCountryResolvers<ContextType>;
  GroupedNetworkWithCompaniesWithLegalEntitiesAndCountries?: GroupedNetworkWithCompaniesWithLegalEntitiesAndCountriesResolvers<ContextType>;
  HappinessLevel?: HappinessLevelResolvers<ContextType>;
  HashedId?: GraphQLScalarType;
  HiringOffice?: HiringOfficeResolvers<ContextType>;
  IdvWeightDto?: IdvWeightDtoResolvers<ContextType>;
  InternationalAddress?: InternationalAddressResolvers<ContextType>;
  InternationalBankAccount?: InternationalBankAccountResolvers<ContextType>;
  KeyResultDTO?: KeyResultDtoResolvers<ContextType>;
  KudosCompanyCountryVisibilityDTO?: KudosCompanyCountryVisibilityDtoResolvers<ContextType>;
  KudosCompanyCountryVisibilityShowMoreDTO?: KudosCompanyCountryVisibilityShowMoreDtoResolvers<ContextType>;
  KudosDTO?: KudosDtoResolvers<ContextType>;
  KudosLegalEntityVisibilityDTO?: KudosLegalEntityVisibilityDtoResolvers<ContextType>;
  KudosLegalEntityVisibilityShowMoreDTO?: KudosLegalEntityVisibilityShowMoreDtoResolvers<ContextType>;
  KudosPaginationDTO?: KudosPaginationDtoResolvers<ContextType>;
  KudosShowMoreDTO?: KudosShowMoreDtoResolvers<ContextType>;
  KudosWithVisibilityFlagDTO?: KudosWithVisibilityFlagDtoResolvers<ContextType>;
  LatestContractDTO?: LatestContractDtoResolvers<ContextType>;
  LeaveEntitlement?: LeaveEntitlementResolvers<ContextType>;
  Leavers?: LeaversResolvers<ContextType>;
  LeaversByPeriod?: LeaversByPeriodResolvers<ContextType>;
  LegalEntity?: LegalEntityResolvers<ContextType>;
  LegalEntityTiny?: LegalEntityTinyResolvers<ContextType>;
  LocaleDTO?: LocaleDtoResolvers<ContextType>;
  LogoutOk?: LogoutOkResolvers<ContextType>;
  ManagedCompany?: ManagedCompanyResolvers<ContextType>;
  ManagerOfBusinessUnit?: ManagerOfBusinessUnitResolvers<ContextType>;
  ManagerOfCluster?: ManagerOfClusterResolvers<ContextType>;
  ManagerOfCompany?: ManagerOfCompanyResolvers<ContextType>;
  ManagerOfNetwork?: ManagerOfNetworkResolvers<ContextType>;
  ManagingUnits?: ManagingUnitsResolvers<ContextType>;
  Meeting?: MeetingResolvers<ContextType>;
  MeetingConclusionPdf?: MeetingConclusionPdfResolvers<ContextType>;
  MeetingEmbedAppraisal?: MeetingEmbedAppraisalResolvers<ContextType>;
  MeetingEmbedOther?: MeetingEmbedOtherResolvers<ContextType>;
  MeetingInvitationStatus?: MeetingInvitationStatusResolvers<ContextType>;
  MeetingInviteOptions?: MeetingInviteOptionsResolvers<ContextType>;
  MeetingInviteOptionsExtended?: MeetingInviteOptionsExtendedResolvers<ContextType>;
  MeetingRequestDTO?: MeetingRequestDtoResolvers<ContextType>;
  MeetingStep?: MeetingStepResolvers<ContextType>;
  MeetingTiny?: MeetingTinyResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NationalContractEmployeeLevelDTO?: NationalContractEmployeeLevelDtoResolvers<ContextType>;
  NationalContractEmployeeLevelHistoryDTO?: NationalContractEmployeeLevelHistoryDtoResolvers<ContextType>;
  NationalContractLevel?: NationalContractLevelResolvers<ContextType>;
  NationalContractReferenceDTO?: NationalContractReferenceDtoResolvers<ContextType>;
  NationalContractReferenceLevelDTO?: NationalContractReferenceLevelDtoResolvers<ContextType>;
  NationalContractReferenceWithTypeDTO?: NationalContractReferenceWithTypeDtoResolvers<ContextType>;
  Network?: NetworkResolvers<ContextType>;
  NewEntries?: NewEntriesResolvers<ContextType>;
  NewEntriesByPeriod?: NewEntriesByPeriodResolvers<ContextType>;
  NextBestActionMissingTargets?: NextBestActionMissingTargetsResolvers<ContextType>;
  NextBestActivity?: NextBestActivityResolvers<ContextType>;
  NextBestActivityLeavingEmployees?: NextBestActivityLeavingEmployeesResolvers<ContextType>;
  NextBestActivityLimitedContractEnding?: NextBestActivityLimitedContractEndingResolvers<ContextType>;
  NextBestActivityNoMeeting?: NextBestActivityNoMeetingResolvers<ContextType>;
  NextBestActivityProbationTalk?: NextBestActivityProbationTalkResolvers<ContextType>;
  NoteInfo?: NoteInfoResolvers<ContextType>;
  ObjectiveAttachmentInfoDTO?: ObjectiveAttachmentInfoDtoResolvers<ContextType>;
  ObjectiveDTO?: ObjectiveDtoResolvers<ContextType>;
  ObjectiveKeyResultDTO?: ObjectiveKeyResultDtoResolvers<ContextType>;
  ObjectivePayment?: ObjectivePaymentResolvers<ContextType>;
  ObjectiveTemplateDTO?: ObjectiveTemplateDtoResolvers<ContextType>;
  OnboardingDataDTO?: OnboardingDataDtoResolvers<ContextType>;
  OneOffPayment?: OneOffPaymentResolvers<ContextType>;
  Option?: OptionResolvers<ContextType>;
  PerBaseEntity?: PerBaseEntityResolvers<ContextType>;
  PermissionCheck?: PermissionCheckResolvers<ContextType>;
  PersonalProfile?: PersonalProfileResolvers<ContextType>;
  ProbationPeriodEnding?: ProbationPeriodEndingResolvers<ContextType>;
  ProbationPeriodEndingByPeriod?: ProbationPeriodEndingByPeriodResolvers<ContextType>;
  Profile?: ProfileResolvers<ContextType>;
  PublicProfile?: PublicProfileResolvers<ContextType>;
  PyramidForecastDTO?: PyramidForecastDtoResolvers<ContextType>;
  PyramidForecastFiltersDTO?: PyramidForecastFiltersDtoResolvers<ContextType>;
  PyramidForecastValueDto?: PyramidForecastValueDtoResolvers<ContextType>;
  PyramidForecastValues?: PyramidForecastValuesResolvers<ContextType>;
  PyramidForecastWithFiltersDTO?: PyramidForecastWithFiltersDtoResolvers<ContextType>;
  PyramidSelectorYearAndMonth?: PyramidSelectorYearAndMonthResolvers<ContextType>;
  PyramidValueDto?: PyramidValueDtoResolvers<ContextType>;
  PyramidValueLevelDecrease?: PyramidValueLevelDecreaseResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ReferencePyramid?: ReferencePyramidResolvers<ContextType>;
  ReferencePyramidDetail?: ReferencePyramidDetailResolvers<ContextType>;
  ReferencePyramidTemplateDTO?: ReferencePyramidTemplateDtoResolvers<ContextType>;
  ReferencePyramidTemplateDetailDTO?: ReferencePyramidTemplateDetailDtoResolvers<ContextType>;
  ReportDTO?: ReportDtoResolvers<ContextType>;
  ReportPaginationDTO?: ReportPaginationDtoResolvers<ContextType>;
  ResignedEmployeeDto?: ResignedEmployeeDtoResolvers<ContextType>;
  ResignedViewEmployeesDTO?: ResignedViewEmployeesDtoResolvers<ContextType>;
  ReviewerAndEmployee?: ReviewerAndEmployeeResolvers<ContextType>;
  ReviewerOfEmployees?: ReviewerOfEmployeesResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RoleOfUser?: RoleOfUserResolvers<ContextType>;
  Salary?: SalaryResolvers<ContextType>;
  SalaryDTO?: SalaryDtoResolvers<ContextType>;
  SalaryHistoryDTO?: SalaryHistoryDtoResolvers<ContextType>;
  ScoreGoal?: ScoreGoalResolvers<ContextType>;
  ScoreGoalDto?: ScoreGoalDtoResolvers<ContextType>;
  ScoreGrid?: ScoreGridResolvers<ContextType>;
  ScoreGridDto?: ScoreGridDtoResolvers<ContextType>;
  ScoreGridsOverviewDTO?: ScoreGridsOverviewDtoResolvers<ContextType>;
  SelfReflectionSummary?: SelfReflectionSummaryResolvers<ContextType>;
  SelfreflectionQuestion?: SelfreflectionQuestionResolvers<ContextType>;
  SelfreflectionQuestionBoolean?: SelfreflectionQuestionBooleanResolvers<ContextType>;
  SkillEmployeeStatusDto?: SkillEmployeeStatusDtoResolvers<ContextType>;
  SkillEmployeeStatusMeetingInvitationDto?: SkillEmployeeStatusMeetingInvitationDtoResolvers<ContextType>;
  SqsBuffer?: SqsBufferResolvers<ContextType>;
  Subordinate?: SubordinateResolvers<ContextType>;
  SubordinateSearchPagination?: SubordinateSearchPaginationResolvers<ContextType>;
  TalentsSeasonSettingsDTO?: TalentsSeasonSettingsDtoResolvers<ContextType>;
  TalentsSeasonYearDTO?: TalentsSeasonYearDtoResolvers<ContextType>;
  TargetBonus?: TargetBonusResolvers<ContextType>;
  TargetBonusDTO?: TargetBonusDtoResolvers<ContextType>;
  TargetBonusHistoryDTO?: TargetBonusHistoryDtoResolvers<ContextType>;
  TargetCorrectionPaymentAllowedYearsDto?: TargetCorrectionPaymentAllowedYearsDtoResolvers<ContextType>;
  TargetCorrectionPaymentDto?: TargetCorrectionPaymentDtoResolvers<ContextType>;
  TargetReportGenerationRequestDTO?: TargetReportGenerationRequestDtoResolvers<ContextType>;
  TargetsCalculationHelperDTO?: TargetsCalculationHelperDtoResolvers<ContextType>;
  TemporalBoundaries?: TemporalBoundariesResolvers<ContextType>;
  ToBePaid?: ToBePaidResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserInfo?: UserInfoResolvers<ContextType>;
  WorkforceMovementCounters?: WorkforceMovementCountersResolvers<ContextType>;
  YearsAndCompaniesForRankingReportDTO?: YearsAndCompaniesForRankingReportDtoResolvers<ContextType>;
};

